<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre1">Erster Teil. Der Herbst</h2>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page37" title="lac/DaoH"></a> <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page38" title="Ruktz/lac"></a> Gelobt sei Jesus Christus!</p>
<p class="calibre3">»In Ewigkeit Amen! beste Agathe, und wohin wandert ihr denn,
was?«</p>
<p class="calibre3">»In die Welt, zu den Menschen, euer Liebden, in die weite Welt!
...«</p>
<p class="calibre3">Sie zog mit dem Stecken einen Bogen von Osten nach Westen.</p>
<p class="calibre3">Der Priester schaute unbewußt in jene Ferne und senkte rasch die
Augen, denn über dem Westen hing die blendende Sonne; dann fragte
er stiller, wie ängstlich fast ...</p>
<p class="calibre3">»Haben die Klembs euch fortgetrieben, was? Oder habt ihr euch
nur gezankt? ... Vielleicht ...«</p>
<p class="calibre3">Sie antwortete nicht gleich, reckte sich etwas und ließ die
alten verbleichten Augen schwer über die herbstlichen, leeren
Felder und die Dächer des Dorfes schweifen, das in Obstgärten
getaucht ruhte.</p>
<p class="calibre3">»I nee, nee ... rausgejagt ... nee, wie sollten sie denn. Sind
doch ganz gute Leute, Verwandte. War auch kein Zank nicht da./Man
merkt nur selber so, daß es Zeit ist, in die Welt fort./Vom fremden
Wagen muß der Mensch 'runter wenn es Zeit ist, selbst ins
Wasser.</p>
<p class="calibre3">Man mußte ... sie hatten schon keine Arbeit mehr für mich ... es
geht nach dem Winter, wie kann man denn da/umsonst sollen sie das
Essen geben und die Ecke fürs Schlafen? ...</p>
<p class="calibre3">Und weil sie doch auch gerade das Kalb, den kleinen Bullen,
entwöhnt haben ... und bei den kalten Nächten müssen auch die
Gänschen 'rein/da hab' ich Platz gemacht, was soll man denn anders,
is doch schade ums schöne Vieh, sind auch Gottesgeschöpfe ... Die
Leute sind gut, nehmen mich doch für den Sommer ins Haus und gönnen
mir meine Ecke und mein Essen/so daß der Mensch wie eine Hofbäuerin
herumparadiert ...</p>
<p class="calibre3">Und für den Winter/viel brauch' ich ja nicht/da muß man schon
bitten gehen. Auf dem Bettel geben einem die <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page39" title="Monne3/lac"></a> guten Leute schon was, und bis zum
Frühjahr werde ich mich mit unseres Herrn Jesu Hilfe durchwürgen.
'n paar Groschen spart man sich auch noch über/das ist dann für
meine Leute, auf die Vorerntezeit ... von wegen der
Verwandtschaft.</p>
<p class="calibre3">Und das süße Jesuskind wird die Armut schon nicht
verlassen.«</p>
<p class="calibre3">»Nein, das wird er nicht,« rief der Priester mit Wärme und
drückte ihr ein blankes Fünfzehnkopekenstück in die Faust.</p>
<p class="calibre3">»Hochwürden, unser lieber Hochwürden!«</p>
<p class="calibre3">Sie beugte sich, daß ihr zittriger Kopf seine Knie berührte, und
die Tränen kollerten wie Erbsen über ihr greises, wie Herbstäcker
zerfurchtes Gesicht.</p>
<p class="calibre3">»Geht nur mit Gott/geht nur,« murmelte er bekümmert und richtete
sie auf.</p>
<p class="calibre3">Sie sammelte mit zitternden Händen die Bettelsäcke, den Stecken
mit der Igelspitze, bekreuzigte sich und ging über den breiten
ausgefahrenen Weg in der Richtung des Waldes davon; doch immer
wieder blickte sie sich um nach dem Dorf, nach den Feldern, auf
denen man Kartoffeln grub, nach dem Rauch der Hirtenfeuer, der
dicht über den Stoppelfeldern hinkroch, und immer wieder blickte
sie traurig zurück bis sie zuletzt hinter den Büschen am Wege
verschwand.</p>
<p class="calibre3">Der Priester kehrte auf seinen alten Platz zwischen die Räder
der Pflugkarre zurück, langte nach einer Prise und schlug das
Brevier auf, doch seine Augen glitten von den roten Lettern ab und
liefen über die weiten, von herbstlicher Versonnenheit umfangenen
Lande, schweiften über den blassen Himmel und machten dann bei
einem Knecht halt, der über einen Pflug gebeugt ging.</p>
<p class="calibre3">»Walek ... die Furche ist schief ... täh ...« schrie er und
lupfte leicht vom Sitz. Schritt für Schritt folgte er nun mit den
Augen dem runden Schimmelpaar, das den knirschenden Pflug zog.</p>
<p class="calibre3">Dann fing er wieder unbewußt an, die roten Lettern des <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page40" title="Monne3/lac"></a> Breviers zu
durchlaufen und die Lippen murmelnd zu bewegen. Doch die Augen
waren immer wieder hinter den Schimmeln her und beobachteten die
Krähen, die mit behutsam vorgestreckten Schnäbeln in der
Ackerfurche hüpften und bei jedem Peitschenhieb und jeder Wendung
des Pfluges schwer aufflatterten, um gleich wieder auf den Acker
zurückzufallen und die Schnäbel an den harten trockenen Schollen zu
wetzen.</p>
<p class="calibre3">»He, Walek! lang' er ihr mal eine über die Pantalons, die Rechte
zieht nicht!«</p>
<p class="calibre3">Er schmunzelte heimlich, da die Rechte nach dem Peitschenhieb
ihre Pflicht tat. Als die Pferde wieder an den Weg herangekommen
waren, erhob er sich eilig und klopfte ihnen wohlwollend den
Nacken, so daß sie die Nüstern nach ihm reckten und
freundschaftlich sein Gesicht beschnupperten.</p>
<p class="calibre3">»Heeet aa!« rief Walek mit singender Stimme, er zog die silbrig
blinkende Pflugschar aus der Erde, hob sie etwas hoch, riß die
Pferdeleine an, so daß die Gäule einen kurzen Bogen machten, stieß
den blanken Sieck in das Stoppelfeld und schwang die Peitsche; die
Pferde ruckten an, daß die Ortscheite quarrten. Und er pflügte
weiter, das weite Gelände hinab, das im geraden Winkel vom Weg
abfiel und als ein langer Zug leinwandgrauer Schollen sich zum tief
gelagerten Dorf hin reckte, welches wie versunken lag in rötlichen
und goldenen Obstgärten.</p>
<p class="calibre3">Die Luft war still, warm und etwas schläfernd.</p>
<p class="calibre3">Obgleich es schon gegen Ende September war, wärmte die Sonne
nicht schlecht; sie schwebte über den Wäldern auf der Hälfte des
Weges zwischen Süden und Westen, doch legten sich schon nächtlich
kühle Schatten um die Knicks, um die Steinhaufen, um die harten
trockenen Ackerkrumen und unter die Birnbäume auf den Feldern.</p>
<p class="calibre3">Über den verlassenen Fluren lag Stille und eine berauschende
Süße war in der von Sonnendunst gedämpften Luft; im hohen, blassen
blauen Himmel lagen hier und da <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page41" title="Monne3/lac"></a> gewaltige weiße Wolken verstreut, wie
Schneewälle, die von Winden aufgeballt und zerfetzt waren.</p>
<p class="calibre3">Und unter diesen Wolken, soweit das Auge reichen konnte, ruhte
graues Ackerland/eine riesige Schale mit eingekerbtem Rand
bläulicher Wälder, durch die gleich silbernen, in der Sonne
aufflirrenden Gespinsten der Fluß mit seinen Windungen zwischen
Erlen und Uferweiden hervorblitzte. Er staute sich mitten im Dorf
zu einem großen länglichen Weiher und lief nach Norden durch eine
Schlucht zwischen den Hügeln; im Talkessel rund um den Weiher
lagerte sich das im Sonnenschein schillernde Dorf in der Pracht
seiner herbstlich bunten Baumwipfel, gleich einer rotgelben
zusammengerollten Raupe auf einem grauen Lattichblatt. Lange Gewebe
etwas wirrer Ackerhufen, Plantücher grauer Felder mit Schnüren von
Rainen voll Steinhaufen und Schlehdornbüschen streckten sich vom
Dorf bis zu den Wäldern. Hin und wieder nur ergossen sich Rinnsale
von Gold in das silbrige Grau/Lupinenfelder breiteten ihre gelben
Flächen voll duftender Blumen, ausgedörrte Strombetten entblößten
ihre weißlichen Sandgründe und müde lagen die sandigen Wege.
Mächtige Pappeln stiegen in Reihen an ihren Rändern langsam die
Hügel empor den fernen Wäldern zu.</p>
<p class="calibre3">Der Priester erwachte aus seiner Versunkenheit, denn ein langes,
klagendes Brüllen ertönte dicht bei ihm. Schreiend flogen die
Krähen auf und flügelten schräg zum Kartoffelland hinüber und ein
schwarzer Schatten huschte ihnen tief unten nach, über Äcker und
Brachen.</p>
<p class="calibre3">Der Priester schützte seine Augen mit der Hand und schaute
sonnenwärts/ein Mädchen, das eine große, rotbraune Kuh am Seil
führte, ging auf dem Weg vorüber, der vom Walde kam; sie bot Gott
zum Gruß, drehte zum Priester hin und wollte ihm die Hand küssen,
aber die Kuh riß sie heftig weg und fing wieder an zu brüllen.</p>
<p class="calibre3">»Geht sie zum Verkauf, was?«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page42" title="Monne3/lac"></a> »Nii ...
zum Müller seinen Bullen ... halt' still, Pestige ... verrücktes
Vieh!« schrie sie nach Atem ringend und versuchte sich
entgegenzustemmen, aber die Kuh riß sie mit, bis sie beide
dahinstoben, was die Lenden hielten und in einer Staubwolke
verschwanden.</p>
<p class="calibre3">Danach schleppte sich schwer über den Sandweg der Lumpenjude; ab
und zu kuschelte er sich hin und ächzte schwer, denn die Karre war
vollgeladen.</p>
<p class="calibre3">»Was gibt's Neues, Mäusche?«</p>
<p class="calibre3">»Was soll's geben? ... Wem's gut geht, bei dem gibt's gut ... De
Kartoffeln sind, Gott Dank, geraten, der Roggen gibt was her, Kohl
wird auch da sein. Wer Roggen hat, wer Kohl hat, wer de Kartoffeln
hat/bei dem gibt's gut!« Er küßte den Ärmel des Priesterrocks,
legte sich in die Gurten der Karre und schob bedächtig weiter, denn
der Weg führte schon über ein leichtes Gefäll hinab.</p>
<p class="calibre3">Dann kam mittwegs, im aufgewirbelten Staub, den er mit seinen
Füßen aufstieben machte, ein blinder Bettler daher, geführt von
einer dicken, an einem Bindfaden vertäuten Töle.</p>
<p class="calibre3">Dann wieder rannte von der Waldseite her ein Junge mit einer
Flasche, der beim Anblick des Priesters am Wegrand in einem großen
Bogen um diesen herum querfeldein zur Schenke lief.</p>
<p class="calibre3">Ein Bauer aus dem Nachbardorf fuhr zur Mühle und eine Jüdin
trieb eine Herde gekaufter Gänse vorüber.</p>
<p class="calibre3">Jeder bot Gott zum Gruß, wechselte ein paar Worte und ging
seines Wegs, begleitet vom wohlwollenden Wort und Blick des
Priesters, der, da die Sonne schon tief stand, sich erhob und
seinem Knecht zurief:</p>
<p class="calibre3">»Bis zu den Birken pflügen, Walek, und dann nach Haus, ... sonst
strapazieren wir die Pferde zu viel.«</p>
<p class="calibre3">Gemächlich ging er über die Feldraine, sprach halblaut das
Gebet, und umfaßte mit einem klaren Blick voll Liebe das Land
...</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page43" title="Teledahner/lac"></a> ...
Reihen roter Frauenröcke leuchteten über dem Kartoffelacker auf ...
das Kollern der eingeschütteten Kartoffeln gegen die Wagenbretter
wurde hörbar ... stellenweise pflügte man noch für die Wintersaat
... Herden buntscheckiger Kühe weideten auf dem Brachland ... und
lange aschfarbene Saatenfelder begannen sich rostrot mit dem
sprießenden Getreide zu färben ... Auf den dürren verschossenen
Wiesen aber schimmerten Gänse, wie weiße Schneeflecken. Irgendwo
muhte eine Kuh ... Es brannten Feldfeuer und lange blaue
Rauchsträhnen zogen über die Erde hin ... Hin und wieder wurde
Wagengeroll hörbar, oder ein Pflug knirschte gegen Steine an. Dann
wiederum umfing auf einen Augenblick Stille das Land, daß man das
hohle Gurgeln des Stromes und das Rollen der Mühle hörte, die sich
hinter dem Dorf im Dickicht der herbstlichen Bäume versteckte ...
Ein Liedchen flog auf, wie ein Ruf von irgendwo, flatterte tief
über die Rillen und Furchen und sank ohne Widerhall im
Herbstdämmer, auf spinnwebgebundene Stoppeln, an öden Wegen, wo die
Ebereschen die blutigen schweren Köpfe neigten. Man eggte einen
Ackerstreifen und ein Schweif hundertjährigen mürben Staubes hob
sich hinter den Eggen auf, zog sich in die Länge hügelan, und
senkte sich. Unter ihm kam, wie aus einer Wolke, ein barfüßiger
Bauer hervor, mit bloßem Kopf und einem quer über den Leib
gebundenen Schurz. Er ging langsam, schöpfte Korn aus dem Leintuch
und säete mit eintöniger, andachtsvoller, segenspendender Gebärde.
Bis an den Feldrand kam er, füllte nach aus einem Sack, kehrte um
und schritt hügelan ... zuerst tauchte sein zerzauster Kopf auf,
dann seine Schultern und schließlich ward er ganz sichtbar auf dem
Sonnenhintergrund mit seiner segnenden Bewegung des Säemanns; mit
dem immer gleichen heiligen Wurf schleuderte er das Korn, das
wirbelnd, wie goldener Staubregen, in die Erde fiel.</p>
<p class="calibre3">Der Priester ging immer langsamer, zuweilen blieb er <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page44" title="Wunibald/DaoH"></a> stehen, um Atem
zu schöpfen, dann blickte er sich nach seinen Schimmeln um, und sah
den Jungen zu, die mit Steinen nach einem gewaltigen Birnbaum
warfen, bis sie allesamt zu ihm hingelaufen kamen, die Hände hinter
dem Rücken versteckend, um seinen Rockärmel zu küssen.</p>
<p class="calibre3">Er strich ihnen über die Köpfe und ermahnte: »Brecht nur nicht
die Äste ab, sonst gibt's nächstes Jahr keine Birnen.«</p>
<p class="calibre3">»Wir werfen nicht wegen den Birnen, aber da is 'n Krähennest,«
ließ sich ein Dreisterer vernehmen.</p>
<p class="calibre3">Gütig lächelnd nickte er und blieb gleich wieder bei den
Kartoffeln ausnehmenden Leuten stehen.</p>
<p class="calibre3">»Der Herr segne die Arbeit!«</p>
<p class="calibre3">»Vergelt's Gott, wir danken schön!« antworteten sie zugleich,
indem sie sich emporreckten und sich alle in Bewegung setzten, um
die Hände des lieben Hochwürden zu küssen.</p>
<p class="calibre3">»Der liebe Gott hat dieses Jahr schöne Kartoffeln wachsen
lassen, was?« sprach er und streckte den Männern die geöffnete
Tabaksdose hin; sie nahmen gewissenhaft und ehrerbietig in kleinen
Prisen, ohne zu wagen, in seiner Gegenwart zu schnupfen.</p>
<p class="calibre3">»Stimmt, groß wie Katzenköpfe sind sie und viele unter dem
Busch.«</p>
<p class="calibre3">»Na, dann werden die Schweine teuer werden, denn jeder wird
mästen wollen.«</p>
<p class="calibre3">»Sind auch so teuer genug; im Sommer sind sie an der Seuche
wegkrepiert und auch nach Preußen kauft man viel.«</p>
<p class="calibre3">»Ist schon wahr. Wem gehören die Kartoffeln hier?«</p>
<p class="calibre3">»Boryna seine.«</p>
<p class="calibre3">»Den Bauern seh' ich nicht, da hab' ich ihn halt nicht aus dem
Haufen erkannt.«</p>
<p class="calibre3">»Vater und Meiner sind in den Wald gefahren.«</p>
<p class="calibre3">»Ach, das seid ihr, Anna, na, wie macht es sich?« wandte er sich
zu der jungen schmucken Frau im Kopftuch, die, da ihre Hand mit
Erde beschmutzt war, mit der Schürze nach seiner langte, um sie
auch zu küssen. <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page45" title="Wunibald/lac"></a></p>
<p class="calibre3">»Wie geht es denn euerm Jungen, den ich zur Erntezeit getauft
habe?«</p>
<p class="calibre3">»Gott Lob und Dank, er wächst auf, Hochwürden, er fängt schon
an, herumzukrabbeln.«</p>
<p class="calibre3">»Nu, dann ... Grüß Gott!«</p>
<p class="calibre3">»Schönen Dank.«</p>
<p class="calibre3">Er wandte sich nach rechts dem Friedhof zu, der noch diesseits
des Dorfes am Pappelweg lag.</p>
<p class="calibre3">Sie sahen noch lange schweigend seiner leicht gebeugt
dahinschreitenden geschmeidigen Gestalt nach, und ihre Jungen
lösten sich erst, als er hinter die niedrige steinerne
Kirchhofsmauer einbog, zwischen Grabhügeln der Kapelle
zuschreitend, die inmitten blaßgelber Birken und roter Ahorne
stand.</p>
<p class="calibre3">»Einen Besseren gibt's wohl nicht in der ganzen Welt,« fing eine
der Weiber an.</p>
<p class="calibre3">»Is wahr, nach der Stadt wollten sie ihn schon haben. Wenn Vater
und der Schulzen nicht um ihn bis zum Bischof gewesen wären, hatten
mer'n auch nicht mehr ... Hackt man zu, Leute, bis Feierabend ist
nicht mehr lange und Kartoffeln noch genug,« sagte Anna, indem sie
ihren Korb auf einen hellen Kartoffelhaufen leerte, der aus der
zerwühlten Erde voll trockener Kartoffelstrünke aufragte.</p>
<p class="calibre3">Sie griffen flink und schweigend zu, so daß man nur das Picken
der Hacken auf der Erdkruste und zuweilen das Aufschlagen des
Eisens gegen einen Kiesel hörte. Ab und zu reckte einer oder der
andere den gebückten, schmerzenden Rücken, atmete tief auf und sah
stumpf dem Saemann im Nachbarfeld zu, grub dann weiter und las die
gelben Kartoffeln vom grauen Boden auf, die er in den nebenan
stehenden Korb warf.</p>
<p class="calibre3">Es war vielleicht ein Dutz Leute, meist alte Weiber und/ Kätner.
Hinter ihnen, an zwei gekreuzten Holzgestellen hingen in geknoteten
weißen Leinentüchern ein paar kleine Kinder, die ab und zu
greinten.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page46" title="joe_ebc/lac"></a> »Die Alte
is nu doch in die Welt gegangen,« leitete die Gusche ein.</p>
<p class="calibre3">»Wer denn?« fragte Anna, sich erhebend.</p>
<p class="calibre3">»Die alte Agathe doch ...«</p>
<p class="calibre3">»Auf den Bettel ...«</p>
<p class="calibre3">»Jawoll, auf den Bettel! Hale, wohl nicht zum Spaß. Hat den
Verwandten die Arbeit gemacht, sich den Sommer über geschunden/nu
kann sie die frische Luft besehen.</p>
<p class="calibre3">Zum Frühjahr kommt sie schon heim, dann bringt sie ihnen in den
Hungersäckelchen Zucker und chinesischen Tee, auch'n paar Groschen
hat sie dann noch über/gleich werden sie sie dann lieben, lassen
sie im eignen Bett unter den Daunen schlafen, für die Arbeit ist
sie dann zu gut, sie braucht Ruhe ... Base und Tante sagen sie ihr
dann, bis sie ihr den letzten Notgroschen abgetrieben haben ... Im
Herbst aber da gibt's keinen Platz mehr, nich im Flur und nich im
Schweinstall. Verdammtes Aaszeug, Hundeverwandtschaft!« spie sie
hervor und eine solche Wut überkam sie, daß ihr Gesicht blau
anlief.</p>
<p class="calibre3">»Ich mein' schon, dem Armen weht der Wind immer in die Augen,«
pflichtete einer der Kätner bei, ein alter, ausgemergelter Bauer
mit einem schiefen Mund.</p>
<p class="calibre3">»Hackt man zu, Leute, hackt man zu,« trieb Anna wieder an, mit
der Wendung, die das Gespräch nahm, nicht zufrieden.</p>
<p class="calibre3">Gusche, die nicht lange aushalten konnte ohne herumzuschwatzen,
sagte, nach einem unweit stehenden Burschen hinüberblickend:</p>
<p class="calibre3">»Die beiden Patschesjungen, das sind schon reichlich alte
Burschen, die Zotteln fangen schon an, ihnen zu sprießen.«</p>
<p class="calibre3">»Und immer noch Junggesellen,« meinte eine andere.</p>
<p class="calibre3">»Und so viele Mädchen werden alt, oder müssen in den Dienst
...«</p>
<p class="calibre3">»Is wahr, und haben doch 'ne ganze halbe Huf' und die kleine
Wiese hinter der Mühle dazu.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page47" title="halei/gary"></a> »Jawohl,
aber wird sie sie heiraten lassen, die Alte ... läßt sie sie mal
locker? ...</p>
<p class="calibre3">Wer würde da die Kühe melken oder die Wäsche spülen, wer würde
die Wirtschaft besorgen und auf die Schweinchen passen ...</p>
<p class="calibre3">Die Mutter muß um ihre Jagna hantieren/die spielt doch schon das
reine gnädige Fräulein, 'ne richtige Gutstochter, immer nur putzen
tut sie sich und waschen und sich im Spiegel angaffen, oder die
Zöpfe flechten.«</p>
<p class="calibre3">»Und paßt nur auf, wen sie sich unters Federbett holt, ob er
auch stark genug ist!« fügte Gusche mit einem bösen Lächeln
bei.</p>
<p class="calibre3">»Jusek Bandcha schickte schon mit Schnaps zu ihr/sie wollte ihn
nicht.«</p>
<p class="calibre3">»Guck einer/die verdammte Marjell!«</p>
<p class="calibre3">»Und die Alsch sitzt den halben Tag in der Kirche, betet aus dem
Gebetbuch und tut von Dorf zu Dorf auf Ablaß gehen, wo es nur
Kirchweih gibt.«</p>
<p class="calibre3">»Is schon so, aber 'ne Hexe is sie auch; und Wawschjons Kühen,
wer hat ihnen die Milch genommen, was? Und als sie Johannes sein'
Jungen beim Pflaumenstehlen erwischt hat, hat sie ihm ein solches
Wort gesagt, daß ihm der Weichselzopf gewachsen ist und alle
Glieder sind ihm krumm geworden, du lieber Gott!«</p>
<p class="calibre3">»Und da soll Gottes Segen über dem Volk sein, wenn solche im
Dorf sitzen ...«</p>
<p class="calibre3">»Und damals, als ich noch Väterchens Kühe hütete, da mein' ich,
hat man solche zum Dorf rausgejagt,« gab Gusche bei.</p>
<p class="calibre3">»Den zweien passiert schon kein Unrecht nicht, die haben schon
welche, die es mit ihnen halten ...,« und die Stimme zum Flüsterton
dämpfend, indem sie nach Anna schielte, die vornbei in der ersten
Furche hackte, tuschelte sie ihren Nachbarinnen zu:</p>
<p class="calibre3">»Der erste dazu, wäre wohl der Anna ihrer, sagt man ... der ist
hinter der Jagna her, wie 'n Hund in seiner Zeit ...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page48" title="halei/gary"></a>
»Jeses/Jeses ... was ihr nicht sagt ... wäre doch die reine Sünd'
und Schand' ...« tuschelten sie beieinander, ohne die Köpfe dabei
zu erheben und emsig weitergrabend.</p>
<p class="calibre3">»Ist er denn der einzige ... wie einer Hündin laufen sie ihr
nach.«</p>
<p class="calibre3">»Schön ist sie, das muß ihr der Neid lassen: und fein rund wie
eine Färse, und die schöne weiße Fratze ... die Augen sind akk'rat
wie Flachsblumen ... und solche Kraft hat sie, daß manch' ein Kerl
nicht gegen ankann ...«</p>
<p class="calibre3">Sie schwiegen eine lange Weile, denn sie mußten die Kartoffeln
auf einen Haufen schütten.</p>
<p class="calibre3">Darauf redeten sie hin und wieder nur ein paar Worte mehr und
schwiegen ganz, als eine von ihnen gewahr wurde, daß vom Dorf her
Borynas Fine über das Stoppelfeld gelaufen kam.</p>
<p class="calibre3">Sie war es tatsächlich und kam schon von weitem schreiend
atemlos angerannt.</p>
<p class="calibre3">»Anna, kommt schnell nach Haus, der Kuh ist was.«</p>
<p class="calibre3">»Jesus Maria/welche denn? ...«</p>
<p class="calibre3">»Die Bunte! ... die Bunte! ... ich kann kaum atmen ...«</p>
<p class="calibre3">»Mein Gott, ich hab' mich ganz verfahren, ich dachte meine,«
rief Anna erleichtert.</p>
<p class="calibre3">»Eben erst hat Witek sie eingetrieben; der Heger hat sie aus dem
Wald gejagt. Ganz verbiestert war sie, sie ist ja so dick ... beim
Kuhstall ist sie gleich umgefallen, nicht mal trinken will sie,
fressen auch nicht, sie wälzt sich hin und her und brüllt immerzu,
daß Gott erbarm'!«</p>
<p class="calibre3">»Is' Vater nicht da?«</p>
<p class="calibre3">»Näh, Vaterchen ist noch nicht zurückgekommen. O Jesus, mein
Jesus, so eine Kuh, die auf einmal gut ein Liter Milch gegeben hat.
Kommt doch man schnell.«</p>
<p class="calibre3">»Ich flieg schon ..., in einem Nu.«</p>
<p class="calibre3">Sie riß das Kind aus dem Leinentuch, stülpte ihm die
Quastenmütze über, wickelte es in die Schürze und eilte rasch
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page49" title="halei/gary"></a> fort. Sie war
so verstört durch diese Nachricht, daß sie nicht einmal den
Beiderwandrock herunterzog, daran dachte sie ganz und gar nicht,
und ihre bis an die Knie bloßen Beine schimmerten weiß gegen den
dunklen Acker. Fine lief voraus.</p>
<p class="calibre3">Indessen schoben sich die kartoffelgrabenden Leute, jeder
breitbeinig über seiner Furche langsam vorwärts und hackten
bedächtiger, denn niemand trieb sie und niemand drängte sie.</p>
<p class="calibre3">Die Sonne rollte schon dem Erdenrande zu, und wie erhitzt vom
raschen Lauf, erglühte sie zu einer purpurnen Radscheibe und sank
in die hohen schwarzen Wälder. Die Dämmerung stieg empor und kroch
über die Felder; sie schob sich durch die Furchen heran, hockte in
den Gräben, staute sich im Dickicht an und ergoß sich leise über
die Erde, da dämpften sich die Farben und erloschen, nur die
Schöpfe der Bäume, die Türme und Dächer der Kirche flammten noch
glühend. Es zogen schon einige von den Feldern heim.</p>
<p class="calibre3">Und Menschenstimmen, Wiehern, Gebrüll, Wagengeratter klangen
immer schärfer durch die stille dämmerumfangene Luft.</p>
<p class="calibre3">Mit erzenem Gezwitscher begann die Betglocke der Kirche das Ave
einzuläuten; die Menschen blieben stehen und das Murmeln der Gebete
sank, wie welke Blätter, in die Dämmerung.</p>
<p class="calibre3">Unter Gesang und frohen Zurufen wurde das Vieh von den Weiden
getrieben; es kam dichtgedrängt in Herden, von Staubwolken
eingehüllt, so daß nur hin und wieder gewaltige Köpfe und
breitgegabelte Hörner sichtbar waren.</p>
<p class="calibre3">Hier und da blökten ein paar Schafe, vom Weideland flatterten
Gänsescharen auf ins Abendrot und ihr durchdringender Schrei
ertönte aus der Luft.</p>
<p class="calibre3">»Wär' doch man schade um die Kuh; was die kalbte!«</p>
<p class="calibre3">»Na ja ... einen Armen hat es nicht getroffen.«</p>
<p class="calibre3">»Immerhin schade, daß so 'n statiöses Vieh so elendiglich
umkommen muß.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page50" title="halei/gary"></a> »Keine
Hausfrau hat Boryna, da sackt alles weg wie durch ein Sieb.«</p>
<p class="calibre3">»Und Anna, ist denn die keine?«</p>
<p class="calibre3">»Für sich selbst ... wie zur Miete sitzen die bei dem Vater, und
daß die nur drauf lauern, was in ihre Tasche fällt, kannst du
denken, und das Väterliche, da kann der Hund für aufkommen.«</p>
<p class="calibre3">»Und Fine, so 'n Kiekindiewelt, was kann die dabei?«</p>
<p class="calibre3">»Na aber, könnte denn auch der Boryna nicht seinen Hof dem Antek
abgeben, ah?«</p>
<p class="calibre3">»Und selbst soll er zu ihnen auf den Altenteil, wie? ... Alt
seid ihr, Laurenz, und noch immer dumm bis in die Klamotten,«
begann Gusche lebhaft. »Hoho, der alte Boryna, der stellt noch
seinen Mann; der kann sich noch verheiraten. Dumm wäre er, wenn er
was seinen Kindern abschriebe.«</p>
<p class="calibre3">»Na ja ...a, kräftig is er schon, aber sechzig Jahre.«</p>
<p class="calibre3">»Brauchst keine Angst zu haben, Laurenz, jede Junge nimmt den,
laß ihn nur ein Wort sagen.«</p>
<p class="calibre3">»Zwei Frauen hat er schon begraben.«</p>
<p class="calibre3">»Laß ihn auch die dritte mit Gottes Hilfe begraben, aber den
Kindern, solange er lebt ... kein Stückchen, keinen Fetzen, nicht
mal so viel, wie einer unter dem Pantoffel hat. Aaspack, dem käm's,
wie meine mir. Einen Altenteil würden sie ihm geben, auf Arbeit
könnte er dann gehen, verhungern oder den Bettelstock nehmen. Gib's
nur her, was du hast, deinen Kindern, die werden's dir schon
vergelten, das reicht dann für ein Stricklein, oder für 'n Stein um
den Hals ...«</p>
<p class="calibre3">»Nach Hause, Leute, 's wird schon dunkel.«</p>
<p class="calibre3">»Jaja, und die Sonne ist auch weg.«</p>
<p class="calibre3">Sie sammelten rasch die Hacken und Körbe, nahmen ihre
Zweiertöpfe auf, die vom Mittagsessen noch da waren, und gingen im
Gänsemarsch miteinander redend den Feldrain entlang; nur die alte
Gusche schrie immer noch wütend <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page51" title="halei/gary"></a> über ihre Kinder und fluchte zu guter Letzt auf
die ganze Welt.</p>
<p class="calibre3">Neben ihnen im gleichen Schritt trieb ein Mädchen eine Sau mit
ihren Ferkeln und sang mit dünnem Stimmchen:</p>
<p class="vers">Aj, geh nicht um den Wagen,<br class="calibre2"/>
Aj, halt dich nicht ans Rad,<br class="calibre2"/>
Aj, gib dem Mann kein Küßlein,<br class="calibre2"/>
Aj, wenn er selbst gebeten hat.</p>
<p class="calibre3">»Tä, Dumme, schreit, als ob man ihr die Haut abschälte.«</p>
<p class="pcalibre6 initial1">Auf Borynas Hof, der von drei
Seiten mit Wirtschaftsgebäuden umstellt war und den von der vierten
ein Obstgarten von der Dorfstraße trennte, hatte sich schon viel
Volk angesammelt; ein paar Weiber beratschlagten und gestikulierten
wegen einer gewaltigen rotweißen Kuh, die auf einem Misthaufen vor
dem Kuhstall lag.</p>
<p class="calibre3">Ein alter, etwas lahmer Hund mit glatzigen Flanken umkreiste die
Bunte, beroch sie und bellte. Dann jagte er die Kinder, die
neugierig am Zaun hingen, von der Einfahrt zwischen die Hecken
zurück und versuchte sich an eine Sau heranzupirschen, die sich an
die Wand des Wohnhauses lang ausgestreckt hingelegt hatte und leise
stöhnte, denn die jungen, weißen Ferkel sogen an ihr.</p>
<p class="calibre3">Gerade stürzte Anna atemlos heran, warf sich auf die Kuh und
fing an, ihren Kopf und ihr Maul zu streicheln.</p>
<p class="calibre3">»Bunte, arme Bunte!« rief sie weinerlich und brach in ein
Schluchzen und Wehklagen aus.</p>
<p class="calibre3">Die Frauen aber beratschlagten immer wieder über neue
Rettungsversuche für die Kranke; einmal goß man ihr Salzlauge in
den Hals, dann geschmolzenes Wachs von einer geweihten Kerze in
Milch zerlassen; eine riet Molken mit grüner Seife/eine andere
schrie, daß man sie zur Ader lassen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page52" title="halei/gary"></a> sollte/doch der Kuh wollte nichts helfen,
sie streckte sich immer länger, hob nur von Zeit zu Zeit den Kopf
hoch und brüllte gedehnt und schmerzlich, wie nach Rettung; ihre
schönen, rosig umrandeten Augen begannen sich neblig zu trüben und
der schwere gehörnte Kopf fiel zurück vor Ermattung. Sie streckte
die Zunge aus und leckte Annas Hände.</p>
<p class="calibre3">»Vielleicht würde Ambrosius helfen?« schlug eine vor.</p>
<p class="calibre3">»Hast recht, der kennt sich auf Krankheit aus,« bestätigte
man.</p>
<p class="calibre3">»Lauf, Fine. Soeben haben sie das Ave ausgeläutet, da muß er
noch bei der Kirche sein. Herr, du meine Güte, wenn Vater kommt,
wird das ein Fluchen werden. Wir haben aber doch keine Schuld,«
klagte sie weinerlich.</p>
<p class="calibre3">Dann setzte sie sich auf die Schwelle des Kuhstalls, streckte
dem plärrenden Jungen die weiße volle Brust hin und blickte mit
schreckhafter Angst bald auf die röchelnde Kuh, bald aufhorchend
auf den Weg zwischen den Hecken.</p>
<p class="calibre3">In der Dauer von ein bis zwei Paternostern kam Fine mit Geschrei
zurück/Ambrosius käme schon.</p>
<p class="calibre3">Und wirklich kam er gleich hinterdrein, ein vielleicht
hundertjähriger Alter, gerade wie eine Kerze, obgleich er einen
Stelzfuß hatte und am Stocke ging. Sein Gesicht war trocken und
runzlig wie eine Kartoffel im Frühjahr und von derselben grauen
Farbe. Es war glatt ausrasiert und voller Hiebnarben. Sein Haar war
milchweiß und fiel in Strähnen auf Stirn und Nacken, denn er kam
bloßköpfig daher.</p>
<p class="calibre3">Er trat geradewegs auf die Kuh zu und besah sie sich
eingehend.</p>
<p class="calibre3">»Oho, ich seh schon, daß ihr frisches Fleisch kriegt.«</p>
<p class="calibre3">»Helft ihr man, kuriert sie doch, die Kuh ist ja die dreihundert
Silberlinge wert/und eben erst nach dem Kalben, helft doch.«</p>
<p class="calibre3">»Oh Jesus/Jesus!« rief Fine.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page53" title="Frank_9901/gary"></a>
Ambrosius holte aus der Tasche ein Aderlaßmesser, wetzte es am
Stiefelschaft, hielt die Spitze gegen das Abendlicht und
durchschnitt der Bunten die Arterien unter dem Bauch / aber das
Blut spritzte nicht, es trat nur langsam, schwarz und schaumig
hervor.</p>
<p class="calibre3">Sie standen alle vorgebeugt ringsherum und sahen mit verhaltenem
Atem zu.</p>
<p class="calibre3">»Zu spät! Oho, das Viecherl läßt schon den letzten Atem von
sich,« sagte Ambrosius mit Feierlichkeit. »Das ist gewiß die böse
Seuche oder etwas anderes ... man sollte gleich, wie sie krank
wurde ... aber diese Frauenzimmer, die haben nur den Verstand zum
Weinen, das Aaszeug, wenn man helfen soll, dann blöken sie, wie die
Schafe.« Er spuckte verächtlich aus, ging um die Kuh herum, sah ihr
in die Augen, betrachtete die Junge, wischte die blutigen Hände an
ihrem weichen glänzenden Fell ab und schickte sich an,
fortzugehen.</p>
<p class="calibre3">»Zu diesem Begräbnis werde ich euch nicht läuten; das Geläut
macht ihr schon selbst mit den Pötten.«</p>
<p class="calibre3">»Der Vater und Antek!« rief Fine und rannte auf den Weg hinaus
ihnen entgegen, denn ein dumpfes, schweres Rollen ließ sich von der
anderen Seite des Weihers her vernehmen, wo in dem vom Abendlicht
rotleuchtenden Staub ein länglicher, mit ein paar Pferden
bespannter Wagen sichtbar wurde.</p>
<p class="calibre3">»Vater, da ... die Bunte tut verrecken!« Boryna bog gerade mit
dem Wagen um den Weiher; Antek schob hinten nach, denn sie hatten
eine lange Fichte aufgeladen.</p>
<p class="calibre3">»Red' nicht Unnützes,« brummte er, die Pferde antreibend.</p>
<p class="calibre3">»Ambrosius hat sie zur Ader gelassen und gar nichts ...
geschmolzenes Wachs hat man ihr in die Gurgel gegossen, auch nichts
... und Salz ... und alles nichts ... das ist gewiß die schlimme
Seuche ... Witek sagte, der Heger hat sie aus dem Weidewald gejagt,
und die Bunte hätte sich immer hingelegt und gestöhnt, bis er sie
hergekriegt hat ...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page54" title="Frank_9901/gary"></a> »Die
Bunte, die beste Kuh, daß ihr die Kränke kriegt, Saupack,
verdammtes, so wird hier aufgepaßt«; er warf dem Sohn die Zügel hin
und lief mit der Peitsche in der Hand voraus.</p>
<p class="calibre3">Die Weiber traten auseinander, und Witek, der die ganze Zeitlang
vor dem Wohnhaus an irgend etwas herumgebastelt hatte, sprang aus
lauter Angst davon und verschwand im Garten, selbst Anna erhob sich
und stand ratlos und verängstigt da.</p>
<p class="calibre3">»Zuschanden haben sie mir das Tier gemacht,« ... rief der Bauer
schließlich aus, nachdem er die Kuh besichtigt hatte! »Dreihundert
Silberlinge rein in den Dreck geschmissen!/ Zum Fressen da sind die
Biester da, die ganze Stube voll, aber Obacht geben, das gibt's
nicht. So 'ne Kuh, so 'ne Kuh! Nicht aus dem Haus raus kann man,
gleich kommt Verlust und Schaden draus ...«</p>
<p class="calibre3">»Schon von Mittag an war ich doch beim Kartoffelausnehmen,«
entschuldigte sich Anna leise.</p>
<p class="calibre3">»Wenn du doch einmal was sehen tätest!« schrie er wütend. »Aber
geht dich das an, was meins ist?« /</p>
<p class="calibre3">»So 'ne Kuh, so 'n Prachtstück, 'ne zweite, wie die, könnte man
auf dem Gutshof suchen!«</p>
<p class="calibre3">Er fluchte immer erbitterter, ging um die Kuh herum, versuchte
sie zu heben, zog sie am Schwanz, guckte ihr in die Zähne, aber das
Tier atmete röchelnd und immer mühevoller, selbst das Blut hörte
auf zu fließen und gerann langsam zu schwarzen, krustigen
Schlacken/sie lag augenscheinlich schon in den letzten Zügen.</p>
<p class="calibre3">»Nichts zu machen, man muß sie notschlachten, wenigstens das
'rausschlagen!« sagte er schließlich, holte eine Sense aus der
Scheune, wetzte sie schnell an einem Schleifstein, der unter der
Dachtraufe des Kuhstalls stand, zog seinen Spencer aus, krämpte die
Hemdsärmel hoch und machte sich ans Schlachten ...</p>
<p class="calibre3">Anna und Fine heulten los, denn die Bunte erhob mühevoll den
Kopf, als ob sie den nahen Tod fühlte, brüllte <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page55" title="Frank_9901/gary"></a> dumpf auf und fiel mit
durchschnittener Gurgel zurück, nur noch mit den Beinen strampelnd
...</p>
<p class="calibre3">Der Hund leckte das an der Luft gerinnende Blut und sprang
darauf nach den Kartoffelgruben, die Pferde anbellend, die mit dem
Wagen vor der Umzäunung stehengeblieben waren. Antek hatte sie dort
gelassen und sah gleichgültig dem Schlachten zu.</p>
<p class="calibre3">»Heul' nicht, dumme Trine! Was geht uns Vaters Kuh an, ist doch
nicht unser Verlust!« sagte er giftig zu seiner Frau und ging an
das Ausspannen und Abschirren der Pferde, die Witek eifrig an den
Mähnen in den Stall zerrte.</p>
<p class="calibre3">»Viel Kartoffeln auf dem Feld?« fragte Boryna, die Hände am
Brunnen waschend.</p>
<p class="calibre3">»Weiß Gott, nicht wenig, an die zwanzig Säcke wird's wohl
machen.«</p>
<p class="calibre3">»Die müssen heut noch rein.«</p>
<p class="calibre3">»Dann fahr' sie selbst ein, ich fühl' schon meine eigenen Füße
nicht mehr, meinen Rücken auch nicht ... und das Handpferd lahmt
auf dem Vorderfuß.«</p>
<p class="calibre3">»Fine, ruf' mal den Jakob her vom Kartoffelfeld, mag er dafür
das Jungpferd vorspannen, es muß heute eingefahren werden. / Es
kann Regen geben.«</p>
<p class="calibre3">Es siedete in ihm vor Wut und Ärger, und immer wieder blieb er
vor der Kuh stehen und fluchte gallig, dann machte er sich auf dem
Hof zu schaffen, guckte in den Kuhstall, in die Scheuer, in den
Schuppen und wußte selbst nicht, was er suchte; der Verlust fraß an
ihm.</p>
<p class="calibre3">»Witek! Witek!« brüllte er mit einem Male und schnallte den
breiten Riemen von den Hüften los, aber der Junge blieb
verschwunden.</p>
<p class="calibre3">Die Leute verzogen sich, denn sie begriffen, daß ein solcher
Schade, eine solche Verdrießlichkeit mit Prügeln enden mußte, um so
mehr da Boryna meist schnell damit zur Hand war, aber der Alte
fluchte heute nur und ging in die Stube.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page56" title="gary/Pirki"></a> »Anna, das
Essen her!« herrschte er die Schwiegertochter durchs offene Fenster
an und ging auf seine Seite.</p>
<p class="calibre3">Das Haus war ein landläufiges Bauernhaus/in der Mitte durch eine
große Diele getrennt; seine Giebelseite ging auf den Hof und die
vierfenstrige Front schaute nach dem Obstgarten und auf die
Straße.</p>
<p class="calibre3">Die eine Seite, nach dem Garten zu, nahm Boryna mit Fine ein,
auf der anderen saß Antek und seine Frau. Der Knecht und der
Hirtenjunge schliefen bei den Pferden.</p>
<p class="calibre3">In der Stube war es schon dämmerig, denn durch die kleinen
Fensterchen, die von der Dachtraufe beschattet wurden und vor denen
die Bäume buschig wuchsen, kam wenig Licht herein, außerdem
dunkelte es schon draußen; nur die Gläser auf den Heiligenbildern,
die auf der geweißten Wand eine schwarze Reihe bildeten,
schimmerten noch. Die Stube war groß, aber von einer
rußgeschwärzten Balkendecke niedergedrückt und so mit allerhand
Hausrat vollgestellt, daß man nur um den großen, an der Flurwand
stehenden Herd herum mit seinem mächtigen Rauchfang darüber etwas
freien Platz hatte.</p>
<p class="calibre3">Boryna zog die Stiefel aus und trat in die dunkle Buze hinein,
die Tür hinter sich schließend; von der kleinen Fensterscheibe
schob er das Brett zurück, so daß das Abendlicht mit blutigem
Schein den Raum erleuchtete.</p>
<p class="calibre3">Die Buze war voll Kram und Wirtschaftsgeräten, auf querlaufenden
Stangen hingen Schafspelze, rote gestreifte Beiderwandröcke, weiße
Haartuchkittel, ganze Raspeln grauer Garne, zu Ballen
zusammengerollte schmutzige Schaffließe und Säcke voll Daunen. Er
holte einen weißen Haartuchkittel und einen roten geflochtenen
Hanfgürtel hervor und suchte darauf lange in den mit Getreide
gefüllten Tonnen herum, dann wieder in einem Haufen alten Eisens
und alter Riemen; als er jedoch Anna in der Vorderstube hantieren
hörte, zog er das Brett über das kleine Fenster und scharrte noch
lange im Korn. <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page57" title="gary/Pirki"></a>
Auf der Bank vor dem Fenster dampfte schon das Essen; aus dem
gewaltigen Tiegel voll Kohl verbreitete sich der Duft von
geröstetem Speck; auch nach Rühreiern roch es, wovon eine nicht
kleine Schüssel daneben stand.</p>
<p class="calibre3">»Wo hat Witek die Kühe gehütet?« fragte er, eine mächtige
Schnitte von einem Brotlaib schneidend, der so groß war, wie ein
Getreidesieb.</p>
<p class="calibre3">»Im Weidewald, im Gutsbezirk, der Heger hat sie verjagt.«</p>
<p class="calibre3">»Aasbiester, <span class="spaced">die</span> haben mir das Tier
zuschanden gerichtet.«</p>
<p class="calibre3">»Selbstredend, so 'ne große Kuh, die hat sich verhitzt bei dem
Getreibe, 'n Brand hat sie gekriegt.«</p>
<p class="calibre3">»Das Lumpenpack. Der Weidewald gehört uns, das steht deutlich
wie 'n Ochs im Grundbuch, und die tun nichts als 'rausjagen und
meinen, es sei ihrer.«</p>
<p class="calibre3">»Die anderen haben sie auch 'rausgejagt und Waleks Jungen hat er
verprügelt und wie geprügelt ...«</p>
<p class="calibre3">»Ha! da muß man vors Gericht und zum Kommissar. Dreihundert
Silberlinge ist sie wert, mindestens!«</p>
<p class="calibre3">»Gewiß!« versicherte sie, froh, daß der Vater sich
zufriedengegeben hatte.</p>
<p class="calibre3">»Sag' Antek, wenn sie die Kartoffeln eingefahren haben, sollen
sie sich gleich an die Kuh heranmachen, man muß sie häuten und
zerlegen. Wenn ich vom Schulzen heimkomme, will ich euch helfen. In
der Banse am Balken soll man sie aufhängen/das wird sicherer sein
vor den Hunden oder sonst welchem Viehzeug ...«</p>
<p class="calibre3">Er war bald mit dem Essen fertig und stand auf, um sich
zurechtzumachen, aber er fühlte eine solche Trägheit in sich, ein
solches Ziehen in den Knochen, eine solche Schläfrigkeit, daß er,
so wie er dastand, sich aufs Bett warf, um etwas zu schlafen.</p>
<p class="calibre3">Anna ging auf ihre Seite zurück und wirtschaftete in der Stube,
sich von Zeit zu Zeit hinauslehnend, um nach Antek <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page58" title="gary/Pirki"></a> zu sehen, der auf der Veranda
vor dem Haus sein Essen bekommen hatte. Er war von der Schüssel
abgerückt, wie es Brauch ist, und schlürfte Löffel auf Löffel,
indem er laut gegen die gerillte Schüssel kratzte und gelegentlich
vor sich hin auf den Weiher starrte. Dort lag die Abendröte und es
entstanden auf dem Wasser gold-purpurne Regenbogen und flammende
Kreise, durch die, gleich weißen Wölklein, die Gänse schnatternd
hindurchschwammen, Schnüre blutroter Perlen aus den Schnäbeln
vergießend.</p>
<p class="calibre3">Im Dorf fing es an, sich zu regen und zu wimmeln; auf dem Wege
um den Weiher herum erhoben sich ständig Staubwolken, erklang
Wagengerassel und das Brüllen der Kühe, die bis an die Knie ins
Wasser stiegen, langsam tranken und die schweren Köpfe
aufrichteten, daß ihnen dünne Wasserrinnsale, gleich opalfarbenen
Peitschenschnüren aus den breiten Mäulern herunterrannen.</p>
<p class="calibre3">Irgendwo vom anderen Ende des Weihers knatterten die
Waschschlegel der Wäscherinnen, und dumpf und eintönig klang von
einer fernen Scheune herüber das Aufschlagen der Dreschflegel.</p>
<p class="calibre3">»Antek, hack' mir etwas Holz, denn allein werde ich nicht
fertig,« bat sie schüchtern und ängstlich; denn er machte sich
nichts daraus, zu fluchen oder zuzuschlagen aus dem ersten besten
Anlaß.</p>
<p class="calibre3">Nicht einmal antworten tat er, als hätte er nichts gehört, so
daß sie sich gar nicht mehr traute, noch etwas zu sagen und selbst
hinging, von den Holzklötzen Holz abzuspalten; er aber schwieg
verärgert, von der Tagesarbeit erschöpft und blickte jetzt nach dem
jenseitigen Ufer auf ein Haus, dessen weiße Wände und
Fensterscheiben leuchteten, denn es stand gegen das Abendlicht.
Büschel roter Georginen sah er, die sich über die steinerne
Gartenmauer lehnten und grell auf dem Hintergründe der Wände
brannten, und vor dem Haus, einmal im Obstgarten, einmal zwischen
den Hecken bewegte sich geschäftig eine hohe Gestalt <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page59" title="gary/Pirki"></a> /das Gesicht konnte man nicht
erkennen, denn jeden Augenblick verschwand sie im Hausflur oder
unter den Bäumen.</p>
<p class="calibre3">»Der schläft wie 'n Gutsherr, und du arbeite man gefälligst, wie
'n Knecht,« murrte er böse auf, denn das väterliche Schnarchen
drang bis auf die Veranda.</p>
<p class="calibre3">Er ging auf den Hof und besah sich nochmals die Kuh.</p>
<p class="calibre3">»Das ist recht, Vater seine Kuh ist es, aber auch unser
Verlust,« sagte er zu seiner Frau, die, da Jakob die Kartoffeln vom
Feld eingefahren hatte, das Holzspalten aufgab und sich dem Wagen
näherte.</p>
<p class="calibre3">»Die Kartoffelgruben sind noch nicht in Ordnung, da muß man auf
die Tenne abladen.«</p>
<p class="calibre3">»Vater sagt doch, du sollst auf der Tenne die Kuh häuten und
ausweiden.«</p>
<p class="calibre3">»Die Kuh wird Platz haben und die Kartoffeln auch,« brummelte
Jakob, indem er die Scheunentür sperrangelweit aufstieß.</p>
<p class="calibre3">»Ich bin kein Schinder, daß ich dazu da bin, der Kuh die Haut
abzuziehen,« warf Antek ein.</p>
<p class="calibre3">Sie sprachen nichts weiter, man hörte nur das Kullern der
Kartoffeln, die auf die Tenne geschüttet wurden.</p>
<p class="calibre3">Die Sonne war erloschen, es wurde Abend, das letzte Rot
leuchtete noch wie Lachen geronnenen Blutes und erstarrten Goldes.
Der Weiher war wie mit Kupferstaub bestreut und die stillen
Gewässer zuckten unter rostigen Schuppen im schläfrigen
Gemurmel.</p>
<p class="calibre3">Das Dorf versank in Dunkelheit, in die tiefe, tote Stille eines
Herbstabends. Die Bauernhäuser wurden kleiner, als ob sie sich zur
Erde duckten, als schmiegten sie sich gegen die schlaftrunken
geneigten Bäume und grauen Hecken.</p>
<p class="calibre3">Antek und Jakob waren mit dem Einfahren der Kartoffeln
beschäftigt, während Anna und Fine die Wirtschaft besorgten. Die
Gänse sollten noch zur Nacht eingetrieben werden und die Schweine
gefüttert, die sich mit Gequieke auf die <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page60" title="gary/Pirki"></a> Diele drängten und die gefräßigen
Rüssel in die Zuber steckten, worin der Drank für das Vieh war.</p>
<p class="calibre3">Die Kühe mußten auch gemolken werden, denn gerade hatte Witek
die letzten von der Weide heimgetrieben und legte jeder einen Arm
voll Heu in die Raufe, damit sie stillhielten beim Melken.</p>
<p class="calibre3">Fine setzte sich gerade zurecht, die erste vom Rande zu melken,
als Witek unter der Krippe hervorkroch leise und ängstlich
fragend:</p>
<p class="calibre3">»Fine, is der Bauer bös? ...«</p>
<p class="calibre3">»Du lieber Himmel, prügeln wird er dich, armer Kerl ... was hat
er geflucht,« antwortete sie, den Kopf zum Licht wegdrehend und
dabei mit der Hand das Gesicht schützend, weil die Kuh der Fliegen
wegen mit dem Schweif gegen die Flanken klatschte.</p>
<p class="calibre3">»Ich ... kann ich denn was dafür ... Der Heger hat mich doch
rausgetrieben und wollte noch mit dem Stock nach mir schlagen, aber
ich bin gelaufen ... und die Bunte hat sich doch gleich hingelegt
und gebrüllt und gestöhnt, so daß ich sie gleich heimgetrieben habe
...«</p>
<p class="calibre3">Er schwieg; man hörte nur ein stilles, banges Schluchzen und
Schneuzen.</p>
<p class="calibre3">»Witek ... Hab' dich doch nicht wie 'n Kalb, ist doch nicht das
erstemal, daß Vater dich verwichst...«</p>
<p class="calibre3">»Nein, nicht zum erstenmal, aber ich hab' doch solche Angst ...
von wegen weil ich keine Ausdauer hab' ...«</p>
<p class="calibre3">»Bist dumm, wird schon bald ein Knecht und hat Angst ... ich
werd's Väterchen schon stecken ...«</p>
<p class="calibre3">»Willst du das, Fine?« rief er freudig aus, »das war doch der
Heger, der hat mich mit den Kühen weggejagt/das war doch ...«</p>
<p class="calibre3">»Ich werd's schon stecken, Witek, brauchst keine Angst zu haben!
...«</p>
<p class="calibre3">»Wenn es so ist ... dann hast du hier den Vogel!« flüsterte er
freudig erregt und zog unter der Jacke ein hölzernes <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page61" title="gary/Pirki"></a> Wunderwerk hervor. »Guck nur,
wie er sich von selbst bewegt.«</p>
<p class="calibre3">Er stellte sein Geschenk auf die Schwelle des Kuhstalls, drehte
es auf und der Vogel fing an zu wackeln, die langen Beine zu heben
und zu marschieren ...</p>
<p class="calibre3">»Jesus, 'n Storch, der ist ja ganz wie lebendig!« schrie sie
erstaunt, stellte die Melkgelte beiseite, hockte vor der Schwelle
nieder und sah ganz glückselig und bewundernd zu.</p>
<p class="calibre3">»Jesus! bist du ein Mechanikus! und bewegt er sich denn von
selbst so, äh? ...«</p>
<p class="calibre3">»Doch, von selbst, Fine, nur mit dem Hölzchen muß ich ihn
aufdrehen, dann spaziert er wie 'n Gutsherr nach dem Mittagessen/da
...,« er drehte ihn um, und der Vogel streckte ernst und komisch
seinen langen Hals, hob die Beine und spazierte.</p>
<p class="calibre3">Sie lachten beide herzhaft und ergötzten sich an seinen
Bewegungen, zuweilen nur hob Fine die Augen und sah den Jungen voll
Staunen und Bewunderung an.</p>
<p class="calibre3">»Fine!« ertönte die Stimme Borynas vor dem Wohnhaus.</p>
<p class="calibre3">»Was denn?« ... schrie sie zurück.</p>
<p class="calibre3">»Komm mal her.«</p>
<p class="calibre3">»Wir melken doch.«</p>
<p class="calibre3">»Paß hier auf, ich gehe zum Schulzen hinüber,« sagte er, den
Kopf in den dunklen Kuhstall steckend, »hast du nicht dieses
aufgelesene Landstraßenbalg gesehen, ha?«</p>
<p class="calibre3">»Witek?/ni, der is mit Antek auf'm Kartoffelfeld, denn Jakob
soll Häcksel schneiden ...,« sie antwortete schnell und etwas
ängstlich, denn Witek verkroch sich aus Angst hinter ihrem
Rücken.</p>
<p class="calibre3">»Aas von Junge, nur in Stücke reißen, so eine Kuh zu ruinieren,«
brummte er, in die Stube zurückgehend, wo er den neuen weißen
Tuchrock anzog, der an allen Nähten entlang mit schwarzem
Litzenmuster benäht war, suchte den hohen spitzen Filzhut mit der
roten Kokarde hervor, wickelte <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page62" title="Monne3/gary"></a> dazu den roten Gürtel um und entfernte sich über
den Weg am Weiher in der Richtung der Mühle.</p>
<p class="calibre3">»So viel Arbeit noch ... Das Holz ist noch nicht eingefahren ...
die Saat nicht beendigt ... der Kohl draußen ... die Nadelstreu
nicht zusammengeharkt ... für die Kartoffeln muß gepflügt werden
... auch für'n Hafer müßte man ... und du fahr man zum Gericht ...
Herr Gott, daß man die Arbeit nie fertigkriegt, immer nur wie'n
Ochs im Joch ... nicht ausschlafen, nicht ausruhen kann unsereiner
...,« sinnierte er ... »Und dazu nun noch Gericht ... Aasschlampe,
sieh einer an, ich mit der schlafen ... daß dir die Zunge verdorrt
... Lumpentrine ... Metze ...,« er spuckte wütend aus, pfropfte die
kleine Pfeife mit Knaster voll und rieb die feuchtgewordenen
Streichhölzer lange gegen die Hose, bevor er sie in Brand setzen
konnte.</p>
<p class="calibre3">In Abständen paffend schleppte er sich langsam vorwärts; alle
Glieder schmerzten ihm und der Verdruß wegen der Kuh machte ihn
mißmutig und zog ihm durch alle Knochen.</p>
<p class="calibre3">»Und den Arger kann man sich nicht einmal wegprügeln oder
ausklagen, nichts ... wie 'n einsamer Pflock ist man auf der Welt;
alles muß man selbst bedenken, über alles mit seinem eigenen Kopf
deliberieren, hinter allem selbst her sein, wie ein Hofhund ...
reden kann man mit niemand ein Wort und von nirgends 'n Rat und 'ne
Hilfe / nur Schaden und Verlust allenthalben ... und die ganze
Gesellschaft, wie Wölfe um ein Schaf herum ... die zerren nach
allen Seiten und lauem nur, wenn sie einen in Stücke reißen
...«</p>
<p class="calibre3">Im Dorf war es schon dunkel, in den warmen Abend quollen durch
die angelehnten Türen und Fenster Flackerscheine der Herdfeuer, der
Duft gekochter Kartoffeln und saurer Mehlsuppen mit Speckgrieben;
hier und bei verzehrte man das Nachtmahl auf den Dielen oder selbst
vor den Häusern, daß man von überall das Kratzen der Löffel und die
Stimmen der Menschen hörte.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page63" title="rudi49/gary"></a> Boryna
ging immer langsamer, die Erbitterung machte ihn schwerfällig, und
dann fuhr ihm die Erinnerung an die im Frühjahr Verstorbene an die
Gurgel ...</p>
<p class="calibre3">»Ho! ho! ... bei der/möge sie unberufen in Frieden ruhn/wär' das
der Bunten nicht passiert ... das war 'ne Bäuerin! ... Gewiß, ein
Schandmaul hatte sie und eine böse Zunge, ein gutes Wort hat sie
niemandem gegönnt, mit den Weibern hat sie sich immerzu in den
Haaren gelegen ... aber die Ehefrau war es immerhin doch und 'ne
gute Hausfrau!« Hier seufzte er auf mit frommem Wunsch für ihr
Seelenheil und eine noch größere Betrübnis legte sich auf ihn, denn
er gedachte dessen, wie es einstmals gewesen war.</p>
<p class="calibre3">Kam er von der Arbeit nach Hause, abgearbeitet/dann hielt sie
fettes Essen bereit, und oft und manch einmal steckte sie ihm
hinter dem Rücken der Kinder noch sein gutes Stück Wurst zu ... Und
wie gedieh da alles! ... Die Kälber und die schönen Gänse und die
Ferkel ... zu jedem Jahrmarkt hatte man was mit zur Stadt zu fahren
und bar Geld war immer da, allein vom Jungvieh schon... Und was
Kohl mit Erbsen ist/so wie die kann das 'ne andere gar nicht
...</p>
<p class="calibre3">Und jetzt was? ...</p>
<p class="calibre3">Antek zerrt was er kann, der Schmied lungert auch nur herum, was
er in die Krallen kriegt, und Fine? Die dumme Dirn', hat doch nur
Streu im Kopf. Is ja auch man erst an die Zehn, was 'n Wunder da
... Anna kreucht herum wie 'ne Nachteule und ist immerlos krank und
was die tut, ist gerade so viel wert, wie das, was sich der Hund
zusammenheult.</p>
<p class="calibre3">So geht alles zugrunde ... die Bunte mußte geschlachtet werden
... in der Erntezeit ist ein Mastschwein krepiert ... die Krähen
sind zwischen die Gössel gekommen, kaum die Hälfte ist
übriggeblieben! ... So viel vergeudet, so viel zuschanden gemacht!
... Alles rinnt wie durch ein Sieb ... wie durch ein Sieb ...</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page64" title="lac/gary"></a> »Aber ich
duld' es nicht!« schrie er fast laut; »solange ich noch auf den
Klumpen stehe, will ich keinen Morgen Land abschreiben! Das is mal
sicher, auf den Altenteil geh ich zu euch nicht ...</p>
<p class="calibre3">Soll mir erst mal der Gschela vom Militär heimkommen, dann kann
Antek auf Anna ihren paar Morgen wirtschaften ... ich duld' es
nicht ...«</p>
<p class="calibre3">»Gelobt sei Jesus Christus,« ertönte eine Stimme.</p>
<p class="calibre3">»In Ewigkeit,« ... antwortete er gewohnheitsmäßig und bog von
der Straße in einen langen Heckenweg ein, in dessen Hintergrund das
Gewese des Schulzen lag.</p>
<p class="calibre3">In den Fenstern war Licht und die Hunde schlugen an.</p>
<p class="calibre3">Er trat geradeswegs in die Giebelstube ein.</p>
<p class="calibre3">»Der Schulze da?« fragte er eine dicke Frau, die vor einer Wiege
niedergekniet war und einem Kind die Brust gab.</p>
<p class="calibre3">»Der kommt gleich, ist nur 'raus, um die Kartoffeln einzufahren.
Setzt euch so lange, Matheus, is schon nichts zu machen dazu,
dieser wartet auch,« mit einer Bewegung des Kinns wies sie nach
einem Bettler, der neben dem Herd saß; das war jener alte blinde
Bettler, der von einem Hund geführt wurde; das rötliche Licht der
Scheite umfloß grell sein gewaltiges ausrasiertes Gesicht, seinen
nackten Schädel und seine weit aufgerissenen Augen, die mit einer
weißen Haut überzogen waren und unbeweglich unter den greisen,
buschigen Augenbrauen saßen ...</p>
<p class="calibre3">»Woher kommt ihr mit Gottes Hilfe?« fragte Boryna, sich an die
andere Seite des Feuers setzend.</p>
<p class="calibre3">»Aus der Welt, Bauer, woher denn sonst,« erwiderte er langsam
mit seiner breiten, kläglichen Bettelstimme und spitzte fleißig die
Ohren, die Tabakdose hervorholend.</p>
<p class="calibre3">»Langt zu, Bauer.«</p>
<p class="calibre3">Matheus nahm eine kräftige Prise und nieste dreimal
hintereinander, so daß ihm die Tränen in die Augen kamen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page65" title="lac/gary"></a> »Starkes
Zeug!« und er wischte mit dem Ärmel über die tränenden Augen.</p>
<p class="calibre3">»Gut bekomm's. Petersburgischer, is gut auf die Augen.«</p>
<p class="calibre3">»Kehrt morgen bei mir ein, eine Kuh hab' ich notgeschlachtet, da
findet sich für euch schon 'n Bissen.«</p>
<p class="calibre3">»Gott lohn's ... Boryna, scheint mir, was?«</p>
<p class="calibre3">»Freilich, daß ihr das aber erkannt habt? ... he, he.«</p>
<p class="calibre3">»Noch der Stimme nur, nach dem Reden.«</p>
<p class="calibre3">»Was gibt's denn so in der Welt? Ihr seid doch immerzu
unterwegs.«</p>
<p class="calibre3">»Du lieber Gott, was es wohl geben kann. Einmal schlecht, einmal
gut, einmal verschieden, rote immer in der Welt. Und alle pfeifen
aus dem letzten Loch und jammern, wenn es sein muß, dem Bettler was
zu geben, oder auch einem anderen, aber für den Schnaps da haben
sie was.«</p>
<p class="calibre3">»Wahr habt ihr geredet, so ist es.«</p>
<p class="calibre3">»Ho, ho! so viel Jahre schleppt sich einer über diese heilige
Erde, da kennt man sich aus.«</p>
<p class="calibre3">»Und wo habt ihr denn diesen aufgelesenen Jungen hingetan, der
euch im letzten Jahre führte?« fragte die Schulzin.</p>
<p class="calibre3">»Gegangen ist das Aas, fort, schön hat er mir die Bettelsäcke
umgekehrt ... Etwas Geld hatt' ich ja von guten Leuten, das war für
Messen vor dem Altar der Tschenstochauer heiligen Jungfrau, das hat
mir das Aas ausgenommen, und denn davon, über alle Berge! Still da,
Burek! Den Schulzen hört er, mein' ich.« Er zerrte an der Schnur
und der Hund horte auf zu knurren.</p>
<p class="calibre3">Er hatte gut geraten, denn der Schulze kam herein, warf die
Peitsche in die Ecke und rief gleich an der Schwelle:</p>
<p class="calibre3">»Frau, Essen, hab 'n Wolfshunger./Wie geht's mit euch, Matheus,
und was wollt ihr, Alter? ...«</p>
<p class="calibre3">»Ich komme von wegen meiner Gerichtssache, die für morgen
angesetzt ist.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page66" title="lac/gary"></a> »Und ich kann
warten, Herr Schulze. Befehlt ihr auf der Diele/schön, auch dort
wird's gut sein, und laßt ihr mich am Feuer, da ich doch alt bin,
dann bleib' ich, und gebt ihr mir 'ne kleine Schüssel Kartoffeln,
oder auch 'ne Brotrinde/dann will ich für euch ein Gebet sprechen
und noch ein zweites dazu ... als hättet ihr mir bar Geld gegeben,
oder vielleicht 'n Groschen ...«</p>
<p class="calibre3">»Bleibt man sitzen, Abendbrot kriegt ihr, und wenn ihr wollt,
könnt ihr übernachten ...«</p>
<p class="calibre3">Und der Schulze setzte sich an die Schüssel voll gemuster
Kartoffeln, die reichlich mit Speckbrühe begossen waren. Neben ihm
stand eine große Satte voll saurer Milch.</p>
<p class="calibre3">»Setzt euch zu uns, Matheus, und nehmt, was da ist,« lud die
Schulzin ein, indem sie einen dritten Löffel zurechtlegte.</p>
<p class="calibre3">»Gott lohn's. Als ich vom Wald heimgekommen bin, da hab' ich
schon ordentlich gefuttert ...«</p>
<p class="calibre3">»Haltet euch nur an den Löffel, das wird euch nicht schaden,
jetzt sind die Abende schon lang ...«</p>
<p class="calibre3">»Ein langes Gebet und eine große Schüssel, dadurch ist noch
niemand ins Grab gekommen,« warf der Bettler ein.</p>
<p class="calibre3">Boryna zierte sich, aber schließlich, da der Speckduft ihm stark
gegen die Nüstern stieß, setzte er sich an die Bank und langte
bedächtig und vorsichtig zu, wie es die gute Sitte wollte.</p>
<p class="calibre3">Die Schulzin aber stand ein nach dem andern Male wieder auf,
füllte die Kartoffeln nach und goß neue Milch in die Satte.</p>
<p class="calibre3">Der Hund des Bettlers fing an sich zu drehen und leise und
bescheiden nach Essen zu winseln.</p>
<p class="calibre3">»Still, Burek, die Bauern essen jetzt ... auch du kriegst was,
hab' keine Angst ...,« beruhigte ihn der Bettler, die schmackhaften
Düfte mit der Nase witternd, und wärmte sich die Hände am
Feuer.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page67" title="lac/gary"></a> »Da soll euch
die Eve verklagt haben,« schnitt der Schulze an, nachdem er sich
etwas gesättigt hatte.</p>
<p class="calibre3">»Ja, das hat sie schon, wegen dem Lohn, den ich ihr nicht
ausgezahlt haben soll! Die hat ihn gekriegt, so wahr wie Gott ist,
und noch darüber, aus gutem Herzen hab' ich dem Priester einen Sack
Hafer gegeben wegen der Taufe ...«</p>
<p class="calibre3">»Und die sagt aus, daß dieses Kind ...«</p>
<p class="calibre3">»Im Namen Gottes und des Sohnes. Is sie toll geworden, oder
was?«</p>
<p class="calibre3">»Ho, ho! alt seid ihr, aber noch 'n Meister!« Die Schulzen
fingen an zu lachen.</p>
<p class="calibre3">»Leichter passiert's dem Alten, denn der kennt sich drauf und
hat die Übung,« murmelte der Bettler.</p>
<p class="calibre3">»Die lügt wie'n Hund, nicht angerührt hab ich sie. Das fehlte
mir noch, diese Schlampe ... am Zaun wär' sie verreckt, und wie hat
sie gewinselt, daß man sie nur fürs Essen und für die Ecke zum
Schlafen da behielte, weil es doch zum Winter ging. Ich wollte
nicht, aber die Selige meinte: laß sie man kommen, kann sich im
Haus nützlich machen, was sollen wir Tagelöhner nehmen ... Die
eigene wird zur Hand sein ... Ich wollte nicht, im Winter gibt's
doch keine Arbeit, und da noch ein Maul mehr zum Fressen. Aber die
Selige hat gemeint: zu sorgen brauchst du dich nicht, sie soll
Beiderwand und Leinen weben können, ich krieg' sie 'ran, mög' sie
man 'rumpuddeln, irgendwas wird sie schon herauspuddeln. Na und sie
is geblieben, hat sich 'rausgefüttert und sich nach Zuwachs
umgesehen ... Und wer da Kumpeljonk is, davon haben sie schon
manches geredet ...«</p>
<p class="calibre3">»Sie klagt gegen euch.«</p>
<p class="calibre3">»Kalt werd' ich das Aas noch machen, die Zigeunermetze!«</p>
<p class="calibre3">»Aber zum Gericht müßt ihr.«</p>
<p class="calibre3">»Das will ich. Gott vergelt's, daß ihr es gesagt habt, denn ich
wußte bis jetzt nur das wegen dem Lohn/aber <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page68" title="Frank_9901/gary"></a> bezahlt hab' ich, da hab' ich
Zeugen für! Die vermaledeite Schnauze, die Bettelschickse. Großer
Gott, so viel Kummer, daß man schon gar nicht weiß, wie man das
tragen soll / und dazu ist mir noch die Kuh umgekommen,
notschlachten hab' ich sie müssen, auf dem Feld bleibt die Arbeit
liegen und man ist allein auf seine fünf Finger angewiesen.«</p>
<p class="calibre3">»Das Schaf unter den Wölfen ist der Witwer unter den Menschen,«
fügte abermals der Bettler hinzu.</p>
<p class="calibre3">»Von der Kuh hab' ich gehört, man sagte es mir schon auf dem
Feld ...«</p>
<p class="calibre3">»Da hat das Gut seine Finger dabei gehabt, ich hör', der Heger
hat sie aus dem Weidewald verjagt. Die beste Kuh, dreihundert
Silberlinge war sie wert, sie hat sich verhitzt, so'n schweres
Tier, und hat den Brand gekriegt, ich mußte sie schlachten ... Aber
das Gut soll mir nicht damit durchkommen ... klagen werd' ich.«</p>
<p class="calibre3">Der Schulze jedoch fing an, ihm zuzureden und ihm die Sache
auseinanderzusetzen und meinte, er möge damit warten, der Ärger sei
ein schlechter Berater; er hielt zum Gut, und um schließlich der
Unterhaltung eine andere Wendung zu geben, blinzelte er seiner Frau
zu und sagte:</p>
<p class="calibre3">»Ihr müßtet wieder heiraten, dann wär' da jemand, der nach der
Wirtschaft sieht.«</p>
<p class="calibre3">»Zieht ihr mich auf, oder was? ... Ich habe doch am
Kräutersonntag meine achtundfünfzig Jahr beendigt. Was euch nur
einfällt, die andere ist noch nicht richtig kalt geworden.«</p>
<p class="calibre3">»Ihr müßt 'ne Frau nehmen, die zu eurem Alter paßt, dann kommt
alles wieder zurecht,« ergänzte die Schulzin und begann
abzuräumen.</p>
<p class="calibre3">»Ein gutes Eheweib krönt des Mannes Erdenleib,« warf der Bettler
hinzu, die Schüssel betastend, die die Schulzin vor ihn hingestellt
hatte.</p>
<p class="calibre3">Boryna wehrte ab, aber er wurde nachdenklich darüber, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page69" title="Frank_9901/gary"></a> warum ihm der
Gedanke nicht auch schon gekommen war. Denn wie auch die Frau sein
mag, die einer kriegt, es ist doch immerhin besser, mit ihr
zusammen, als sich alleine abzuquälen...</p>
<p class="calibre3">»Manche ist dumm und nicht rührig, manche wiederum 'ne böse, die
nach des Bauers Zotteln langt und manche is 'n Schmutzfink und 'n
Rumtreiber, hat nur Schenke und Tanzmusik im Kopfe / und doch ist
der Bauer besser mit ihr dran und hat auch seine Bequemlichkeit,«
führte der Bettler essend weiter aus.</p>
<p class="calibre3">»Da würden sie im Dorf was haben, um sich darüber aufzuhalten,«
sagte Boryna.</p>
<p class="calibre3">»Na ja / und werden euch die Leute die Kuh wieder gesund machen,
oder helfen, die Wirtschaft besorgen, oder euch bemitleiden,« legte
die Schulzin gefühlvoll los.</p>
<p class="calibre3">»Oder euch das Federbett wärmen,« lachte der Schulze. »Und im
Dorf gibt es so viele Madchen, daß wenn man zwischen den Häusern
geht, die Glut schon durch die Wände schlägt ...«</p>
<p class="calibre3">»Pfui doch, sieh' einer mal, diesen Liederjan ... Was der nicht
alles möchte ...«</p>
<p class="calibre3">»Und dem Gregor seine Sophie, wie wär' denn die zum Beispiel,
schlank, schön und 'ne gute Mitgift.«</p>
<p class="calibre3">»Was denn, Mitgift, braucht denn Matheus 'ne Mitgift / der erste
Bauer im Dorf!«</p>
<p class="calibre3">»Wer hätte genug, daß er nicht mehr wollte?« protestierte der
Bettler.</p>
<p class="calibre3">»Nee, dem Gregor seine ist nichts für ihn«, nahm der Schulze
wieder auf, »die ist noch zu matt, is ja kaum trocken hinter den
Ohren.«</p>
<p class="calibre3">»Und dem Andreas seine Kassja«, zählte die Schulzin weiter.</p>
<p class="calibre3">»Vergeben. Gestern hat dem Rochus sein Adam mit Schnaps zu ihr
geschickt.«</p>
<p class="calibre3">»Dann ist noch dem Stach seine Veronika da.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page70" title="Monne3/gary"></a> »Die
Bummelliese, dieser Rumtreiber und 'ne dicke Hüfte hat sie
dazu.«</p>
<p class="calibre3">»Und dem Tomek seine Witwe, wie wär's mit der ... is noch ganz
reputierlich ...«</p>
<p class="calibre3">»Drei Kinder, vier Morgen, zwei Kuhschwänze und den alten
Schafspelz vom Seligen.«</p>
<p class="calibre3">»Und Ulischja, die vom Wojtek, die hinter der Kirche sitzen?
...«</p>
<p class="calibre3">»Ji ... das wär' was für'n Junggesellen ... gleich mit Zuwachs,
der Junge wäre schon zum Hüten gut, aber Matheus braucht keinen, er
hat schon seinen Hirten.«</p>
<p class="calibre3">»Gewiß, es gibt noch genug von diesem Jungfernkraut, aber ich
such' doch solche aus, die für Matheus passen sollen.«</p>
<p class="calibre3">»Aber eine hast du vergessen, die für ihn grad die Rechte
wäre.«</p>
<p class="calibre3">»Wen denn?«</p>
<p class="calibre3">»Dem Dominik seine Jagna.«</p>
<p class="calibre3">»Das is wahr, die hab' ich ganz vergessen.«</p>
<p class="calibre3">»'ne deftige Dirn', und gut gewachsen, über den Zaun kommt die
nicht, ohne daß die Latten unten wegbrechen ... und schön noch
dazu, ordentlich weiß ums Maul, schmuck wie 'ne Färse.«</p>
<p class="calibre3">»Jagna,« wiederholte Boryna, der schweigend der Aufzählung
gefolgt war, »von der sagt man doch, daß sie auf die Jungen happig
ist.«</p>
<p class="calibre3">»Hat sich was / war denn jemand dabei, der das weiß? Die
Klatschmäuler reden nur, um zu reden; macht alles nur der Neid,«
verteidigte die Schulzin mit Nachdruck.</p>
<p class="calibre3">»Ich red' auch nicht von mir aus / es wird nur so erzahlt. /
Aber ich muß gehen;« er rückte den Gurt zurecht, steckte ein Stück
Kohle in die Pfeife und sog ein paarmal.</p>
<p class="calibre3">»Um wieviel Uhr zu Gericht?« fragte er gelassen.</p>
<p class="calibre3">»Auf neun Uhr steht's in der Vorladung. Vor Tag müßt ihr
aufstehen, wenn's zu Fuß gehen soll.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page71" title="Monne3/gary"></a> »Nee ...
mit der Jungstute will ich langsam hinfahren. Gehabt euch wohl, und
schönen Dank für das Essen und den nachbarlichen Rat.«</p>
<p class="calibre3">»Gott auf'n Weg und überlegt es euch, was wir euch angeraten
haben ... Und sagt ihr ein Wort, geh' ich selbst mit dem Schnaps
zur Mutter und noch vor Weihnachten feiern wir Hochzeit ...«</p>
<p class="calibre3">Boryna antwortete darauf nichts, drehte nur mit den Augen und
entfernte sich.</p>
<p class="calibre3">»Wenn ein Alter 'ne Junge freit, freut sich der Teufel, denn er
wird davon Profit haben,« sagte der Bettler gewichtig, indem er
laut über den Grund der Schüssel schabte.</p>
<p class="calibre3">Boryna kehrte langsam heim und kaute nachdenklich durch, was sie
ihm geraten hatten. Er hatte sich wohlweislich nichts merken lassen
bei den Schulzens, daß ihm dieser Gedanke recht gut mundete; wieso
hätte er denn auch sollen, er war doch ein Großbauer und kein
Bursch mehr, der noch gelb um den Schnabel ist, der, wenn man ihm
vom Heiraten redet, schon quiekt und von einem Fuß auf den anderen
springt.</p>
<p class="calibre3">Die Nacht hielt schon die Erde umfaßt und die Sterne blinkten,
wie silberner Tau, aus dunklen, stummen Tiefen. Das Dorf war still,
nur die Hunde bellten hin und wieder, und hier und da glommen
zwischen den Bäumen schwache Lichtlein ... Manchmal wehte ein
feuchter Windhauch von den Wiesen, so daß die Bäume anfingen leicht
zu schaukeln und mit den Blättlein leise zu flüstern.</p>
<p class="calibre3">Boryna wählte nicht den Weg, auf dem er gekommen war, sondern
wandte sich tiefer ins Tal, überschritt die Brücke, unter der das
vom Fluß herkommende Wasser gurgelnd vorüberfloß, mit dumpfem
Getöse sich zur Mühle hinwälzend, und schwenkte nach der anderen
Seite des Weihers hinüber. Das Gewässer lag still und schimmerte
schwärzlich, die Uferbäume warfen auf die spiegelnde Fläche <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page72" title="Monne3/gary"></a> schwarze Schatten
und faßten die Ränder, wie in eine Umrahmung ein, und in der Mitte
des Weihers, wo es heller war, spiegelten sich die Sterne, wie in
einem Stahlspiegel, wider.</p>
<p class="calibre3">Matheus wußte nicht, warum er nicht geradenwegs nach Hause
gegangen war, sondern den Umweg gemacht hatte, vielleicht um an
Jagnas Hause vorüberzugehen? vielleicht auch um sich etwas zu
sammeln und zu meditieren.</p>
<p class="calibre3">»Natürlich, schlecht wär' es schon nicht! natürlich! Und was man
da über sie erzählt, das ist soviel wert ...« Er spuckte aus. »'n
deftiges Frauenzimmer!« Ein Frösteln lief ihm über den Rücken. Vom
Weiher kam nämlich feuchte Kühle und bei dem Schulzen war es
mächtig heiß gewesen.</p>
<p class="calibre3">»Und ohne Eheweib muß man zugrunde gehen oder den Kindern die
Wirtschaft abschreiben,« überlegte er, »und groß ist das Biest und
wie gemalt. / Und die beste Kuh ist krepiert, und wer kann wissen,
was morgen kommt? ... Vielleicht muß man doch 'ne Frau suchen. Aber
die alte Dominikbäuerin ist der reine bissige Köter / na was kann
das schaden, ihr Haus haben sie und ihren Grundbesitz, die kann
dann auf dem ihrigen sitzenbleiben. Dreie sind sie und haben
fünfzehn Morgen, dann kämen auf Jagna fünf zum Beispiel und die
Auszahlung von wegen dem Haus und dem Infantar! / Fünf Morgen,
gerade die Felder hinter meinem Kartoffelland, Roggen haben sie,
glaub' ich, gesät dieses Jahr, ja ... Fünf Morgen zu den meinen,
das wären ... fünfunddreißig Morgen fast! Mächtig viel Land!
...«</p>
<p class="calibre3">Er rieb sich die Hände und schob seinen Gurt zurecht. / »Dann
hat nur der Müller mehr ... der Dieb, durch Menschenunrecht,
Prozente und Betrügereien hat er es zusammengeschachert ... Und im
nächsten Jahr würde ich gut durchmisten, den Acker durchnehmen und
auf dem ganzen Stück Weizen säen; ein Pferd müßte man hinzukaufen
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page73" title="Monne3/gary"></a> und dann für
die Bunte irgendeinen rechten Ersatz ... Das ist wahr, 'ne Kuh
würde sie noch mitkriegen ...«</p>
<p class="calibre3">Und so überlegte er, zählte und schwelgte in wirtschaftlichen
Plänen, bis er zuweilen in tiefem Nachdenken stehenblieb. Und da er
ein kluger Kerl war, raffte er alle Gedanken zusammen und guckte
tief in seinen Kopf hinein, um nicht irgend etwas zu übersehen oder
zu vergessen.</p>
<p class="calibre3">»Schreien würde die Bagage, schreien!« dachte er, sich der
Kinder erinnernd, aber sofort überflutete ihn das Selbstbewußtsein
und das Gefühl seiner Macht und verstärkte seinen dumpfen, noch
wankenden Entschluß.</p>
<p class="calibre3">»Der Grundbesitz ist mein, da soll sich jeder hüten, da
beizugehen. Und wollt ihr nicht, dann soll euch ...« er beendete
nicht, denn er stand vor dem Hause der Jagna.</p>
<p class="calibre3">Sie hatten noch Licht, und ein breiter Lichtstreifen fiel durch
das offene Fenster auf einen Georginenbusch, auf einige niedrige
Pflaumenbäume und lief über den Zaun bis auf die Dorfstraße.</p>
<p class="calibre3">Boryna blieb im Schatten stehen und versenkte den Blick in die
Stube.</p>
<p class="calibre3">Ein Lämpchen glimmte über dem Rauchfang, aber auf dem Herd mußte
noch ein gehöriges Feuer brennen, denn man hörte das Knackern von
Tannenzweigen, und rötliches Licht erfüllte den großen, in den
Ecken dämmrigen Raum; die Alte saß vor dem Kamin hingekauert und
las irgend etwas vor, und ihr gegenüber saß Jagna mit dem Gesicht
in der Richtung des Fensters und rupfte eine Gans; sie hatte nur
noch das Hemd an und die Ärmel waren bis an die Schultern
hochgekrempt.</p>
<p class="calibre3">»Verdeubeltes Luder, verdeubelt!« dachte er. Sie hob zuweilen
den Kopf, sah zur Mutter hinüber und seufzte tief auf; dann machte
sie sich wieder ans Rupfen der ängstlich unter ihren Händen
gackernden Gans, die mit <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page74" title="Monne3/gary"></a> Geschrei und mit Flügelschlagen ihr zu entrinnen
versuchte, so daß die Daunen, wie eine weiße Wolke, durch die Stube
flogen. Sie beruhigte das Tier rasch und preßte es fest zwischen
ihre Knie, bis die Gans nur unterdrückt und schmerzlich gackelte.
Irgendwo, vom Hof oder von der Diele, antworteten ihr die
anderen.</p>
<p class="calibre3">»Statiöses Frauenzimmer,« kam es ihm. Er ging rasch davon, denn
es war ihm zu Kopf geschlagen, so daß er sich kratzend über den
Schädel fuhr, eine Rocköse zuknöpfte und den Gürtel strammer
anzog./</p>
<p class="calibre3">Schon hatte er das Tor seines Gehöfts hinter sich und ging an
den Hecken entlang dem Hause zu, als er sich noch einmal nach ihrem
Hof umblickte, der gerade gegenüber, nur an der anderen Seite des
Wassers lag. Zur selben Zeit trat drüben jemand hinaus, denn durch
die geöffnete Tür sprühte ein Lichtstrahl, blitzte auf wie ein
Wetterleuchten und fiel bis auf den Weiher; darauf hörte man das
feste Stapfen von Schritten, das Plantschen eines Wassereimers, der
gefüllt wurde, und schließlich erklang durch die Dunkelheit und
durch die Nebeldünste, die von den Wiesen aus sich anfingen über
den Weiher zusammenzuziehen, ein gedämpftes Singen:</p>
<p class="vers">Ich hinterm Wasser und du hinterm Wasser,<br class="calibre2"/>
Wie soll ich nun den Kuß dir reichen.<br class="calibre2"/>
Ich geb' ihn auf einem Blättelein.<br class="calibre2"/>
Da hast du ihn, Geliebter mein!</p>
<p class="calibre3">Er lauschte lange, obgleich die Stimme schon schwieg und die
Lichter erloschen waren.</p>
<p class="calibre3">Aus den Wäldern kam der Vollmond über den Himmel gerollt und
versilberte die Schöpfe der Bäume, streute sein Licht durch die
Zweige über den Weiher und guckte in die Fenster der Hütten, die
ihm gegenüber lagen. Selbst die Hunde schwiegen. Eine
unergründliche Stille umfaßte das ganze Dorf und die Kreatur.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page75" title="Monne3/gary"></a> Boryna
umschritt den Hof, sah bei den Pferden ein, die schnaubten und ihr
Futter fraßen, und steckte den Kopf in den Kuhstall, dessen Türen
der Hitze wegen ausgesperrt standen. Die Kühe lagen wiederkauend da
und taten ihrer Gewohnheit nach ab und zu schnaufen. / Er lehnte
noch die Scheunentür an.</p>
<p class="calibre3">Mit dem Hut betrat er die Stube und sprach halblaut das
Gebet.</p>
<p class="calibre3">Da jedoch schon alle schliefen, zog er leise die Stiefel aus und
legte sich gleich schlafen.</p>
<p class="calibre3">Aber der Schlaf wollte nicht kommen; einmal brannte ihn das
Federbett, daß er die Füße heraussteckte, dann wieder gingen ihm
verschiedene Geschäfte durch den Kopf, verschiedene Sorgen und
Gedanken ... und dann fühlte er ein arges Drücken im Magen, so daß
er herumstöhnte und vor sich hin brummte.</p>
<p class="calibre3">»Das sag' ich immer, saure Milch bläht nur den Bauch auf, die
soll man nicht für die Nacht geben ...«</p>
<p class="calibre3">Danach fing er an, über die Jagna nachzudenken; und wie gut das
wäre, denn sie wäre schön gewachsen und tüchtig, und das viele Feld
... Seine Kinder kamen ihm in den Sinn, das Gerede über Jagna, bis
sich alles in ihm verwirrte und er nicht mehr wußte, was er
anfangen sollte; er richtete sich etwas hoch und wollte, wie er es
gewohnt war, nach dem andern Bett herüberrufen und um Rat
fragen.</p>
<p class="calibre3">»Marysch! Soll ich die Jagna heiraten, oder soll ich sie nicht
heiraten, die Jagna? ...«</p>
<p class="calibre3">Aber zur rechten Zeit fiel es ihm ein, daß Marysch schon seit
dem Frühjahre auf dem Friedhof lag und daß dort im Bett Fine
schlief und schnarchte; daß er 'ne ganze Waise geworden ist und
niemanden hat, den er um Rat fragen kann, darum seufzte er schwer
auf, bekreuzigte sich und fing an Aves für die Selige zu beten, und
für alle Seelen, die im Fegefeuer sind.</p>
<p class="pcalibre6 initial1"> <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page76" title="DaoH/gary"></a> Die Morgendämmerung hatte schon die Dächer
kalkweißer Helle übertüncht und die Nacht mit ihren verblaßten
Sternen mit einem grauen Sacktuch zugeworfen, als es sich auf dem
Borynahof zu regen begann.</p>
<p class="calibre3">Jakob kroch von seiner Pritsche herunter und guckte vor den
Stall. – Auf der Erde lag Frühreif und alles war noch in Grau
getaucht, aber schon fing im Osten das Morgenrot an aufzuglühen und
die Wipfel der bereiften Bäume rot zu färben. Er reckte sich
behaglich, gähnte noch ein paarmal und ging hinüber in den
Kuhstall, um Witek zuzuschreien, daß es Zeit sei aufzustehen, aber
der Junge hob nur etwas seinen schlaftrunkenen Kopf und murmelte:
»Gleich, Jakob, gleich!« und preßte sich fester an seine
Lagerstätte.</p>
<p class="calibre3">»Schlaf noch was; armer Kerl, schlaf nur!« Er deckte ihm den
Schafspelz über und humpelte davon; man hatte ihm einst das Bein am
Knie durchschossen, darum hinkte er stark und schleppte den einen
Fuß nach. Er wusch sich am Brunnen, glättete mit der Handfläche die
spärlichen, zausigen Haare, die ihm in filzigen Zotteln um den Kopf
hingen, und kniete auf der Schwelle des Stalles zum Morgengebet
nieder.</p>
<p class="calibre3">Der Bauer schlief noch; in den Fenstern des Wohnhauses
entzündete sich der blutige Schein des Morgens, und dichte weiße
Nebel zogen sich langsam von den Weihern zurück, schaukelten
schwerfällig und rafften ihre zerrissenen Fetzen zusammen.</p>
<p class="calibre3">Jakob bewegte den Rosenkranz zwischen den Fingern und betete
lange, seine Blicke aber liefen durch den Hof, an den Fenstern des
Wohnhauses entlang, über den Obstgarten, dessen tiefster Teil noch
im Dämmer lag, von Apfelbaum zu Apfelbaum, wo die Früchte groß wie
Fäuste hingen; dann warf er irgend etwas nach der Hundehütte, die
dicht bei der Tür stand und traf den weißen Kopf <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page77" title="MEsswein/gary"></a> Waupas, so daß der Hund
aufknurrte und sich zusammenrollte, um wieder weiterzuschlafen.</p>
<p class="calibre3">»Sieh einer, bis die Sonne 'raus ist, will er schlafen. Das
Biest!« und er warf zum zweitenmal nach ihm. Der Hund kroch heraus,
streckte sich, gähnte, wedelte mit dem Schwanz und setzte sich hin,
um sich zu kratzen und mit den Zähnen im dichten Pelz Ordnung zu
schaffen.</p>
<p class="calibre3">»... Und dieses Gebet spreche ich dir und allen Heiligen zu
Ehren, Amen!« Er schlug sich lange gegen die Brust, und sich
erhebend sagte er zu Waupa:</p>
<p class="calibre3">»Hela! olegantes Viech, sucht sich die Flöh' zusammen, wie'n
Frauenzimmer vor der Hochzeit.«</p>
<p class="calibre3">Da er aber ein fleißiger Mensch war, machte er sich gleich an
die Morgenarbeit, rollte den Wagen aus der Scheune hervor,
schmierte ihn, tränkte die Pferde und füllte ihnen Heu nach. Sie
fingen an zu schnaufen und mit den Hufen zu stampfen. Dann holte er
aus der Banse etwas Spreu, gut mit Hafer vermengt und schüttete ihn
der Stute, die im Verschlag abgesondert stand, in die Krippe.</p>
<p class="calibre3">»Friß, Alte, friß! 'n Fohlen wirst du haben, da brauchst du
Kraft, friß!« Er streichelte sie über die Nüstern, so daß die Stute
ihm den Kopf auf die Schulter legte und liebkosend mit ihrem Maul
nach seinen Zotteln griff.</p>
<p class="calibre3">»... Bis Mittag fahren wir die Kartoffeln ein, und gegen Abend
muß man in den Wald Nadelstreu holen/brauchst nichts zu fürchten,
die Streu ist leicht und gejagt wirst du nicht ...«</p>
<p class="calibre3">»Und du Faulpelz, kriegst einen mit der Peitsche über, paß du
auf, der Hafer sticht den Gauner,« redete er zum nebenan stehenden
Wallach, der den Kopf zwischen den Brettern des Verschlages
durchschob, um zur Krippe der Stute zu gelangen/er langte ihm einen
kräftigen mit der Faust auf den Hintern, daß das Pferd zur Seite
sprang und aufwieherte.</p>
<p class="calibre3">»So ein Judenpferd! Fressen würdest du selbst reinen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page78" title="JohannN/gary"></a> Hafer, aber für
die Arbeit bist du nicht zu haben; ohne Peitsche geht das Luder
nicht von der Stelle! ...«</p>
<p class="calibre3">Er umging ihn und sah nach der Jungstute, die ganz zuletzt an
der Wand stand und schon von weitem ihm den kastanienbraunen Kopf
mit einer weißen Blesse an der Stirn entgegenstreckte und ganz zart
zu ihm herüberwieherte.</p>
<p class="calibre3">»Still man, Kleine! Freß dich satt, sollst den Bauer zur Stadt
fahren!« Er drehte sich einen Büschel Heu zurecht und putzte ihr
die besudelte Flanke. »So 'ne große Stute, soll schon bald zum
Hengst kommen, und so'n Schwein! Gleich wie 'ne Sau muß sie sich
einschmieren,« redete er vor sich hin und wandte sich nach den
Schweineställen, die quiekenden Schweine herauszulassen. Hinter ihm
kam Waupa und versuchte ihm in die Augen zu gucken.</p>
<p class="calibre3">»Willst was zu essen? Hier hast ein Stück Brot, da!« Er holte
ein Stück Brot hervor und warf es ihm hin, der Hund fing es auf und
flüchtete ins Hundehaus, denn die Schweine stürzten auf ihn zu, um
ihm den Bissen zu entreißen.</p>
<p class="calibre3">»Hale, diese Schweine, ganz wie manch' Mensch, nur immer Fremdes
an sich bringen und 'runterschlingen.«</p>
<p class="calibre3">Er trat in die Scheune und sah lange auf die am Balken hängende
Kuh.</p>
<p class="calibre3">»Wenn es auch nur ein dummes Tier ist, sein Ende hat's doch
gefunden. Morgen werden wir Fleisch zu Mittag haben ... Das ist
auch alles, was von dir übrigbleibt, daß der Mensch sich Sonntags
sattessen kann ...«</p>
<p class="calibre3">Er seufzte auf im Gedanken an das gute Essen und schlurfte
davon, um Witek zu wecken ...</p>
<p class="calibre3">»Gleich geht die Sonne auf ... Es ist Zeit, die Kühe auf die
Weide zu treiben.«</p>
<p class="calibre3">Witek murmelte etwas, wehrte sich, schmiegte sich an den
Schafspelz, mußte aber schließlich doch aufstehen und kroch
schwerfällig und schlaftrunken im Hof herum.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page79" title="JohannN/gary"></a> Der Bauer
hatte die Zeit verschlafen, denn die Sonne war schon aufgegangen,
hatte den Reif gerötet und entzündete Feuerscheine in den Gewässern
und Fensterscheiben, aber aus dem Wohnhaus kam niemand zum
Vorschein ...</p>
<p class="calibre3">Witek saß auf der Schwelle des Kuhstalls, kratzte sich emsig und
gähnte zwischendurch, und als die Spatzen von den Dächern zum
Brunnen herunterflatterten und im Trog mit den Flügeln plätschernd
zu baden begannen, setzte er eine Leiter an und stieg unter die
Traufe, um nach den Schwalbennestern zu sehen, in denen es heute
eigentümlich still war.</p>
<p class="calibre3">»Sind sie erfroren, oder was?«</p>
<p class="calibre3">Er fing an, behutsam die erkalteten Vögelchen herauszuziehen und
sie unters Hemd an seine Brust zu stecken.</p>
<p class="calibre3">»Jakob, wißt ihr, die leben nicht, oh!« Er lief nach dem Knecht
und zeigte ihm die steifen, abgestorbenen Schwalbenkörperchen.</p>
<p class="calibre3">Aber Jakob nahm sie nur in die Hand, legte sie gegen das Ohr,
pustete ihnen in die Augen und sagte:</p>
<p class="calibre3">»Die sind nur steif, war auch ein Morgenfrost, der sich sehen
lassen kann, daß die dummen Dinger nicht eher in die warmen Länder
gegangen sind / na, na ...« Er kehrte an seine Arbeit zurück.</p>
<p class="calibre3">Witek setzte sich inzwischen vors Wohnhaus an der Giebelseite
nieder, weil die Sonne da schon schien und die geweißten Wände
übergoß, auf denen die Fliegen anfingen herumzukriechen; er zog die
Vögel hervor, die, durch seinen Körper erwärmt, sich schon etwas
bewegten, hauchte sie an, öffnete ihnen die Schnäbel und tränkte
sie aus dem eigenen Munde / bis sie sich belebten, die Augen
öffneten und ihm zu entschlüpfen versuchten; dann hielt er die
Rechte lauernd gegen die Wand, langte sich hin und wieder die eine
oder andere Fliege, fütterte einen Vogel und ließ ihn los.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page80" title="lesebaer/gary"></a> »Fliegt
hin zur Mutter, fliegt!« flüsterte er, die Schwalben beobachtend,
wie sie sich auf den First des Kuhstalls setzten, sich mit den
Schnäbeln putzten und wie zum Dank zwitscherten.</p>
<p class="calibre3">Und Waupa saß vor ihm und winselte possierlich; sobald ein Vogel
aufflog, warf er sich ihm nach, lief einige Schritte und kehrte auf
seinen Beobachtungsposten zurück ...</p>
<p class="calibre3">»Da, kannst den Wind im Feld fangen,« murmelte Witek, und war so
mit seiner Tätigkeit des Aufwärmens der Vögel beschäftigt, daß er
gar nicht sah, daß Boryna um die Ecke des Hauses kam und vor ihm
stehenblieb.</p>
<p class="calibre3">»Wirst du hier mit den Vögeln spielen, du Aas, was?«</p>
<p class="calibre3">Der Junge sprang auf, um davonzustürzen, aber der Bauer griff
ihn fest ins Genick und knüpfte rasch mit der anderen Hand den
breiten, harten Ledergurt ab.</p>
<p class="calibre3">»Nicht schlagen, nicht schlagen!« hatte er nur noch Zeit
aufzuschreien./</p>
<p class="calibre3">»So'n Hirt bist du, was? So hütest du, was? Die beste Kuh hast
zuschanden gemacht, was ... du Landstraßenbalg, du Warschauer
Mistgeburt, du!« und er schlug sinnlos, wohin er traf, daß der
Lederriemen sauste. Der Junge wand sich wie 'n Aal und heulte.</p>
<p class="calibre3">»Schlagt nicht! Mein Gott! Er macht mich tot! Bauer! ... O
Jesus, Hilfe! ...«</p>
<p class="calibre3">Selbst Anna sah hinaus, was geschehen war, und Jakob spuckte aus
und verschwand in den Stall.</p>
<p class="calibre3">Boryna aber prügelte ihn windelweich, er gerbte ihm seinen
Verlust so wütig aufs Fell, daß Witek schon ein blaues Gesicht
hatte und das Blut ihm aus der Nase lief. Er schrie
gottsjämmerlich, riß sich wie durch ein Wunder los, griff mit
beiden Händen hinten an die Hosen und rannte auf die Hecken zu.</p>
<p class="calibre3">»Jesus, sie haben mich totgeschlagen, totgeschlagen haben sie
mich!« brüllte er und lief dermaßen, daß ihm der Rest der Schwalben
herausfiel und auf dem Weg liegenblieb.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page81" title="lesebaer/gary"></a> Boryna
drohte ihm noch nach, umgürtete sich und kehrte ins Haus zurück,
auf Anteks Seite eintretend.</p>
<p class="calibre3">»Die Sonne ist schon zwei Mann hoch, und du liegst noch herum!«
fuhr er seinen Sohn an.</p>
<p class="calibre3">»Hab' mich gestern genug, wie ein Vieh, abgeschunden, da laß ich
mir jetzt was zukommen.«</p>
<p class="calibre3">»Ich fahr' aufs Gericht ... hol' du die Kartoffeln ein, und wenn
die Leute mit dem Ausnehmen fertig sind, dann sollen sie Streu
harken, und du könntest die Pflöcke eintreiben, damit wir für den
Winter die Wände mit Faschinen schützen.«</p>
<p class="calibre3">»Belegt euch das Haus selbst mit Faschinen, uns weht es hier
nicht.«</p>
<p class="calibre3">»Du hast es gesagt ... Dann werde ich meine Seite belegen und du
kannst frieren, wenn du so 'n Lüderjan bist.«</p>
<p class="calibre3">Er knallte die Tür zu und ging auf seine Seite.</p>
<p class="calibre3">Fine hatte schon Feuer gemacht und machte sich auf den Weg, die
Kühe zu melken.</p>
<p class="calibre3">»Gib rasch das Essen, denn ich fahre gleich ...«</p>
<p class="calibre3">»Ich soll mich wohl zerreißen, zwei Arbeiten auf einmal kann
kein Mensch tun,« meinte sie und ging.</p>
<p class="calibre3">»Nicht einen ruhigen Augenblick hat man, man kann nur immer den
Leuten die Zähne zeigen!« dachte er und zog sich um, er war
verärgert und aufgebracht. »Wie soll man denn auch nicht, dieser
ewige Krieg mit dem Sohn, nicht ein Wort kann man sagen, sonst
springt er einem mit den Krallen an die Augen, oder sagt was, daß
man es bis in die Eingeweide fühlt. Auf niemanden kann man sich
verlassen, nur schuften, immer wieder schuften!«</p>
<p class="calibre3">Der Ärger stieg in ihm, so daß er leise vor sich hin fluchte und
mit seinen Kleidungsstücken und Stiefeln um sich warf.</p>
<p class="calibre3">»Gehorchen sollten die, und tun es doch nicht! Warum denn das?«
überlegte er.</p>
<p class="calibre3">»Mir deucht, ohne einen Knüttel geht's nicht mit ihnen, und das
nicht ohne einen derben! Lange schon haben sie es <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page82" title="lesebaer/gary"></a> verdient, gleich nach dem
Tode der Seligen, als sie anfingen, sich um das Land zu reißen,«
aber er hatte es sich immer noch überlegt, um nicht im Dorf das
böse Beispiel zu geben. Er war doch nicht der erste beste Bauer,
auf dreißig Morgen saß er, und von Geburt war er auch nicht
irgendeiner, Boryna doch, das weiß man! Aber mit Güte kommt man bei
denen zu keinem Ende. Hier kam ihm sein Schwiegersohn, der Schmied,
in Erinnerung, der alle im stillen aufhetzte und ihm auch selbst
immerfort in den Ohren lag, daß man ihm sechs Morgen und einen
Morgen Wald abschreiben sollte; auf den Rest würde er schon warten
...</p>
<p class="calibre3">»Wenn ich sterbe, meint er! Wart' du man, Luder, warte,« dachte
er wütig. »Solange ich meine Knochen schleppe, wirst du nicht eine
Parzelle zu riechen bekommen. Seht mal diesen klugen Mussiö!«</p>
<p class="calibre3">Die Kartoffeln brodelten schon stark auf dem Feuerherd, als Fine
vom Melken zurückkam und sofort das Frühstück herrichtete.</p>
<p class="calibre3">»Fine, und das Fleisch sollst du verkaufen. Morgen ist Sonntag,
sie wissen schon Bescheid im Dorf, da werden sie schon gerannt
kommen; nur niemand was borgen. Die Keule laß für uns; Ambrosius
wollen wir bestellen, der kann sie pökeln ...«</p>
<p class="calibre3">»Aber das kann doch auch der Schmied ...«</p>
<p class="calibre3">»Jawohl, und teilen würde der, wie der Wolf mit dem Schaf.«</p>
<p class="calibre3">»Magda wird sich grämen, von wegen weil es unsere Kuh ist und
sie selbst davon nichts zu sehen kriegt.«</p>
<p class="calibre3">»Dann schneide für Magda einen Teil heraus und trag' es ihr hin,
aber der Schmied soll nicht kommen.«</p>
<p class="calibre3">»Gut seid ihr, Väterchen, gut seid ihr.«</p>
<p class="calibre3">»Nana, Mädel, nana. Paß du hier auf und ich werd' dir schon 'ne
Semmel mitbringen, oder sonst was Schönes.«</p>
<p class="calibre3">Er aß sein tüchtiges Teil, umgürtete sich mit dem Gurt, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page83" title="lesebaer/gary"></a> glättete mit
bespuckter Handfläche die spärlichen, widerspenstigen Haare, nahm
seine Peitsche und sah sich im Zimmer um.</p>
<p class="calibre3">»Daß ich nichts vergesse.« Er hatte Lust, in die Butze
hineinzugucken, doch er hielt sich zurück, denn Fine äugte zu ihm
herüber; so bekreuzigte er sich denn nur und machte sich auf den
Weg.</p>
<p class="calibre3">Und schon auf seinem Wagen aus Weidengeflecht rief er, die
Hanfzügel raffend, Fine zu.</p>
<p class="calibre3">»Wenn sie mit den Kartoffeln fertig sind, sollen sie gleich
Streu harken gehen, die Quittung ist hinter dem Bild, 'ne Hainbuche
oder eine Fichte können sie auch noch fällen/die kann man
brauchen.«</p>
<p class="calibre3">Der Wagen ruckte an; er war schon zwischen den Hecken, als Witek
an den Apfelbäumen vorübersauste.</p>
<p class="calibre3">»Das hab' ich noch vergessen ... prrr ... Witek! Prrr! Witek,
bring' die Kühe auf die Wiese, paß' aber auf, sonst werde ich dich
Biest so durchbläuen, daß du an mich denken sollst!«</p>
<p class="calibre3">»He-He, ihr könnt mir was ... küssen ...!« schrie er ihm trotzig
zurück, hinter der Scheune verschwindend.</p>
<p class="calibre3">»Willst du noch hier das Maul aufreißen, hüte dich, wenn ich
'runter komm! ...«</p>
<p class="calibre3">Er wendete vom Heckenweg links ab auf die Straße, die zur Kirche
führte, und gab der Jungstute einen Peitschenhieb, so daß sie
gemächlich trabend auf dem ausgefahrenen steinigen Weg
dahinzuckelte.</p>
<p class="calibre3">Die Sonne war schon ein weniges über den Hütten hervorgekommen
und schien immer wärmer, daß die bereiten Strohdächer anfingen zu
tropfen und zu dünsten, nur im Schatten, an den Zäunen der
Obstgärten und in den Gräben lag noch der weiße Frost. Über den
Weiher schleppten sich die letzten dünnen Nebel, und das Wasser
fing an, unter seinen Nebelhäuten Glanz zu brauen und die Sonne
blitzend zu spiegeln.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page84" title="lesebaer/gary"></a> Im Dorfe
begann das alltägliche Treiben: der Morgen war hell und kühl, und
da der Frühreif die Luft erfrischt hatte, rührte man sich munterer
und lärmender; haufenweise zogen sie auf die Felder; die einen
gingen zum Kartoffelausnehmen, Hacken und Körbe schleppend, sie
kauten noch an ihrem Frühstück; andere zogen mit dem Pflug auf die
Stoppelfelder; etliche kamen, die Eggen auf ihrem Leiterwagen
hatten und Säcke voll Saatkorn; und andere mit geschulterten Harken
schlugen den Weg nach den Wäldern ein, um Nadelstreu fürs Vieh zu
holen./Das Getöse und Geschrei von beiden Seiten des Weihers wurde
immer stärker, denn auf den Wegen drängte sich das Vieh, das auf
die Weide zog, Hundegebell und Zurufe drangen aus den niedrigen
schweren Staubwolken, die sich von den taufeuchten Wegen
erhoben.</p>
<p class="calibre3">Boryna wich den Herden behutsam aus, manchmal langte er einem
Lämmlein, das zu dumm war, vor seinem Pferd auszuweichen, eins
übers Fell oder verscheuchte ein Kalb, bis er alle überholt hatte;
neben der Kirche, die herbstgelbe Linden und Ahorne wie mit einem
gewaltigen Wall umschlossen, bog er auf die breite Heerstraße ab,
die zu beiden Seiten von einer langen Reihe mächtiger Pappeln
eingesäumt war.</p>
<p class="calibre3">In der Kirche wurde gerade die heilige Messe zelebriert, denn
die Betglocke hatte zur Konsekration geläutet, und die Orgel tönte
mit leiser Stimme. Er nahm den Hut ab und seufzte fromm auf.</p>
<p class="calibre3">Der Weg, den dichte Schattenstreifen durchschnitten, die die
Stämme der Pappeln warfen, weil die Sonne von der Seite schien, war
leer und mit gefallenem Laub so dicht bedeckt, daß die Löcher und
Schneisen unter einer rostiggoldenen Decke lagen.</p>
<p class="calibre3">»Wioh, Kleine, wioh!« Die Peitsche sauste durch die Luft, und
die Stute lief etwas munterer ein paar Klafter weit, aber dann ließ
sie nach und schleppte sich langsam, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page85" title="DaoH/gary"></a> denn der Weg stieg, wenn auch unmerklich, zu
den Hügeln hinauf, auf denen die schwarzen Wälder standen.</p>
<p class="calibre3">Boryna, der durch die Stille, die ihn umgab, wie benebelt war,
sah durch die Säulenreihe der Pappeln auf die im rosigen
Morgenlicht gebadeten Felder, dann versuchte er über die
Gerichtssache mit der Eve nachzudenken und auch über die Bunte,
doch es überfiel ihn das Duseln so stark, daß er nicht gegen
angehen konnte.</p>
<p class="calibre3">Die kleinen Vögel zirpten in den Zweigen und manchmal glitt der
Wind mit leichten Fingern über die Schöpfe der Bäume, so daß hier
und dort sich ein Blatt, wie ein goldener Falter, vom Mutterzweig
löste und kreisend auf den Weg fiel oder auch auf die staubigen
Disteln, die mit brandigen Blütenaugen trotzig in die Sonne
starrten/und die Pappeln Huben an, miteinander zu reden, flüsterten
leise mit den Zweigen und schwiegen ganz, als ob sie Dorfbasen
wären, die beim Emporheben des heiligen Sakraments die Augen
aufwärtsrichten, die Arme auseinanderbreiten und im Gebet
aufseufzen, um gleich darauf in den Staub zu sinken vor der
verborgenen Majestät in jener goldenen Monstranz, die über der Erde
hing, über der heiligen, heimatlichen ..</p>
<p class="calibre3">Erst dicht am Wald wurde er ganz munter und hielt das Pferd
an.</p>
<p class="calibre3">»Der geht nicht schlecht auf,« meinte er, die graue Ackerfläche
gegen das Sonnenlicht beäugend, die die keimende Roggensaat wie mit
einer kurzen rostroten Bürste bedeckte.</p>
<p class="calibre3">Ein gutes Stück Feld, und gerade neben meinem liegend, als ob
jemand das mit Absicht so gemacht hätte. Den Roggen haben sie,
deucht mir, gestern erst gesät. Er seufzte auf, die frisch
zugeeggten Ackerbeete mit gierigem Blick umfassend und fuhr in den
Wald hinein.</p>
<p class="calibre3">Das Pferd trieb er jetzt häufiger an, weil der Weg durch ebenes
Gelände ging und härter war, aber das Wurzelwerk hatte ihn ziemlich
durchwachsen, und der Wagen holperte darüber mit lautem Rollen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page86" title="DaoH/gary"></a> Er war ganz
wach geworden durch den herben, kühlen Atem des Waldes.</p>
<p class="calibre3">Der Forst war gewaltig und alt/als dicht gedrängte Masse stand
er in der vollen Majestät seiner Jahre und seiner Kraft, Baum an
Baum, lauter Kiefern fast, dazwischen oft eine breitästige,
altersgraue Eiche, und Birnek zuweilen in weißen Hemden mit
auseinandergeflochtenen gelben Zöpfen, da es Herbst war. Das
geringere Buschwerk, Haseln, krüppelige Hainbuchen, zitternde
Espen/ scharten sich um die roten mächtigen Stämme, die dermaßen
mit ihren Kronen und Ästen ineinander verzweigt waren, daß das
Sonnenlicht nur spärlich hier und da sich hindurchzwängte und wie
goldene Spinnen über Moose und rostig-grüne Farnkräuter kroch.</p>
<p class="calibre3">»Immerhin sind hier vier Morgen mein!« dachte er, verschlang den
Wald mit den Blicken und wählte schon dem Auge nach das Beste.
»Herr Jesus wird's nicht zugeben, daß uns Unrecht geschieht/auch
werden wir's selbst nicht zulassen, nein ... Das Gut glaubt, es ist
viel, was wir beanspruchen, wir glauben, es ist wenig ... Darum
sind meine doch vier und Jaguscha kommt ein Morgen zu ... dann
haben wir vier und eins zusammen ... Wioh! Dumme, wirst Angst vor
Elstern haben!« Er klatschte ihr leicht über den Rücken, denn auf
dem verdorrten Baum, an dem Christi Marter hing, zankten sich mit
wütigem Geschrei die Elstern, so daß die Jungstute die Ohren
spitzte und stehenblieb.</p>
<p class="calibre3">»Elsternhochzeit/Regenzeit.« Er heftete ihr ein paar
Peitschenhiebe an und fuhr im Trab weiter.</p>
<p class="calibre3">Es war schon gut nach acht, denn die Menschen auf den Feldern
setzten sich gerade an die Frühstücks-Zweierkrüge, als er in Tymow
einfuhr; die leeren Straßen des Städtchens waren mit baufälligen
Häusern umstellt, die wie alte Hökerinnen über den Rinnsteinen voll
angesammelter Schmutzhaufen saßen, zwischen denen sich Hühner,
zerlumpte Judenkinder und Schweine tummelten ...</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page87" title="DaoH/gary"></a> Gleich an
der Einfahrt umringten ihn die Juden, und alsbald ging es ans
Herumstöbern und Hineintasten ins Erbsenstroh unter dem Sitz des
Korbwagens – ob er nicht etwas Verkaufbares mitbrächte.</p>
<p class="calibre3">»Fort, grindiges Pack! ...« murrte er, den Wagen nach dem
Marktplatz lenkend, wo schon etliche Wagen mit ausgespannten
Pferden daneben hielten, im Schatten alter zerzauster
Kastanienbäume, die in der Mitte des Platzes im herbstlichen
Absterben dastanden.</p>
<p class="calibre3">Dort brachte er auch seinen Korbwagen unter, spannte die
Jungstute aus, stellte sie mit dem Kopf nach dem Wagenkorb hin,
schüttete ihr Hafer in den Kober und versteckte die Peitsche unter
dem Wagensitz. Nachdem er seine Kleider vom Stroh gereinigt hatte,
ging er geradeswegs nach Mordka, wo die drei Messingteller
glänzten, um sich ein wenig ausrasieren zu lassen. Bald darauf kam
er glatt geschabt wieder zum Vorschein, nur auf dem Kinn hatte er
einen einzigen Schnitt, der mit Papier verklebt war, durch das noch
etwas Blut sickerte.</p>
<p class="calibre3">Die Gerichtssitzungen hatten noch nicht begonnen.</p>
<p class="calibre3">Aber vor dem Gerichtsgebäude, das gleich vorne am Marktplatz
stand, gegenüber einer großen Kirche, die ehemals zu einem Kloster
gehörte, wartete schon viel Volk. Sie saßen auf den ausgetretenen
Stufen, oder scharten sich vor den Fenstern, um einmal ums andere
ins Innere zu spähen; die Frauen hockten an den geweißten Wänden
entlang, hatten die roten Schürzen vom Kopf auf die Schultern
gleiten lassen und schwadronierten.</p>
<p class="calibre3">Boryna wurde, als er Eve mit dem Kind auf dem Arm entdeckte, wie
sie im Haufen ihrer Zeugen stand, sofort wütig, denn der Jörn kam
ihn leicht an, er spie aus und betrat den langen Flur, der das
Gerichtsgebäude quer durchlief.</p>
<p class="calibre3">Linkerhand lagen die Gerichtszimmer und rechts hatte der
Gerichtsschreiber seine Wohnung; gerade hatte Hyacinthus <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page88" title="DaoH/gary"></a> den Samowar auf die
Schwelle gesetzt und schürte die Glut mit dem Schaft eines
Krempstiefels so eifrig an, daß der Samowar wie ein Fabrikschlot
qualmte und jeden Augenblick schnarrte eine verärgerte Stimme aus
dem Hintergrund des qualmerfüllten Flurs.</p>
<p class="calibre3">»Hyacinth! die Stiefel für die Fräulein!«</p>
<p class="calibre3">»Gleich, gleich!«</p>
<p class="calibre3">Der Samowar brauste schon wie ein Vulkan und spie Flammen.</p>
<p class="calibre3">»Hyacinth! Wasser zum Waschen für die Gnädige.«</p>
<p class="calibre3">»Gleich doch, alles wird sich machen, alles!« Und schwitzend,
halb von Sinnen jagte er im Flur herum, daß es dröhnte, kehrte um,
schürte wieder und raste wieder zurück, denn die Gnädige
schrie.</p>
<p class="calibre3">»Hyacinthus! Du Lümmel, wo sind meine Strümpfe! ...«</p>
<p class="calibre3">»Oh, du mein! Ein Aas, nicht 'n Samowar!«</p>
<p class="calibre3">Das alles dauerte ein paar gute Paternoster oder vielleicht auch
so lange wie man einen Rosenkranz betet, bis schließlich die
Gerichtstüren sich öffneten und das Volk die große weißgekalkte
Stube zu füllen begann.</p>
<p class="calibre3">Hyacinth, jetzt schon als Gerichtsdiener, barfuß in hellblauen
Hosen und in einer kurzen Jacke von der gleichen Farbe mit
Messingknöpfen dran und mit einem roten schwitzigen Gesicht, das er
immer wieder mit dem Ärmel wischte, machte sich eifrig hinter dem
schwarzen Gitter zu schaffen, das die Stube in zwei Hälften teilte.
Er schüttelte den Kopf, wie ein Pferd, das eine Bremse sticht, und
die flachsblonden Haare fielen ihm wie eine Mähne über die Augen,
oder er sah behutsam in die Nebenstube und setzte sich auf einen
Augenblick am grünen Ofen nieder.</p>
<p class="calibre3">Es hatte sich soviel Volk hineingedrängt, daß man nicht einmal
einen Finger dazwischenstecken konnte, sie drängten immer stärker
gegen die Schranke an, die schon zu krachen anfing; das erst noch
leise Stimmengewirr steigerte sich allmählich, bis es wie ein
Sausen klang, das durch die Stube <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page89" title="DaoH/gary"></a> fuhr und zuweilen aufbrauste und hier und da
zu einem deutlich vernehmbaren Gezänk wurde, bei dem die Kraftworte
immer dichter fielen.</p>
<p class="calibre3">Unter den Fenstern babbelten die Juden, und ein paar Weiber
erzählten laut von dem Unrecht, das man ihnen angetan hatte und
weinten noch lauter dazu, aber man konnte nicht auseinanderkennen,
wo und wer es war, denn Kopf an Kopf gedrängt stand die Menge da,
wie ein Roggenfeld voll roter Mohnblumen, über das der Wind
streicht, und das aufschaukelt und raunt und rauscht, und dann
stehenbleibt Ähre neben Ähre. Auch Eve, die den an die Schranke
gelehnten Boryna erspäht hatte, fing an zu schreien und ihm giftige
Bemerkungen zuzuwerfen, so daß er beleidigt und im scharfen Ton ihr
antwortete.</p>
<p class="calibre3">»Schweig still, du Hündin, sonst werde ich dir deine Knochen
nachzählen, daß dich die eigene Mutter nicht auskennt.«</p>
<p class="calibre3">Als Antwort darauf stürzte sich Eve mit gespreizten Krallen
gegen ihn und fing an, sich durch das Menschendickicht
hindurchzudrängeln, das Kopftuch rutschte ihr vom Kopf und das Kind
begann zu schreien. Gott weiß, womit es geendet hätte, wenn
Hyacinth, der Gerichtsdiener, nicht plötzlich aufgesprungen wäre
und die Tür aufreißend gerufen hätte:</p>
<p class="calibre3">»Still, Aaszeug, das Gericht kommt! ...«</p>
<p class="calibre3">Das Gericht trat ein; voraus der dicke, hohe Erbherr auf
Raciborowice, und hinter ihm zwei Schöffen und der
Gerichtssekretär, der sich an ein Nebentischchen am Fenster setzte,
die Papiere ausbreitete und zu den Richtern hinüberblickte, die
hinter einem großen mit rotem Tuch bedeckten Tisch stehengeblieben
waren und die goldenen Ketten um die dicken Nacken legten.</p>
<p class="calibre3">Es wurde still, nur die Stimmen der Leute, die auf der Straße
vor den Fenstern sprachen, hörte man noch.</p>
<p class="calibre3">Der Erbherr legte die Papiere auseinander, räusperte sich,
blickte auf den Sekretär und kündete mit tiefer weit <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page90" title="DaoH/gary"></a> vernehmbarer Stimme an, daß
die Gerichte begonnen hätten.</p>
<p class="calibre3">Darauf las der Sekretär die auf diesen Tag fallenden Termine vor
und flüsterte dann etwas dem ersten Schöffen zu, der es dem Richter
weitergab, welcher bejahend mit dem Kopf nickte.</p>
<p class="calibre3">Die Gerichtssitzung nahm ihren Lauf.</p>
<p class="calibre3">Zuerst kam die Klage eines Flurjägers gegen einen Stadtfratz
wegen Verunreinigung eines Hofes.</p>
<p class="calibre3">Er wurde in Abwesenheit verurteilt.</p>
<p class="calibre3">Dann eine Klage wegen Verprügelung eines Jungen, der die Pferde
im fremden Klee geweidet hatte.</p>
<p class="calibre3">Man einigte sich/die Mutter bekam fünf Rubel und der Junge neue
Hosen und eine neue Jacke.</p>
<p class="calibre3">Ein Termin wegen Einpflügens in ein fremdes Feld.</p>
<p class="calibre3">Vertagt aus Mangel an Beweisen.</p>
<p class="calibre3">Ein Termin wegen Waldfrevels im Walde des Richters; der
Verwalter stand Zeuge/verklagt waren die Bauern aus Rokiciny.</p>
<p class="calibre3">Verurteilt zu Geldstrafen oder zum Absitzen/jeder für zwei
Wochen.</p>
<p class="calibre3">Sie nehmen das Urteil nicht an, sie werden appellieren.</p>
<p class="calibre3">Und so laut fingen sie an über die Ungerechtigkeit zu schreien,
denn der Wald war gemeinsam, mit Servituten belegt, daß der Richter
dem Hyacinthus ein Zeichen machte und dieser donnerte los:</p>
<p class="calibre3">»Still, still da, hier ist das Gericht, keine Schenke.«</p>
<p class="calibre3">So ging ein Termin hinter dem andern vorüber, gleichmäßig wie
Erdscholle nach Erdscholle und ziemlich ruhig; nur manchmal erhoben
sich Klagen und Schluchzen oder auch ein Fluch, den Hyacinthus
sofort unterdrückte.</p>
<p class="calibre3">Aus der Gerichtsstube waren schon einige gegangen, und doch war
es abermals so gedrängt voll geworden, daß die Menschen, wie eine
Garbe, zusammengepreßt standen, niemand konnte sich rühren, und die
Hitze war so groß, daß <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page91" title="DaoH/gary"></a> man kaum Atem holen konnte, bis der Richter den
Befehl gab, die Fenster zu öffnen.</p>
<p class="calibre3">Jetzt kam die Gerichtssache des Bartek Kosiol aus Lipce; wegen
des Diebstahls eines Schweins bei Marziana Antonowna Patsches.
Zeugen: dieselbe Marziana, ihr Sohn Simeon und Barbara Kleinhund
...</p>
<p class="calibre3">»Die Zeugen zugegen?« fragte ein Schöffe.</p>
<p class="calibre3">»Sind da!« riefen sie zusammen.</p>
<p class="calibre3">Boryna, der bis jetzt geduldig und für sich an der Schranke
gelehnt hatte, schob sich etwas näher zur Patscheswittib heran, um
sie zu begrüßen, weil sie Jagnas Mutter, die Dominikbäuerin
war.</p>
<p class="calibre3">»Der Beklagte, Bartek Kosiol, näher vor die Schranke.«</p>
<p class="calibre3">Ein untersetzter Bauer, drängte mitten aus der Menge so heftig
nach vorne, daß man zu fluchen begann, er träte die Leute und
zerreiße die Kleidung.</p>
<p class="calibre3">»Still, Aaszeug, das hochlöbliche Gericht spricht,« schrie
Hyacinth, den Bauer vorlassend.</p>
<p class="calibre3">»Seid ihr Bartholomäus Kosiol?«</p>
<p class="calibre3">Der Bauer kratzte sich besorgt über das dichte, in einer geraden
Linie verschnittene Haar; ein dummeliches Lächeln verzog sein
dürres ausrasiertes Gesicht, und die kleinen rotbebuschten Äuglein
sprangen wie Eichhörnchen schlau von Richter zu Richter.</p>
<p class="calibre3">»Seid ihr der Bartholomäus Kosiol?« fragte der Richter abermals
den schweigenden Bauer.</p>
<p class="calibre3">»Sehr wohl, dieser hier ist der Bartholomäus Kosiol zu dienen
der hochlöblichen Gerichtsamkeit!« piepste mit einmal eine
gewaltige Frau, die sich energisch vor der Schranke
aufpflanzte.</p>
<p class="calibre3">»Und ihr, was wollt ihr?«</p>
<p class="calibre3">»Bin doch die Frau, euer Hochwohlgeboren zu dienen, die Frau von
dem mageren Schlucker da, dem Bartek Kosiol,« und sie grüßte mit
der Hand bis zur Erde, so daß die gezängelte Haube an dem
Richtertisch haken blieb.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page92" title="DaoH/gary"></a> »Seid ihr
Zeuge?«</p>
<p class="calibre3">»Zeuge sozusagen? nicht ni ..., nur euer Hochwohlgeboren zu
dienen ...«</p>
<p class="calibre3">»Schmeiß' sie hinter die Schranke, Gerichtsdiener.«</p>
<p class="calibre3">»Zurück hier, Frau, hier ist kein Platz für euch ...« Er packte
sie an den Schultern und schob sie hinterrücks der Schranke zu.</p>
<p class="calibre3">»Ich möchte die hochlöbliche Gerichtsamkeit untertänigst gebeten
haben, weil Meiner nicht gut hören kann, sozusagen ...,« schrie
sie.</p>
<p class="calibre3">»Zurück solange ich gut bin!« Sie schnaufte, so hatte er sie
gegen die Schranke geschoben, denn sie wollte keinen Schritt im
guten weichen.</p>
<p class="calibre3">»Geht hinaus, wir werden laut reden, dann hört er schon und wenn
er auch nur euer Kosiol ist.«</p>
<p class="calibre3">Die Untersuchung begann.</p>
<p class="calibre3">»Wie ist der Name.«</p>
<p class="calibre3">»Hää? ... Name? ... Haben doch gerufen, den wissen Sie doch
...«</p>
<p class="calibre3">»Dummkopf. Wie ihr euch nennt?« forschte der Richter
unerbittlich weiter.</p>
<p class="calibre3">»Bartek Kosiol, hochlöbliche Gerichtsamkeit,« warf die Frau
dazwischen.</p>
<p class="calibre3">»Wie alt?«</p>
<p class="calibre3">»Hää? alt? ... kann ich das wissen! Wieviel Jahr' Mutter?
...«</p>
<p class="calibre3">»Zweiundfünfzig kann er schon im Frühjahr werden, mein'
ich.«</p>
<p class="calibre3">»Hofbauer?«</p>
<p class="calibre3">»Ih ... schöner Bauer... drei Morgen Land und ein Kuhschwanz
dazu.«</p>
<p class="calibre3">»Schon vorbestraft?«</p>
<p class="calibre3">»Hää? bestraft? ...«</p>
<p class="calibre3">»Ob ihr gesessen habt?«</p>
<p class="calibre3">»Im Kriminal meint ihr? ... von wegen Strafe? ... Mutter, war
ich denn im Kriminal, he? ...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page93" title="rudi49/gary"></a> »Das warst
du, Bartek, das warst du, da haben dich doch die Biester von dem
Gutshof wegen dem toten Lämmlein ...«</p>
<p class="calibre3">»Is wahr, is wahr ... auf der Weide habe ich ein verrecktes Lamm
gefunden ... da hab' ich's mitgenommen, was sollen's die Hunde
auseinanderschleppen ... verklagt haben sie mich, geschworen, daß
ich gestohlen hab', das Gericht hat verurteilt ... Sie haben mich
eingesteckt, da hab' ich auch gesessen ... Ungerechtigkeit, nur
Ungerechtigkeit immer ...,« redete er dumpf und sah sich unmerklich
nach seiner Frau um.</p>
<p class="calibre3">»Ihr seid angeklagt wegen Diebstahl eines Mutterschweins der
Marziana Patsches! Ihr habt es vom Feld genommen, nach Hause
getrieben, abgeschlachtet und aufgegessen. Was habt ihr zu eurer
Verteidigung zu sagen? ...«</p>
<p class="calibre3">»Hää? Aufgegessen! Daß ich den lieben Gott nicht bei meinem Tode
sehe, wenn ich sie gegessen hab' ... Oh, Herr, aufgegessen! ... Oh,
über diese Welt, diese Welt, ich hab' sie aufgegessen!« rief er
klagend.</p>
<p class="calibre3">»Was könnt ihr denn zu eurer Verteidigung sagen?«</p>
<p class="calibre3">»Verteidigung? ... sollt' ich was zu sagen haben, Mutter? ...
Jawohl, ich weiß schon; ich bin nicht schuldig, das Schwein hab'
ich nicht gegessen, aber dem Dominik sein' Wittib, mein' ich, bellt
sich was, wie 'n Hund, daß man ihr nur so an die Schnauze langen
sollte und verprügeln ... ah ...«</p>
<p class="calibre3">»Menschenkinder, hört ihn bloß ...,« stöhnte die
Dominikbauerin.</p>
<p class="calibre3">»Das könnt ihr euch für später aufheben, erzählt nur jetzt, wie
es kam, daß das Schwein der Patsches sich bei euch vorfand?
...«</p>
<p class="calibre3">»Das Schwein der Patsches ... bei mir? ... Mutter, was meint der
hochwohlgeborene Erbherr? ...«</p>
<p class="calibre3">»Das ist doch wegen dem Ferkel, Bartek, das dir bis in die Hütte
nachgekommen ist ...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page94" title="clehners/gary"></a> »Ich
weiß schon, jawohl, ich weiß schon, ein Ferkel war das und gar kein
Schwein, zu dienen dem Hochwohlgeborenen Gericht, man soll es
hören, was ich gesagt habe, ich tu' es aussagen; ein Ferkel war es
und kein Schwein; ein weißes Ferkel und schwarz gefleckt am Schwanz
oder noch etwas tiefer.«</p>
<p class="calibre3">»Gut, wie hat sich das zu euch gefunden?«</p>
<p class="calibre3">»Zu mir, zum Beispiel? ... Gleich will ich alles gründlich
erzählen, woraus sich ergeben wird vor dem hochlöblichen Gericht
und vor allem Volk/daß ich nicht schuldig bin und die
Dominikwittib/ein Zigeuner, ein Klatschmaul und eine verdammte
Zunge ist! ...«</p>
<p class="calibre3">»Ich betrüge! Bei der allerheiligsten Jungfrau will ich
erflehen, daß dich der Blitz trifft ohne die heilige Beichte!«
sagte die Dominikbäuerin leise, mit einem schweren Seufzer zum Bild
der Mutter Gottes aufsehend, und dann, da sie nicht länger an sich
halten konnte, steckte sie die zusammengeballte dürre Faust ihm
entgegen und zischte:</p>
<p class="calibre3">»Du Schweinedieb, du Räuber, du!« ... und sie spreizte die
Finger, als wollte sie ihn greifen.</p>
<p class="calibre3">Aber Bartels Frau warf sich ihr kreischend entgegen.</p>
<p class="calibre3">»Was, schlagen möchtest du ihn, du Hündin, schlagen, du Hexe, du
Rabenmutter deiner Söhne, du!«</p>
<p class="calibre3">»Ruhe!« rief der Richter.</p>
<p class="calibre3">»Maul halten, wenn das Gericht spricht, sonst kriegt ihr das
Alleinsein zu schmecken!« bekräftigte Hyacinth, die Leinwandhose
hochziehend, denn der Hosengurt war ihm geplatzt.</p>
<p class="calibre3">Es wurde gleich still, und die Weiber, die schon nahe daran
waren, einander in die Schöpfe zu fahren, blieben stehen und
bohrten einander mit den Blicken an, vor Gift nach Atem schnappend
...</p>
<p class="calibre3">»Redet, Bartholomäus, erzählt alles, aber bei der Wahrheit
bleiben.«</p>
<p class="calibre3">»Die Wahrheit? ... die reine Wahrheit will ich erzählen, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page95" title="clehners/gary"></a> rein wie Glas,
ehrlich will ich alles sagen, wie in der Beichte, wie 'n Hofbauer
zu einem Hofbauer, wie man nur zu seinen Leuten spricht, denn ich
bin ein Hofbauer vom Großvater und Urgroßvater her, kein Kätner,
kein Prefessiant oder ein Stadtlump.«</p>
<p class="calibre3">»Das war so.«</p>
<p class="calibre3">»Guck' gut auf deine Gedanken, damit du nichts vergißt,« rief
ihm die Frau zu.</p>
<p class="calibre3">»Nee, ich werd' es nicht vergessen, Magdusch, nee. Das war so.
Ich geh' also ... ich glaube es war gerade Frühjahr... und hinter
der Wolfskuhle, neben Boryna seinem Klee... ich geh' also und sage
mein Gebet her, denn wenn ich so sagen soll, hatte man schon zum
Ave geläutet ... Es nächtelte schon ... ich geh' also ... da hör'
ich 'ne Stimme, oder keine Stimme? ... Du lieber Gott, denk' ich,
grunzt es oder grunzt es nicht? ... Ich sehe hinter mich – nichts
zu sehen, ganz und gar still.</p>
<p class="calibre3">Der Böse versucht mich oder was? ... Ich gehe weiter, weil mir
aber etwas wie Ameisen über den Rücken kam, aus Angst, so spreche
ich das Ave für mich hin. Es grunzt wieder! Sieh, denk' ich, nichts
als 'n Schwein oder auch 'n Ferkel. Ich steig' etwas 'runter in den
Klee und sehe mich um ... jawohl, irgend etwas kriecht sich, ich
bleibe stehen/ das bleibt auch stehen, was Weißes, Niedriges und
Langes ... und die Glotzen leuchteten ihm wie bei einer Wildkatze
oder beim Schlechten ... Ich bekreuzigte mich, und da es mir nur so
kalt über die Haut fuhr, mach ich, daß ich schneller
vorwärtskomm'/versteht sich, weiß man denn, was sich in den Nächten
herumtreibt? ... Und alle wissen es in Lipce, daß es in der
Wolfskuhle umgeht.«</p>
<p class="calibre3">»Das is schon so,« erläuterte die Frau, »denn voriges Jahr, als
der Kohlmeis dort nachts vorüberging, hat ihn irgendwas an die
Gurgel gepackt und zu Boden geschmissen und so verhauen, daß der
Mann zwei Wochen krank gelegen hat.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page96" title="Wunibald/gary"></a> »Sei man
still, Magdusch, sei man still! Ich gehe also, ich gehe und gehe
... und dieses kommt immerlos nachgekrochen und grunzt!</p>
<p class="calibre3">Und da gerade das helle Mondlein herausgekommen ist, sehe ich /
das ist ja nur 'n Ferkel und nichts Schlechtes. Ich wurde
ärgerlich, was bildet sich das dumme Vieh ein / den Menschen bange
machen, da hab' ich einen Zweig danach geschmissen und gehe heim.
Ich ging auf dem Feldrain zwischen Michaels Rüben und Boryna seinem
Weizen, und dann zwischen Tomeks Sommerkorn und Jasieks Hafer, den,
mein' ich, den man voriges Jahr zum Militär genommen hat, und dem
seine Frau von gestern her im Kindbett liegt ... Und das Ferkel wie
'n Hund immer wieder hinter mir drein, einmal nebenher, dann ab in
die Kartoffeln der Dominikwittib, und hier wird geschnüffelt, und
da wird geschnüffelt, und hier wird gegrunzt und da wird gequiekt,
aber zurückbleiben, nein, immer wieder hinter mir drein ...</p>
<p class="calibre3">Ich biege auf den Fußweg, der querfeldein geht – und das Ferkel
auch. Da ist mir aber die Hitze angekommen, denn Herr du meine
Güte, so 'n Schwein, das ist vielleicht gar kein Schwein! Ich biege
auf den Weg neben dem Kruzifix, und das Ferkel auch... Weiß war es,
das sah ich, und weiter unten beim Schwanz schwarzgefleckt. Ich
über den Graben, es kommt mir nach; ich über die Grabhügel hinterm
Kruzifix/es kommt mir nach, ich auf den Steinhaufen d'rauf, und wie
es sich mir zwischen die Beine schmeißt, da lieg' ich schon im
Dreck so lang ich bin. Ich denk', es is besessen oder was soll
passieren! ... Kaum hab' ich meine Glieder wieder zusammen / und
das Ferkel, heidi den Schwanz hoch und in Sprüngen vor mir her!
Renn' du nur, Pestige, hab' ich mir gedacht. Aber weglaufen, nee,
immer nur vor mir her ist es gerannt bis zu meiner Hütte / ganz bis
zu meiner Hütte, hochlöbliches Gericht, bis in die Umzäumung ist es
reingegangen, in den Flur auch, und weil die Tür offen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page97" title="Frank_9901/gary"></a> war,
direktemang in die Stube... So helfe mir Gott, Amen!«</p>
<p class="calibre3">»Und dann habt ihr sie geschlachtet und aufgegessen, nicht
wahr?« sagte der Richter amüsiert.</p>
<p class="calibre3">»Hä! Geschlachtet und aufgegessen? ... Ja, was sollten wir denn
tun? Ein Tag geht vorüber / das Ferkel geht nicht weg; eine Woche /
es ist immer noch da, gar nicht wegzutreiben, und schmeiß' ich es
raus, kommt es mit Gequiek wieder zurück ... Die Meinige steckte
ihm zu, was wir über hatten, was sollten wir machen, verhungern
lassen, ih nee, so was tut man doch nicht, ist doch auch 'n
Geschöpf Gottes ... Das hochlöbliche Gericht ist klug, da wird es
sich schon gerecht auslegen, daß ich armer Schlucker mit ihr so
umgehen mußte! Niemand holt sie und zu Hause nichts zu essen / und
gefressen hat sie, daß zwei andere nicht so viel verschlingen ...
Noch 'n Monat und sie hätte uns mit Haut und Haar mit aufgefressen
... Was sollten wir tun? sollte sie uns / so haben wir sie selbst
aufgegessen und dazu noch nicht die ganze, denn im Dorf haben sie's
zu hören gekriegt, und die Dominikbäuerin hat geklagt, den
Schultheiß hat sie mir ins Haus gebracht und weggeholt haben sie
mir alles ...«</p>
<p class="calibre3">»Alles? Und die ganzen Hinterschinken, wo sind die geblieben,
was? ...« zischte die Dominikbäuerin drohend hervor.</p>
<p class="calibre3">»Wo? Fragt mal den Krutschek und andere Köter. / Für die Nacht
haben wir es in die kleine Scheune gebracht. Die Hunde, was so
Biester für Witterung haben / und dabei hat die Scheunentür noch
Löcher / haben sie 'rausgeschleppt und sich ein Fest gemacht, aus
meiner mühseligen Arbeit, daß sie 'rumgelaufen sind dickgefressen,
wie die reinen Herren.«</p>
<p class="calibre3">»Das Schwein ist, hast du nicht gesehen, von selbst ihm
nachgelaufen, das glaubt ihm ein Dummer, aber nicht das Gericht.
Diebsgesindel! und das Schaf, wer hat das <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page98" title="Frank_9901/gary"></a> dem Müller gestohlen und
Hochwürden seine Gänse / was? ...«</p>
<p class="calibre3">»Hast du es gesehen, was? Hast du es gesehen!« kreischte Kosiols
Frau auf, mit den Krallen heranspringend.</p>
<p class="calibre3">»Und die Kartoffeln aus der Kartoffelgrube vom Organist, wer hat
sie? ... Und immerzu is im Dorf was weg, einmal is es man 'n
Gänschen, denn wieder 'n Huhn, und dann wieder ein Stück Hausrat,«
setzte sie unerbittlich fort.</p>
<p class="calibre3">»Du Aas! Und was hast du getrieben, wie du jung warst, man weiß,
was stellt die Deine mit den Burschen an, das wirft dir niemand
vor, und du kläffst noch wie 'n Hund ...«</p>
<p class="calibre3">»Hüte dich, an meine Jagna zu rühren! Hüte dich, sonst schlag'
ich dir dein Maul bunt und blau, daß dir ... Hüt' du dich nur! ...«
brüllte sie auf, bis ins lebendige Fleisch getroffen.</p>
<p class="calibre3">»Ruhig da, Krakeeler, sonst wird 'rausgeschmissen!«
beschwichtigte Hyacinth, seine Hosen zurechtrückend.</p>
<p class="calibre3">Das Verhör der Zeugen begann.</p>
<p class="calibre3">Zuerst zeugte die Dominikbäuerin als Geschädigte / sie sagte aus
mit einer leisen, andächtigen Stimme und schwor alle Augenblicke
bei der Tschenstochauer Muttergottes, das Schwein sei ihrs, sie
bekreuzigte sich und schlug sich vor die Brust / es wäre die
lautere Wahrheit, daß Kosiol die Sau von der Weide gestohlen hätte,
sie wolle aber keine Strafe dafür von seiten des hochlöblichen
Gerichts, der liebe Herr Jesus möge ihm schon dafür nicht am
Fegefeuer sparen; dagegen forderte sie aber mit mächtiger Stimme
Gericht und Strafe für die Beleidigung, die die Kosiols ihr und
Jagna vor allem Volke angetan.</p>
<p class="calibre3">Darauf zeugte Schymeck, einer von den Söhnen der Dominikbäuerin;
die Mütze hing an den wie zum Gebet zusammengefalteten Händen und
seine Augen waren ununterbrochen auf den Richter gewendet. Mit
einer kläglichen, geistesabwesenden Stimme sagte er aus, daß die
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page99" title="Frank_9901/gary"></a> Sau der
Mutter gehörte, sie wäre über den ganzen Körper weißlich gewesen
und hatte nur am Schwanz einen schwarzen Fleck, auch ein
zerrissenes Ohr habe sie gehabt, denn Boryna sein Waupa hätte sie
im Frühjahr daran gepackt und sie hätte so geschrien, daß er,
obgleich er in der Scheune war, es gehört habe ...</p>
<p class="calibre3">Dann wurden Barbara Kleinhund und andere aufgerufen.</p>
<p class="calibre3">Sie zeugten der Reihe nach und legten den Schwur ab, Schymek
aber stand immerzu da mit der Mütze in den Händen und gaffte den
Richter an; Kosiols Frau versuchte sich mit Geschrei, Verleugnungen
und Flüchen durch die Schranke zu drängen, und die Dominikbäuerin
seufzte nur das heilige Bild an und blickte auf Kosiol, dessen
Augen herumsprangen, der herumhorchte und sich immer wieder auf
seine Magdusch umguckte.</p>
<p class="calibre3">Das Volk hörte aufmerksam zu, und immer wieder schlugen
Geflüster, bissige Bemerkungen oder Gelächter bis zur Balkendecke
empor, so daß Hyacinth sie mit Drohungen beschwichtigen mußte.</p>
<p class="calibre3">Die Verhandlung dauerte ohne Unterbrechung bis zur Pause,
während der sich das Gericht in die Nebenstube zurückzog, um zu
beratschlagen. Das Volk war auf den Flur und vor das Haus getreten,
um etwas Luft zu schöpfen: der eine um sich etwas zu stärken, der
andere um sich mit seinen Zeugen zu besprechen, einer um sich über
sein Unrecht auszubreiten, ein anderer wiederum um über die
Ungerechtigkeit Klage zu führen und zu fluchen, wie das üblich ist
bei den Gerichtsterminen.</p>
<p class="calibre3">Nach der Gerichtspause und nach dem Vorlesen der Gerichtssprüche
kam Borynas Fall zur Verhandlung.</p>
<p class="calibre3">Eve stellte sich, das Kind schaukelnd, das in eine Schürze
gewickelt war, vor die Richter und fing an, weinerlich und klagend
das ihr geschehene Unrecht vorzutragen; sie wäre bei Boryna in
Dienst gewesen und hätte gearbeitet bis ihr <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page100" title="Frank_9901/gary"></a> die Füße wie Klumpen wurden,
nie hätte sie ein gutes Wort gehört, nicht mal 'ne eigne Ecke zum
Schlafen hätte man ihr gegeben, und für das Essen hätte sie bei den
Nachbarn herumlungern können, und ihren Lohn hätte er ihr
zurückbehalten, und mit seinem eigenen Kind hatte er sie in die
Welt hinausgejagt... und zuletzt kam ein heftiger Heulausbruch, und
sie warf sich mit Geschrei vor den Richtern auf die Knie.</p>
<p class="calibre3">»Das hat er mir angetan! Das hat er, und dieses hier auch, das
Kind ist sein, durchlauchtigstes Gericht!«</p>
<p class="calibre3">»Die lügt wie 'n Hund,« murmelte Boryna entsetzt.</p>
<p class="calibre3">»Ich lüge?! Alle wissen es doch, das ganze Dorf, daß er ...«</p>
<p class="calibre3">»Daß du 'ne Hündin und ein Rumtreiber bist ...«</p>
<p class="calibre3">»Und früher, hochwohlgeborenes Gericht, da nannte er mich Evka,
seine Evusch und mit noch süßeren Namen, und Perlenschnüre brachte
er mir, und oftmals 'ne Semmel aus der Stadt und sagte noch: hier
hast du, Evusch, dich hab' ich am liebsten ... und jetzt, Jesu,
mein Jesu! ...« sie brüllte los.</p>
<p class="calibre3">»So 'n Lügenmaul, vielleicht hab' ich dich noch mit dem
Federbett zugedeckt und dir gesagt: schlaf, mein Evusch, schlaf!
...«</p>
<p class="calibre3">Die ganze Stube erdröhnte vor Lachen.</p>
<p class="calibre3">»Und habt ihr nicht vielleicht, nein? Wie 'n Hund vor der Tür
habt ihr gewinselt, und was habt ihr mir da alles versprochen,
ha?«</p>
<p class="calibre3">»Du mein Gott, Leute, daß der Blitz nicht solch Scheusal auf der
Stelle trifft!« rief er fassungslos aus.</p>
<p class="calibre3">»Hochwohlgeborenes Gericht, die ganze Welt hat es gesehen, wie
er war, ganz Lipce kann es bezeugen, daß ich die Wahrheit spreche.
Ich war doch bei denen in Dienst, da hat er mir immerzu keine Ruhe
gelassen. Oh, ich arme Waise, ich Arme ... Oh, mein unseliges Los
... Was konnte ich mich denn gegen solch großes Mannsbild wehren?
... Geschrien hab' ich, da hat er mich durchgeprügelt und gemacht
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page101" title="Monne3/Pirki"></a> was er
wollte ... Wo soll ich denn nun abbleiben mit einem so kleinen
Kindelchen, wo nur? ... Die Zeugen werden es sagen und bezeugen!«
schrie sie zwischen Heulen und Jammern.</p>
<p class="calibre3">Die Zeugen hatten aber inzwischen nichts ausgesagt als Klatsch
und Vermutungen, darum begann sie von neuem zu beweisen und zu
überzeugen, bis sie zu guter Letzt als endgültigen Beweis, das Kind
auswickelte und es vor die Richter legte; es strampelte mit den
nackten Beinchen und schrie gottsjämmerlich.</p>
<p class="calibre3">»Das hochwohlgeborene Gericht wird selbst sehen, wessen es ist;
da, grad' dieselbe Kartoffelnase und auch die Triefaugen grad' so
grau, wie seine ... Wie ein Ei aufs andere, das ist 'n Boryna, kein
anderer! ...« rief sie.</p>
<p class="calibre3">Aber auch das Gericht konnte sich nicht länger vor Lachen
halten, und das Volk johlte vor Vergnügen. Man sah das Kind an,
dann wieder den Boryna, und immer wieder fielen die
Bemerkungen:</p>
<p class="calibre3">»Schöne Jungfer das, wie 'n geschundener Hund!«</p>
<p class="calibre3">»Boryna ist 'n Witwer, mag er sich mit der verheiraten, kriegt
er gleich 'n Hüterjungen mit ...«</p>
<p class="calibre3">»Und ruppig is' sie, wie 'ne Kuh im Frühjahr.«</p>
<p class="calibre3">»Was Feines, ja, aber erst mit Erbsenstroh ausgestopft und in
die Hirse gesetzt / die Krähen wird sie vertreiben ...«</p>
<p class="calibre3">»Die Hunde laufen so wie so schon, wenn Evusch durchs Dorf
kommt! ...«</p>
<p class="calibre3">»Und ein Mäulchen hat sie, wie mit Spülwasser begossen...«</p>
<p class="calibre3">»Weil sie eine gute Hausfrau ist, die wäscht sich nur einmal im
Jahr, will doch Seife sparen ...«</p>
<p class="calibre3">»Den Juden heizt sie die Öfen, da hat sie keine Zeit, ist auch
kein Wunder! ...«</p>
<p class="calibre3">Man höhnte immer bissiger und erbarmungsloser, sie aber
verstummte und sah mit Augen eines gejagten Hundes von einem zum
anderen. Sie schien etwas zu überlegen ... <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page102" title="lesebaer/Pirki"></a></p>
<p class="calibre3">»Still da! 'ne Sünde is es, so über die Arme herzuziehen!« rief
die Dominikbäuerin so laut, daß alle verstummten, und manch einer
kratzte sich beschämt den Schädel.</p>
<p class="calibre3">Die Klage wurde abgewiesen.</p>
<p class="calibre3">Boryna fühlte eine gewaltige Erleichterung, denn wenn er auch
nicht schuldig war, so hatte er doch vor dem Gerede der Leute
Angst, na ja, und auch deswegen, daß er hätte zahlen müssen/denn
das Gesetz ist nun mal so, daß niemand weiß, wen es beim Kragen
fassen wird/den Schuldigen oder den, der recht hat. Das war nicht
einmal oder zweimal, nein, zehnmal war es schon so.</p>
<p class="calibre3">Er verließ sofort das Gericht, und in Erwartung der
Dominikbäuerin fing er an, die ganze Angelegenheit noch einmal zu
überlegen und in sich abzuwägen. Er konnte noch immer nicht
begreifen, warum und zu welchem Zweck Eve geklagt hatte.</p>
<p class="calibre3">»Nein, das ist nicht ihr Verstand und nicht ihr Kopf, das war
irgendein anderer, der durch sie nach ihm langte, aber wer nur?
...«</p>
<p class="calibre3">Sie gingen zu dritt, er, die Dominikbäuerin und ihr Schymek, in
die Schenke, einen Trunk zu tun und einen Happen zu essen, denn es
war schon spät am Mittag. Und obgleich ihm die Dominikbäuerin
leichthin erwähnte, daß er sich bei seinem Schwiegersohn, dem
Schmied, für die Klage der Eve bedanken müßte, konnte er es doch
gar nicht glauben.</p>
<p class="calibre3">»Was sollte der davon haben?«</p>
<p class="calibre3">»So viel, daß er euch reizen will, daß er euch Kummer besorgt,
und daß die Leute über euch lachen. Manch einer ist so, daß er dem
anderen zum Spaß die Haut vom Leibe schinden möchte.«</p>
<p class="calibre3">»Das ist mir doch merkwürdig, das mit Eve ihrer Verbissenheit!
Denn ich hab' ihr nichts zu Leid getan, und noch für die Taufe von
dem Wechselbalg hab' ich Hochwürden einen Sack Hafer gegeben...«
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page103" title="Monne3/Wunibald"></a></p>
<p class="calibre3">»Die dient beim Müller, dieser aber geht in Kumpanie mit dem
Schmied ... versteht ihr? ..</p>
<p class="calibre3">»Verstehen tu ich's, aber ich kann mich gar nicht darin
auskennen! Trinken wir noch einen!«</p>
<p class="calibre3">»Gott bezahl's, Matheus, trinkt zuerst!«</p>
<p class="calibre3">Sie tranken mal und noch einmal, aßen das zweite Pfund Wurst mit
einem halben Laib Brot. Der Alte kaufte eine Semmelreihe für Fine,
und sie schickten sich an, aufzubrechen.</p>
<p class="calibre3">»Setzt euch bei mir 'rauf, Dominikbäuerin, es wird einem mieß so
allein, wir können zusammen reden ...«</p>
<p class="calibre3">»Recht gern, nur will ich noch einen Sprung ins Kloster machen,
'n bißchen beten.«</p>
<p class="calibre3">Sie ging, kam aber in der Dauer von zwei Paternostern wieder
zurück, und sie fuhren ab.</p>
<p class="calibre3">Schymek zuckelte gemächlich hinterdrein, denn er hatte einen
alten Klepper vor dem Wagen, und die Sandwege waren schlimm. Da er
aber duselig war, denn er hatte nicht die Gewohnheit zu trinken,
und weil ihn die Gerichtsverhandlung mitgenommen hatte, so wackelte
er schlaftrunken in seinem Korbwagen hin und her, und wenn er zu
sich kam, riß er die Mütze vom Kopf, bekreuzigte sich fromm und
murmelte, geistesabwesend den Schwanz seiner Mähre anstarrend, als
wär' er das Gesicht des Gutsherrn aus der Gerichtsstube: »der
Mutter ihre Sau, ganz weißlich, nur am Schwanz der schwarze Fleck
...«</p>
<p class="calibre3">Die Sonne bog schon nach Westen, als sie in den Wald
einfuhren.</p>
<p class="calibre3">Sie redeten kaum viel, obgleich sie nebeneinander auf dem
Vordersitz saßen.</p>
<p class="calibre3">Hier und da sagte eins ein Wort, da es doch nicht Sitte ist,
nebeneinander wie Murmeltiere zu sitzen, aber es war nur grad so
viel, daß der Schlaf ihnen nicht ankam und die Zunge nicht trocken
würde ...</p>
<p class="calibre3">Boryna trieb die Jungstute an, denn sie hatte den Gang <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page104" title="lesebaer/Wunibald"></a> verlangsamt
und war vor Müdigkeit und Hitze bis zur Hälfte der Flanken mit
Schweiß bedeckt. Hin und wieder pfiff er vor sich hin und schwieg
sich aus. Er schien etwas durchzukäuen, wägte etwas in seinem
Innern ab, kalkulierte und blickte oft, aber unmerklich, zur Alten
hinüber, auf ihr ausgedörrtes, wachsbleiches Gesicht, das zu
länglichen Runzeln erstarrt war. Sie bewegte den zahnlosen Mund,
als ob sie im stillen betete; manchmal zog sie die rote, über den
Kopf geworfene Schürze tiefer in die Stirn, denn die Sonne schien
ihr in die Augen und blieb dann wieder unbeweglich sitzen, nur ihre
dunkelgrauen Augen glühten.</p>
<p class="calibre3">»Seid ihr schon mit den Kartoffeln fertig, ha?« begann er
schließlich.</p>
<p class="calibre3">»Versteht sich. Die haben dies Jahr nicht schlecht
getragen.«</p>
<p class="calibre3">»Wird gut sein, wenn ihr Jungvieh aufziehen wollt.«</p>
<p class="calibre3">»Einen jungen Eber hab ich in die Mastkoje getan, zu Fastnacht
kann man ihn brauchen...«</p>
<p class="calibre3">»Gewiß, gewiß ... ich höre, Raphus sein Walek hat mit Schnaps zu
euch geschickt? ...«</p>
<p class="calibre3">»Das haben schon mehr... aber das Geld hätten sie sich sparen
können ... für solche ist meine Jagusch nicht zu haben, nee...«</p>
<p class="calibre3">Sie hob den Kopf und bohrte sich mit Sperberaugen in ihn hinein,
aber Boryna, der doch ein Mann in Jahren war, nicht irgendein
Windbeutel, zeigte ein gleichgültiges, kühles Gesicht, aus dem
nichts herauszulesen war. Lange sprachen sie kein Wort, als wollten
sie in diesem Schweigen ihre Kräfte aneinander messen.</p>
<p class="calibre3">Boryna war es nicht recht, als erster anzufangen, denn wieso
denn, er war doch schon in Jahren und der erste Bauer in ganz
Lipce; und wie konnte er denn kurzweg sagen, daß ihm Jagusch recht
war?... Er hatte doch seine Ehre und seinen Verstand ... aber da er
von Natur aus heißen Blutes war, konnte er kaum an sich halten vor
Arger, daß er <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page105" title="lesebaer/Wunibald"></a> so aufpassen und im Bogen um den Brei
herumgehen mußte.</p>
<p class="calibre3">Die Dominikbäuerin meinte ihn etwas zu durchschauen und zu
erraten, was ihm so wider den Strich ging und mißmutig machte, aber
nicht mit einem Wörtlein half sie nach. Mal sah sie ihn an, mal
schaute sie vor sich in die Welt, in die Himmelsweiten, und sagte
wie unabsichtlich:</p>
<p class="calibre3">»Eine Hitze haben wir, wie zur Erntezeit.«</p>
<p class="calibre3">»Wie ihr sagt.«</p>
<p class="calibre3">So war es auch, denn den Weg umgaben die mächtigen Wände des
Forstes, die weder Luft noch den leisesten Windzug vom freien Feld
durchließen, und die Sonne hing gerade vor ihren Köpfen und brannte
so, daß die lechzenden Bäume bewegungslos dastanden und die Köpfe
matt neigten. Nur hin und wieder ließen sie ein paar bernsteingelbe
Nadeln gleiten, die wirbelnd auf den Weg niedersanken. Der pilzige
Duft, der von den Kolken kam, der Geruch des Eichenlaubs stieg
ihnen in die Nasen.</p>
<p class="calibre3">»Wißt ihr, es ist mir und auch andern verwunderlich, daß ein
Großbauer wie ihr einer seid, der doch nicht den ersten besten
Verstand hat, und so viel Grund und Boden, und so reputierlich bei
ein und jedem beisteht, gar keine Ehrsucht auf ein Amt hat...«</p>
<p class="calibre3">»Ihr trefft recht, gar keine Ehrsucht hab' ich. Was soll mir
das? Schultheiß bin ich ganze drei Jahr gewesen, da hab' ich bar
Geld zugezahlt. Und was hab' ich mich und meine Gäule dabei
abgeschunden! was hab' ich mich gegiftet, was für Scherereien hab'
ich gehabt/ein Hund, der auf 'm Feld Wache halten soll, hat's nicht
schlimmer. Und Niedergang war in der Wirtschaft, lauter Verlust, so
daß mir die Meine nicht ein gutes Wort gegönnt hat...«</p>
<p class="calibre3">»Die hatte auch ihren Verstand, aber ein Amt zu haben ist doch
'ne Ehre und ein Profit.«</p>
<p class="calibre3">»Danke schön. Vor dem Gendarm mußt du den Rücken krumm machen,
den Schreiber um die Beine fassen, und <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page106" title="lesebaer/Wunibald"></a> den ersten besten Esel vom
Amt auch ... Große Ehre! Werden die Steuern nicht bezahlt, wird
eine Brücke schlecht oder ein Hund toll, kriegt einer eins mit
einer Runge über den Schädel/wer hat da Schuld?... Der Schultheiß
hat Schuld, der Schultheiß muß es ausbaden! Jawohl, das ist Profit.
Gerade genug Hühner und Eier und manche Gans hab' ich zum Schreiber
und aufs Kreisamt getragen ...«</p>
<p class="calibre3">»Wahr ist es schon, aber dem Pietrek stößt die Schulzenschaft
nicht auf, nein; Feld hat er zugekauft und eine kleine Scheune
angebaut, und Pferde hat er, die reinen Elefanten!...«</p>
<p class="calibre3">»Das stimmt, man weiß nur nicht, was davon übrigbleibt, wenn er
sein Amt niederlegt...«</p>
<p class="calibre3">»Glaubt ihr?...«</p>
<p class="calibre3">»Ich hab' so meine Augen und merk' schon manches.«</p>
<p class="calibre3">»Großschnauzig ist er und selbst mit Hochwürden rupft er manche
Katz, denn Frieden kann er nicht halten.«</p>
<p class="calibre3">»Und daß ihm alles gelingt/das ist nur durch die Frau. Er
amtiert und die hält alles in der Faust.«</p>
<p class="calibre3">Sie schwiegen wieder gut ein Paternoster lang.</p>
<p class="calibre3">»Und ihr, schickt ihr denn nicht mit Schnaps zu einer?...«
fragte sie vorsichtig.</p>
<p class="calibre3">»Ii... bei mir brennt's nicht mehr nach den Weibern, zu alt bin
ich dazu...«</p>
<p class="calibre3">»Redet nicht, was ihr selbst nicht glauben könnt. Alt ist nur,
wer sich nicht rühren kann, dem man den Löffel an den Mund heben
muß und der auf der Ofenbank hockt und aufs Ende wartet... Ich sah
euch neulich, wie ihr einen Sack Roggen schlepptet.«</p>
<p class="calibre3">»Na ja, derb bin ich noch, aber welch eine würde mich
wollen?...«</p>
<p class="calibre3">»Wer nicht selbst probiert/was weiß der? Seht zu!«</p>
<p class="calibre3">»Alt bin ich, die Kinder wachsen heran und die erste beste nehm'
ich nicht.«</p>
<p class="calibre3">»Macht nur 'ne Verschreibung beim Notar, und die Beste wird
schon nichts gegen euch haben ...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page107" title="lesebaer/Wunibald"></a>
»Der Verschreibung wegen! Da hat man die Schweinerei! Für die paar
Morgen würde selbst die jüngste den Bettler vor der Kirchtür
heiraten...«</p>
<p class="calibre3">»Und die Mannsleut', die gucken nicht nach dem Heiratsgut?«</p>
<p class="calibre3">Antworten tat er nicht mehr, zog aber der Jungstute einen
solchen über, daß sie vom Platz weg in Galopp fiel.</p>
<p class="calibre3">Sie schwiegen lange.</p>
<p class="calibre3">Erst als sie aus dem Wald auf die Felder gekommen waren und
unter den Pappeln, die am Wegrand standen, entlang fuhren, brauste
Boryna, in den es inzwischen gegärt und gewühlt hatte, auf.</p>
<p class="calibre3">»Für die Hunde ist eine solche Einrichtung in der Welt! Für
alles mußt du zahlen, für das geringste gute Wort selbst! Schlecht
ist es und schlechter kann es gar nicht sein. Die Kinder selbst
ziehen gegen die Eltern los, keiner gehorcht mehr und alle fallen
sie übereinander her, wie die Hunde.«</p>
<p class="calibre3">»Das kommt davon, weil sie dumm sind und nicht bedenken, daß sie
allesamt unter die heilige Erde kommen.«</p>
<p class="calibre3">»Kaum ist der eine oder der andere ausgewachsen, und schon
gebraucht er sein Maulwerk gegen die Väter, sie sollen ihm sein
Erbteil geben. Über die Älteren machen sie sich nur lustig! Bande,
das Dorf ist ihnen zu eng, die alte Ordnung paßt ihnen nicht mehr,
selbst die Tracht ist schon manchem genierlich!«</p>
<p class="calibre3">»Das ist alles so, weil sie Gott nicht mehr achten ...«</p>
<p class="calibre3">»Darum, und auch nicht darum, aber es steht bös!«</p>
<p class="calibre3">»Und zum Besseren geht's nicht, nein.«</p>
<p class="calibre3">»Wie soll es auch gehen, wer wird sie dazu zwingen?«</p>
<p class="calibre3">»'ne Strafe Gottes! denn die Stunde des Gerichtes unseres Herrn
Jesu wird kommen, und sie wird kommen.«</p>
<p class="calibre3">»Aber was vorher noch an Volk zugrunde geht, das bringt niemand
wieder ein.«</p>
<p class="calibre3">»Solche Zeiten, es wäre besser, die Seuche käme über das
Land.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page108" title="lesebaer/lac"></a>
»Zeiten, ja, aber die Menschen sind auch dran schuld. Und so einer
wie der Schmied zum Beispiel? Oder der Schulze? Mit Hochwürden
zanken sie 'rum, hetzen die Leute auf, streuen Sand in die Augen
und die Dummen glauben's.«</p>
<p class="calibre3">»Dieser Schmied, das ist mein Gift, obgleich er mein
Schwiegersohn ist ...«</p>
<p class="calibre3">Und so klagten sie gemeinsam über die schlechte Welt und sahen
auf das Dorf, das zwischen den Pappelbäumen ihnen immer näher
rückte.</p>
<p class="calibre3">Nahe am Friedhof leuchteten schon von weitem die roten Gewänder
der in Reihen arbeitenden gebückten Frauen, über denen wie ein
zarter Flor der Rauch lag, und bald begann der Windhauch ihnen das
dumpfe eintönige Klatschen der Flachsbrechen zuzutragen, das aus
dem Wiesengrund kam.</p>
<p class="calibre3">»Die Zeit ist gut zum Flachsbrechen. Ich steig' da ab; meine
Jagusch ist dazwischen.«</p>
<p class="calibre3">»Ist mir kein Umweg, ich fahr' euch 'ran ...«</p>
<p class="calibre3">»Gut seid ihr, Matheus, daß es mich wundernimmt ...« Sie
lächelte verschmitzt ...</p>
<p class="calibre3">Er bog vom Pappelweg auf einen Feldpfad ab, der bis zur
Friedhofspforte hinlief und fuhr sie bis zu der Stelle, wo unter
der steingrauen Mauer, im Schatten der Birken und Ahorne und im
Bereich der Kreuze, die sich von den Grabhügeln zu den Feldern
herüberneigten, etliche Frauen emsig den getrockneten Flachs
brachen, so daß der Staub wie Dunst über ihnen hing und die langen
Fasern sich ins gelbe Birkenlaub verknüpften und an den schwarzen
Armen der Kreuze hängenblieben; nebenan an den aufgesteckten Ruten
trocknete man über Gruben, in denen Feuer brannten, den feuchten
Flachs.</p>
<p class="calibre3">Die Flachsbrechen klappten rasch, und die ganze Reihe der Frauen
beugte sich immer wieder in kurzen und raschen Stößen, nur hin und
wieder reckte sich die eine oder die andere gerade, klopfte ihren
Büschel Flachs von den letzten <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page109" title="lesebaer/lac"></a> Acheln frei, wickelte ihn zu einem Kogel
oder zu einer Puppe zusammen und warf sie vor sich auf ein
ausgebreitetes Leinentuch.</p>
<p class="calibre3">Die Sonne, die schon bis zu den Wäldern gerollt war, schien
ihnen direkt ins Gesicht, aber das störte sie nicht – denn die
Arbeit, das Gelächter und die frohen Reden ließen keinen Augenblick
nach.</p>
<p class="calibre3">»Glück zu bei der Arbeit!« rief Boryna nach Jagna hinüber, die
gleich vornean am Flachs hantierte; sie trug nur ein Hemd und ihren
roten Beiderwandrock, und um den Kopf ein Tuch gegen den Staub.</p>
<p class="calibre3">»Gott bezahl's!« gab sie ihm fröhlich zurück. Sie sah mit ihren
leuchtenden blauen Augen zu ihm auf, und ein Lächeln durchflog ihr
schönes sonnengebräuntes Gesicht.</p>
<p class="calibre3">»Is trocken, Töchterchen, was?« fragte die Alte, die
geschwungenen Flachsbündel betastend.</p>
<p class="calibre3">»Trocken wie Pfeffer, er bricht schon ...,« wieder lächelte sie
dem Alten zu, daß es ihm durch und durch ging; er schlug mit der
Peitsche durch die Luft und fuhr davon, aber fortwährend sah er
sich nach ihr um, obgleich sie schon längst außer Sicht war, so
lebhaft stand sie vor seinen Augen ...</p>
<p class="calibre3">»Ein Mädel wie eine Hinde ... Paßt gerade recht ...« überlegte
er.</p>
<p class="pcalibre6 initial1">Sonntag war's/ein stiller,
spinnwebumsponnener, sonnendurchtränkter Septembertag. Auf dem
Stoppelfeld, sogleich hinter den Scheunen weidete das ganze Vieh
des Borynahofes, und unter dem hohen, bauchigen Getreideschober,
den eine frischgrüne Bürste jungen Roggens umgab, der beim Verladen
des Kornes ausgeschüttet war, lag Jakob, gab auf das Vieh Obacht
und unterwies Witek im Gebet. Er fuhr ihn öfters an oder knuffte
ihn mit dem Peitschenstiel, denn der Junge irrte sich fortwährend
und überflog die Obstgärten mit den Blicken.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page110" title="lesebaer/lac"></a> »Acht',
was ich sage, es ist doch das Gebet,« mahnte er ernst.</p>
<p class="calibre3">»Ich acht' schon, Jakob, ich acht' schon.«</p>
<p class="calibre3">»Na, und was hast du dich denn da in die Obstgärten zu
vergucken, hä...ä?«</p>
<p class="calibre3">»Klembs haben noch die Äpfel im Garten, glaub' ich.«</p>
<p class="calibre3">»Die kommen dir grad zu paß, was? Hast du sie denn gepflanzt?
Repetier' du das Credo/noch emal.«</p>
<p class="calibre3">»Die Rebhündel habt ihr doch auch nicht aufgezogen und habt 'ne
ganze Schar davon weggenommen.«</p>
<p class="calibre3">»Dämlack! Die Äpfel sind Klemb seine und die Vögel sind dem Herr
Jesus seine, verstanden?«</p>
<p class="calibre3">»Sie sind doch aber vom Gutsfeld.«</p>
<p class="calibre3">»Auch das Feld gehört dem Herrn Jesus. Seh' mir einer den
Klugschnacker an! Repetier' du nur das Credo.«</p>
<p class="calibre3">Witek wiederholte rasch, denn die Knie taten ihm schon weh, aber
er hielt es nicht aus.</p>
<p class="calibre3">»Mir scheint, das Füllen geht in Michel seinen Klee,« rief er,
bereit, auf und davonzulaufen.</p>
<p class="calibre3">»Hab' man keine Angst nich um das Füllen und paß aufs Gebet
...«</p>
<p class="calibre3">Endlich war er am Ende, konnte jedoch nicht länger stillehalten,
kuschelte sich, drehte sich nach allen Seiten und schleuderte einem
Haufen Spatzen auf den Pflaumenbäumen einen Erdklumpen nach, dann
begann er eilig sich auf die Brust zu schlagen.</p>
<p class="calibre3">»Und den Schluß hast du einfach 'runtergeschluckt, wie 'ne
Mulschbirne, was?«</p>
<p class="calibre3">Der Junge wiederholte den Schluß und machte sich mit großer
Erleichterung an den Hund heran, mit dem er sich herumzunecken
begann.</p>
<p class="calibre3">»Paß auf; mußt du denn immerzu tollen, wie 'n albernes
Kalb?«</p>
<p class="calibre3">»Werdet ihr Hochwürden die Vögel hintragen? ...«</p>
<p class="calibre3">»Das werd' ich ...«</p>
<p class="calibre3">»Aufm Feld hier könnten wir sie braten.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page111" title="lesebaer/DaoH"></a> »Brat'
dir Kartoffeln. Sieh' mal einer an, was er nicht alles will!«</p>
<p class="calibre3">»In die Kirche gehen sie schon,« rief Witek plötzlich, da er die
roten Schürzen auf dem Wege hinter den Hecken und Bäumen schimmern
sah.</p>
<p class="calibre3">Die Sonne wärmte gehörig, so daß man alle Fenster und Türen in
den Hütten durch und durch geöffnet hatte; hier und da wusch man
sich noch an der Hauswand, hier wiederum strählte man das Haar und
flocht es in Zöpfe, da klopfte man die Feiertagskleider aus, die
durch das lange Liegen in den Truhen zerknüllt waren, und trat
schon da und dort auf die Straße, daß bald hier bald dort, gleich
roten Mohnblumen, und gelben Georginen, die an den Wänden schon im
Verblühen waren, oder wie Kresse und Feuernelken geputzte Menschen
herauskamen. Frauen, Kinder, Mädchen, Knechte kamen angegangen, und
wie große reife Roggengarben kamen die Bauern in ihren weißen
Haartuchröcken anmarschiert und alles strebte bedächtig der Kirche
zu, auf Wegen und Stegen kamen sie gegangen zu seiten des Weihers,
der wie in einer goldenen Schale die Sonne wiederspiegelte, daß es
vor den Augen zu flirren begann.</p>
<p class="calibre3">Die Glocken klangen ununterbrochen mit ihren freudigen Stimmen
des Sonntags, der Ruhe und der Andacht.</p>
<p class="calibre3">Jakob wartete, bis man ausgeläutet hatte, da ihm aber die Zeit
zu lang wurde, steckte er seinen Bund Rebhühner unter den
Kapottrock und sagte:</p>
<p class="calibre3">»Witek, du wirst das Vieh in die Ställe treiben, wenn sie
ausgeläutet haben, und kommst dann zum Gottesdienst.«</p>
<p class="calibre3">Er ging so schnell er sich nur vorwärtsbewegen konnte, er hinkte
nämlich stark, den Fußweg entlang, der zwischen den Gärten lief und
so dicht mit gelbem Pappellaub bedeckt war, daß Jakob wie auf einem
safrangelben Perserteppich wandelte.</p>
<p class="calibre3">Das Pfarrhaus stand gegenüber der Kirche, nur durch eine Straße
von dieser getrennt, im Hintergrund eines <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page112" title="lesebaer/DaoH"></a> großen Gartens voll grüner
Birnen und roter Äpfel. Vor der mit rotem Weinlaub bewachsenen
Veranda blieb Jakob ratlos stehen, schüchtern in die sperrangelweit
offenen Fenster, dann wieder in die offene Haustür lugend, und da
er sich nicht hineinzugehen traute, wich er bis an ein großes
Blumenbeet zurück, das voll Rosen, Levkojen und Astern war und aus
dem ihm ein süßer betäubender Duft entgegenschlug; eine weiße
Taubenschar krabbelte auf dem grünen, moosbewachsenen Dach umher
und flatterte bis auf die Veranda herunter.</p>
<p class="calibre3">Der Pfarrer ging im Garten auf und ab mit dem Brevier in der
Hand, doch schüttelte er hin und wieder an einem Birn- oder
Apfelbaum, daß man das schwere Aufplatzen der Früchte auf den Boden
hörte; er sammelte das Obst auf in den Schoß seines Priesterkleides
und wollte es ins Haus tragen.</p>
<p class="calibre3">Jakob vertrat ihm den Weg und bückte sich demütig bis an seine
Knie.</p>
<p class="calibre3">»Was gibt's denn? Ach so ... Jakob vom Borynahof.«</p>
<p class="calibre3">»Jawohl! 'n paar Rebhühndl hab' ich Hochwürden gebracht.«</p>
<p class="calibre3">»Gott lohn's dir. Komm mit.«</p>
<p class="calibre3">Jakob betrat den Vorplatz und blieb auf der Schwelle stehen,
denn er traute sich keinesfalls in die Zimmer hinein. Soweit es
durch die offene Tür möglich war, blinzelte er aber zu den Bildern
hinüber, die an den Wänden hingen, bekreuzigte sich fromm, holte
tief Atem und fühlte sich dermaßen geblendet durch all die
Herrlichkeit, daß ihm selbst die Tränen in die Augen traten. Er
hatte große Lust zu beten, nur traute er sich nicht, niederzuknien,
um das glänzende, glatte Parkett nicht zu beschmutzen. Doch der
Pfarrer kam gleich wieder aus den Zimmern heraus, gab ihm fünfzehn
Kopeken in Silber und sagte:</p>
<p class="calibre3">»Gott bezahl's, Jakob, du bist ein guter, frommer Mensch, du
gehst auch jeden Sonntag zur Kirche.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page113" title="lesebaer/DaoH"></a> Jakob
umfaßte seine Knie, doch er war dermaßen betäubt durch das Gefühl
der plötzlichen Freude, daß er gar nicht gewahr wurde, wie er sich
wieder auf der Straße befand.</p>
<p class="calibre3">»Sieh mal an, für die paar Vögelchens und so 'n Geld!
Hochwürden/der Liebe ...« flüsterte er, die Münze beäugend. Nicht
das erstemal zwar brachte er Hochwürden etwas, mal 'n paar Vögel,
dann wieder ein Häschen oder Pilze. Niemals aber hatte er so viel
bekommen; auf den Höchstfall einen Groschen oder auch nur ein gutes
Wort ... und heute, du lieber Gott! einen ganzen Silberling, und
aufs Zimmer hatte man ihn gerufen, und so viel Gutes gesagt. Jesus!
Es klemmte ihm die Gurgel zu, und Tränen flossen wie von selbst aus
seinen Augen, und im Herzen fühlte er eine solche Wärme, als ob ihm
jemand Glut auf die Brust geschüttet hätte.</p>
<p class="calibre3">Allein der Priester weiß den Menschen zu ehren, er nur einzig
und allein./Daß ihn Gott gesund erhalte und die heilige Jungfrau
Maria von Tschenstochau. 'n guter Herr bist du, oh 'n guter! ...«
Und die im Dorf, die konnten ihn nur Hinkefuß, Tölpel,
unbrauchbares Subjekt nennen, die Bauern wie die Knechte, niemand
gönnte ihm ein gutes Wort, niemand hatte Mitleid mit ihm/höchstens
nur die Gäule und 'n paar Dorfhunde ... und war er nicht aus guter
Familie ... ein Bauernsohn ... kein Landstreicher, sondern ein
guter Christ, ein Katholischer...</p>
<p class="calibre3">Immer höher und sicherer reckte er den Kopf, machte sich gerade
so gut es ging und schaute von oben herab und herausfordernd in die
Welt, auf die Menschen, die den Kirchhof betraten, und auf die
Pferde, die unter der Mauer bei den Wagen standen; die Mütze setzte
er sich auf seinem Zottelkopf zurecht und begab sich langsam und
würdig nach der Kirche zu, wie irgendein Hofbauer, die Hände in den
Gürtel geschoben und mit dem schiefen Bein hinterherfegend, daß der
Staub hinter ihm aufwirbelte. Nein, heute blieb er nicht in der
Vorhalle, wie sonst, und wie's für ihn, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page114" title="lesebaer/lac"></a> den armen Knecht vom Borynahof
paßte, sondern er fing an, sich mächtig durch das Gedränge
vorwärtszuschubsen und schob geradeaus nach dem Hauptaltar/da, wo
nur die Hofbauern zu stehen pflegten, wo Boryna stand und der
Dorfschulze selbst, und all diejenigen, die den Traghimmel hinter
Hochwürden hertragen, und die auch, die mit Kerzen dick wie eine
Runge vor dem Altar Wacht halten durften während der Ausstellung
des heiligen Sakraments.</p>
<p class="calibre3">Mit Staunen und Entsetzen betrachteten sie ihn, und häufig genug
mußte er ein unangenehmes Wort hören oder erhielt einen Blick/wie
ein Hund, der sich hindrängt, wohin man ihn nicht gerufen hat. Doch
Jakob machte sich heute nichts daraus; fest hielt er die Münze in
der Faust und hatte die Seele voll Süße und Güte; wie nach der
Beichte fühlte er sich, oder selbst besser noch.</p>
<p class="calibre3">Der Gottesdienst begann.</p>
<p class="calibre3">Er kniete ganz dicht am Geländer und sang andächtig mit den
andern, dabei den Hauptaltar angaffend, wo ganz oben Gott-Vater zu
sehen war, ein weißhaariger Herr, streng und ganz dem Gutsherrn aus
Dschasgowa-Wola ähnlich. Und aus der Mitte, im goldigen Mantel, sah
ihn die Tschenstochauer Muttergottes selbst an ... Und überall
gleißte Gold, lohten die Kerzenflammen, standen Sträuße aus roten
Papierblumen und hoben sich aus den Wänden und bunten Fenstern
goldene Scheine und ernste Heiligengesichter heraus. Streifen von
Gold, Purpur und Violett fielen wie ein Regenbogen auf sein
Gesicht, auf seinen Kopf, ganz als ob er im Weiher untergetaucht
wäre vor Sonnenuntergang, wenn die Sonne über das Wasser kommt. Und
er fühlte sich in diesen Herrlichkeiten wie im Himmel, so daß er
sich nicht zu bewegen traute und nur so kniete, versunken im
Anschauen des schwärzlichen, lieben Muttergesichts der heiligen
Jungfrau, daß er ein Gebet nach dem anbeten mit fiebertrockenen
Lippen stammelte und dann vor sich hin sang mit solcher Andacht, so
aus allen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page115" title="lesebaer/Vera6020"></a> Kräften seiner glaubensstarken Seele, so
aus dem begeisterten Herzen heraus, daß seine eingetrocknete,
knarrende Stimme am meisten vernehmbar war.</p>
<p class="calibre3">»Jakob, ihr blökt ja, wie 'ne Judenziege,« flüsterte ihm einer
von der Seite zu.</p>
<p class="calibre3">»Unsrem Herrn Jesus und der heiligen Jungfrau zu Ehren,«
brummelte er, nachdem er seinen Gesang unterbrochen hatte, denn in
der Kirche wurde es allmählich still. Der Priester kletterte auf
die Kanzel und alle reckten die Köpfe und schauten Hochwürden an,
der im weißen Chorhemd sich über das Volk beugte und das Evangelium
las. Und Lichter und Farben fluteten über seine Gestalt von den
Fenstern her, daß er allen wie ein Engel auf einem Regenbogen
dünkte. Der Priester sprach lange und mit solchem Nachdruck, daß
der eine und der andere aus reuigem Herzen aufseufzte und manchem
die Tränen übers Gesicht flossen, und ein anderer wiederum den
Blick senkte, in seinem Gewissen bereute und sich vornahm, besser
zu werden. Jakob starrte auf Hochwürden, wie auf ein Heiligenbild,
und es war ihm fast seltsam, daß dieses derselbe gute Herr sein
sollte, der mit ihm vorhin gesprochen hatte und ihm den Silberling
gegeben hatte/denn jetzt sah er wie ein Erzengel auf dem Feuerwagen
der Morgenröte aus, sein Gesicht war bleich geworden, die Augen
schleuderten Blitze, als er die Stimme erhob und dem Volk alle
Sünden vorhielt: Geiz und Trunkenheit, Zügellosigkeit, Schädigung
des Nachbarn, Nichtachtung vor den Älteren und Gottlosigkeit! Und
er rief mit großer Stimme, zur Besinnung mahnend, flehte, beschwor
und bat/so daß Jakob nicht länger an sich halten konnte und unter
der Last all dieser Sünden innerlich zu beben begann und laut
losheulte/und ihm nach das ganze Volk, Frauen, ja selbst
Hofbauern/so daß ein Weinen in der Kirche entstand, ein Schluchzen
und Schneuzen; und als der Priester sich mit dem Bußgebet gegen den
Altar wandte und niederkniete, überflog ein <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page116" title="lesebaer/Snoopy64"></a> Stöhnen die Kirche, und
das ganze Volk stürzte, wie ein sturmgebeugter Forst, mit den
Gesichtern zu Boden, so daß der Staub aufwirbelte und wie mit einer
Wolke die reuigen, tränenschweren, seufzenden und flehenden Herzen,
die zum Herrn um Erbarmen riefen, umhüllte. Und Stille sank darauf
herab, die Stille der tiefen Andacht und des innigsten
Zwiegesprächs mit dem Herrn, denn nun begann die Messe/die Orgel
setzte mit einer gedämpften, demütigen und tiefen Stimme ein/so daß
Jakobs Seele in Wonne und unaussprechlichem Glück schier
erstarb.</p>
<p class="calibre3">Und dann erhob sich plötzlich vom Altar her die Stimme des
Priesters und floß über die gesenkten Köpfe, wie ein Bach von
Klängen, oder die Schellen klangen in kurzen Stößen, und Weihrauch
schlug in duftenden Säulen empor und umgab die knienden
Andachtversunkenen wie mit einem Flor, Jakob aber wurde darob mit
einer solchen Wollust erfüllt, daß er nur seufzte und die Arme
ausbreitete, gegen seine Brust hämmerte und in diesem süßen Gefühl
des Ersterbens sich ganz auflöste. Das Geflüster der Gebete, die
Seufzer und plötzlichen Aufschreie, das vereinzelte Stöhnen, die
heißen Atemzüge, die Lichter, der Dunst und der Orgelklang tauchten
ihn wie in eine Verzückung und in einen heiligen Traum.</p>
<p class="calibre3">»Jeses, mein lieber Jeses,« flüsterte er geblendet und
geistesabwesend und hielt seine Silbermünze fest in der Faust. Und
als Ambrosius, der Küster, mit einem Teller herumging und mit dem
Geld zu klappern begann, damit man hörte, daß er Gaben fürs Licht
sammelt, erhob sich Jakob, warf seine Münze laut hin und suchte
lange, wie das die echten Hofbauern so taten, nach dem Rest von 26
Pfennigen. »Gott bezahl's« hörte er voll Behagen.</p>
<p class="calibre3">Und als die Kerzen verteilt wurden, denn die Messe war mit der
Zurschaustellung des heiligen Sakraments und mit einem Festgang um
die Kirche, streckte Jakob mutig seine Hand aus, und obgleich er
große Lust hatte, eine ganze Kerze zu <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page117" title="lesebaer/Snoopy64"></a> nehmen, griff er doch nur
nach der kleinsten, nach einem Lichtstumpf fast, denn er begegnete
dem gestrengen, rügenden Blick der Dominikbäuerin, die mit ihrer
Tochter Jagna neben ihm stand/er zündete rasch sein Licht noch an,
denn der Priester hatte schon die Monstranz erfaßt und sich mit ihr
nach dem Volk umgedreht, so daß alle mit dem Gesicht zu Boden
fielen. Nun stimmte Hochwürden den Gesang an und schritt langsam
die Treppenstufen des Altars hinab durch eine plötzlich gebildete
Straße aus singenden Köpfen, flammenden Kerzen, grellen Farben und
ächzenden Stimmen. Der feierliche Umzug setzte sich in Bewegung,
die Orgel erdröhnte mächtig, die Schellen fingen an rhythmisch zu
läuten, das Volk, die zweite Stimme ergreifend, sang mit einer
einzigen großen Stimme des Glaubens, und vorne, vor dem Gedränge,
umgeben von bebenden Lichtern, blinkte das silberne Kreuz,
schaukelten die Tragaltare ganz in Tüll gehüllt, voll Blumen und
mit goldenen Kronen gekrönt, und am Hauptausgang, wo durch die
Weihrauchwolken die Sonne einströmte, entfalteten sich schon die
gesenkten Fahnen und schlugen wie purpurfarbene und grüne Vögel mit
den Flügeln.</p>
<p class="calibre3">Die Prozession umkreiste die Kirche.</p>
<p class="calibre3">Jakob beschattete sein Licht mit der gekrümmten Handfläche und
hielt sich eigensinnig ganz nahe hinter dem Priester, über dem die
Hofbauern Boryna, Thomas Klemb, der Schmied und der Dorfschulze den
roten Traghimmel trugen, unter welchem die Monstranz golden
leuchtete und so im Feuer des Sonnenlichts stand, daß man durch
ihre runde Glasscheibe in der Mitte die blasse durchsichtige Hostie
sah.</p>
<p class="calibre3">Jakob war so geistesabwesend, daß er immer wieder stolperte und
den anderen auf die Füße trat.</p>
<p class="calibre3">»Paß auf, du Stummelaffe!«</p>
<p class="calibre3">»Mißgeburt, Hinkefuß,« warfen sie ihm zu, die Worte nicht selten
mit Rippenstößen begleitend.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page118" title="JohannN/Snoopy64"></a> Er
hörte nichts davon. Der Gesang des Volkes rauschte mächtig dahin,
erhob sich wie eine Säule, schien wie eine Woge zu fließen und
schlug gegen die weiße Sonne. Die Glocken dröhnten ununterbrochen
aus erzenen Mündern, so daß die Linden und Ahorne bebten und hin
und wieder sich ein rotes Blatt von den Zweigen losriß, wie ein
aufgescheuchter Vogel, und auf die Köpfe niedersank. Und hoch, hoch
über den Wandelnden, über den Wipfeln der gebeugten Bäume, über dem
Kirchturm kreiste ein Schwarm aufgescheuchter Tauben ...</p>
<p class="center">— — — — —</p>
<p class="calibre3">Nach dem Gottesdienst ergoß sich die Volksmenge auf den um die
Kirche gelegenen Friedhof, auch Jakob kam mit den anderen hinaus,
aber heute hatte er keine Eile, obgleich er wußte, daß zu Mittag
Fleisch von der notgeschlachteten Kuh da sein würde; nein, warum
denn auch, hin und wieder blieb er stehen, redete mit diesem und
jenem von seiner Bekanntschaft und schob sich an seine Leute heran,
denn auch der Antek stand mit seiner Frau bei den anderen im
Haufen. Man besprach sich, wie es immer an den Sonntagen nach der
Hochmesse Brauch ist.</p>
<p class="calibre3">In einem anderen Haufen aber, der sich schon hinter der Pforte
auf der Dorfstraße versammelt hatte, führte der Schmied das erste
Wort. Der war ein großer, schon ganz städtisch gekleideter Kerl, in
einem schwarzen, auf dem Rücken mit Wachs betropften Knierock,
dunkelblauer Mütze, langen über die Stiefelschäfte
heruntergelassenen Hosen und einer silbernen Uhrkette auf der
Weste. Er hatte ein rotes Gesicht, einen rosthaarigen Schnurrbart
und wirres, steifes Kraushaar, schwadronierte weit vernehmbar und
brach hin und wieder in quarrendes Gelächter aus, denn er war der
erste Spötter im Dorf, und Gott behüte den, welchen seine böse
Zunge sich zum Opfer ausersehen hatte. Der alte Boryna schielte
immerzu verdächtig zu ihm herüber und lauschte auf seine Worte,
denn er fürchtete sich vor seinem Geschwätz. Selbst den eigenen
Vater hätte der Schmied <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page119" title="JohannN/Snoopy64"></a> nicht ungeschoren gelassen, geschweige denn
den Schwieger, mit dem er in ständigem Krieg war wegen der Mitgift
seiner Frau, doch konnte Boryna nicht viel heraushören, denn gerade
wurde er die Dominikbäuerin mit Jagna gewahr, die nun die Kirche
verließen. Sie gingen beide langsam, da viel Volk auf dem Kirchhof
war, warfen dem und jenem ein Wort hin und begrüßten den einen und
den anderen, denn trotzdem sie sich alle kannten und obendrein
versippt und verschwägert waren, wie es im Dorf zumeist so ist, wo
man nur um einen Zaun oder Grenzrain voneinander entfernt sitzt, so
war es doch recht schön, vor der Kirche miteinander zu reden, und
es paßte sich so ... Mit einer leisen, und andachtsvollen Stimme
verbreitete sich die Dominikbäuerin über Hochwürden, wahrend Jagna
sich nach den Leuten umsah. Sie war im Wuchse den größten Männern
des Dorfes gleich, und so schmuck schien sie heut, daß die
Burschen, die sich qualmend auf dem Wege vor der Zufahrt in einem
Haufen zusammengerottet hatten und ihr lachend die Zähne zeigten,
mit den Augen an ihr hingen. Sie war so wohlgestaltet, so prächtig
aufgeputzt, und von so hoher Statur, daß selbst ein
Herrschaftsfräulein sich mit ihr nicht hätte messen können.</p>
<p class="calibre3">Die Dorfmädchen und auch die Bäuerinnen, die vorbeigingen,
blickten sie neidisch an oder blieben gar dicht neben ihr stehen,
um ihre Augen an dem gestreiften und reichen Beiderwandrock zu
sättigen, der an ihr leuchtete, wie ein Regenbogen ihrer
mazurischen Heimat, ihre schwarzen hohen Stiefel anzustaunen, die
bis zum weißen Strumpf hinauf mit roter Litze verschnürt waren, das
Mieder aus grünem Samt, das so reich mit Gold bestickt war, daß es
einem in den Augen flimmerte, und auch die Bernstein- und
Korallenschnüre, die ihren weißen, vollen Hals umschlossen. Ein
Büschel verschiedenfarbiger Bänder hing vom Verschluß der Schnüre
auf den Rücken herab und flatterte, wenn sie ging, ihr buntfarben
nach.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page120" title="JohannN/Snoopy64"></a>
Jagna merkte die neidischen Blicke nicht, aber eine plötzliche Röte
schoß ihr ins Gesicht, als ihre lichtblauen Augen, von einem zum
andern irrend, den sie anstarrenden Blicken Anteks begegneten. Sie
zupfte die Mutter am Ärmel und ging voraus, ohne zu warten.</p>
<p class="calibre3">»Wart' doch, Jagna« schrie diese ihr nach, indem sie den alten
Boryna begrüßte.</p>
<p class="calibre3">Mitten auf der Straße blieb Jagna aber stehen, denn die Burschen
umdrängten sie in hellem Haufen, begrüßten sie und fingen an, sich
über Jakob lustig zu machen, der hinter ihr her ging, in ihrem
Anblick wie in ein Heiligenbild vergafft.</p>
<p class="calibre3">Der aber spuckte nur aus und wandte sich trägen Schritts
heimwärts, denn auch seine Bauersleute waren auf dem Heimweg, und
man mußte doch auch noch nach den Pferden sehen.</p>
<p class="calibre3">»Grad wie auf einem Bild!« rief er unwillkürlich aus, schon auf
der Galerie des Bauernhauses sitzend.</p>
<p class="calibre3">»Wer denn, Jakob?« fragte Fine, die das Mittagessen
richtete.</p>
<p class="calibre3">Er senkte beschämt seine Augen, aus Angst, daß man ihm etwas
anmerken könnte.</p>
<p class="calibre3">Da aber das Mittagessen reichlich und lang war, hatte er bald
alles vergessen. Fleisch gab es heute, Kohl mit Erbsen, Brühe mit
Kartoffeln, und zum Schluß stellte man noch eine ordentliche
Schüssel mit in Speck gerösteter Gerstengrütze auf den Tisch.</p>
<p class="calibre3">Sie aßen bedächtig, ernst und schweigsam vor sich hin, und als
der erste Hunger gestillt war, fingen sie an, sich miteinander zu
bereden und sich am Essen zu freuen.</p>
<p class="calibre3">Fine, die in den Platz der Hausfrau aufgerückt war, setzte sich
nur hin und wieder am Rande der Bank nieder, aß schnell und achtete
fleißig darauf, daß es nicht am Essen fehlte, und daß die Töpfe aus
der Stube rechtzeitig nach draußen zum Nachfüllen kamen, denn
niemand sollte sich beklagen können, daß in den Schüsseln Grund
komme.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page121" title="DaoH/Snoopy64"></a> Sie
aßen auf der Galerie, denn das Wetter war still und warm.</p>
<p class="calibre3">Waupa drehte sich um sie herum, scharwenzelte, rieb sich gegen
die Beine der Essenden und schnüffelte in den Schüsseln, bis ihm
jemand hin und wieder einen Knochen hinwarf, mit dem er nach der
Mauerbank rannte, und beglückt durch die Anwesenheit seiner Leute,
vielleicht auch weil man seinen Namen laut nannte, fing er an,
freudig zu bellen und hinter den Spatzen her zu jagen, die in
Erwartung der Brocken vom Mahl sich in die Hecken hingen.</p>
<p class="calibre3">Und oft kam jemand über den Weg, den Essenden seinen Gruß
zurufend, auf den sie einstimmig antworteten.</p>
<p class="calibre3">»Hast Hochwürden ein paar Vöglein gebracht?« erkundigte sich
Boryna.</p>
<p class="calibre3">»Jawohl, jawohl!« Er legte plötzlich den Löffel hin und fing an
zu erzählen, wie der Pfarrer ihn auf die Zimmer gerufen hatte, und
wie es dort schön sei und welche Menge Bücher.</p>
<p class="calibre3">»Wann kann er die alle lesen?« sagte Fine.</p>
<p class="calibre3">»Wann? An den Abenden! Dann geht er durch die Zimmer auf und ab,
trinkt Tee und liest immerzu.«</p>
<p class="calibre3">»Das muß wohl ... lauter Frommes sein?« warf Jakob ein.</p>
<p class="calibre3">»Versteht sich, daß es keine Fibeln sind.«</p>
<p class="calibre3">»Und Zeitungen bringt ihm der Gemeindebote jeden Tag,« fügte
Anna hinzu.</p>
<p class="calibre3">»Weil man in den Zeitungen schreibt, was in der Welt passiert
...« ließ sich Antek vernehmen.</p>
<p class="calibre3">»Auch der Schmied mit dem Müller halten sie sich.«</p>
<p class="calibre3">»Päh ... so 'ne Schmiedszeitung! ...« sagte Boryna höhnisch.</p>
<p class="calibre3">»Ganz und gar dieselbe, wie dem Pastor seine,« entgegnete Antek
scharf.</p>
<p class="calibre3">»Hast sie gelesen, daß du es weißt?«</p>
<p class="calibre3">»Das hab' ich, und ob ...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page122" title="DaoH/Snoopy64"></a> »Und
bist doch nicht klüger geworden, daß du dich mit dem Schmied
einläßt.«</p>
<p class="calibre3">»Für den Vater ist nur der klug, der mindestens seine halbe Hufe
Land hat und sein Dutzend Kuhschwänze dazu.«</p>
<p class="calibre3">»Halt's Maul, solang ich gut bin. Sieh einer nur, da sucht er
sich wieder Gelegenheit, mir die Zähne zu zeigen. Das Brot bläht
dich auf, wie's mir scheint ... mein Brot ...«</p>
<p class="calibre3">»Jawohl, das steckt mir schon wie 'n Knochen in der Gurgel.«</p>
<p class="calibre3">»Such dir Besseres, auf Anna ihren drei Morgen wirst du Semmeln
essen können.«</p>
<p class="calibre3">»Und sollte ich selbst Kartoffeln fressen, so wird sie mir
niemand vorwerfen.«</p>
<p class="calibre3">»Ich werfe sie dir auch nicht vor.«</p>
<p class="calibre3">»Wer denn sonst? ... Wie 'n Ochs muß man sich schinden und nicht
mal ein freundliches Wort kriegst du dafür.«</p>
<p class="calibre3">»In der Welt ist es leichter, da braucht man nicht zu arbeiten
und kriegt alles.«</p>
<p class="calibre3">»Versteht sich! ...«</p>
<p class="calibre3">»Dann geh' er doch hin und versuch' er es.«</p>
<p class="calibre3">»Mit leeren Händen nicht!«</p>
<p class="calibre3">»Einen Stecken kannst kriegen, damit du was für die Hunde
hast.«</p>
<p class="calibre3">»Vater!« schrie Antek, von der Bank aufspringend, aber er fiel
gleich zurück, denn Anna hielt ihn fest. Der Alte warf ihm einen
drohenden Blick zu, bekreuzigte sich, da das Mittagessen beendet
war, und sagte noch im Weggehen hart:</p>
<p class="calibre3">»Auf den Altenteil geh ich nicht zu dir, nee!«</p>
<p class="calibre3">Sie gingen gleich darauf auseinander, nur Antek blieb auf dem
Vorbau und grübelte. Jakob führte die Pferde aufs Kleefeld hinter
den Scheunen und lagerte sich unter dem Getreideschober, um etwas
zu schlummern, aber schlafen konnte er nicht, das Essen drückte ihn
im Leib und der Gedanke quälte ihn, daß er, wenn er eine Flinte
hätte, 'ne <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page123" title="DaoH/Snoopy64"></a> Menge Vögel und manches Häschen schießen
könnte, um jeden Sonntag Hochwürden etwas zu bringen.</p>
<p class="calibre3">Der Schmied würde ihm wohl eine Flinte machen können, gerade
solche wie dem Forstaufseher. Wenn einer daraus im Walde schießt,
hört man es drin im Dorf!</p>
<p class="calibre3">»Ein schlaues Luder! Aber 5 Rubel müßte man ihm dafür bezahlen!«
überlegte er. »Und woher nehmen? ... Der Winter rückt näher, einen
Schafpelz muß man kaufen, die Stiefel halten auch nur bis zum Fest
... Gewiß, zehn Rubel bekommt er noch und zwei Stück Zeug, eine
Hose und ein Hemd ... Der Schafpelz kostet mindestens 5 Rubel ...
der wird allerdings etwas kurz sein ... die Stiefel an die drei
Rubel ... und eine Mütze täte not ... einen Rubel muß man
Hochwürden für die Seelenmesse der Eltern wegen bezahlen ...
Verflucht ..., daß auch nichts übrigbleibt! ...« Er spuckte aus und
fing an, in der Tasche seiner Joppe nach Tabakresten zu kramen,
stieß aber auf das Geld, das er während des Mittagsmahles ganz
vergessen hatte.</p>
<p class="calibre3">»Sieh da, bar Geld, sieh da!« Die Schlaflust war plötzlich
verflogen; von der Schenke her ertönte die Stimme der Musik, fern
wie durchgesiebt; ein Wiederhall von Zurufen wurde vernehmbar.</p>
<p class="calibre3">»Da tanzen sie, die Biester, trinken Schnaps und rauchen
Zigaretten!« Er seufzte auf, legte sich wieder bäuchlings hin und
sah den gefesselten Gäulen zu, wie sie zu einem Haufen geschart
einander in den Nacken griffen. Er überlegte, daß er abends
ebenfalls in die Schenke müßte, um etwas Tabak zu kaufen und
wenigstens den Tanzenden zuzugucken. Immer wieder besah er seine
paar Geldmünzen und blinzelte in die Sonne. Sie war noch recht hoch
und schob sich heute so langsam gen Westen, als ob sie auch ein
bißchen sonntäglich ausruhte. So mächtig zog's ihn schon nach der
Schenke, daß er kaum an sich halten konnte, er drehte sich von
einer Seite auf die andere und stöhnte nur hin und wieder voll
sehnsuchtsvollen Begehrens; auf den <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page124" title="DaoH/Snoopy64"></a> Weg machte er sich jedoch nicht gleich,
denn hinter den Scheunen hervor erschien gerade Antek mit Anna. Sie
gingen über den Rain ins Feld.</p>
<p class="calibre3">Antek voraus und Anna mit dem Säugling im Arm hinterdrein. Hin
und wieder sagten sie etwas. Sie gingen langsam, und immer wieder
beugte sich Antek über den Acker, mit der Hand die aufgehenden
Halme betastend.</p>
<p class="calibre3">»Es kommt sich ... dicht wie eine Bürste,« brummte er und
umschlang mit den Blicken jene Ackerhufen, die er dem Vater gegen
Lohn bestellte.</p>
<p class="calibre3">»Dicht ist es schon, aber das Väterliche is besser, wie ein Wald
schießt es hervor,« sagte Anna, die benachbarten Äcker
beäugend.</p>
<p class="calibre3">»Weil der Acker besser zubereitet ist.«</p>
<p class="calibre3">»Wenn man drei Kühe hätte/dann würde auch der Boden mehr Nahrung
haben.«</p>
<p class="calibre3">»Und sein eigenes Pferd dazu.«</p>
<p class="calibre3">»Und noch was zu mästen zum Verkauf. Aber so? Jede Spreu, jede
Kartoffelschale rechnet der Vater an und hält es noch für Gott weiß
was für eine Wohltat.«</p>
<p class="calibre3">»Und alles kriegt man noch vorgezählt.«</p>
<p class="calibre3">Sie verstummten plötzlich. Ein Gefühl erlittenen Unrechts füllte
ihre Herzen mit Bitterkeit, Zorn und dumpfer, zerrender
Empörung.</p>
<p class="calibre3">»Acht Morgen würden nur auf jeden zufallen,« rief er
unwillkürlich aus.</p>
<p class="calibre3">»Natürlich, mehr nicht. Fine ist doch da und dem Schmied seine
Frau und Gregor und wir,« zählte sie her.</p>
<p class="calibre3">»Dem Schmied seinen Teil könnte man auszahlen und bei dem Haus
mit der halben Hufe bleiben.«</p>
<p class="calibre3">»Und hast du, womit?« ... Sie stöhnte auf im Gefühl ihrer
Ohnmacht, das so stark war, daß ihr die Tränen kamen, als sie mit
den Blicken die väterlichen Felder umfaßte, diese Erde, wie
gediegenes Gold, wo man Weizen und Roggen, Gerste und Rüben von
Scholle zu Scholle <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page125" title="DaoH/Snoopy64"></a> ernten konnte ... So viel Gut, und alles
fremdes, nicht ihr's.</p>
<p class="calibre3">»Heul' nicht, Dumme, acht Morgen davon sind immerhin unser.«</p>
<p class="calibre3">»Wenn's wenigstens noch die Hälfte wäre und das Haus und das
Kohlfeld dazu!« sie wies links nach dem Wiesenland, wo lange
Kohlbeete blauten. Dahin wandten sie sich.</p>
<p class="calibre3">Unter die Knicks am Wiesenrand setzten sie sich, Anna machte
sich an das Stillen des Kindes, da es angefangen hatte zu greinen,
und Antek drehte sich eine Zigarette zurecht, brannte sie an und
starrte finster vor sich hin.</p>
<p class="calibre3">Er sprach zu seiner Frau nicht darüber, was ihm bis in die
Eingeweide hineinfraß und auf dem Herzen wie glühende Kohlen lag,
denn er hätte es weder ausdrücken können noch hätte sie ihn richtig
verstanden. Wie die Weiber nun einmal sind, weder Überlegung haben
sie noch können sie etwas selbständig bedenken und leben so wie ein
Schatten, den ein Mensch wirft ...</p>
<p class="calibre3">»Die Wirtschaft, die Kinder, die Gevatterinnen/das ist ihre
ganze Welt. Und alle sind sie so, alle ...« sann er voll
Bitterkeit, und das Herz preßte sich ihm zusammen ... »Ein Vogel,
der über die Moore fliegt, hat es besser, als manch ein Mensch ...
Was hat er zu sorgen? Er fliegt und singt sich eins und Herr Jesus
säet für ihn, so daß er nur zu ernten und sich zu nähren braucht
...«</p>
<p class="calibre3">»Und fehlt denn Vater vielleicht an bar Geld?« fing Anna wieder
an.</p>
<p class="calibre3">»Freilich!«</p>
<p class="calibre3">»Und Fine hat er solche Korallen gekauft/daß ein anderer dafür
eine Kuh haben könnte, und Gregor schickt er immerzu Geld durch den
Schulzen.«</p>
<p class="calibre3">»Das tut er,« antwortete er, an anderes denkend.</p>
<p class="calibre3">»Das ist doch ein Nachteil für die anderen. Und der seligen
Mutter ihre Kleider hält er in der Truhe unter Schloß und Riegel,
nicht mal zeigen tut er sie ... Und was <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page126" title="DaoH/Snoopy64"></a> für Röcke sind das, was für
Tücher, Hauben und Perlenschnüre,« sie begann umständlich alles Gut
aufzuzählen. Alles Unrecht, alle Bitternisse und Hoffnungen zählte
sie her, aber Antek schwieg verbissen, bis sie ihn ungeduldig gegen
den Arm stieß.</p>
<p class="calibre3">»Schläfst du denn? ...«</p>
<p class="calibre3">»Ich höre schon, rede nur, rede, das wird dich erleichtern, und
wenn du fertig bist, sag' mir Bescheid ...«</p>
<p class="calibre3">Anna, die leicht bereit zum Weinen war und auch tatsächlich viel
auf der Seele hatte, brach in Schluchzen aus und fing an, ihm
Vorwürfe zu machen, daß er zu ihr wie zu einer Magd spreche, daß er
weder von ihr noch von den Kindern etwas halte.</p>
<p class="calibre3">Bis Antek aufsprang und ihr höhnisch zurief:</p>
<p class="calibre3">»Schreie nur, soviel wie du willst, die Krähen da werden dich
schon hören und beklagen!« Er deutete mit den Augen auf die Vögel,
die über die Wiese geflogen kamen, drückte die Mütze tiefer auf und
ging hastig mit großen Schritten auf das Dorf zu.</p>
<p class="calibre3">»Antek! Antek!« rief sie kläglich hinter ihm her, doch er wandte
sich nicht einmal um.</p>
<p class="calibre3">Sie wickelte das Kind ein und eilte aufschluchzend über die
Feldraine dem Bauernhof zu; ihr Herz war schwer/niemand war da, mit
dem man reden konnte, vor dem man sich über sein Los hätte beklagen
können. Und man lebt allein wie 'n ... Termit, nicht mal zum
Nachbarn hat man Lust hinzugehen, um sich all den Kummer vom Herzen
zu reden. Antek würde ihr schon kommen mit den Gevatterinnen,
nichts als zu Hause sitzen, sorgen und sich abmoraken und zu guter
Letzt kriegt man selbst nicht ein gutes Wort dafür! Andere gehen in
den Dorfkrug und zu Hochzeiten ... aber der Antek ... kann man dem
was recht machen? ... Manchmal ist er so gut, wie Balsam auf die
Wunde, und dann kann man wochenlang nicht ein Wort aus ihm
herauskriegen, nicht einmal ansehen tut er einen ... Immer nur
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page127" title="DaoH/Snoopy64"></a> grübeln
und sinnieren ... Er weiß auch worüber, das ist wahr! Und der
Vater, könnte der ihnen nicht Land abschreiben, ist es nicht Zeit
für den Alten, auf seinen Altenteil zu gehen ... Ach, sie würde ihn
schon pflegen, daß selbst der eigene Vater es nicht besser bei ihr
haben könnte.</p>
<p class="calibre3">Sie wollte sich zu Jakob setzen, aber dieser klemmte sich mit
dem Rücken gegen den Heuschober und tat, als ob er schliefe,
obgleich ihm die Sonne gerade in die Augen schien; erst als sie
hinter der Scheunenecke verschwunden war, erhob er sich, klopfte
das Stroh herunter und schlich sich bedächtig an den Obstgärten
entlang dem Dorfkrug zu ... das Geld brannte ihm in der Tasche
...</p>
<p class="calibre3">Die Schenke stand am Ende des Dorfes hinter dem Pfarrhof am
Anfang der Pappelallee.</p>
<p class="calibre3">Menschen waren noch wenige da; die Musikanten klimperten hin und
wieder, niemand jedoch tanzte; es war noch viel zu früh, und die
Jugend zog es vor, im Obstgarten herumzuscharmieren oder vor der
Einfahrt an den Wänden entlang zu stehen, wo auf frischen und noch
gelben Holzbalken schon ein ganzer Schwarm Mädchen und Weiber saß.
In der großen Stube mit der schwarzen rußigen Balkendecke war es
fast leer, die kleinen angelaufenen Scheiben ließen das rote Licht
des Spätnachmittags so schwach durch, daß nur ein einziger Streifen
auf dem ausgetretenen Fußboden lag, in den Ecken aber war es
dämmerig. Ein paar Leute saßen da hinter den Tischen an der Wand,
aber unterscheiden konnte man nicht, wer es war.</p>
<p class="calibre3">Einzig Ambrosius, der Küster, stand mit einem von der
Brüderschaft der Lichttragenden mit der Schnapsbuttel in der Faust
am Fenster da/sie tranken einander häufig zu und redeten dies und
jenes ...</p>
<p class="calibre3">»Die tanzen heute wie die Fliegen im Pech! Los, rühr' dich mal,
Eve! Die ganze Nacht hast dich herumgetrieben und jetzt schläfst du
im Tanz! Und das Thomasle! Mach doch, mach vorwärts! Ist's dir denn
so schwer geworden, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page128" title="DaoH/Snoopy64"></a> dieses Maß Hafer, das du dem Juden verkauft
hast, was? ... Hab nur keine Angst, der Vater weiß es noch nicht.
Laß dich man mit den Rekruten ein, Maruschka, und bitte mich auf
der Stelle zu Gevatter.«</p>
<p class="calibre3">So stichelte die alte Gusche gegen die Tänzer der Reihe nach,
sie war eine Zügellose und hatte eine Wut gegen alle, weil sie die
eigenen Kinder benachteiligt hatten, so daß sie auf ihre alten Tage
auf Tagelohn gehen mußte. Da ihr aber niemand antwortete, bekam sie
das Keifen bald satt und begab sich in die gute Stube, wo der
Schmied mit Antek und noch einige jüngere Bauernsöhne saßen. Oben
an der schwarzen Balkendecke hing eine Lampe und erhellte mit ihrem
schwachen gelben Schimmer die hellen, wuscheligen Köpfe. Sie saßen
um den Tisch herum, stemmten sich fest auf die Ellbogen und hatten
alle die Augen auf den Schmied gerichtet, der über den Tisch
gebückt, ganz rot, mit den Händen breit fuchtelte und hin und
wieder mit der Faust aufschlug und leise erzählte.</p>
<p class="calibre3">Die Baßgeigen brummten, gerade als ob sich von draußen eine
Hummel in die Stube verflogen hätte und umhersauste ... manches Mal
zwitscherte eine Geige ganz unerwartet auf, tief wie ein lockendes
Vöglein, dann wiederum turtelte und klirrte eine Trommel ... aber
alsbald breitete sich wieder Stille aus.</p>
<p class="calibre3">Jakob ging geradeaus auf die Tonbank zu, hinter der Jankel mit
einem Käppchen auf dem Hinterkopf und ohne Rock und Weste saß, denn
es war warm in der Stube. Der Jude streichelte hin und wieder den
weißen Bart, schaukelte hin und her und vertiefte sich in seine
Lektüre, die Augen dicht an die Blätter des Buches haltend.</p>
<p class="calibre3">Jakob überlegte, trat von einem Fuß auf den anderen, zählte sein
Geld, kratzte in seinem Zottelhaar und blieb lange so stehen, bis
Jankel ihn ein paarmal anblickte und ohne in seinem Schaukeln und
seinem Gebet innezuhalten, das eine und das andere Mal die
Schnapsgläser klirren ließ ...</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page129" title="DaoH/Snoopy64"></a> »'n
halbes Maß, aber starken!« bestimmte er schließlich.</p>
<p class="calibre3">Zankel goß den Schnaps schweigend ein und langte mit der Linken
nach dem Geld ...</p>
<p class="calibre3">»In ein Glas schenken?« fragte er, nachdem die rostigen
Kupfermünzen ins Schubfach geschoben waren.</p>
<p class="calibre3">»Versteht sich, doch nicht in 'n Stiebel! ...«</p>
<p class="calibre3">Er schob sich nach der Ecke der Tonbank, stürzte das erste Glas
hinunter, spuckte aus und begann sich in der Schenke
umzuschauen;/den zweiten trank er gleich darauf, sah die
Schnapsbuttel gegen das Licht an und klopfte mit ihr stark gegen
die Tonbank.</p>
<p class="calibre3">»Noch einen und Tobak!« sagte er schon selbstbewußter, denn eine
wohlige Wärme durchrieselte ihn nach dem Schnaps und eine
merkwürdige Kraft floß ihm durch die Glieder.</p>
<p class="calibre3">»Hat Jakob heute seinen Dienstlohn bekommen?«</p>
<p class="calibre3">»Warum denn das ... ist denn heut Neujahr?«</p>
<p class="calibre3">»Etwas Arrak gefällig?«</p>
<p class="calibre3">»Nee ... reicht nich.« Er zählte das Geld über und blickte
kläglich nach der Arrakflasche.</p>
<p class="calibre3">»Ich kann borgen, wir sind doch mit Jakob gute Bekannte.«</p>
<p class="calibre3">»Nich nötig./Wer borgt, der geht bald ohne Stiefel,« sagte Jakob
scharf.</p>
<p class="calibre3">Trotzdem stellte Jankel ein Fläschchen mit Arrak vor ihm
hin.</p>
<p class="calibre3">Er wehrte sich, machte selbst schon Anstalten wegzugehen, aber
das Luder von Arrak duftete so stark, daß es in der Nase kribbelte;
so kämpfte er nicht länger, sondern trank nur, ohne viel zu
überlegen.</p>
<p class="calibre3">»Habt ihr im Wald was verdient?« fuhr Jankel fort, geduldig
auszufragen.</p>
<p class="calibre3">»Nein, nicht im Walde ... sechs Rebhühndel, die ich im Netze
griff, brachte ich Hochwürden... der hat mir dafor einen Silberling
gegeben.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page130" title="Snoopy64/rudi49"></a>
»Fünfzehn Kopeken für sechs! 'n Zehner würde ich für jedes
bezahlen.«</p>
<p class="calibre3">»Wieso, sind denn Rebhühndel koscheres Fleisch?...« Er war ganz
erstaunt.</p>
<p class="calibre3">»Darüber brauchen sich Jakob kein Kopfzerbrechen machen ...
bring' er mir welche und viel, und für jedes Rebhühndel kriegt er
'n Zehner in bar, und zum Einverständnis werde ich einen extra
Starken spendieren. Gelt?«</p>
<p class="calibre3">»'n ganzen Zehner for das Stück wird Jankel bezahlen?«</p>
<p class="calibre3">»Mein Wort ist kein Wind. Und für die sechs hätte Jakob bei mir
zwei halbe Maß reinen Schnaps und vier mit Arrak, einen Hering, 'ne
Semmel und 'n Paket Tabak bekommen/verstanden?«</p>
<p class="calibre3">»Freilich ... vier halbe Maß mit Arrak und 'n Hering ... und
freilich ... 'n Vieh bin ich nicht, ohne Verstand ... richtig wahr!
Vier halbe mit Arrak und Tobak und Semmeln ... und 'n ganzen
Hering.« Der Schnaps umnebelte ihn schon und machte ihn etwas
flau.</p>
<p class="calibre3">»Wird er welche bringen, Jakob?«</p>
<p class="calibre3">»Vier Halbe ... und 'n Hering und... Das werd' ich... Verflixt,
wenn ich so 'n Gewehr hätte ...,« sagte er, etwas wieder zu
Bewußtsein kommend, und fing abermals an zu berechnen. »Ein
Schafpelz zum Beispiel kostet 5 Rubel ... Stiefel sind auch nötig,
an die drei Rubel ... nee, es reicht nich ... an die fünf Rubel
würde der Schmied für 'n Gewehr haben wollen ... wie von Raphus ...
nee,« er überlegte laut weiter.</p>
<p class="calibre3">Jankel machte eine schnelle Berechnung mit der Kreide und
flüsterte ihm leise ins Ohr.</p>
<p class="calibre3">»Würde Jakob auch 'n Reh totschießen?«</p>
<p class="calibre3">»Freilich, aber aus der Faust kann keiner totschießen, mit dem
Gewehr würde ich das Luder schon treffen.«</p>
<p class="calibre3">»Kann denn Jakob aus dem Gewehr schießen?«</p>
<p class="calibre3">»Jankel is 'n Jud', da weiß er nicht, was alle im Dorf <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page131" title="Snoopy64/wedi"></a> wissen, daß ich
mit den Herren in die Wälder ging, daß man mir dort diesen Klumpen
angeschossen hat... warum soll ich da nicht schießen können.«</p>
<p class="calibre3">»Ich werde ein Gewehr geben, und Pulver werde ich geben und
alles was Jakob braucht... und was er totschießt, das muß er mir
bringen. Für 'n Reh gebe ich 'n ganzen Rubel, verstanden? 'n ganzen
Rubel. Und für das Pulver muß er 15 Kopeken pro Stück bezahlen, das
kann man abziehen... Und dafür, daß das Gewehr wird schlechter
werden, wird er mir 'n Maß Hafer bringen.«</p>
<p class="calibre3">»Einen Rubel für ein Reh... und wiederum ich für das Pulver 15
Kopeken... 'n ganzen Rubel!... ja, wieso denn!«</p>
<p class="calibre3">Jankel rechnete nochmals genau vor.</p>
<p class="calibre3">»Hafer?... Ich werd' ihn doch nicht den Pferden unterm Maul
wegholen...« Das eine hatte er verstanden.</p>
<p class="calibre3">»Wozu den Pferden nehmen! Auf dem Borynahof gibt's welchen auch
anderswo.«</p>
<p class="calibre3">»Ja, wieso denn...?« Er stierte den Juden an und überlegte.</p>
<p class="calibre3">»Alle machen es so! Und woher«, dachte Jakob, »haben die Knechte
Geld?... jeder braucht Tabak und ein Glas Schnaps und möchte mal
Sonntags tanzen gehen. Woher nehmen?...«</p>
<p class="calibre3">»Wieso... bin ich denn 'n Dieb, verfluchter Jud / oder was?«
donnerte er plötzlich los, mit der Faust aufs Tischbrett schlagend,
daß die Schnapsgläser hochsprangen.</p>
<p class="calibre3">»Was hat Jakob hier zu toben? Bezahlen soll er und sich zum
Teufel scheren...«</p>
<p class="calibre3">Aber Jakob bezahlte nicht und ging nicht fort, er hatte schon
kein Geld mehr und war dem Juden selbst etwas schuldig... so
stemmte er sich schwer gegen die Tonbank und fing an, schläfrig zu
berechnen, und Jankel beruhigte sich und schenkte ihm nochmal ein
Glas Arrak, aber reinen, ein, und sprach nichts mehr...</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page132" title="Snoopy64/rudi49"></a>
Inzwischen strömten die Leute immer zahlreicher in die Schenke, die
Dämmerung wurde dichter, man brannte das Licht an, die Musikanten
fingen an, flinker zu spielen, und ein lautes Stimmengewirr hatte
sich erhoben. Das Volk sammelte sich vor der Tonbank, an den
Stubenwänden entlang oder auch mitten in der Schenkstube, beriet
sich, unterhielt sich und der eine oder der andere trank dem
Nachbar zu, aber nicht allzuhäufig, denn sie waren nicht zum Saufen
gekommen, sondern nur um mal 'n bißchen nachbarlich nebeneinander
zu stehen, miteinander zu plaudern, auf die Geigen zu lauschen und
auf die Baßviolen; auch dieses und jenes an Neuigkeiten zu
erfahren... Es war doch Sonntagszeit/ da ist es keine Sünde,
auszuruhen, die Neugierde zu befriedigen, oder selbst dieses Glas
Schnaps mit dem Gevatter auszutrinken: wenn nur alles wie es sich
paßte war und ohne Gotteslästerung vor sich ging, so hatte selbst
Hochwürden nichts dagegen... Warum denn auch nicht, auch das liebe
Vieh zum Beispiel ist froh, nach der Arbeit auszuruhen, und muß es
auch. An den Tisch aber setzten sich die älteren Hofbauern und
einige Frauen in rotleuchtenden Beiderwandröcken und Kopftüchern,
sie sahen wie aufgeblühte Malven aus, und da die ganze Menschheit
gleichzeitig sprach, ging es wie Waldesrauschen durch die Schenke,
und das Stampfen der Füße war wie Dreschflegelgeklopf auf der
Tenne, und die Stimmen der Geigen, die ständig schäkernd sangen,
klangen weit vernehmbar:</p>
<p class="calibre3">»Ach wer wird mich greifen wollen ... greifen wollen!?«</p>
<p class="calibre3">»Ich will's tun – ich will's tun – ich will's tun!« brummelten
die stöhnenden Baßgeigen als Antwort und die Trommel schüttelte
sich nur immerzu und kicherte und schäkerte und machte Lärm mit
ihren Schellen.</p>
<p class="calibre3">Nicht viele tanzten, aber sie trampelten so mächtig, daß die
Bretter des Tanzbodens krächzten und der Tisch bebte, daß hin und
wieder die Flaschen klirrten und die Schnapsgläser umfielen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page133" title="Snoopy64/rudi49"></a> Doch
die Lust war nicht allzugroß, denn es war auch keine richtige
Gelegenheit dazu, wie das bei Hochzeiten und Verlobungen üblich
ist. Man tanzte nur so, zum Spaß allein, oder um die Beine und das
Rückgrat gerade zu recken. Allein die Burschen, die im Spätherbst
zur Musterung mußten, amüsierten sich eifriger und tranken aus
Kummer, was auch nicht verwunderlich war, denn sie sollten ja in
die weite Welt hinausgetrieben werden, unter Fremde.</p>
<p class="calibre3">Am lautesten aber lärmte der Bruder des Dorfschulzen, und dann
auch Martin Weißer, Thomasle Kohlmeise, Paul Boryna, ein Vetter von
Antek. Antek war heute allein in die Schenke gekommen, in der
Dämmerung, tanzte aber nicht. Er saß in der guten Stube mit dem
Schmied und mit anderen noch. Auch Franz, der Müllerbursch, war da,
ein niedriger, stämmiger, krausköpfiger Bursche, das größte Maul,
der ärgste Windbeutel und Maulaffe auf Gottes Erdboden, ein Kerl,
der auf die Dirnen besonders happig war und darum auch häufig ein
zerkratztes und zerschundenes Maul hatte. Aber da er heute gleich
auf der Stelle sich vollgesoffen hatte, wie 'n Schwein, so stand er
ruhig an der Tonbank mit der dicken Magda vom Organisten, die
bereits im sechsten Monat war.</p>
<p class="calibre3">Der Pastor hatte das schon von der Kanzel herab gerügt, und zur
Heirat gemahnt, aber Franz wollte nichts davon hören, da er doch im
Herbst dienen mußte, was sollte er da mit einem Frauenzimmer.</p>
<p class="calibre3">Magda zog ihn gerade in eine Ecke zur Ofenbank und redete mit
weinerlicher Stimme auf ihn ein, er aber antwortete ihr darauf
immer wieder:</p>
<p class="calibre3">»Hab' ich mich dir aufgehängt... Dummes Luder!... Die Taufe
werd' ich bezahlen und einen Rubel schmeiße ich noch dazu, wenn's
mir gefällt!...« Er war ganz unzurechnungsfähig und stieß sie von
sich, daß sie auf der Ofenbank neben Jakob niedersitzen mußte, der
sich bereits, mit den Füßen nach der Schenkstube zu, in der Asche
schlafen gelegt <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page134" title="Snoopy64/rudi49"></a> hatte; dort schluchzte sie leise vor sich
hin, und Franz ging weitertrinken und die Dirnen in den Tanz zu
nehmen. Die Bauerntöchter wollten ihn nicht, denn er war ein
Müllerbursche, so etwas also wie ein Knecht etwa. Und die
einfacheren Mädchen wollten ihn auch nicht, denn er war besoffen
und stellte beim Tanzen allerhand Dummes an. So spuckte er denn
verächtlich aus und fing an, sich mit dem Küster Ambrosius zu
umarmen und mit etlichen Bauern desgleichen, die, weil sie ihr
Getreide in der Mühle hatten, ihn ihrerseits bewirteten.</p>
<p class="calibre3">»Trinke, Franz, und mahle mein Korn bald fertig. Meine Alte
liegt mir schon immerzu in den Ohren, und zum Klößebacken ist auch
nichts mehr da, nicht ein Krümelchen Mehl...«</p>
<p class="calibre3">»Und meine rattert wegen der Grütze ohn' Unterlaß...«</p>
<p class="calibre3">»Es täte auch mächtig not wegen dem Schweinefutter für die
Mastsau ...,« redete ein dritter.</p>
<p class="calibre3">Franz trank, versprach und brüstete sich laut, daß alles in der
Mühle nach seinem Kopf gehe, daß der Müller auf ihn hören müsse,
denn andernfalls ... weiß er solche Sachen anzustellen, daß zum
Beispiel Würmer in die Getreidekisten kämen ..., das Wasser
austrocknete, die Fische ausstürben wenn er nur über den Teich
hauchen würde ..., daß das Mehl klütig würde und keiner daraus
einen Kuchen backen könnte...</p>
<p class="calibre3">»Deinen Schafskopf würd' ich dir rupfen, wenn du mir das machen
solltest!« schrie Gusche, die sich überall 'rumdrückte, wo was los
war, obgleich sie nicht trank, denn selten hatte sie bar Geld
parat; es war aber immer möglich, daß ihr ein Gevatter ein halbes
Maß spendierte und ein Vetter desgleichen, denn man hatte Respekt
vor ihrer scharfen Zunge. So bekam es auch Franz mit der Angst,
obgleich er betrunken war und hielt sein Maul. Sie wußte über ihn
manches und mancherlei, wie er in der Mühle wirtschaftete, und da
sie schon etwas angetrunken war, stemmte sie die Arme <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page135" title="Snoopy64/gary"></a> in die Seiten
und legte los, indem sie mit dem Fuß den Takt dazu schlug ...</p>
<p class="calibre3">»Das ist die reine Wahrheit, denn so steht's auch in der Zeitung
klar und deutlich ... So leben die Leute nicht in der Welt, wie
hier bei uns, nein. Du lieber Gott, was hat man denn von seinem
Leben? Der Gutsherr regiert, der Propst regiert, der Beamte
regiert/und du arbeite und verrecke den Hungertod und verneige dich
vor jedem, damit du nichts an den Kopf kriegst ...«</p>
<p class="calibre3">»Und kaum 'n Stück Land gehört dir, bald wird's nich mal für
einen kleinen Streifen Acker pro Kopf reichen!«</p>
<p class="calibre3">»Und der Gutsherr allein hat mehr als zwei Dörfer zusammen.«</p>
<p class="calibre3">»Gestern erzählten sie am Gericht, daß neues Land verteilt
werden soll.«</p>
<p class="calibre3">»Was für Land?«</p>
<p class="calibre3">»Na, herrschaftliches, welches denn sonst!«</p>
<p class="calibre3">»Sieh mal an! Geschenkt habt ihr's dem Gutsherrn, daß ihr es
zurücknehmen wollt? Schau, schau, mit fremdem Gut wollen die schon
wirtschaften,« brüllte Gusche und neigte sich lachend nach den
Diskutierenden hin.</p>
<p class="calibre3">»Und sie regieren sich selbst,« erzählte der Schmied weiter,
ohne auf das Weibergerede zu achten, »und alle gehen zur Schule,
leben in Herrenhöfen und sind Herren ...«</p>
<p class="calibre3">»Wo ist denn das so?« fragte Gusche den Antek Boryna, der gleich
am Rande saß.</p>
<p class="calibre3">»In warmen Ländern!« gab er zurück.</p>
<p class="calibre3">»Nee, wenn's dorten so gut ist, warum ist der Schmied da nicht
hingegangen, wie? Das rußige Luder lügt ja wie gedruckt und
schwindelt, und die Dummen glauben's!« rief sie schon ganz
leidenschaftlich dazwischen.</p>
<p class="calibre3">»Geht, Gusche, woher ihr gekommen seid, solange ich gut bin
...«</p>
<p class="calibre3">»Das würde mir einfallen! Die Schenke ist für jedermann da und
ich bin für meine drei Groschen ebenso gut wie <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page136" title="Snoopy64/gary"></a> du. Seht nur diesen
Klugen, den Juden dient er, mit den Beamten hält er, nimmt vor dem
Gutsherrn die Mütze ab, und die hier glauben ihm! ... So 'n
Großmaul! ... Na, ich weiß schon ...« aber sie kam nicht zu Ende,
denn der Schmied faßte sie stark unter die Rippen, öffnete mit dem
Fuß die Tür und schmiß sie in die Vorderstube hinaus, wo sie, so
lang wie sie war, liegen blieb.</p>
<p class="calibre3">Nicht einmal fluchen tat sie, und sagte nur lachend, nachdem sie
sich erhoben hatte:</p>
<p class="calibre3">»Ein starkes Luder, wie 'n Pferd, so einer würde mir in die Ehe
passen.«</p>
<p class="calibre3">Das Volk schlug eine Lache an, und gleich darauf ging sie
hinaus, still vor sich hin schimpfend.</p>
<p class="calibre3">Auch die Schenke leerte sich bereits, die Musik schwieg, die
Menschen gingen auseinander nach Hause, einzelne standen noch in
Haufen vor der Schenke, denn der Abend war hell und warm. Der Mond
schien. Nur die Rekruten waren noch geblieben, tranken drauflos und
lärmten. Der Küster Ambrosius aber, besoffen wie ein Vieh, war auf
die Mitte der Dorfstraße gewankt und sang, von einer Seite zur
anderen taumelnd.</p>
<p class="calibre3">Auch die aus der guten Stube, mit dem Schmied voran, kamen
heraus.</p>
<p class="calibre3">Später, als schon der Jude die Lichter zu löschen begann,
schoben die Rekruten zur Türe hinaus, sie faßten sich recht fest
unter, nahmen die ganze Straße ein und gingen aus voller Kehle
gröhlend, so daß die Hunde geiferten und hin und wieder jemand aus
offenem Fenster ihnen nachblickte ...</p>
<p class="calibre3">Nur Jakob schlief ununterbrochen in der Asche und so fest, daß
ihn Jankel wecken mußte, aber der Bursche wollte nicht auf, er
stieß noch ihm mit den Füßen, fuchtelte durch die Luft und
brummte.</p>
<p class="calibre3">»Scher' dich, Jud', verfluchter! So wie ich will, werde ich auch
schlafen ... ein Hofbauer bin ich, habe meinen eigenen Willen und
du bist 'n Lausejud und 'n Rotkopf.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page137" title="Snoopy64/gary"></a> Erst
ein Eimer Wasser half, so daß er aufstand, etwas klarer wurde und
mit Angst und Staunen zu hören bekam, daß er einen ganzen Rubel
vertrunken hatte/daß er in Schuld geblieben war ...</p>
<p class="calibre3">»Wieso denn? Zwei Halbe mit Arrak ... ein ganzer Hering ...
Tobak und noch zwei Halbe ... und schon 'n ganzer Rubel? Wieso denn
... zwei ...,« phantasierte er ...</p>
<p class="calibre3">Jankel überzeugte ihn schließlich, und sie verständigten sich
wegen des Gewehres, das ihm der Jude vom Jahrmarkt mitbringen
sollte, und zum Schluß gab's noch ein Glas Essenz mit Spiritus.</p>
<p class="calibre3">Nur den Hafer weigerte sich Jakob entschieden zu versprechen
...</p>
<p class="calibre3">»Jakobs Vater war kein Dieb/so ist der Sohn auch kein Dieb.«</p>
<p class="calibre3">»Geht, geht doch endlich, 's ist schon Schlafenszeit ... und ich
habe noch meine Gebete zu lesen.«</p>
<p class="calibre3">»Donnerwetter! ... So 'n Spekulant! Zum Stehlen will er einen
überreden, und muß Gebete lesen ...« brummte er vor sich hin im
Nachhausegehen und fing nun an, sich alles zu überlegen und
nachzusinnen, denn es konnte ihm gar nicht in den Kopf, daß er
einen ganzen Rubel vertrunken hatte ... Da er aber noch nicht
nüchtern war und die frische Luft ihn flau gemacht hatte, so
torkelte er 'n bißchen und wankte hin und wieder gegen einen der
Zäune oder auch auf einen Haufen Bauholz, das verschiedentlich vor
den Katen lag ... Dann fluchte er ...</p>
<p class="calibre3">»Krumm sollt ihr werden, ihr Ludersch! ... Halunken, so den Weg
zu versperren! Besoffen sind sie, die Biester ... und Hochwürden
kann umsonst mahnen ... und Hochwürden ...« hier wurde er
nachdenklich und überlegte, bis über ihn schließlich die Erkenntnis
kam und ein solcher Jammer, daß er stehenblieb, rings um sich
blickte, sich beugte und nach irgendwas herumsuchte ... sofort
hatte er es aber wieder vergessen und faßte sich an seine Zotteln
und <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page138" title="Snoopy64/gary"></a> fing
an, sich mit der Faust aufs Maul zu schlagen und zu schreien.</p>
<p class="calibre3">»Du Saufjan! Du verfluchtes Schwein! Zu Hochwürden werde ich
dich hinschleppen, daß er dir vor dem ganzen Volk ins Gesicht sagt,
daß du ein Hund und 'n Saufjan bist ... daß du zwei halbe ... daß
du einen ganzen Rubel versoffen hast ... daß du 'n Vieh bist, oder
noch was Schlimmeres! ... Daß du ...«</p>
<p class="calibre3">Und ein plötzliches Weh erfaßte ihn über sich selbst, daß er
sich auf der Dorfstraße niedersetzte und losheulte.</p>
<p class="calibre3">Der helle, große Mond ruderte durch die dunklen Räume und hier
und da, nicht allzu dicht, blitzten die Sterne wie silberne
Nagelköpfe; die Nebel spannen sich in grauen unscheinbaren
Spinnweben über dem Dorfe und wehten, wie ein Schleier über den
Wassern. Die unergründliche Stille einer Herbstnacht erfüllte die
Welt, nur hin und wieder riß sich von ihr das Gesinge der von der
Schenke Heimkehrenden los und das Kläffen der Hunde.</p>
<p class="calibre3">Und auf der Dorfstraße vor der Schenke wankte Ambrosius von
einer Seite der Straße zur anderen und sang immerzu, immerzu, ohne
Unterbrechung bis er nüchtern wurde:</p>
<p class="vers">Maruschka, oh Maruschka!<br class="calibre2"/>
Wem brautest du das Bier wohl da?<br class="calibre2"/>
Wem brautest du das Bier wohl da?<br class="calibre2"/>
Maruschka, oh Maruschka!</p>
<p class="pcalibre6 initial1">Es ging immer tiefer in den
Herbst hinein. Blasse Tage schleppten sich durch die leeren,
stummgewordenen Felder, erstarben in den Waldrevieren und wurden
immer stiller, immer bleicher/gleich heiligen Hostien im
verlöschenden Schein der Totenkerzen.</p>
<p class="calibre3">Und bei jedem Morgengrauen stand der Tag träger auf, ganz von
Kälte erstarrt, im Rauhreifkleide und in der <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page139" title="Snoopy64/gary"></a> schmerzerfüllten Stille der
ersterbenden Erde; die blasse, schwere Sonne erblühte aus den
Tiefen inmitten der Kränze von Krähen und Dohlen, die irgendwo über
den Morgenröten aufflatterten und niederen Fluges über die Ebene
zogen, dumpf, lange und kläglich krächzend ... Ihnen nach jagte der
scharfe, kalte Wind/trübte die starren Gewässer, zehrte das letzte
Grün der Blätter aus und riß das letzte Laubwerk von den gebeugten
Pappeln an den Wegen, so daß die Blätter still niedertropften, wie
Tränen/wie blutige Tränen des gestorbenen Sommers, die schwer auf
den Boden fallen.</p>
<p class="calibre3">Und bei jedem Morgengrauen/wachten die Dörfer später auf: das
Vieh zog träger auf die Weiden, die Angeln der Tore knarrten
leiser, leiser klangen die Stimmen, die die öde Totenstille der
Felder gedämpft hatte, und leiser, ängstlicher ging der Pulsschlag
des Lebens. Manchmal nur sah man vor den Hütten oder auf den
Feldern Menschen jäh stehenbleiben und lange in die düstere,
bläuliche Ferne starren ... Und über den vergilbten Gräsern hoben
sich mächtige gehörnte Köpfe und versenkten langsam wiederkäuend
die Augen in den weiten, weiten Raum ... Manchmal nur irrte über
das öde Land ein dumpfes, klagendes Gebrüll.</p>
<p class="calibre3">Und bei jedem Morgengrauen war es immer dämmeriger und kälter,
der Rauch spann sich niedriger durch die kahlen Obstgärten hin und
immer mehr Vögel kamen ins Dorf geflogen und suchten Schutz an den
Scheunen und Schobern; die Krähen ließen sich auf die Dachfirste
nieder, hingen sich in die nackten Bäume oder zogen Kreise über der
Erde und krächzten stumpf, als müßten sie das Klagelied des Winters
singen.</p>
<p class="calibre3">Die Mittage waren sonnig, aber so tot und glasig, daß das
Rauschen der Wälder wie ein beängstigendes Raunen bis hinein in das
Dorf drang, und das Gurgeln des Flusses wie ein schluchzendes
Gemurmel klang. Die Reste des Altweibersommers <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page140" title="Snoopy64/gary"></a> kamen noch von irgendwo
dahergeflogen und verschwanden in den scharfen, kühlen Schatten,
die zwischen den Hütten lagen.</p>
<p class="calibre3">Die Wehmut des Sterben-Müssens war in diesen stillen Mittagen,
das Schweigen lag auf den leeren Wegen, und in den entblätterten
Obstgärten lauerte die tiefe Schwermut des Leids und des bangen
Wartens.</p>
<p class="calibre3">Und oft und immer öfter umzog sich der Himmel mit graugelben
Wolken, so daß man schon zur frühen Vesperzeit vom Feld heim mußte,
denn die Dämmerung legte sich früh über die Erde ...</p>
<p class="calibre3">Man pflügte noch die Äcker für das Sommerkorn und manch einer
warf die letzten Schollen schon im dichten Düster; heimwärts
schreitend, sah er sich noch einmal um und umfing mit einem
abschiednehmenden Blick sein Land, des fernen Lenzes mit einem
Seufzer gedenkend.</p>
<p class="calibre3">Nach der Vesperzeit gingen häufig Regenschauer nieder; sie
dauerten noch kurz, waren aber kalt, und immer häufiger dehnten sie
sich in die Länge, bis zum Eintritt der Dämmerung/der langen
herbstlichen Dämmerung, in der die Fenster der Hütten wie goldene
Blüten aufflammten und die Pfützen auf den leeren Wegen sich mit
Glast überzogen. Die feuchte, kalte Nacht stieß gegen die Wände und
stöhnte in den Gärten.</p>
<p class="calibre3">Selbst der flügellahme Storch, der zurückgeblieben war und
einsam auf den Wiesen watete, suchte immer häufiger Borynas Schober
auf, oder kam sogar auf den Hof, wo Witek ihm als Lockmittel eifrig
Nahrung hinwarf.</p>
<p class="calibre3">Und verschiedene Bettler besuchten immer öfter das Dorf; es war
das übliche Bettelvolk, das mit tiefen Säcken und langen Gebeten
von Tür zu Tür ging, vom Kläffen der Hunde geleitet/es kamen auch
andere, solche, die von heiligen Statten kamen/sie kannten
Ostra-Brama, Tschenstochau und Kalwarya und erzählten gern an
langen Abenden, wo und was in der Welt geschehen war und welche
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page141" title="DaoH/gary"></a> Wunder sich
irgendwo offenbart hatten, und zuweilen fand sich gar ein solcher
ein, der im stillen selbst über das Heilige Land zu reden wußte und
solche Wunder berichtete, solche Länder kannte, durch solche Meere
gefahren war, so viele Abenteuer erlebt hatte, daß die andächtig
lauschenden Zuhörer ein Staunen ergriff, und manch einem schwer
wurde, an das alles zu glauben ... Doch horchte man gierig, da ja
jeder gern etwas Neues erfahren mochte, und auch die Abende waren
lang, man konnte sich obendrein bis zum Morgengrauen reichlich
ausschlafen, selbst auf beiden Seiten.</p>
<p class="calibre3">Das war der Herbst, der späte Herbst, juchhe!</p>
<p class="calibre3">Doch im Dorf hörte man weder Gesang noch frohe Juchzer, weder
das Piuken der Vögel, noch helle Zurufe/ nichts als den Wind, der
in den Strohdächern wimmerte, als die Regenfälle, die wie mit
Glassplittern gegen die Scheiben prasselten, und das dumpfe, sich
von Tag zu Tag mehrende Geklopfe der Dreschflegel in den
Scheunen.</p>
<p class="calibre3">Lipce erstarb, wie seine umliegenden Felder, die erschöpft, grau
und beraubt in der Ruhe, und in der Stille des Erstarrens dalagen;
wie seine kahlen, zerzausten, trauernden Bäume, die langsam für
einen langen, langen Winter abstarben.</p>
<p class="calibre3">Das war die Herbstzeit, die leibliche Mutter des Winters.</p>
<p class="calibre3">Man tröstete sich nur noch damit, daß es noch nicht das schlimme
Schmutzwetter war, daß die Wege noch nicht allzusehr durchweicht
waren und daß vielleicht das Wetter bis zum Jahrmarkt aushalten
würde, zu dem ganz Lipce sich aufmachen wollte, wie zu einer
Kirmes.</p>
<p class="calibre3">Der Jahrmarkt sollte auf den Tag der heiligen Kordula fallen,
und war der letzte große Markt vor dem Weihnachtsfest; darum
bereitete sich alles mit großer Sorgfalt für den Tag vor.</p>
<p class="calibre3">Schon einige Tage vordem deliberierte man im Dorf, was sich wohl
verkaufen ließe, sei es vom Inventar, sei es <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page142" title="wolfeh/gary"></a> vom Korn oder auch vom
aufgezogenen Jungvieh. Und da es zum Winter ging, so hatte man auch
nicht wenig einzukaufen, an Kleidung und Geräten und manchen
Wirtschaftssachen, was in den Hütten verschiedene Sorgen machte und
wovon manche Zänke und Zwistigkeiten entstanden, denn man weiß es
ja, daß niemand es allzu reichlich hat, und daß bar Geld immer
schwerer zu haben ist.</p>
<p class="calibre3">Und gerade um die Zeit wurden die Steuern fällig, dann wieder
die Gemeindebeiträge und zu guter Letzt noch verschiedene
Abzahlungen untereinander und bei manchen die Anleihen aus der
Vorerntezeit. Etliche mußten auch die Dienstlöhne ausbezahlen / all
das machte so viel zusammen aus, daß selbst einer, der eine halbe
Hufe besaß, schwer aufseufzend überlegte. Dabei kam aber doch
nichts anderes heraus, als daß eine Kuh oder ein Pferd zu Markt
getrieben werden mußte; von den Ärmeren schon gar nicht zu
reden.</p>
<p class="calibre3">So führte denn mancher seine Kuh vor den Kuhstall, putzte ihr
mit einem Strohwisch die mistbeschmutzten Flanken und warf ihr für
die Nacht noch Kleefutter in die Raufe, oder mit Kartoffeln
gekochte Gerste in die Krippe, damit es sie noch ein bißchen
aufblähte inzwischen; ein anderer richtete seinen alten, ganz
erblindeten Klepper her, damit er, sozusagen, wieder
Pferdeähnlichkeit hatte.</p>
<p class="calibre3">Andere noch droschen eifrigst ganze Tage lang, um rechtzeitig
zum Jahrmarkt fertigzuwerden.</p>
<p class="calibre3">Auch bei Boryna bereitete man sich emsig vor; der Alte drosch
mit Jakob den Weizen zu Ende, und Fine und Anna mästeten, soviel
sie noch konnten, in ihrer freien Zeit eine Sau und ein paar Gänse
zurecht, die sie sich von den Zuchtgänsen ausgeschichtet hatten.
Und Antek, da schon jeden Tag die Regenzeit eintreten konnte, fuhr
mit dem Hirtenjungen in den Forst, Reisig und Tannennadelstreu zu
holen, von der ein Teil für den Kuhstall bestimmt war, während der
Rest zu einem Haufen vor dem Wohnhaus <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page143" title="wolfeh/gary"></a> aufgeschüttet wurde, um für den
Winterschutz der Wände zu dienen.</p>
<p class="calibre3">Bis spät in die letzte Nacht vor dem Jahrmarkt dauerte diese
beschleunigte Arbeit; und erst als der Weizen schon in großen
Säcken auf dem Wagen lag, den man in die Scheune geschoben hatte,
und alles für den morgigen Tag bereitet war, setzten sich alle zum
Nachtmahl in Borynas Stube.</p>
<p class="calibre3">Auf dem Herd brannte lustig ein helles Feuer aus Tannenholz und
knisterte fortwährend, sie aber aßen langsam und schweigend, da
niemand nach der angestrengten Arbeit Lust hatte, sich zu äußern;
erst als sie mit dem Essen fertig waren und die Frauen die
Schüsseln und Töpfe von der Bank weggeräumt hatten, sagte Boryna,
dem Herde leicht näherrückend:</p>
<p class="calibre3">»Vor Tag soll aufgebrochen werden!«</p>
<p class="calibre3">»Natürlich, nicht später,« antwortete Antek und ging ans
Schmieren des Pferdegeschirrs. Jakob schnitzte einen Klöppel für
den Dreschflegel, und Witek schalte Kartoffeln für den Morgen,
stieß dabei aber immer wieder den Waupa an, der neben ihm lag und
sich mit den Zähnen Flöhe aus dem Pelz zog.</p>
<p class="calibre3">Eine Stille war eingetreten, so daß man nur das Knistern des
Feuers hörte und ab und zu das Aufzirpen der Heimchen hinterm Herd.
Von der anderen Seite des Hauses drang Wassergeplantsch herüber und
das Geklirr der gewaschenen Töpfe.</p>
<p class="calibre3">»Jakob, bleibt er denn weiter im Dienst?«</p>
<p class="calibre3">Jakob ließ das Schnitzmesser, mit dem er herumbastelte,
zuschnappen und verguckte sich dermaßen ins Feuer, daß Boryna ihn
mahnen mußte.</p>
<p class="calibre3">»Hörst du nicht, was ich dir sage?«</p>
<p class="calibre3">»Hören ..., das hab' ich schon, ich laß es mir nur durch den
Kopf gehen, daß ich, wahr gesagt, bei euch nichts auszustehen hatte
... Alles was recht ist, aber doch ...,« er brach bestürzt ab.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page144" title="wolfeh/gary"></a> »Fine,
gib mal Schnaps und was zum Beißen, was sollen wir beim Trocknen
beratschlagen, wie hergelaufene Juden,« befahl der Alte und schob
die Bank dicht an den Herd, auf dem Fine bald darauf eine Flasche,
Brot und einen Kranz Würste hinstellte.</p>
<p class="calibre3">»Trink' mal einen, Jakob, und sag', was du zu sagen hast.«</p>
<p class="calibre3">»Gott bezahl's, Bauer ... Bleiben, das würd' ich schon, aber ...
aber ...«</p>
<p class="calibre3">»Ich will dir auch was zugeben ...«</p>
<p class="calibre3">»Das würde schon zu paß kommen, gewiß, der Schafspelz fällt
schon ganz auseinander und die Stiefel auch, und den Kapottrock
müßt' ich auch wieder neu haben ... der Mensch sieht schon wie 'n
Lump aus, und selbst in die Kirche wagt man sich nicht hinein, man
muß schon rein in der Vorhalle bleiben ... denn wie kann man vor
den Hauptaltar in solcher Verfassung ...«</p>
<p class="calibre3">»Und Sonntag, da hast das nicht gemeint, da hast du dich
zwischen die Ersten gedrängt ...,« sagte Boryna streng.</p>
<p class="calibre3">»Gewiß schon ... aber ... das is wahr ...,« stotterte er sehr
beschämt und errötete heftig.</p>
<p class="calibre3">»Und Hochwürden predigt doch, daß man die Älteren ehren soll.
Trink' mal eins zum Frieden, Jakob, und höre was ich dir sage, da
wirst du schon selbst sagen, daß ein Knecht kein Bauer ist ...
Jeder hat seinen Platz und für jeden hat unser Herr Jesus etwas
anderes bestimmt. Hat dir der Herr Jesus deinen Platz bestimmt, so
halt' dich dran und such' nicht gegen anzugehen, und dräng' dich
nicht auf die erste Stelle, erhebe dich nicht über die anderen,
sonst begehst du 'ne große Sünde, und selbst Hochwürden wird dir
das sagen, daß es so sein muß / damit Ordnung in der Welt ist.
Begreifst du das, Kuba?«</p>
<p class="calibre3">»Da müßt' ich schon 'n dummes Vieh sein, wenn ich das nicht
verstehen soll. Meine Vernunft hab' ich schon.«</p>
<p class="calibre3">»Dann paß auf, daß du dich nicht über die anderen erhebst.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page145" title="wolfeh/gary"></a> »Ih ...
nur dem Altar wollt' ich näher sein.«</p>
<p class="calibre3">»Herr Jesus wird dich selbst aus dem letzten Winkel hören, hab'
keine Angst. Und wozu sich unter die Allerersten drängeln, wo doch
alle wissen, wer du bist.«</p>
<p class="calibre3">»Gewiß, gewiß ... wär' ich ein Hofbauer, würde ich den
Traghimmel tragen und Hochwürden am Arm führen, und in den Bänken
sitzen und nach dem Buch laut singen ... aber da ich nur ein Knecht
bin, wenn auch ein Bauernsohn, so soll ich in der Vorhalle stehen,
oder auch draußen vor der Kirchtür, wie 'n Hund ...« murrte er
traurig.</p>
<p class="calibre3">»Das ist schon eine solche Einrichtung in der Welt und dein Kopf
wird's nicht ändern.«</p>
<p class="calibre3">»Freilich, meiner nicht, freilich ...«</p>
<p class="calibre3">»Trink' noch einen, Kuba, und sage mir, was ich dir an Lohn mehr
geben soll.«</p>
<p class="calibre3">Jakob trank aus; da ihn aber der Schnaps schon etwas umnebelt
hatte, so bildete er sich ein, er säße in der Schenke mit dem
Michael vom Organisten oder mit einem anderen Kameraden, und daß
sie sich frei und guter Dinge miteinander berieten, wie unter
seinesgleichen. Er lüftete seinen Kapottrock, streckte seine Beine
von sich, ließ die Faust auf die Bank niedersausen und schrie
los:</p>
<p class="calibre3">»Vier Papierchen und einen Rubel Handgeld wird er zuzahlen, dann
bleib' ich.«</p>
<p class="calibre3">»Es scheint mir, daß du besoffen bist, oder hat sich dir etwas
im Kopf verdorben?« rief Boryna aus; aber Jakob ging schon seinen
Gedanken und seinen alten Träumen nach, und obendrein hörte er
nicht mehr die Stimme des Hofbauers, so reckte er denn seine
geduckte Seele, wuchs in einen solchen Ehrgeiz und in solches
Selbstbewußtsein hinein, daß er sich wie ein Hofbauer fühlte.</p>
<p class="calibre3">»Vier Papierchen und noch einen Rubel Handgeld / legt er das zu,
dann bleib' ich bei ihm, und tut er das nicht, dann geh' ich,
hundsverdammt nochmal, zum Jahrmarkt und finde mir schon einen
Dienst und vielleicht noch gar als <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page146" title="wolfeh/gary"></a> Herrschaftskutscher ... Man kennt mich,
daß ich arbeiten kann und daß ich mich auf alles auskenne, was im
Feld und um das Haus 'rum ist, manch ein Hofbauer könnt' bei mir
Vieh hüten und bei mir in die Lehre gehen ... Und tut er's nicht,
dann werde ich Vögel schießen und sie Hochwürden hintragen oder
auch dem Jankel ... und tut er's nicht ...«</p>
<p class="calibre3">»Sieh mal an ... dieser Hinkfuß, was der hier auftitscht ...
Kuba!« rief er streng.</p>
<p class="calibre3">Jakob verstummte und ernüchterte sich aus seinen Zuständen, doch
verlor er seinen Trotz nicht, denn er gab nicht nach, so daß
Boryna, ob er wollte oder nicht, ihm hier einen halben Rubel, da
einen Silberling zugab, bis es schließlich dabei bestehen blieb,
daß er ihm für das kommende Jahr einen Zuschuß von drei Rubeln und
zwei Hemden anstatt des Handgelds versprach.</p>
<p class="calibre3">»Ho, ho, du bist mir ein netter Vogel,« rief der Alte, indem er
ihm zum Einverständnis zutrank, und obgleich er ärgerlich war, daß
er so viel Gelb hinschmeißen mußte, so war es zwecklos, zu
schwanken, denn Jakob war auch mehr wert, ein arbeitsamer Knecht,
gut für zwei, was dem Bauer sein war, das war dem heilig, und um
das Vieh kümmerte er sich mehr wie um sich selbst, und wenn er auch
lahmte, und nicht sehr stark war, so kannte er sich doch gut in der
Wirtschaft aus / man konnte sich ganz auf ihn verlassen, daß er
alles, wie es sich gehörte, machen würde und dazu noch den
Tagelöhner überwachen.</p>
<p class="calibre3">Sie beratschlagten noch über dieses und jenes, und als sie sich
anschickten, auseinanderzugehen, ließ sich Jakob ganz schüchtern
von der Tür aus vernehmen:</p>
<p class="calibre3">»Is so gut mit den drei Rubeln und den zwei Hemden, aber...
aber... die Jungstute, die dürft ihr nicht verkaufen ... ist doch
bei mir geworfen worden ... mit meinem Schafpelz hab' ich sie doch
zugedeckt, daß sie nicht umkam ..., das seh' ich nicht mit an, wenn
sie ein Jude oder irgendein Lump aus der Stadt schlagen sollte...
Verkauft <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page147" title="Frank_9901/gary"></a> sie nicht ... ein Gold von einem Pferd ...
gehorsam wie ein Kind ... so 'n Pferd, da ist manch Mensch 'n Vieh
dabei. Tut sie nicht verkaufen.«</p>
<p class="calibre3">»Nicht in den Kopf ist mir das gekommen.«</p>
<p class="calibre3">»Sie haben es in der Schenke gesagt ... da hab' ich mich darum
gesorgt ...«</p>
<p class="calibre3">»Vormünder, Hundsgesindel, immer wissen sie 's am besten.«</p>
<p class="calibre3">Jakob hätte am liebsten aus Freude seine Knie umschlungen, aber
er traute sich nicht, so setzte er denn seine Mütze auf und ging
bald, da es denn auch Zeit war, schlafen zu gehen, in Betracht auf
den morgigen Jahrmarktstag.</p>
<p class="center">— — — — —</p>
<p class="calibre3">Am nächsten Morgen, vor Tagesanbruch also, / kaum hatten die
Hähne zum zweiten Male gekräht, / rührten sich auf allen Wegen und
Stegen, die nach Tymow führten, die Menschen.</p>
<p class="calibre3">Was nur lebte in der ganzen Umgegend, strömte zum Jahrmarkt hin.
Gegen Morgen war starker Regen gefallen, doch nach Sonnenaufgang
hatte es sich etwas aufgehellt, aber der Himmel war noch mit grauen
Wolkenungetümen bedeckt und über den tiefgelegenen Landen hingen
graue Nebelschwaden, wie ganz durchnäßte Sackleinentücher; auf den
Wegen spiegelten die Pfützen und hier und da in den Wegsenkungen
quantschte der Schmutz unter den Füßen.</p>
<p class="calibre3">Auch von Lipce kamen sie schon vom frühen Morgen her
angezogen.</p>
<p class="calibre3">Auf dem Pappelweg hinter der Kirche und weithin bis an die
Wälder sah man eine Kette von Wagen sich Schritt für Schritt
vorwärtsbewegen, so ein Gedränge war es, und auf den Stegen von
beiden Seiten des Weges schimmerte es von roten Beiderwandröcken
der Frauen und weißen Haartuchkitteln der Männer.</p>
<p class="calibre3">So viel Volk war unterwegs, als ob ein ganzes Dorf
auswanderte.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page148" title="Frank_9901/gary"></a> Die
ärmeren Bauern gingen zu Fuß, es kamen Frauen, Knechte und
Dorfmädchen, es kamen Kätner und auch ganz armes Volk, lauter
Tagelöhner / alles zog dahin, denn es war ein Jahrmarkt, zu dem die
Bauern dingten und auf dem Stellen gewechselt wurden.</p>
<p class="calibre3">Der eine hatte was zu kaufen, der andere was zu verkaufen, und
noch andere gingen, um sich zu amüsieren.</p>
<p class="calibre3">Dieser und jener führte eine armselige Kuh oder ein kräftiges
Kalb am Strick, der wiederum trieb eine Sau mit Ferkeln vor sich
hin, die hin und her quiekten und dermaßen auseinanderdrängten, daß
man sie immerfort zusammentreiben und hüten mußte, damit sie nicht
unter die Wagen kämen; ein anderer zockelte auf einer Mähre dahin.
Etliche aber trieben geschorene Schafe und hier und da blitzte eine
kleine Herde Gänse, mit festgebundenen Flügeln auf, oder ein
Hahnenkamm guckte unter einer Frauenschürze hervor ... Auch die
Wagen waren nicht schlecht beladen, immer wieder schob sich in
irgendeinem Korbwagen die Schnauze eines Mastschweins aus dem Stroh
hervor und schrie, daß die Gänse erschrocken aufgackerten und die
Hunde, die mit den Menschen Schritt hielten, anfingen, gegen die
Wagen anzukläffen. Und so zogen sie dahin und füllten die ganze
Straße, aber es war unmöglich, daß alle darauf Platz fanden trotz
ihrer Breite. Manch einer mußte vom Weg heruntertreten und zwischen
den Furchen des Ackerlands gehen.</p>
<p class="calibre3">Bei vollem Tag, nachdem sich der Himmel so erhellt hatte, daß
die Sonne jeden Augenblick zu erwarten war, trat auch Boryna
hinaus; vordem schon hatten Anna und Fine bei Morgengrauen die Sau
und den angemästeten Eber fortgetrieben, und Antek war mit zehn
Säcken Weizen und einem halben polnischen Scheffel roten Klees
weggefahren. Zu Hause blieb Jakob mit Witek und die Gusche, die man
herbestellt hatte, um das Essen zu kochen und aufs Vieh zu
passen.</p>
<p class="calibre3">Witek heulte laut vor dem Kuhstall, denn er hatte auch Lust, mit
zum Jahrmarkt zu gehen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page149" title="Frank_9901/gary"></a> »Was
dem nur einfällt« brummte Boryna, bekreuzigte sich und machte sich
zu Fuß auf den Weg, denn er rechnete damit, unterwegs irgendwo
aufzusteigen. So geschah es auch gleich, denn dicht hinter der
Schenke holte ihn der Organist ein, der in einer mit zwei tüchtigen
Pferden bespannten Britschka dahergefahren kam.</p>
<p class="calibre3">»Nanu, Matheus, zu Fuß?«</p>
<p class="calibre3">»Der Gesundheit wegen ... Gelobt sei Jesus Christus.«</p>
<p class="calibre3">»In Ewigkeit. Setzt euch bei uns auf, wir kommen alle zusammen
unter!« schlug die Frau des Organisten vor.</p>
<p class="calibre3">»Gott bezahl's. Auch zu Fuß würd' ich schon hinkommen, aber wie
man so sagt: es ist der Seele mehr wert, wenn sie im Wagen fährt«
antwortete er, den Vordersitz einnehmend, indem er seinen Rücken
den Pferden zugewandt hielt.</p>
<p class="calibre3">Sie drückten sich freundschaftlich die Hände; die Pferde zogen
an.</p>
<p class="calibre3">»Der Herr Jasch, wo kommt er denn her, nicht mehr in den
Klassen?« fragte er den Jungen, der neben dem Knecht auf dem Bock
saß.</p>
<p class="calibre3">»Nur für den Jahrmarkt bin ich hergekommen!« rief der
Organistenbub fröhlich.</p>
<p class="calibre3">»'ne Prise gefällig? französischer ...,« bot der Organist an,
gegen seine Tabakdose schnippend.</p>
<p class="calibre3">Sie langten zu und niesten beiderseits gehörig.</p>
<p class="calibre3">»Was gibt's bei euch? Verkauft ihr heute was?«</p>
<p class="calibre3">»Gott, ja, in der Früh haben sie Weizen hingefahren und die
Frauen haben ein Schwein fortgetrieben.«</p>
<p class="calibre3">»So viel!« rief die Organistin aus, »Jaschu, nimm das
Halstüchel, es ist kalt,« schrie sie dem Sohn zu.</p>
<p class="calibre3">»Mir ist warm, ganz warm,« versicherte er, trotzdem aber
wickelte sie den roten Wollschal um seinen Hals.</p>
<p class="calibre3">»Und die Ausgaben, die sind jetzt auch nicht klein. Man weiß
schon nicht, woher man alles nehmen soll ...«</p>
<p class="calibre3">»Klagt nicht, Matheus, ihr habt genug, Gott sei's gedankt.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page150" title="Frank_9901/gary"></a>
»Meinen Grund und Boden kann ich doch nicht essen ... und bar Geld
hat man nicht zu Hause liegen ..</p>
<p class="calibre3">Im Grunde war Boryna nicht zufrieden mit diesen Anspielungen in
Gegenwart des Knechtes; er beugte sich schnell vor und fragte
leise:</p>
<p class="calibre3">»Und Herr Jasch, wird er denn noch lange in den Klassen
bleiben?«</p>
<p class="calibre3">»Nur noch bis zu den Feiertagen.«</p>
<p class="calibre3">»Kommt er nach Hause oder wird er ein Amt lernen?«</p>
<p class="calibre3">»Oh, du mein, was sollte der wohl zu Hause auf den fünfzehn
Morgen machen, da gibt es noch gerade genug Kleinzeug ... Und die
Zeiten sind schlecht / man muß es rein wie aus Steinen herausholen
...,« seufzte sie auf.</p>
<p class="calibre3">»Das ist schon recht, Taufen gibt's da noch genug, aber viel
Profit kommt nicht heraus dabei!« pflichtete der Organist bei.</p>
<p class="calibre3">»An Beerdigungen mangelt's doch aber nicht,« warf Boryna
ironisch hin.</p>
<p class="calibre3">»Iii ... aber was für Beerdigungen, lauter armes Volk stirbt
weg, und kaum paarmal im Jahr, daß sich ein ordentliches
Bauernbegräbnis trifft, bei dem was abfällt.«</p>
<p class="calibre3">»Messen werden auch immer weniger bestellt, und handeln tun sie
dabei wie die Juden« ergänzte die Frau.</p>
<p class="calibre3">»Das kommt alles wegen der Armut und den schlechten Zeiten,«
entschuldigte Boryna.</p>
<p class="calibre3">»Aber auch von daher, daß die Menschen nichts auf ihr Seelenheil
geben und sich nicht um die kümmern, die im Fegefeuer sind. Der
Propst hat's mehr wie einmal zu dem Meinen gesagt.«</p>
<p class="calibre3">»Auch die Herrenhöfe werden immer weniger. Als man früher zum
Erntedank <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#foot3" id="text3"><sup class="calibre6">F3</sup></a> oder mit den Oblaten herumfuhr, und zu
Weihnachten gratulierte, oder wegen der Volkszählung <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#foot4" id="text4"><sup class="calibre6">F4</sup></a> kam, dann ging man, ohne
sich lang zu bedenken, direktemang zum Herrenhof; da wurde dann
nicht gespart an Getreide, Geld und Legümien. Und jetzt ist es rein
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page151" title="DaoH/gary"></a> zum
Gotterbarmen, jeder Bauer krümmt sich, und die kleinste Garbe
Roggen, die er dir gibt, ist noch halb von Mäusen zerfressen, und
wenn du ein viertel Maß Hafer kriegst, dann gibt's gewiß mehr Spreu
wie Korn drin. Das laßt euch mal von meiner Frau erzählen, was für
Eier sie mir vergangenes Jahr zur Osterzählung <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#foot5" id="text5"><sup class="calibre6">F5</sup></a> mitgegeben haben/ mehr
als die Hälfte war verrottet. Wenn der Mensch nicht sein bißchen
Grund und Boden hätte, dann könnte man betteln gehen,« schloß er,
Boryna die Tabaksdose anbietend.</p>
<p class="calibre3">»Gewiß, gewiß ...,« gab Boryna bei, aber weismachen ließ er sich
nichts, er wußte schon, daß der Organist Geld auf Prozente oder
gegen Entgelt in Feldarbeit den Kätnern lieh, so lächelte er nur zu
diesen Klagen und wandte sich nochmals zu Jasch hin ...</p>
<p class="calibre3">»Und was denn, wird er ins Amt gehen? ...«</p>
<p class="calibre3">»Was? Mein Jasch ins Amt ... ein Schreiber? Dafür hab' ich's mir
nicht vom Mund abgespart, daß er die Schulen durchmacht, ja nicht!
Ins Seminar kommt er, wird Priester werden ...«</p>
<p class="calibre3">»Priester!«</p>
<p class="calibre3">»Ist das vielleicht ein schlechtes Auskommen? Gibt's vielleicht
einen Priester, der's schlecht hat?«</p>
<p class="calibre3">»Das ist wohl recht ... und eine Ehre ist es auch; man sagt ja
doch: Wer einen Priester zum Verwandten hat, frißt sich alle Tage
satt ...,« sagte er langsam und sah mit Hochachtung über die
Schulter auf den Jungen, der den Pferden zuflötete, für die es
gerade nötig war, einen Augenblick anzuhalten ...</p>
<p class="calibre3">»Man erzählte, daß dem Müller sein Stacho Priester werden
sollte, und jetzt praktiziert er auf den hohen Schulen und will 'n
Doktre werden ...«</p>
<p class="calibre3">»Hat sich was, den Lump noch zum Priester machen, da ist doch
die Magda bei uns, die geht schon im sechsten Monat, und das ist
von ihm ...«</p>
<p class="calibre3">»Man sagte, daß es der Müllersknecht gewesen ist.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page152" title="lac/DaoH"></a> »Häh, wer
dran glaubt, das sagt die Müllerin, um ihren reinzuwaschen. Das ist
ein Liederjahn, das Gott erbarm, der paßt zum Dokter.«</p>
<p class="calibre3">»Versteht sich, daß Priester sein besser ist, es ist auch unserm
Herrn Jesus zu Ehren und den Menschen zum Trost,« pflichtete ihr
Boryna schlau bei, was sollte er auch mit einer Frau herumzanken,
und ganz aufmerksam hörte er ihren Ausführungen zu. Der Organist
lüftete inzwischen ein übers andere Mal seine Mütze und antwortete
mit einem lauten: »In Ewigkeit, Amen!« auf die Grüße der Leute, die
ihr Wagen überholte. Sie fuhren im leichten Trab, Jascho wich den
Wagen, Menschen und dem des Wegs getriebenen Vieh mit Bravour aus,
bis er den Wald erreichte, wo es schon freier wurde und der Weg
breiter war.</p>
<p class="calibre3">Gleich am Waldrand holten sie die Dominikbäuerin ein; sie fuhr
mit Jagna und Schymek, und eine an den Hörnern befestigte Kuh ging
hinter dem Wagen, aus dem ein paar Gänseriche ihre weißen Hälse
hervorstreckten und wie die Vipern zischten.</p>
<p class="calibre3">Man bot einander Gott zum Gruß, und Boryna, der sich beim
Überholen ganz herausbeugte, rief:</p>
<p class="calibre3">»Ihr kommt zu spät!«</p>
<p class="calibre3">»Wir kommen zurecht!« rief ihm Jagna lachend zurück.</p>
<p class="calibre3">Man fuhr vorbei, doch der Organistensohn drehte sich mehrmals
nach ihr um, und fragte schließlich:</p>
<p class="calibre3">»War die der Dominikbäuerin ihre Jagna?«</p>
<p class="calibre3">»Das war sie, jaja,« antwortete Boryna, sich aus der Ferne noch
nach ihr umschauend.</p>
<p class="calibre3">»Hab' sie gar nicht wiedererkannt, zwei Jahre sind es schon gut,
daß ich sie nicht gesehen habe.«</p>
<p class="calibre3">»Die ist noch grün, damals hat sie grad' das Vieh gehütet. Ist
nur so aufgegangen, wie eine Färse im Klee,« und er bog sich weit
über den Wagenrand, um nach ihr hinzusehen.</p>
<p class="calibre3">»Sie ist sehr schön,« warf Junge der hin.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page153" title="lac/gary"></a> »Wie alle
Mädel,« sagte die Organistin verächtlich.</p>
<p class="calibre3">»Jawohl, die ist glatt, 'ne wohlgeratene Dirn'; keine Woche ist,
daß nicht jemand zu ihr mit Schnaps schickt.«</p>
<p class="calibre3">»'ne wählerische is sie! Die Alte denkt, daß wenigstens ein
Verwalter ihretwegen angefahren kommt, und jagt die Burschen zur
Türe 'raus ...,« zischelte sie bissig.</p>
<p class="calibre3">»Es könnte sie auch einer nehmen, der selbst 'ne ganze Hufe hat
... denn so viel ist die wert ...«</p>
<p class="calibre3">»Dann bleibt nichts anderes über, als daß ihr die Brautbitter
schickt, Matheus, da ihr sie doch so lobt!« fing sie an zu lachen.
Boryna sagte kein Wort mehr.</p>
<p class="calibre3">»Sieh da, so 'n Stadtfetzen, hohe Persönlichkeit, die den
Bauernhühnern unter den Schwanz guckt, ob sie nicht für sie Eier
legen und den Menschen in die Hand, ob nichts für sie abfällt; will
sich so eine lustig machen über ansässige Hofbauern! Wag' du dich
an die Jagusch heran!« dachte er, stark beleidigt, und sah immerzu
vor sich hin auf den Wagen der Dominikbäuerin aus dem die roten
Schürzen leuchteten und der immer weiter zurückblieb, denn Jascho
fuhr energisch mit der Peitsche zwischen die Pferde, daß sie von
der Stelle aus wegstoben und die Räder tiefe Rillen in den Schmutz
gruben.</p>
<p class="calibre3">Vergeblich fing die Organistin wieder an, über dies und jenes zu
reden, er nickte nur mit dem Kopf und brummelte etwas vor sich hin;
er hatte sich dermaßen in sich verbissen, daß er nicht mal mit
einem einzigen Wort antworten wollte.</p>
<p class="calibre3">Und kaum waren sie auf dem holprigen Straßenpflaster des
Städtchens, stieg er auch schon von der Britschka ab und bedankte
sich für die Fahrt.</p>
<p class="calibre3">»Gegen Abend kehren wir heim, da setzt euch wieder zu uns, wenn
ihr wollt.«</p>
<p class="calibre3">»Gott bezahl's, meine eigenen Pferde sind ja da. Sonst würden
die Leute sagen, ich tät' mich zum Blasebalgtreten verdingen, oder
als Organistengehilfe ... und ich kann <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page154" title="lac/gary"></a> nicht einen einzigen Ton
'rauskriegen und zum Lichterausblasen bin ich auch nicht angelernt
...«</p>
<p class="calibre3">Sie bogen in eine Nebengasse ab, und er zwängte sich langsam
durch die Hauptstraße nach dem Marktplatz hin vorwärts. Der
Jahrmarkt konnte sich sehen lassen, die Menschen stauten sich zu
einem dichten Gewirr, obgleich es noch ziemlich früh war; alle
Straßen, Plätze, Winkel und Höfe waren mit Menschen, Wagen und
vielerlei Waren vollgepfercht/es war wie ein großes Wasser, zu dem
noch ohne Unterlaß aus allen Seiten neue Menschenstrome stießen;
sie drängten sich, wallten und fluteten durch die engen Gassen, so
daß die Häuser zu zittern schienen und ergossen sich über den
großen Klosterplatz. Der Schmutz, der auf den Wegen noch nicht
allzu arg war, ging hier, wo ihn tausend Füße zerstampften und zu
Brei zertraten, schon bis über die Knöchel und spritzte unter den
Rädern nach allen Seiten auf.</p>
<p class="calibre3">Das Stimmengewirr war beträchtlich, doch steigerte es sich mit
jedem Augenblick; es brauste wie ein Wald, es wogte wie ein Meer,
es schlug gegen die Wände der Häuser und wälzte sich von einem Ende
zum andern/so daß nur zuweilen Kuhgebrüll, Leierkastenklänge vom
Karussell, weinerliche Lamentationen der Bettler oder die scharfen
durchdringenden Pfeifen der Korbmacher dazwischen hörbar
wurden.</p>
<p class="calibre3">Der Jahrmarkt war in der vollen Bedeutung des Wortes groß, es
hatte sich so viel Volk zusammengedrängt, daß es nicht leicht
wurde, durchzukommen, und als Boryna aus dem Marktplatz vor dem
Kloster ankam, da mußte er sich mit Gewalt durchzwangen/eine solche
Menschenwand stand um die Verkaufsbuden herum.</p>
<p class="calibre3">Es waren deren so viele, so furchtbar viele, daß man es gar
nicht zählen noch fassen konnte, wer wäre damit auch fertig
geworden ...</p>
<p class="calibre3">Zuerst die hohen, leinwandbespannten Buden, die an der <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page155" title="lac/gary"></a> Klostermauer entlang
in zwei Reihen standen, ganz mit Weiberkram vollgestopft/mit
Leinwandstücken und Tüchern, die auf Stangen hingen und rot wie
Mohnblumen waren, daß es in den Augen flimmerte, oder auch ganz
gelb aussahen, oder rübenrot ... wer hatte sich das alles merken
sollen! Und es wimmelte von Mädchen und Frauen davor, so daß man
nicht einmal einen Stock dazwischen stecken konnte/die einen
feilschten und wählten aus, und andere standen da, um nur zuzusehen
und die Augen an den Herrlichkeiten zu weiden.</p>
<p class="calibre3">Und weiterhin zogen sich wieder Krambuden, die vor
Perlenschnüren, Spiegelchen, Goldtand, Bändern, Halskrausen und von
grünen, goldenen und verschiedenfarbigen Blümelein, von glitzernden
Hauben und Gott weiß was mehr flimmerten.</p>
<p class="calibre3">Irgendwoanders wurden Heiligenbilder verkauft in goldgleißenden
Rahmen und hinter Glas, und obgleich sie an die Wand gelehnt
standen oder selbst am Boden lagen, kam von ihnen ein solcher
Glanz, daß manch einer nach der Mütze langte und sich
bekreuzigte.</p>
<p class="calibre3">Boryna kaufte ein seidenes Kopftuch für Fine, das er ihr noch im
Frühjahr für das Viehhüten versprochen hatte. Er schob es unter den
Brustlatz und begann sich nach dem hinter dem Kloster gelegenen
Schweinemarkt durchzudrängen.</p>
<p class="calibre3">Vor einer Anzahl Häuser hatten die Hutmacher breite Leitern
hingehängt, die von oben bis unten mit Mützen behangen waren.</p>
<p class="calibre3">Anderwärts hatten Schuster eine ganze Straße aus hohen
Holzböcken gebildet, an denen ganze Stiefelreihen, an den Ösen
aufgehakt waren. Es waren da gewöhnliche gelbe Naturlederstiefel,
zum Schmieren mit zerlassenem Talg, gegen die Nässe, und solche die
zum Glanzwichsen zurechtgemacht waren, und Wadenstiefel für die
Frauen mit roten Schnürlitzen und hohen Absätzen.</p>
<p class="calibre3">Weiter unten kamen die Sattler, mit ihren Kummeten auf <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page156" title="lac/gary"></a> eingerammten
Pflöcken und mit ausgebreitetem Pferdegeschirr.</p>
<p class="calibre3">Und dahinter noch die Seiler und die Netzknüpfer.</p>
<p class="calibre3">Und die, die mit Sieben durchs Land fahren.</p>
<p class="calibre3">Und die, die mit Grütze von Jahrmarkt zu Jahrmarkt ziehen.</p>
<p class="calibre3">Und Rademacher und Gerber.</p>
<p class="calibre3">Anderwärts hatten Schneider und Kürschner ihre Ware zur Schau
gestellt; sie strömte einen solchen Geruch aus, daß es einem in der
Nase zwickte, aber sie hatte einen guten Zuspruch, denn es ging ja
dem Winter zu.</p>
<p class="calibre3">Es waren auch ganze Reihen von Tischen aufgestellt mit
Leinwanddächlein darüber; da lagen Bündel roter taudicker Würste,
Wälle gelben Flomens; geräucherte Schweinsrippen, Speckschwarten
und Schinken türmten sich zu Haufen, und daneben hingen auf Haken
ganze ausgeweidete Schweine, von denen das Blut noch tropfte, so
daß es nötig war, die heranschleichenden Hunde zu verscheuchen.</p>
<p class="calibre3">Neben den Schlächtern hatten sich, wie leibhaftige Brüder, die
Bäcker niedergelassen; auf dick ausgebreitetem Stroh, auf Wagen,
Tischen, und in Körben wo es nur anging lagen Berge von radgroßen
Brotlaiben, gelben Butterkuchen, Semmeln, Brezeln ...</p>
<p class="calibre3">Wer hätte wohl all die Buden behalten und sich merken können,
und obendrein noch das, was darin verkauft wurde? ...</p>
<p class="calibre3">Es waren auch Buden mit Spielsachen da und Lebkuchenbuden, wo
vielerlei Tiergestalten aus Teig geformt waren, und Herzen und
Soldaten und solche Wunder, daß der erste beste sich da gar nicht
auskennen konnte; es waren Buden mit Kalendern und frommen Büchern
da, wo Geschichten von Räubern und grausamen Magellonen verkauft
wurden, und Fibeln dazu. Es gab Buden mit Pfeifen, Harmonikas,
Tonhähnen und anderen musikalischen Dingen/ auf denen das
rothaarige Judenvolk spielte, um Lust zu <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page157" title="lac/gary"></a> machen, und wo ein solches
Gekreisch herrschte, daß es kaum zum Aushalten war/hier pfiff eine
Wasserpfeife, dort tutete eine Trompete, anderswo entlockte man
einigen Flöten bunte Weisen, Geigen juchzten und Trommeln stöhnten
und meckerten dazwischen/der Kopf platzte einem schier vor all dem
Lärm.</p>
<p class="calibre3">Mitten auf dem Marktplatz aber, rings um die Bäume, machten sich
die Küfer und Klempner breit, und die Töpfer hatten so viele
Schüsseln und Töpfe aufgestellt, daß man kaum durchgehen konnte,
dahinter hatten die Tischler ihr Lager; Betten und gemalte Laden,
Schränke, Borte und Tische spielten in allen Farben, daß man mit
den Augen blinzeln mußte ...</p>
<p class="calibre3">Und überall auf den Wagen, an den Rinnsteinen und Häuserwänden,
wo nur irgendein Platz war, saßen verkaufende Weiber; die eine
hatte Zwiebeln in Kränzen oder in Säcken; die andere
selbstgesponnenes Leinen und Beiderwand; eine saß mit Eiern, Käsen,
Pilzen und verkaufte eiförmige Klumpen Butter, die mit
Leinwandstücken umwickelt waren; und eine war mit Kartoffeln und
Gänsen da, stellte ein gerupftes Huhn, schön gekämmten Flachs,
zaspeln Garn zur Schau, und jede saß bei ihrem Teil; sie besprachen
sich würdevoll miteinander, wie es auf Jahrmärkten üblich ist, und
traf sich ein Käufer, so verkauften sie langsam, bedächtig, ohne
Hitzigkeit/wie es Bäuerinnen ziemt und nicht so wie die Juden, die
schreien, sich einem anhängen und herumspringen, als wären sie
nicht bei Verstand.</p>
<p class="calibre3">Ab und zu zwischen den Wagen und Krambuben sah man kleine
blecherne Schornsteine qualmen/dort verkaufte man heißen Tee/und
anderes Essen war auch da, geröstete Wurst, Kohl und Barschtsch mit
Kartoffeln.</p>
<p class="calibre3">Und Bettler ohne Zahl waren aus allen Himmelsrichtungen
zusammengekrochen; Blinde, Lahme, Stumme und auch solche, die weder
Arme noch Beine hatten, es wimmelte von ihnen, wie zu irgendeiner
Kirmeszeit; die einen spielten <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page158" title="Monne3/gary"></a> auf der Geige fromme Lieder, die anderen
sangen und klirrten mit ihren Geldnäpfen, um sich ein paar Groschen
oder eine andere Unterstützung zu ergattern; überall an den
Häuserwänden entlang und unter den Wagen hervor, selbst mitten aus
dem Dreck klang ihr flehentliches Betteln.</p>
<p class="calibre3">Das alles hatte sich Boryna schon besehen, manches erstaunt
betrachtet, hin und wieder mit Bekannten geredet, bis er sich
schließlich zum Schweinemarkt hinterm Kloster durchgedrängt hatte.
Der war auf einem großen, sandigen Platz, den vereinzelte Häuser
umsäumten. An der Klostermauer, über die sich mächtige, noch gelb
belaubte Eichen hervorreckten, drängten sich die Menschen reichlich
dicht zwischen den Wagen, ganze Parzellen Schweine lagen da, die
hier zum Verkauf zusammengetrieben waren.</p>
<p class="calibre3">Bald hatte er Anna und Fine herausgefunden, die dicht am Rand
saßen.</p>
<p class="calibre3">»Verkauft ihr was?«</p>
<p class="calibre3">»Wie man's nehmen will, die Schlachter haben schon um die Sau
gehandelt, aber sie geben nichts ...«</p>
<p class="calibre3">»Sind die Schweine teuer?«</p>
<p class="calibre3">»Na Gott, teuer, die haben hier heuer so viel zusammengetrieben,
daß man nicht weiß, wer das alles kaufen soll.«</p>
<p class="calibre3">»Is wer aus Lipce da?«</p>
<p class="calibre3">»Da, da haben die Klembs ihre Ferkel, und der Dominik-Schymek
steht auch bei einem Eber.«</p>
<p class="calibre3">»Macht schnell, dann kriegt ihr auch 'was vom Jahrmarkt ab.«</p>
<p class="calibre3">»Es wird einem auch schon über, so zu sitzen.«</p>
<p class="calibre3">»Was geben sie für die Sau?«</p>
<p class="calibre3">»Dreißig Papierer, weil sie nicht durchgemästet ist, dicke
Knochen soll sie haben, aber kein Speck.«</p>
<p class="calibre3">»Die zigeunern nur 'rum, wo sie können ..., gut ihre vier Finger
Speck hat die Sau ...,« sagte er, nachdem er ihr den Rücken und die
Flanken befühlt hatte. »Dem Eber fehlt schon was an den Seiten,
aber die Schinken sind <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page159" title="Monne3/gary"></a> gut,« gab er zu, indem er das Tier vom nassen
Sand wegjagte, wo es sich bis zur Hälfte eingewühlt hatte.</p>
<p class="calibre3">»Für fünfunddreißig könnt ihr sie losschlagen, ich geh' nur noch
nach Antek gucken, gleich bin ich wieder da. Ihr werdet wohl auch
Hunger haben? ...«</p>
<p class="calibre3">»Wir haben schon etwas Brot gegessen.«</p>
<p class="calibre3">»Verkauft nur schön, ihr sollt auch Wurst kriegen.«</p>
<p class="calibre3">»Väterchen, vergeßt aber nicht mein Tuch, was ihr mit im
Frühjahr versprochen habt ...«</p>
<p class="calibre3">Boryna langte unter den Brustlatz, doch er hielt an, als ob ihm
etwas eingefallen wäre, und mit der Hand abwinkend sagte er im
Weggehen:</p>
<p class="calibre3">»Ich werd's dir kaufen, Fine, ich werd' schon ...« Er machte
sich Beine, denn er hatte plötzlich Jagnas Gesicht zwischen den
Wagen auftauchen sehen, doch ehe er sie erreicht hatte, war sie
spurlos von der Bildfläche verschwunden, als ob die Erde sie
verschluckt hatte; er fing also an, nach Antek zu suchen; das war
nicht gerade leicht, denn in der Gasse, die vom Schweinemarkt zum
Marktplatz führte, standen Wagen an Wagen, und noch dazu in
mehreren Reihen, so daß man nur mit großer Mühe und Vorsicht mitten
hindurchfahren konnte, dennoch fand er ihn bald heraus. Antek saß
auf den Säcken, holte mit der Peitsche nach den Judenhühnern aus,
die sich um die Kober scharten, aus denen die Pferde fraßen, und
antwortete mundfaul auf die Frage der Käufer.</p>
<p class="calibre3">»Sieben hab' ich gesagt, dabei bleibt's.«</p>
<p class="calibre3">»Sechs und halb geben mer, man kann nicht mehr, der Weizen ist
brandig.«</p>
<p class="calibre3">»Wenn ich dir eins über die verdammte Schnauze lange, Krätzjude,
dann wird sie dir auf der Stelle brandig werden, mein Weizen ist
rein wie Gelb.«</p>
<p class="calibre3">»Kann sein, aber feucht is er ... Nach Maß könnte ich kaufen für
sechs Rubel und fünf Silberlinge.«</p>
<p class="calibre3">»Nach Gewicht wirst du sie kaufen für sieben. Das sag' ich dir
ein für allemal!«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page160" title="Monne3/gary"></a> »Was
ärgert sich der Bauer, werd' ich sie kaufen oder nicht kaufen, man
kann doch handeln.«</p>
<p class="calibre3">»Kannst handeln, wenn dir dein Maul nicht zu schade ist.« Und er
beachtete schon die Juden nicht mehr, die die Säcke der Reihe nach
aufbanden und den Weizen besahen.</p>
<p class="calibre3">»Antek, ich geh' jetzt zum Schreiber und im Nu bin ich wieder da
...«</p>
<p class="calibre3">»Was, wollt ihr den Gutshof verklagen?«</p>
<p class="calibre3">»Und durch wen ist die Bunte verreckt?«</p>
<p class="calibre3">»Da wird euch viel 'bei 'rauskommen!«</p>
<p class="calibre3">»Mein Eigentum werd' ich niemand schenken.«</p>
<p class="calibre3">»Ji ... den Heger müßte man im Forst gegen eine Fichte drücken
und mit was Hartem durchbläuen, daß ihm die Rippen pfeifen, gleich
wäre da Gerechtigkeit.«</p>
<p class="calibre3">»Der Heger, gewiß, der verdient's schon, aber der Gutshof auch,«
sagte er hart.</p>
<p class="calibre3">»Gebt mir ein kleines Silberstück.«</p>
<p class="calibre3">»Wozu denn das?«</p>
<p class="calibre3">»Einen Schnaps möcht' ich trinken und was essen ...«</p>
<p class="calibre3">»Hast du nicht dein eigen Geld? Aber nee, ständig soll Vater die
Hand offenhalten ...«</p>
<p class="calibre3">Antek drehte sich weg und fing ärgerlich an, vor sich
hinzupfeifen, und der Alte knotete mißmutig und widerwillig einen
Silberling aus und gab ihn her.</p>
<p class="calibre3">»Mit seinem eigenen Blutschweiß muß man die alle nähren ...,«
dachte er und drängte sich eilig nach der großen Eckschenke hin, wo
schon viele Menschen waren, die ihre Mahlzeit einnahmen. In einem
Erkerstübchen, das auf den Hof ging, wohnte der Schreiber.</p>
<p class="calibre3">Er saß gerade vor dem Fenster am Tisch, mit einer Zigarre
zwischen den Zähnen, hatte weder Rock noch Weste an und war
ungewaschen und zerzaust; irgendein Frauenzimmer schlief in der
Ecke auf einem Strohsack und war mit einem Paletot zugedeckt.</p>
<p class="calibre3">»Setzt euch, Herr Hofbesitzer!« Er warf einen dreckigen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page161" title="lesdochmal/wedi"></a> Anzug vom
Stuhl herunter und schob diesen Boryna hin, der sogleich den ganzen
Fall ausführlich vor ihm ausbreitete.</p>
<p class="calibre3">»Wie Amen im Gebet, tut ihr gewinnen. Das fehlte noch! Die Kuh
ist verreckt, der Junge liegt krank vor Schreck! Unsere Sache steht
gut!« er rieb sich die Hände und suchte auf dem Tisch nach
Papier.</p>
<p class="calibre3">»Aber..., dem Jungen fehlt doch nichts.«</p>
<p class="calibre3">»Schadet nichts, ihm hätte was fehlen können. Geschlagen hat er
ihn doch...«</p>
<p class="calibre3">»Das nicht, nur den Nachbarsjungen hat er geschlagen.«</p>
<p class="calibre3">»Schade, das wäre noch besser gewesen. Aber das wird man schon
irgendwie zusammenkriegen, wir werden Krankheit durch Verprügelung
und eine verreckte Kuh haben. Laß den Gutshof zahlen.«</p>
<p class="calibre3">»Versteht sich, um die Gerechtigkeit geht es hier allein.«</p>
<p class="calibre3">»Gleich werden wir eine Klage schreiben. Franja, du Faulpelz,
rühr' dich!« schrie er und gab der Liegenden einen solchen
Fußtritt, daß sie den strubbeligen Kopf emporrichtete. »Hol' man
Schnaps und zu essen...«</p>
<p class="calibre3">»Keinen roten Heller hab' ich mehr, und du weißt, Gustav, daß
sie nicht mehr borgen wollen...,« murmelte sie, erhob sich vom
Lager und fing an zu gähnen und sich zu recken; hoch war sie wie
ein Ofen und hatte ein großes, schwammiges, versoffenes Gesicht,
das voll blauer Flecke war, und dabei eine dünne Kinderstimme.</p>
<p class="calibre3">Der Schreiber arbeitete, daß die Feder krächzte, sog an der
Zigarre, pustete Boryna, der dem Schreiber zusah, Rauch ins
Gesicht, rieb sich seine mageren, sommersprossigen Hände und drehte
sein blasses Gesicht voller Pusteln, nach Franja hin; seine
Vorderzähne waren schadhaft, seine Lippen bläulich, sein
Schnurrbart groß und schwarz.</p>
<p class="calibre3">Er schrieb die Klage, nahm einen Rubel dafür, nahm einen zweiten
für die Gebühren und verabredete sich auf drei Rubel wegen der
Gerichtsvertretung, für den Fall, daß die Sache vor den grünen
Tisch käme.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page162" title="lac/wedi"></a> Boryna
erklärte sich zu allem eifrig bereit, denn er kombinierte, daß ihm
das Gut alles, und noch mit Überschuß, bezahlen würde.</p>
<p class="calibre3">»Gerechtigkeit muß sein, die Sache ist gewonnen!« sagte er im
Weggehen.</p>
<p class="calibre3">»Gewinnen wir nicht im Gemeindegericht, dann gehen wir vors
Landgericht, und hilft das Landgericht nicht, dann gehen wir vor
das Oberlandesgericht, selbst bis zum Kassationshof, denen wollen
wir nichts schenken.«</p>
<p class="calibre3">»Das fehlte nun noch, mein Hab und Gut zu verschenken!« rief
Boryna verbissen aus, »und wem dazu noch, dem Gut, das so viel
Wälder und Boden hat!« dachte er weiter, als er auf den Marktplatz
trat. Gleich darauf stieß er von ungefähr in der Hutmacherreihe auf
Jagna.</p>
<p class="calibre3">Sie stand da mit einer dunkelblauen Männermütze auf dem Kopf,
und handelte noch um eine zweite.</p>
<p class="calibre3">»Seht mal her, Matheus, der Rote sagt, sie ist gut, und gewiß
betrügt er...«</p>
<p class="calibre3">»Pik nobel, is wohl für Jendschych?«</p>
<p class="calibre3">»Ja, für Jendschych, dem Schymek hab' ich schon eine
gekauft.«</p>
<p class="calibre3">»Wird sie denn nicht zu klein sein?«</p>
<p class="calibre3">»Grad so 'n Kopf wie ich hat er.«</p>
<p class="calibre3">»Gäbst schon einen feinen Bursch' ab...«</p>
<p class="calibre3">»Vielleicht nicht?« rief sie keck und schob die Mütze ein wenig
aufs Ohr...</p>
<p class="calibre3">»Auf der Stelle würden sie dich hier dingen...«</p>
<p class="calibre3">»Ho-la... nur bin ich zu teuer für den Dienst.« Sie fing an zu
lachen.</p>
<p class="calibre3">»Kommt drauf an, wem... mir würdest du nicht zu teuer
sein...«</p>
<p class="calibre3">»Und Feldarbeit, die tät' ich auch nicht...«</p>
<p class="calibre3">»Für dich würd' ich schon mitarbeiten, Jagusch, das tät' ich,«
flüsterte er ihr etwas leiser zu und sah sie leidenschaftlich
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page163" title="lac/wedi"></a> an, daß das
Mädchen betroffen zurücktrat und, ohne weiterzuhandeln, für die
Mütze bezahlte.</p>
<p class="calibre3">»Habt ihr die Kuh verkauft?« fragte er nach einer kleinen Pause,
nachdem er etwas zu sich gekommen war und von dieser Wohligkeit
aufatmete, die ihm, wie Branntwein, den Kopf benommen hatte.</p>
<p class="calibre3">»Sie haben sie für den Priester nach Jeschow gekauft, und die
Mutter ist mit den Organistenleuten eben fortgegangen, denn sie
will einen Knecht dingen.«</p>
<p class="calibre3">»Dann könnten wir doch auf ein Gläschen Süßen irgendwo
eintreten!...«</p>
<p class="calibre3">»Wie denn das?«</p>
<p class="calibre3">»Muß dir doch hier kalt geworden sein, Jagusch, kannst dich was
wärmen...«</p>
<p class="calibre3">»Wie sollt' ich denn... mit euch Schnaps trinken gehen!...«</p>
<p class="calibre3">»Na, denn sollen sie ihn hierher bringen, können ihn auch hier
trinken, Jagusch...«</p>
<p class="calibre3">»Gott bezahl's, es war gut gemeint, ich muß aber nach der Mutter
sehen.«</p>
<p class="calibre3">»Ich werd' dir helfen, Jagusch...« meinte er mit gedämpfter
Stimme und ging voraus. Er arbeitete sich so mit den Ellenbogen
durch, daß Jagna ungehindert hinterdrein durchs Gedränge ging; doch
als sie zwischen die Leinwandzelte kamen, verlangsamte sie den
Schritt, blieb hier und da stehen und ihre Augen entbrannten im
Anschauen all der Dinge, die hier ausgebreitet lagen.</p>
<p class="calibre3">»Das sind dir aber mal Herrlichkeiten, du lieber Jesus!«
murmelte sie, vor den Bändern stehenbleibend, die oben befestigt
waren und im Winde wie ein greller Regenbogen flatterten.</p>
<p class="calibre3">»Welches meinst du, Jagusch, such' es dir aus,« sagte er nach
kurzem Zögern, seinen Geiz überwindend.</p>
<p class="calibre3">»Hale, dieses gelbe, geblümte, wird schon seinen Rubel kosten,
oder selbst zehn Silberlinge!«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page164" title="lac/wedi"></a> »Kehr dich
nicht dran, nimm nur...«</p>
<p class="calibre3">Aber Jagusch riß sich gewaltsam los und ging zum zweiten Stand
weiter, nur Boryna blieb einen Augenblick zurück.</p>
<p class="calibre3">Hier waren wiederum Tücher und Stoffe für Mieder und Jacken.</p>
<p class="calibre3">»Mein Jesus, so viel Herrlichkeiten!« flüsterte sie bezaubert
vor sich hin und tauchte die zitternden Hände immer wieder in grüne
Atlasgewebe und rote Samte, bis es ihr vor den Augen wirr wurde und
ihr das Herz vor Lust hüpfte. Und diese Kopftücher! Seidene,
ponceaufarbene mit grüngeblümter Borde, ganz goldige, wie die
heilige Monstranz, und blaßblaue wie der Himmel nach dem Regen, und
weiße, und die allerschönsten, die changierenden, die wie das
Wasser beim Sonnenuntergang gleißen, und leicht, wie aus
Spinnweben! Nein nein, sie hielt es nicht mehr aus! sie fing an,
sie anzuprobieren und sich im Spiegel zu besehen, den die Jüdin ihr
geschäftig vorhielt.</p>
<p class="calibre3">Prächtig standen sie ihr, als ob sie die Morgenröte um ihr
Flachshaar gewunden hätte, und ihre lichtblauen Augen flammten in
solcher Freude, daß sich ein veilchenblauer Schatten von ihnen auf
das erglühte Gesicht legte; sie lächelte sich zu, und so schön war
sie und solche Jugend, solche Gesundheit strahlte sie aus, daß die
Menschen nach ihr schauten.</p>
<p class="calibre3">»Eine vom Herrenhof in Tracht oder was?« tuschelte man.</p>
<p class="calibre3">Sie betrachtete sich lange und nahm mit einem schweren Seufzer
das Tuch ab, doch fing sie an, darum zu handeln, denn obgleich sie
das Geld nicht hatte, tat sie so, um sich noch länger daran freuen
zu dürfen.</p>
<p class="calibre3">Sie ernüchterte sich schnell, als die Handelsfrau fünf Rubel
sagte, und selbst Boryna wurde eifrig, um sie wegzulocken.</p>
<p class="calibre3">Sie blieben noch vor den Perlschnüren stehen / von denen es eine
solche Menge gab, daß es schien, als ob die ganze <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page165" title="lac/gary"></a> Bude mit kleinen Edelsteinen
benäht wäre; sie leuchteten und funkelten, daß es schwer war, die
Augen abzuwenden /all die gelben Bernsteine, die wie aus duftendem
Harz geformt waren, all die Korallenschnüre, wie aufgefädelte
Blutstropfen, die Perlen weiß und groß wie Haselnüsse, und andere
aus Silber und Gold ...</p>
<p class="calibre3">Jagusch probierte nicht nur eine an, sie wählte und wählte
zwischen ihnen herum, und am schönsten bedünkte sie eine
Korallenschnur; sie umwickelte viermal ihren weißen Hals damit und
drehte sich zum Alten hin.</p>
<p class="calibre3">»Guckt mal her, na?«</p>
<p class="calibre3">»Die stehen dir schön, Jagusch! Korallen sind mir aber nichts
Neues, denn in meiner Lade liegen noch zehn peitschenlange Schnüre
von der Seligen her, so groß wie Felderbsen sind die ...,« sagte er
mit Bedacht, wie von ungefähr.</p>
<p class="calibre3">»Was hab' ich davon, wenn sie nicht meine sind!« sie schleuderte
jäh die Perlen weg und ging finster und traurig weiter.</p>
<p class="calibre3">»Jagusch, laß uns nur erst ein bißchen niedersetzen.«</p>
<p class="calibre3">»Aber, 's ist doch Zeit, ich muß nach der Mutter sehen.«</p>
<p class="calibre3">»Fürcht' dich nicht, sie fährt dir nicht weg.«</p>
<p class="calibre3">Sie setzten sich auf eine herausragende Wagendeichsel
nieder.</p>
<p class="calibre3">»Fein großer Markt dieses Jahr,« sagte Boryna nach einem
Augenblick, sich auf dem Marktplatz umschauend.</p>
<p class="calibre3">»Natürlich, nicht klein!« Sie blickte noch leidvoll zu den
Krambuden hinüber und seufzte vor sich hin; aber die Traurigkeit
fing schon an nachzulassen, denn sie sagte:</p>
<p class="calibre3">»Die Gutsherrschaft, die hat es gut ... Ich hab' die Gnädige aus
Wola gesehen mit den Töchtern, die haben sich so viel gekauft, daß
ein Lakai hinter ihnen her die Sachen tragen mußte! Das geht so
jeden Jahrmarkt.«</p>
<p class="calibre3">»Is einer auf allen Märkten zu Gange/dem reicht's nicht
lange.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page166" title="lac/DaoH"></a> »Denen
reicht's schon.«</p>
<p class="calibre3">»Solange die Juden was geben,« warf er knifflich ein, so daß
Jagusch sich nach ihm umdrehte und nicht wußte, was sie ihm darauf
antworten sollte, der Alte aber fragte leise ohne sie
anzusehen:</p>
<p class="calibre3">»Waren sie mit Schnaps bei dir von Wojteks Michael, was Jagusch?
...«</p>
<p class="calibre3">»Sie sind gekommen und sind gegangen! ... So'n Dösköpf, und denn
noch Brautbitter schicken,« lachte sie auf.</p>
<p class="calibre3">Boryna stand rasch auf, zog hinter dem Brustlatz ein Tuch hervor
und noch irgend etwas in Papier Gewickeltes.</p>
<p class="calibre3">»Halt mal das, Jagusch, denn ich muß nach Antek sehen.«</p>
<p class="calibre3">»Ist er denn auf dem Jahrmarkt?« Ihre Augen wurden lebhaft.</p>
<p class="calibre3">»Beim Getreide ist er geblieben, dort in der Straße. Nimm dir
das, Jagusch, das ist für dich,« fügte er hinzu, als er sah, daß
Jagna erstaunt das Tuch beäugte.</p>
<p class="calibre3">»Mir gebt ihr das? ... wirklich für mich? Jesus, ist das fein!«
schrie sie, das Band loswickelnd, gerade dasselbe, das ihr so
gefallen hatte. »Hale, ihr spaßt wohl nur mit mir, wofür denn? So
viel Geld ... und das Tuch ist reine Seide ...«</p>
<p class="calibre3">»Nimm, Jagusch, nimm, für dich hab' ich's gekauft; und wenn
einer von den Burschen dir zutrinken will, dann tu' keinen
Bescheid, was sollst du dich eilen ... und ich muß nun gehen.«</p>
<p class="calibre3">»Meins is es, das ist Wahrheit?«</p>
<p class="calibre3">»Was sollt' ich dir da was vorzigeunern?«</p>
<p class="calibre3">»Ich kann es noch gar nicht glauben.« Sie breitete immer wieder
das Tuch und das Band auseinander.</p>
<p class="calibre3">»Bleib' mit Gott, Jagusch.«</p>
<p class="calibre3">»Gott soll's euch vergelten, Matheus.«</p>
<p class="calibre3">Boryna ging; Jagna breitete noch einmal alles vor sich aus und
besah es, mit einem Male raffte sie es aber zusammen, um ihm
nachzulaufen und es ihm wiederzugeben <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page167" title="lac/DaoH"></a> ... wie sollte sie von einem
Fremden sich was schenken lassen, nicht mal verwandt oder mit der
Mutter verschwägert war er ... Aber der Alte war nicht mehr zu
sehen. Sie ging langsam davon, die Mutter zu suchen und befühlte
behutsam und mit Behagen das hinter's Mieder geschobene Tuch. Sie
war so erfreut, daß ihr die weißen Zähne nur so beim Lachen
blitzten und die Wangen glühten.</p>
<p class="calibre3">»Jaguscha! ... Um der Barmherzigkeit willen ... arme Waise ...
liebe Menschen ... wahrhaftige Christen ... Ave Maria für die toten
Seelchen ... Jaguscha! ...«</p>
<p class="calibre3">Jagna kam zu sich und blickte umher, wer sie wohl rufen konnte
und von wannen die Stimme käme; bald wurde sie Agathe gewahr, die
an der Klostermauer, auf einem Strohhäufchen saß, da der Schmutz an
dieser Stelle bis über die Knöchel ging.</p>
<p class="calibre3">Sie blieb stehen, nach einer kleinen Gabe suchend, und Agathe,
erfreut über die Begegnung mit einer aus dem Heimatsdorf, machte
sich eifrig dran, sie auszufragen, wie es da wohl in Lipce ginge
...</p>
<p class="calibre3">»Seid ihr schon so weit mit dem Kartoffelausnehmen?«</p>
<p class="calibre3">»Ganz und gar!«</p>
<p class="calibre3">»Wißt ihr nicht, was es bei den Klembs gibt?«</p>
<p class="calibre3">»Haben euch auf den Bettel in die Welt gejagt, und ihr seid noch
begierig auf sie?«</p>
<p class="calibre3">»Weggejagt oder nicht weggejagt, selbst hab' ich mich
fortgemacht, weil 's nötig war ... wieso denn auch, umsonst werden
sie mir meine Ecke geben oder zu essen, wenn sie es selber nicht
dick haben ... Und begierig bin ich auf sie, von wegen der
Verwandtschaft ...«</p>
<p class="calibre3">»Und wie ist es mit euch?«</p>
<p class="calibre3">»Wie es so gehen muß, von Kirche zu Kirche gehe ich, von Dorf zu
Dorf, von Jahrmarkt zu Jahrmarkt und bitt' mir bei guten Leuten
hier und da ein Eckchen, einen Löffel Suppe aus, oder auch Geld.
Die Menschen sind gut, lassen nicht den Armen Hungers sterben,
nein. Wißt ihr <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page168" title="lesebaer/lac"></a> vielleicht, sind die bei Klembs alle gesund?«
fragte sie schüchtern.</p>
<p class="calibre3">»Sie sind gesund, und ihr, seid ihr nicht krank?«</p>
<p class="calibre3">»Ih ... wie man's nimmt, in der Brust zieht es mich immer, und
wenn mich die Kälte ankommt, dann spuck' ich lebendiges Blut ...
Nicht lange mach' ich's schon, nicht mehr lange. Wenn man nur bis
zum Frühjahr durchhält und ins Dorf heim kann, so ... da zwischen
seinen Leuten sterben/darum bitt' ich das kleine Jesuskind, einzig
darum,« sie breitete die mit Rosenkränzen umwundenen Arme, hob das
verweinte Gesicht und begann so inbrünstig zu beten, daß ihr die
Tränen aus den geröteten Augen quollen.</p>
<p class="calibre3">»Sprecht ein Gebet für Väterchen,« murmelte Jagna und steckte
ihr ein Geldstück zu.</p>
<p class="calibre3">»Das wird für die sein, die im Fegefeuer sind, für die Unsrigen
bet' ich auch so schon immerzu und bitte zum lieben Gott für die
Lebendigen und die Toten. Jagusch, und haben sie nicht mit Schnaps
geschickt?«</p>
<p class="calibre3">»Sie sind schon gekommen.«</p>
<p class="calibre3">»Und keinen hat sie sich ausgesehen ...«</p>
<p class="calibre3">»Keinen. Bleibt mit Gott, und im Frühjahr guckt zu uns 'rein,«
sagte sie noch schnell und ging zur Mutter, die sie in der Ferne
mit den Organistenleuten daherkommen sah.</p>
<p class="calibre3">Boryna jedoch kehrte langsam zu Antek zurück, zum ersten, weil's
ein großes Gedränge war, und zweitens, weil ihm Jagusch immerfort
in seinen Gedanken stand, aber bevor er hinkam, traf er auf den
Schmied.</p>
<p class="calibre3">Sie begrüßten sich und gingen schweigend nebeneinander her.</p>
<p class="calibre3">»Wollt ihr mit mir nu aber endlich mal zum Schluß kommen, häh?«
fing der Schmied scharf an.</p>
<p class="calibre3">»Womit zum Beispiel? Dasselbe hättest du mir auch in Lipce sagen
können.« Der Ärger überkam ihn.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page169" title="lesebaer/lac"></a> »Die
ganzen vier Jahre wart' ich schon doch.«</p>
<p class="calibre3">»Und den heutigen Tag mußtest du dir aussuchen! Dann warte noch
deine vierzig, bis ich wegsterbe.«</p>
<p class="calibre3">»Selbst die Leute raten mir schon, daß ich beim Gericht
petitionier' ... aber ...«</p>
<p class="calibre3">»Petitionier' du! Ich kann dir auch noch dazu sagen, wo man die
Klagen schreibt und werd' dir für 'n Schreiber einen Rubel
geben.«</p>
<p class="calibre3">»Aber ich denke, daß wir im guten uns einigen werden ...,«
drehte der Schmied schlau bei.</p>
<p class="calibre3">»Das ist wahr, wenn's nicht mit Krieg/versucht man's mit
Frieden.«</p>
<p class="calibre3">»Das begreift ihr selbst nicht schlecht.«</p>
<p class="calibre3">»Ich brauch' da weder Krieg noch Frieden mit dir.«</p>
<p class="calibre3">»Das sag' ich immer meiner Frau als erster, daß der Vater für
die Gerechtigkeit ist.«</p>
<p class="calibre3">»Jeder holt die Gerechtigkeit hinzu, der sie als Gevatterin
braucht/ich brauch' das nicht, denn ich weiß nichts von Schuld,«
sagte er hart, so daß der Schmied klein wurde, da er ihm von dieser
Seite nicht beikommen konnte, und als ob nichts geschehen wäre,
sagte er in einem ruhigen und bittenden Ton:</p>
<p class="calibre3">»Ich würde einen trinken, wollt ihr spendieren? ...«</p>
<p class="calibre3">»Gewiß. Warum denn nicht, wenn so 'n pikfeiner Schwiegersohn
bittet, dann gibt man selbst 'ne ganze Quart aus,« höhnte er etwas,
in die Eckschenke eintretend. Dort war auch schon Ambrosius da,
aber er trank nicht und saß mürrisch und trübsinnig in der
Ecke.</p>
<p class="calibre3">»In den Knochen reißt es mich, wir kriegen gewißlich schlechtes
Wetter,« klagte er.</p>
<p class="calibre3">Sie tranken ein- und zweimal, aber schwiegen sich an, denn sie
hatten genug Wut aufeinander in den Eingeweiden.</p>
<p class="calibre3">»Wie auf einem Begräbnis trinkt ihr da herum!« ließ sich
Ambrosius vernehmen, mit Recht giftig, daß sie ihn <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page170" title="lesebaer/DaoH"></a> nicht mit aufgefordert
hatten, denn er hatte seit früh noch so gut wie nichts im
Magen.</p>
<p class="calibre3">»Wie soll man da reden. Der Vater verkauft heute so viel, da muß
er aufpassen, wem er das Geld auf Prozent gibt ...«</p>
<p class="calibre3">»Matheus! Ich sag' es euch, Matheus, daß unser Herr Jesus
...«</p>
<p class="calibre3">»Ob Matheus oder nicht Matheus; nimm du dich für! So 'n
Haderlump! Immer mal los mit der Brüderschaft, Schwein mit dem
Schweinehirt,« er erboste heftig.</p>
<p class="calibre3">Und der Schmied, der schon zwei Starke hinter sich hatte, wurde
großspurig und sagte eindringlich:</p>
<p class="calibre3">»Nun sagt mal das Wort, Vater/gebt ihr oder nicht?«</p>
<p class="calibre3">»Es bleibt dabei; ins Grab nehm' ich es nicht mit, und vorher
lasse ich kein' einen Morgen ab. Auf den Altenteil zu euch geh' ich
nicht ... noch sind mir die ein/zwei Jahre, die ich übrig hab',
lieb.«</p>
<p class="calibre3">»Dann findet mich ab.«</p>
<p class="calibre3">»Ich hab's gesagt, hast du's nicht gehört?«</p>
<p class="calibre3">»Nach der dritten Frau sieht er sich um, was sind da die
Kinder,« knurrte Ambrosius.</p>
<p class="calibre3">»So wird's auch sein.«</p>
<p class="calibre3">»Wenn's mir gefällt, heirat' ich. Willst du es mir
verbieten?«</p>
<p class="calibre3">»Verbieten hin, verbieten her, aber ...«</p>
<p class="calibre3">»Wenn's mir gefällt, schick' ich gleich morgen mit Schnaps.«</p>
<p class="calibre3">»Schickt nur zu, ich habe nichts dawider. Gebt mir doch
wenigstens das Kalb, das von der Bunten nachgeblieben ist, dann
helf' ich euch selbst. Ihr habt schon euren Verstand und werdet
begreifen, womit ihr am besten fahrt. Nicht ein- und nicht zweimal
hab' ich der Meinen vorgestellt, daß euch nur die Frau fehlt, damit
kein Ruin in die Wirtschaft kommt ...«</p>
<p class="calibre3">»Hast du das so gesagt, Michael? ...«</p>
<p class="calibre3">»Die heilige Beichte soll ich nicht erleben, hab' ich das <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page171" title="lesebaer/DaoH"></a> nicht gesagt.
Dem ganzen Dorf rat' ich doch, was jedem not tut, und soll nicht
wissen, was ihr braucht!«</p>
<p class="calibre3">»Du lügst, du Halunke, daß es nur so raucht, kannst aber morgen
kommen, das Kalb kannst du kriegen, denn wenn du bitten tust/dann
laß ich mit mir reden; und willst du mit mir rechten/kriegst du 'n
zerbrochenen Stecken oder noch was Schlimmeres ...«</p>
<p class="calibre3">Sie tranken noch einen, den der Schmied schon spendierte; er
hatte noch zur Gesellschaft Ambrosius zugeholt, der sich befriedigt
zu ihnen heransetzte und solche possierlichen Erzählungen zum
besten gab, solche Witze machte, daß sie immer wieder in ein
Gelächter ausbrachen.</p>
<p class="calibre3">Sie freuten sich nicht lange aneinander, denn jeder hatte es
eilig zu den Seinen und mußte noch verschiedene Angelegenheiten
erledigen; so gingen sie in Frieden auseinander; aber der eine
glaubte dem andern nicht einmal so viel, wie die Breite eines
Fingernagels.</p>
<p class="calibre3">Sie kannten sich gut, wie weißgescheckte Pferde, und
durchschauten einander wie Glas.</p>
<p class="calibre3">Nur noch Ambrosius blieb zurück und harrte der Gevattern und
Bekannten, ob ihm nicht jemand noch ein halbes Maß spendieren
wurde, denn dem Hund ist auch 'ne Fliege gut, solange er keinen
Knochen kriegt; das Trinken das paßte ihm schon, selbst aber wurd'
es ihm schwer, sich eins zu spendieren, was kein Wunder war, denn
er war doch nur ein Küster.</p>
<p class="calibre3">Und der Jahrmarkt ging dem Ende zu.</p>
<p class="calibre3">Gerade zu Mittag leuchtete die Sonne auf, aber nur so viel, als
ob jemand mit einem Spiegel über die Welt geblinkt hätte, dann
versteckte sie sich hinter Wolken; und schon gegen Abend
verdüsterte sich der Tag; große Regenwolken senkten sich tief, daß
sie fast auf den Dächern lagen, und ein feiner Regen stäubte, wie
durch ein dichtes Sieb. So fuhr man denn auch schneller
auseinander/jeder eilte nach Hause, um noch vor Nacht und vor
Einbruch des Unwetters unter Dach zu sein.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page172" title="lesebaer/DaoH"></a> Auch
die Händler nahmen die Buden rascher auseinander und packten sie
auf die Wagen, denn der Regen peitschte immer dichter und wurde
eisig.</p>
<p class="calibre3">Die Dunkelheit fiel schwer und naß.</p>
<p class="calibre3">Das Städtchen vereinsamte und verstummte.</p>
<p class="calibre3">Nur die plärrenden Stimmen der Bettler hörte man hier und da an
den Mauern, und aus den Schenken klang Geschrei und Gezänk der
Trunkenen.</p>
<p class="calibre3">Schon spät am Abend fuhren die Borynaleute aus dem Städtchen
hinaus; sie hatten alles, was sie mit hatten, abgesetzt,
verschiedenes eingekauft und den Jahrmarkt genossen, wie es sich
gehört; Antek trieb die Pferde an und fuhr so scharf, daß im
Straßenschmutz tiefe Furchen nachblieben; es war inzwischen tüchtig
kalt geworden, und sie hatten alle nicht schlecht dem Glas
zugesprochen. Der Alte, trotzdem er sonst geizig war und auf jeden
Groschen erpicht, hatte sie heute dermaßen mit Speise und Getränk
bewirtet und mit guten Worten traktiert, daß es verwunderlich
war.</p>
<p class="calibre3">Es wurde schon völlig Nacht, als sie zum Wald kamen.</p>
<p class="calibre3">Dunkel war es, daß einer sich ruhig die Augen hatte ausstechen
lassen können; die Regentropfen wurden immer dicker, und hier und
da auf der Landstraße hörte man das Rollen der Wagen, das heisere
Singen der Betrunkenen, und hin und wieder das Patschen langsamer
Schritte durch den Schmutz.</p>
<p class="calibre3">Inmitten des Pappelwegs, über dem es dumpf sauste und wie vor
Kälte ächzte, ging Ambrosius, schon ganz besoffen, von einer Seite
nach der anderen torkelnd, manchmal stolperte er gegen einen Baum
oder glitt in den Dreck aus; aber er erhob sich bald und sang
immerzu aus voller Kehle, wie das so seine Angewohnheit war.</p>
<p class="calibre3">Ein solches Unwetter und eine solche Dunkelheit kamen auf, daß
man die Schwänze der Pferde nicht erkennen konnte, und die
auftauchenden Lichter des Dorfes nur wie blinzelnde Wolfsaugen zu
sehen waren.</p>
<ol class="calibre7"><li class="calibre8"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#text3" id="foot3"><span class="pcalibre5 pcalibre4 footnote"><span class="spaced">Mit dem
Erntedank fahren:</span> Da die Dorforganisten in Polen sehr kleine
Gehälter haben, so hat sich seit altersher die Sitte eingebürgert,
mindestens zweimal im Jahre die Bewohner ihres Kirchspiels zu
besuchen, um freiwillige Gaben in Naturalien für sich einzusammeln.
Eine dieser Bittfahrten findet im Herbst statt, wenn die Ernte
eingefahren, aber noch nicht gedroschen ist. Sie heißt eigentlich
Garbenfahrt.</span></a></li>
<li class="calibre8"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#text4" id="foot4"><span class="pcalibre5 pcalibre4 footnote"><span class="spaced">Volkszählung:</span>
Gleichbedeutend mit Osterzählung.</span></a></li>
<li class="calibre8"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#text5" id="foot5"><span class="pcalibre5 pcalibre4 footnote"><span class="spaced">Osterzählung:</span> In der
Fastenzeit vor Ostern veranstalten die Organisten alljährlich eine
Zählung der katholischen Bevölkerung ihres Kirchspiels, bei welcher
auch der alljährige Zuwachs an Seelen verzeichnet wird. Eine
besondere Rubrik wird über die im Beichtalter befindlichen geführt.
Voraussichtlich ist diese alte Sitte dem kirchlichen Bedürfnis
einer genauen Kontrolle entsprungen.</span></a></li>
</ol>
<p class="pcalibre6 initial1"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page173" title="lesebaer/gary"></a> Die Regenzeit war im
vollen Gange. Schon seit dem Jahrmarktstag versank die Welt
allmählich immer mehr in graue, trübe Regenglasten, so daß die
Umrisse der Wälder und des Dorfes blaß geisterten, als wären sie
aus durchnäßten Gespinsten gewoben</p>
<p class="calibre3">Es kamen die endlosen, kalten, durchdringenden Herbststürme.</p>
<p class="calibre3">Weiße, eisige Regenpeitschen schlugen auf den Boden ein und
durchnäßten ihn bis in die Tiefen, und jeder Baum, jeder Halm bebte
im grenzenlosen Schmerz.</p>
<p class="calibre3">Unter den schweren, über der Erde zusammengeballten Wolken
tauchten zuweilen aus den grünlichen Regengüssen Flächen
geschwärzter, durchweichter und plattgedrückter Felder auf,
Rinnsale schaumigen Wassers, das in den Furchen floß, blitzten
hervor, oder Bäume, die einsam auf den Feldrainen wuchsen, hoben
sich dunkel ab/wie vor Feuchtigkeit niedergedrückt und
aufgeschwollen schüttelten sie die letzten Fetzen der Blätter ab
und rissen sich verzweifelt hin und her wie Hunde, die man an die
Kette gelegt hatte.</p>
<p class="calibre3">Die vereinsamten Wege zerflossen in morastige, faulende
Pfützen.</p>
<p class="calibre3">Kurze, traurige, sonnenlose Tage schleppten sich schwer dahin
gleich schmalen, von Verwesung zerfressenen Lichtstreifen, und
Nächte kamen, finster, dumpf und trostlos in ihrem unaufhörlichen,
eintönigen Glucksen.</p>
<p class="calibre3">Eine grauenvolle Stille umklammerte die Erde.</p>
<p class="calibre3">Die Felder verstummten, die Dörfer wurden still, und taub wurden
die Wälder.</p>
<p class="calibre3">Die Siedelungen nahmen eine schwärzliche Düsterkeit an und
schienen sich noch dichter an die Erde und an ihre Umzäunungen zu
schmiegen und tiefer in die entlaubten Gärten zu sinken, die sich
leise ächzend ineinander krallten.</p>
<p class="calibre3">Die grauen Dünste der Regen verschleierten die Welt, tranken die
Farben aus, verlöschten die Lichter und ertränkten <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page174" title="lesebaer/gary"></a> die Erde in Dunkelheiten,
so daß alles wie ein Traumspuk erschien, und Traurigkeit sich von
den durchfaulten Feldern, erstarrten Forsten und totem Ödland erhob
und in schweren Nebeln wallte; sie blieb auf den abgeschiedenen
Kreuzwegen stehen unter Kreuzen, die ihre Arme verzweifelt
ausbreiteten, auf leeren Landstraßen, wo nackte Bäume vor Kälte
bebten und in Qual schluchzten, sah mit leeren Augen in verlassene
Nester, in eingestürzte Hütten hinein, trieb sich auf den toten
Friedhöfen zwischen vergessenen Grabhügeln, modrigen Kreuzen herum
und floß durch die ganze Welt;/durch die nackten, beraubten,
geschändeten Felder, durch die versunkenen Dörfer und blickte in
die Wohnstätten, in die Stallungen und in die Gärten hinein/bis das
Vieh vor Angst brüllte, die Bäume sich mit dumpfem Gestöhn duckten
und die Menschen wehmütig aufseufzten in der gräßlichen
Sehnsucht/in der unstillbaren Sehnsucht nach Sonne.</p>
<p class="center">— — — — —</p>
<p class="calibre3">Der Regen sprühte ohn' Unterlaß, als ob jemand die Welt mit
seinen Glassplitterchen verhüllte, und ganz Lipce tauchte unter ins
dichte Nebelmeer der bösen Regenzeit. Nur die schwarzen Dächer und
dunkle, vor Nässe triefende Steinmauern, ragten hier und da hervor,
und darüber wanden sich die schmutzigen Rauchsträhnen und
schleppten über die Gärten dahin.</p>
<p class="calibre3">Im Dorf war es still, nur hier und da war man in den Scheunen
noch beim Dreschen, aber vereinzelt nur, denn das ganze Dorf befand
sich auf den Kohlfeldern.</p>
<p class="calibre3">Es war leer auf den schlammigen, aufgeweichten Wegen und leer
auf den Zufahrtsstraßen und vor den Häusern, manchmal nur erschien
jemand im Nebel und verlor sich gleich darauf, so daß man nur das
Schlurfen der Pantinen im Schmutz hörte; oder es schleppte sich
langsam ein mit Kohl vollgeladener Wagen von den Torffeldern her
und trieb die Gänse auseinander, die hinter den Kohlblättern
herwateten, welche von den Wagen herabgefallen waren.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page175" title="DaoH/gary"></a> Der Weiher
rüttelte an seinen engen Ufern und stieg immerzu, er überschwemmte
von der Borynaseite die niedriger gelegenen Teile des Weges, kam
bis an die Zäune und spritzte Gischt an die Wände der Hütten.</p>
<p class="calibre3">Das ganze Dorf war mit dem Schneiden und Einfahren des Kohls
beschäftigt; die ganzen Tennen, Dielen und Stuben waren voll davon,
und bei manchen lagen die Haufen blauen Kohls selbst draußen unter
der Dachtraufe.</p>
<p class="calibre3">Vor den Häusern rann der Regen über gewaltige Tonnen, die man in
die Nässe hinausgerollt hatte.</p>
<p class="calibre3">Es herrschte große Eile überall, denn der Regen hörte fast gar
nicht mehr auf, und die Wege wurden unfahrbar vor Schlick.</p>
<p class="calibre3">Auch bei der Dominikbäuerin schnitt man heute.</p>
<p class="calibre3">Schon am frühen Morgen war Jagna mit Schymek aufs Kohlfeld
hinausgefahren, weil Jendschych daheim bleiben mußte, um das Dach
zu flicken, sintemal es im Hause da und dort leckte.</p>
<p class="calibre3">Es ging schon gegen Abend und die Dunkelheit schien sich bei
kleinem einzustellen, so daß die Alte einmal ums andere vors Haus
trat und in die Nebel nach der Mühle zu spähte und hinaushorchte,
ob sie nicht schon kämen? ...</p>
<p class="calibre3">Die Arbeit auf den Kohlfeldern, die tief hinter der Mühle auf
dem Torfgrund lagen, war aber noch im vollen Gange.</p>
<p class="calibre3">Schwärzliche, nasse Nebel lagen auf den Wiesen, und nur da und
dort blinkten breite Gräben voll silberweißen Wassers, und hoch
aufgeworfene Kohlbeete waren sichtbar und schimmerten bläulich,
blaßgrün, oder sahen rostig aus, wie Streifen von Eisenblech. Hier
und da hoben sich aus dem Nebel die roten Frauenröcke und Haufen
abgeschnittener Kohlköpfe hervor.</p>
<p class="calibre3">In der nebeldurchsetzten Ferne, am Fluß, der rauschend durch das
dichte Buschwerk floß, das wie eine Wolkenwand blaute, zeichneten
sich die Torfdiemen und die dastehenden Wagen ab, zu denen man den
Kohl in Leinwandtüchern <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page176" title="DaoH/gary"></a> hinbrachte, denn infolge des durchweichten Bodens
war es unmöglich, an die Kohlfelder heranzufahren.</p>
<p class="calibre3">Einzelne schnitten schon den Rest und schickten sich an,
heimzugehen; die Stimmen ließen sich immer lauter aus dem Nebel
vernehmen und klangen von Beet zu Beet.</p>
<p class="calibre3">Jagna war soeben mit ihrem Beet fertig, sie war furchtbar müde,
hungrig und bis auf die Haut durchnäßt, denn selbst ihre
Holzpantinen versanken in die rotbraune Torferde, so daß sie sie
abnehmen mußte, um das Wasser herauszuschütten.</p>
<p class="calibre3">»Schymek, rühr' dich doch schneller, ich fühl' meine Klumpen
schon gar nicht mehr!« rief sie kläglich, und als sie sah, daß er
das große Bündel nicht aufladen konnte, riß sie es ihm ungeduldig
aus den Händen, warf es sich über die Schulter und ging damit zum
Wagen hin.</p>
<p class="calibre3">»Bist doch schon so 'n großer Kerl und dabei schwach im Rücken
wie 'ne Frau nach dem Wochenbett,« sagte sie verächtlich, den Kohl
in den mit Stroh ausgelegten Korbwagen schüttend.</p>
<p class="calibre3">Schymek brummte beschämt etwas vor sich hin, kratzte sein
Zottelhaar und spannte das Pferd vor.</p>
<p class="calibre3">»Eil' dich, Schymek, die Nacht kommt!« trieb sie ihn an und trug
immer wieder Kohl herbei.</p>
<p class="calibre3">Die Nacht kam auch schon heran und die Dämmerung wurde dichter
und tiefer, und der Regen steigerte sich, daß er auf die
durchweichte Erde und in die Gräben niedertroff, wie rieselndes
Korn.</p>
<p class="calibre3">»Werdet ihr heute fertig?« rief sie zu Borynas Fine hinüber, die
mit Anna und Jakob nebenan auch beim Schneiden war.</p>
<p class="calibre3">»Wir kriegen es noch! Wird auch reichlich Zeit, nach Hause zu
gehen bei dem Schweinewetter, klitschnaß bin ich. Fahrt ihr denn
schon ab?«</p>
<p class="calibre3">»Ja. In einem Nu is Nacht, ist ja schon so finster, daß man den
Weg nicht auskennt. Morgen fährt man den Rest <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page177" title="MEsswein/gary"></a> ein. Feinen Kohl habt ihr!«
fügte sie hinzu und beugte sich zu ihnen hinüber, um auf die sich
im Nebel abhebenden Kohlhaufen zu sehen.</p>
<p class="calibre3">»Eurer ist auch nicht schlecht, aber die Steckrüben habt ihr am
größten ...«</p>
<p class="calibre3">»Die Setzlinge, die waren auch vom neuen Samen, den sich
Hochwürden aus Warschau mitgebracht hat.«</p>
<p class="calibre3">»Jagna,« ließ sich wieder aus den Nebeln Fines Stimme vernehmen,
»wißt ihr schon, daß morgen Josef sein Walek mit Schnaps nach
Maruschka Potschiotek schickt ...«</p>
<p class="calibre3">»So'n Kiekindiewelt! Is die denn schon so weit! Mir deucht, daß
sie noch Kühe gehütet hat im letzten Sommer! ...«</p>
<p class="calibre3">»Das Alter hat sie schon für 'n Mann, und denn noch all das
Land, da haben es die Burschen hild.«</p>
<p class="calibre3">»Auch zu dir werden sie es hild haben, Fine, das werden sie
...«</p>
<p class="calibre3">»Wenn Papachen sich 'ne dritte nimmt!« schrie Gusche irgendwo
von einem anderen Beet.</p>
<p class="calibre3">»Was euch ankommt, hat doch Mutter erst zum Frühjahr begraben,«
warf Anna mit beängstigter Stimme dazwischen.</p>
<p class="calibre3">»Was schadet das dem Mannsvolk. Jedes Mannsbild ist wie 'n
Schwein; wenn es sich noch so vollgefressen hat, steckt es doch die
Schnauze in einen neuen Trog. Ho, ho, die eine ist noch nicht so
weit ... nicht mal richtig kalt, und dann wird sich gleich nach
einer anderen umgesehen ... ein Hundevolk ist das ... Und wie hat
es der Kohlmeis gemacht? Drei Wochen nach der Beerdigung der ersten
hat er die zweite geheiratet.«</p>
<p class="calibre3">»Das ist wahr, fünf kleine Kinder hat ihm aber auch die Selige
nachgelassen ...«</p>
<p class="calibre3">»Ihr habt's gesagt! Aber nur 'n Dummer glaubt, daß es wegen der
Kinder ist ... für sich selbst hat er die geheiratet, weil es ihm
alleine zu langweilig wurde unterm Federbett!«</p>
<p class="calibre3">»Wir würden es Vater nicht erlauben, oho! ...« rief Fine
energisch.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page178" title="MEsswein/gary"></a> »Bist
noch jung, darum bist du auch noch nicht klug ... Vaters Boden und
Vaters Wille, da gibt's nichts dran zu klimpern!«</p>
<p class="calibre3">»Die Kinder haben auch was dreinzureden und ihnen steht auch 'n
Recht zu,« fing Anna wieder an.</p>
<p class="calibre3">»Vom fremden Wagen heißt es heruntergehen, und wenn's auch ins
Wasser hinein ist,« brummte Gusche dumpf und verstummte, denn die
empörte Fine fing an, nach Witek zu rufen, der sich irgendwo am
Fluß herumtrieb; Jagna aber mischte sich nicht in dieses Gespräch
hinein, sie lächelte nur von Zeit zu Zeit, denn der Jahrmarkt kam
ihr in Erinnerung. Sie trug den Kohl auf den Wagen, und als sie
diesen gefüllt hatte, trieb Schymek an und lenkte nach der
Landstraße hin.</p>
<p class="calibre3">»Bleibt mit Gott,« warf sie den Nachbarinnen zu.</p>
<p class="calibre3">»Gott auf den Weg, wir wollen auch gleich ... Jagusch, kommst du
nicht zu uns, Kohl schälen, was?«</p>
<p class="calibre3">»Sag' nur, wann's nötig ist, Fine, dann komm' ich ... ich komm'!
...«</p>
<p class="calibre3">»Und Sonntags spielen die Burschen zum Tanz auf bei Klembs, wißt
ihr es?«</p>
<p class="calibre3">»Ich weiß, Fine, ja, ich weiß ...«</p>
<p class="calibre3">»Wenn ihr Antek trefft, sagt ihm, daß er machen soll, wir warten
auf ihn,« bat Anna.</p>
<p class="calibre3">»Gut, gut ...«</p>
<p class="calibre3">Sie fing an zu laufen, um den Wagen einzuholen, denn Schymek war
schon ein Stück Wegs voraus, man hörte nur noch, wie er auf das
Pferd einschimpfte; der Wagen versank und schnitt bis über die
Achsen in den aufgeweichten Torfboden ein/sie mußten beide an den
schlechten, tieferen Stellen dem Pferd nachhelfen, um den Wagen aus
dem Morast freizubekommen.</p>
<p class="calibre3">Sie schwiegen miteinander, Schymek führte das Pferd, und achtete
darauf, nicht umzukippen, denn es waren überall viele Löcher, und
Jagna ging von der anderen Seite, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page179" title="MEsswein/gary"></a> stützte mit der Schulter den Wagen und
sann nach, daß man sich zu diesem Kohlschälen bei Borynas fein
machen müßte.</p>
<p class="calibre3">Die Dunkelheit senkte sich rasch; man konnte kaum noch das Pferd
sehen; der Regen schien nachgelassen zu haben; es hing nur noch ein
schwerer, nasser Nebel über der Erde, so daß es schwer war, zu
atmen, und in den Lüften rauschte dumpf der Wind und schlug gegen
die Bäume des Dammes, bei dem sie gerade anlangten.</p>
<p class="calibre3">Die Auffahrt zum Damm war schwer, wegen der Steigung und Glätte;
das Pferd blieb stecken und hielt jede paar Schritte an, um
auszuruhen, so daß sie kaum den Wagen halten konnten, damit er
nicht ins Rollen kam.</p>
<p class="calibre3">»Man hätte nicht soviel laden sollen für ein Pferd!« ließ sich
eine Stimme vom Damm herab vernehmen.</p>
<p class="calibre3">»Seid ihr das, Anton? ...«</p>
<p class="calibre3">»Ja, ich bin es.«</p>
<p class="calibre3">»Geht man schnell zu; Anna sieht schon nach euch aus ... Helft
uns mal eben ...«</p>
<p class="calibre3">»Wart' 'n Augenblick, gleich komm ich 'runter und helf' nach. So
'ne Dunkelheit, man sieht keine Hand vor den Augen.«</p>
<p class="calibre3">Sie kamen gleich auf den Damm hinauf, denn er hatte so mächtig
den Wagen gestützt, daß das Pferd vom Fleck weg anzog und erst oben
stehenblieb.</p>
<p class="calibre3">»Gott bezahl's; aber stark seid ihr, Herr Jesus noch mal!« sie
hielt ihm die Hand hin.</p>
<p class="calibre3">Sie verstummten plötzlich, der Wagen setzte sich in Bewegung und
sie gingen nebeneinander, ohne recht zu wissen, was sie sagen
sollten, beide seltsam verlegen.</p>
<p class="calibre3">»Wollt ihr umkehren?« flüsterte sie leise.</p>
<p class="calibre3">»Nur bis zur Mühle bring' ich dich, Jagusch, weil da ein Loch
ist auf der Landstraße, das Wasser hat einen Schaden gemacht.«</p>
<p class="calibre3">»Ist das aber düster, was?« rief sie aus.</p>
<p class="calibre3">»Bist du bange, Jagusch?« flüsterte er, dichter herangehend.
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page180" title="MEsswein/gary"></a></p>
<p class="calibre3">»Hale, was sollt' ich da bange sein ...«</p>
<p class="calibre3">Sie verstummten wieder und gingen nun Hüfte an Hüfte, Arm neben
Arm weiter.</p>
<p class="calibre3">»Wie euch die Augen leuchten, gerade wie beim Wolf ... es wird
einem ganz sonderbar dabei ...«</p>
<p class="calibre3">»Kommst du Sonntag zu Klembs, da ist Musik.«</p>
<p class="calibre3">»Als ob mir das Mutter erlaubt ...«</p>
<p class="calibre3">»Komm doch, Jagusch, komm hin ...,« bat er mit leiser,
gedämpfter Stimme.</p>
<p class="calibre3">»Wollt ihr denn das?« fragte sie weich, ihm in die Augen
sehend.</p>
<p class="calibre3">»Herr Gott nochmal, für dich allein hab' ich doch den Geiger aus
Wola bestellt, und für dich den Klemb noch erst überredet, daß er
bei sich aufspielen läßt, für dich doch, Jagusch ...« flüsterte er,
und näherte heftig atmend sein Gesicht dem ihren, so daß sie etwas
zurückwich und vor Erregung erbebte.</p>
<p class="calibre3">»Geht schon ... man wartet auf euch ... es wird uns noch einer
sehen ... geht ...«</p>
<p class="calibre3">»Tust du auch kommen? ...«</p>
<p class="calibre3">»Ich komm' ... ich komm' ...« wiederholte sie, sich nach ihm
umsehend, aber er war schon im Nebel verschwunden, und man hörte
ihn nur noch durch den Schmutz waten.</p>
<p class="calibre3">Ein plötzliches Frösteln ließ sie erschauern und eine jache Glut
durchflog sie von Herz zu Kopf, so daß sie wankte. Sie wußte nicht,
wie ihr geschehen war./Die Augen brannten ihr, als ob heiße Asche
unter ihre Lider gekommen wäre, sie war ganz atemlos und nicht
imstande, das leidenschaftlich pochende Herz zu beruhigen; ohne es
zu wissen breitete sie die Arme aus, wie zur Umarmung, alles
spannte sich in ihr, denn es faßten sie solche wilden Schauer, daß
sie hätte schreien mögen ... Sie holte laufend den Wagen ein, faßte
eine der Rungen, und obgleich es nicht nötig war, schob sie so
mächtig nach, daß der Wagen knarrte und wankte und Kohlköpfe in den
Schmutz kollerten ... vor ihren <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page181" title="MEsswein/gary"></a> Augen stand immerzu sein Gesicht mit dem
funkelnden, begehrlichen ... brennenden Blick ...</p>
<p class="calibre3">»Ein Ungetüm von Mensch ... es gibt wohl keinen zweiten solchen
in der Welt ...,« dachte sie wirr.</p>
<p class="calibre3">Das Rattern der Mühle, an der sie vorbeifuhren, brachte sie zur
Besinnung, und das Rauschen des Wassers, das unter dem geöffneten
Stauwerk auf die Räder floß, denn der Wasserzudrang war gewaltig,
ernüchterte sie. Der Fluß stürzte sich mit dumpfem Gebrüll in die
Tiefe, und zu weißem Gischt zerstoben wirbelte das Wasser und war
schimmernd auf dem Strom zu sehen, der das Uferbett weit
überschwemmt hatte.</p>
<p class="calibre3">Das Haus des Müllers, das gleich am Wege stand, war schon
erleuchtet, und man sah durch die mit Gardinen verhängten Scheiben
eine Lampe auf dem Tisch stehen.</p>
<p class="calibre3">»Die haben eine Lampe, wie bei Hochwürden oder auf einem
Herrenhof ...«</p>
<p class="calibre3">»Sind sie etwa keine reichen Leute? ... Er hat doch mehr Grund
und Boden wie selbst Boryna, und Geld leiht er auf Perzente, und
beim Mahlen tut er auch betrügen, das ist so,« meinte Schymek.</p>
<p class="calibre3">»Wie die Gutsherrn leben sie ... denen ist es gut sein... Gehen
in ihren Zimmern spazieren ... liegen auf den Kanapees herum...
sitzen in der Wärme ... essen süß, und die Leute lassen sie für
sich arbeiten ...,« dachte sie neidlos, ohne auf Schymek zu hören,
der, so sehr er auch brummig war, kein Ende finden konnte, wenn er
ins Reden kam.</p>
<p class="calibre3">Schließlich langten sie nach vieler Mühsal vor ihrem Hause
an.</p>
<p class="calibre3">In der Stube war es hell und warm, ein Feuer flackerte lustig
auf dem Herd. Jendschych schälte Kartoffeln und die Alte setzte das
Essen zum Abend auf.</p>
<p class="calibre3">Ein alter, weißhaariger Mann wärmte sich vor der
Feuerstelle.</p>
<p class="calibre3">»Habt ihr's fertiggekriegt, Jagusch?«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page182" title="gary/DaoH"></a> »Das
schon, nur daß da noch ein wenig auf dem Beet nach ist, vielleicht
an die drei Leinentücher voll.«</p>
<p class="calibre3">Sie ging in die Kammer, um sich umzuziehen, bald darauf
wirtschaftete sie emsig in der Stube umher, und bereitete das
Essen, ab und zu nach dem Alten neugierig hinüberäugend, der im
tiefen Schweigen dasaß, ins Feuer starrte, die Perlen des
Rosenkranzes durch die Finger schob und die Lippen bewegte. Und als
sie sich zum Abendessen setzten, legte die Alte einen Löffel für
ihn hin und lud ihn ein.</p>
<p class="calibre3">»Bleibt mit Gott ... ich komme noch bei euch einsehen, denn
vielleicht bleibe ich für länger in Lipce ...«</p>
<p class="calibre3">Er kniete inmitten der Stube nieder, verneigte sich vor den
Heiligenbildern, machte das Zeichen des Kreuzes und schritt
hinaus.</p>
<p class="calibre3">»Wer ist das?« fragte Jagna verwundert.</p>
<p class="calibre3">»Ein gesegneter Wanderer, er kommt vom heiligen Grab ... ich
kenn' ihn schon lange, denn er war hier schon eher und brachte
verschiedene heilige Sachen mit ... An die drei Jahre können es
schon her sein ...«</p>
<p class="calibre3">Sie endigte ihren Satz nicht mehr, denn Ambrosius trat herein,
gab Gott zum Gruß und setzte sich vor den Herd.</p>
<p class="calibre3">»So 'ne Kälte, und was für ein Sauwetter, mein Holzfuß ist mir
ganz steif geworden.«</p>
<p class="calibre3">»Was habt ihr denn bei solcher Nacht und dem Schmutz auch noch
herumzulaufen ... da tätet ihr besser, in euren vier Wänden zu
sitzen und Gebete zu sprechen ...,« brummte die Dominikbäuerin.</p>
<p class="calibre3">»Die Zeit ist mir lang geworden so allein, da wollt' ich mal
nach den Mädchen sehen, du bist die erste, Jagusch ...«</p>
<p class="calibre3">»Sucht euch ein Totengerippe, als erste ...«</p>
<p class="calibre3">»Die Mamsell treibt sich jetzt mit jüngeren herum, mich läßt sie
ganz beiseite liegen! ...«</p>
<p class="calibre3">»Wie denn das? ...,« begann die Dominikbäuerin im fragenden
Ton.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page183" title="gary/DaoH"></a> »Die reine
Wahrheit sag' ich. Hochwürden hat den Leib Christi nach dem Bartek,
dem hinterm Weiher, getragen.«</p>
<p class="calibre3">»Hör' einer bloß ... auf dem Jahrmarkt hab' ich ihn doch noch
mobil gesehen ...«</p>
<p class="calibre3">»Das liebe Schwiegersöhnchen hat ihn so mit dem Knüppel
zugerichtet, daß er ihm die Eingeweide um und um geschlagen
hat.«</p>
<p class="calibre3">»Nanu, was war denn da, wann denn?«</p>
<p class="calibre3">»Um was denn anders, als um Grund und Boden. Schon ein halbes
Jahr zanken sie herum, und heute mittag haben sie abgerechnet.«</p>
<p class="calibre3">»Daß es keine Gottesstrafe für diese Totschläger gibt,« ließ
sich Jagna vernehmen.</p>
<p class="calibre3">»Die kommt, Jagna, hab' keine Angst, die kommt noch,« sagte die
Alte hart und heftete die Augen auf die Heiligenbilder.</p>
<p class="calibre3">»Und wer schon gestorben ist, der kann nicht wieder aufstehen,«
ließ Ambrosius kaum merklich fallen.</p>
<p class="calibre3">»Setzt euch an die Schüssel und nehmt, was da ist.«</p>
<p class="calibre3">»Dagegen hab' ich nichts, nein. Mit einem Schüsselchen werd' ich
schon fertig, aber groß muß sie sein,« neckte er.</p>
<p class="calibre3">»Ihr habt nur immer Späße und Spielereien im Kopf.«</p>
<p class="calibre3">»Das ist auch mein Ganzes, was soll ich mit den Sorgen,
häh?«</p>
<p class="calibre3">Sie setzten sich an die Bank, auf der die Schüsseln standen, und
aßen langsam und schweigend; Jendschych paßte auf, um zuzulegen und
zuzugießen, nur Ambrosius sagte von Zeit zu Zeit ein kurzweiliges
Wort und lachte selbst am meisten dazu, denn die Jungen, obgleich
sie Lust hatten zu lachen, trauten sich nicht, wegen drohenden
Blicke der Mutter.</p>
<p class="calibre3">»Ist Hochwürden zu Hause?« fragte sie gegen Ende.</p>
<p class="calibre3">»Wo denn sonst bei solchem Schmutz, wie 'n Jude sitzt er bei den
Büchern.«</p>
<p class="calibre3">»Ein Kluger ist sich der, ein ganz Kluger ...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page184" title="gary/DaoH"></a> »Und gut,
daß man keinen besseren finden kann ...« fügte Jagna hinzu.</p>
<p class="calibre3">»Versteht sich ... gewiß ... auf den Bauch spuckt er sich nicht,
oder einem anderen in den Bart, und was ihm einer gibt, das nimmt
er ...«</p>
<p class="calibre3">»Ihr solltet lieber nicht das erste beste Zeug reden.«</p>
<p class="calibre3">Sie standen vom Abendbrot auf. Jagna setzte sich mit der Alten
am Herd zu den Wocken und die Söhne machten sich, wie gewöhnlich,
an das Aufräumen und Aufwaschen des Geschirrs und an die andere
Hausarbeit. Das war schon immer so bei der Dominikbäuerin, daß sie
ihre Söhne mit eiserner Hand hielt und sie zu Mägden abrichtete,
damit Jagusch ja nicht ihre Händchen beschmutze.</p>
<p class="calibre3">Ambrosius zündete die Pfeife an und paffte in den Kamin oder
rückte die glühenden Scheite zurecht und warf neue Zweige hinzu,
dabei blickte er hin und wieder die Frauen an und schien etwas
abzuwägen und zu bedenken.</p>
<p class="calibre3">»Ich höre, ihr habt die Brautbitter gehabt?«</p>
<p class="calibre3">»Die ersten sind es nicht.«</p>
<p class="calibre3">»Was Wunder, die ist ja wie gemalt, die Jagna. Hochwürden hat
gesagt, die in der Stadt kommen der nicht gleich.«</p>
<p class="calibre3">Jagna wurde rot vor Vergnügen.</p>
<p class="calibre3">»Das hat er gesagt, der liebe Gott lasse ihn bei Gesundheit
bleiben. Ich wollte schon lange 'ne Frühmesse lesen lassen, lange
schon, morgen früh gleich trag' ich es ihm hin.«</p>
<p class="calibre3">»Da würd' noch einer mit Schnaps zu euch schicken, er möcht'
schon, aber er hat es noch etwas mit der Angst ...,« leitete er
behutsam ein.</p>
<p class="calibre3">»Ein Bauernsohn? ...« fragte die Alte, die auf dem Boden
surrende Spindel aufwickelnd.</p>
<p class="calibre3">»Ein Hofbauer, im ganzen Dorf angesehen, ein Erbangesessener ...
aber ein Witwer ...«</p>
<p class="calibre3">»Denk' nicht dran, fremde Kinder zu wiegen ...«</p>
<p class="calibre3">»Sind schon großgezogen, da brauchst keine Angst zu haben,
Jagusch.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page185" title="gary/DaoH"></a> »Was soll
sie mit 'm Alten ... sie kann noch warten, wenn sie Sinn auf einen
jüngeren hat.«</p>
<p class="calibre3">»Junge gibt's genug, die werden ihr nicht mangeln! Kerzengerade
Burschen, rauchen Zigaretten, tanzen in der Schenke, trinken
Schnaps und gucken nur hinter den Mädeln drein, welche ihre paar
Morgen hat und etwas bar Geld, damit sie was zum Amesieren haben
... Das sind mir dann schöne Hofbauern, schlafen bis Mittag, und
nachmittags da wird Mist mit der Schubkarre gefahren und das Feld
mit den Hacken gepflügt ...«</p>
<p class="calibre3">»Einem solchen geb' ich die Jagna nicht, daß sie 'n Schandleben
kriegt.«</p>
<p class="calibre3">»Nicht umsonst sagt man, daß ihr die Klügste im Dorf seid
...«</p>
<p class="calibre3">»Aber mit einem Alten zusammen, das ist für eine Junge auch
keine Freude ...«</p>
<p class="calibre3">»Für die Freude sind doch Junge genug da.«</p>
<p class="calibre3">»Alt seid ihr wie die Welt, und noch so viel buntes Zeug im
Kopf,« sagte sie streng.</p>
<p class="calibre3">»Ii ... wie man so redet, damit die Zunge nicht vermulscht.«</p>
<p class="calibre3">Sie blieben eine Weile stumm.</p>
<p class="calibre3">»Ein Alter wird sie schon zu ehren wissen, und braucht nicht
happig sein auf fremdes Geld,« fing Ambrosius wieder an.</p>
<p class="calibre3">»Nein, nein, nur Gotteslästerung kommt davon.«</p>
<p class="calibre3">»Er könnte eine Schenkung vor Gericht machen,« sagte er
bedeutungsvoll, die Pfeife auf dem Herd ausklopfend.</p>
<p class="calibre3">»Jagna hat genug Eigenes,« antwortete sie nach einer Weile,
schon schwankend und unsicher.</p>
<p class="calibre3">»Der würde mehr geben als nehmen, viel mehr ...«</p>
<p class="calibre3">»Ihr habt's gesagt!«</p>
<p class="calibre3">»Was ich natürlich nicht aus dem Wind gegriffen habe und nicht
aus meinem Kopf, nicht von mir aus komme ich damit ...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page186" title="gary/DaoH"></a> Sie
schwiegen wieder. Die Alte fuhr lange glättend mit der Hand über
die zausige Kunkel, benetzte sodann den Finger und fing an, die
Flachsfasern mit der Linken herauszuzupfen und mit der Rechten ließ
sie die Spindel kreisen, so daß sie sich wie ein Brummkreisel mit
Gesumm auf dem Boden drehte und surrte.</p>
<p class="calibre3">»Wie ist's, soll er denn schicken?«</p>
<p class="calibre3">»Welcher?«</p>
<p class="calibre3">»Wißt ihr's denn nicht? Der da!« er zeigte durchs Fenster auf
die kaum über den Weiher blinzelnden Lichter vom Borynahof.</p>
<p class="calibre3">»Erwachsene Kinder, werden kein gutes Wort geben und haben
Rechte auf ihr Teil ...«</p>
<p class="calibre3">»Was sein ist, kann er aber verschreiben ... wie wär's denn? ...
Ein guter Mensch und nicht der erste beste Hofbauer, und fromm und
noch rüstig, ich hab' selbst gesehen, wie er sich 'n ganzen
poln'schen Scheffel Roggen auf den Buckel geladen hat. Der Jagna
würde da nichts abgehen, der würd' sie sich schon reineweg mit
Vogelmilch aufziehen ... und da sich euer Jendschych im Kommenden
beim Militär melden muß ... der Boryna kennt sich aus mit den
Beamten, er weiß, an wen er sich zu halten hat, der könnt' euch
schon helfen ...«</p>
<p class="calibre3">»Wie scheint dir das, Jagusch? ...«</p>
<p class="calibre3">»Mir ist es eins, befehlt ihr, dann tu' ich ... das ist euer
Kopf, nicht meiner ...,« sprach sie leise, stützte die Stirne auf
die Kunkel und starrte gedankenlos ins Feuer, auf das lustige
Knistern der brennenden Zweige horchend. Dieser oder ein anderer,
das war ihr ganz egal/ihr schauerte nur leicht, wenn sie an Antek
dachte.</p>
<p class="calibre3">»Wie ist's?« fragte Ambrosius, sich von der Bank erhebend.</p>
<p class="calibre3">»Sie sollen schicken ... Versprechung ist noch keine Heirat
...,« antwortete sie langsam.</p>
<p class="calibre3">Ambrosius verabschiedete sich und ging geradeswegs zu
Boryna.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page187" title="gary/DaoH"></a> Jagna saß
immerzu unbeweglich und schweigend da.</p>
<p class="calibre3">»Jagusch ... Töchterchen ... was denn? ...«</p>
<p class="calibre3">»Nichts ... alles ist mir gleich ... wenn ihr wollt, nehm' ich
den Boryna ... und denkt ihr nicht, dann bleib' ich bei euch ...
geht es mir denn hier vielleicht schlecht? ...«</p>
<p class="calibre3">Die Alte spann weiter und redete leise.</p>
<p class="calibre3">»Das Beste will ich für dich, das Beste ... Gewiß, er ist alt,
aber noch rüstig, und gutherzig auch, nicht so wie die anderen
Mannsleute, der wird dich in Ehren halten ... Feine Dame wirst du
bei ihm spielen können, die Hofbäuerin wirst du sein ... Und wenn
er eine Verschreibung macht, so werd' ich ihn schon so richten, daß
das Feld neben unserem kommt, neben dem Juden seinem am Hügel ...
und wenn er so zum Beispiel sechs Morgen verschreiben würde ...
Hörst du zu? an die sechs Morgen! Und irgendein Mannsbild mußt du
schon heiraten ... das mußt du ... was sollen sie über dich
herziehen und dich auf den Zungen im Dorf herumtragen ... Ein
Schwein könnte man schlachten... vielleicht auch nicht ... oder
vielleicht ...,« sie verstummte und begann sich den Rest im Kopf
zurechtzulegen, denn Jagusch war, als ob sie ihre Worte nicht
gehört hätte, sie spann geistesabwesend weiter, als ob sie ihr
eigenes Los nichts anginge, so wenig dachte sie über diese Heirat
nach.</p>
<p class="calibre3">Und hatte sie es vielleicht schlecht bei der Mutter? Sie tat was
sie wollte, kein Mensch mischte sich ein. Was ging sie Grund und
Boden an, die Verschreibungen und der Besitz/ so gut wie gar
nichts, so gut wie der Zukünftige? Es waren nicht wenig Burschen,
die ihr nachliefen/wenn sie nur gewollt hätte, so wären alle in
derselben Nacht noch zusammengelaufen ... und ihre Gedanken spannen
sich träge, wie der Flachsfaden vom Wocken, und drehten sich immer
in gleicher Weise um das Eine herum, daß sie, wenn Mutter wollte,
den Boryna heiraten würde ... Gewiß, daß sie ihn besser mag als die
anderen, denn er hatte ihr das Band und das Seidentuch gekauft ...
gewiß ... aber <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page188" title="gary/DaoH"></a> Antek hätte ihr dasselbe gekauft ... und die
anderen vielleicht auch ... wenn sie nur Borynas Geld hätten ...
jeder ist gut ... und alle zusammen ... als ob sie einen Kopf dazu
hätte, sich erst lange einen auszusuchen! Dazu war Mutter da, um zu
tun, was nötig war ...</p>
<p class="calibre3">Und abermals starrte sie vor sich hin, sie sah aufs Fenster,
denn die schwarz angelaufenen, verwelkten Georginen, die der Wind
schaukelte, guckten in die Scheiben, aber bald vergaß sie auch
diese, vergaß alles, vergaß auch sich selbst und verfiel in eine so
heilige Gefühllosigkeit, wie die Mutter Erde während der toten
Herbstnächte/denn wie die heilige Erde war Jagnas Seele/ganz wie
diese Erde; sie lag in Tiefen, die niemand erkennen konnte, in der
Wirrnis schlaftrunkener Träume/riesig und unbewußt, mächtig, aber
ohne Willen, ohne Wollen, ohne Wünsche, totenstarr und dennoch
unsterblich, und wie diese Erde nahm sie jeder Wind, umhüllte sie,
schaukelte sie und trug sie dahin, wo er wollte ... sie war wie die
Erde, die die warme Sonne zur Frühjahrszeit weckt, mit Leben
befruchtet, mit dem Feuerschauer des Verlangens, der Liebe
erschüttert/und sie gebiert, weil sie muß; sie lebt, singt,
herrscht, schafft und vernichtet, weil sie muß; sie ist, weil sie
muß ... denn wie die heilige Erde war Jagnas Seele/ganz wie diese
Erde! ...</p>
<p class="calibre3">Und lange saß sie so im Schweigen, nur ihre Sternenaugen
leuchteten wie die stillen Wasser zur Frühlingsmittagszeit, bis sie
plötzlich erwachte, weil jemand die Flurtür aufmachte.</p>
<p class="calibre3">Fine kam noch ganz atemlos herein, stürzte nach dem Herd hin,
schüttelte das Wasser aus den Holzpantoffeln und sagte:</p>
<p class="calibre3">»Morgen wird bei uns der Kohl geschält, Jagusch, kommst du?«</p>
<p class="calibre3">»Ich komm'.«</p>
<p class="calibre3">»In der Stube werden wir schälen. Ambrosius sitzt beim Vater,
ich bin heimlich fortgerannt, um dir das vom <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page189" title="DaoH/gary"></a> Kohl zu sagen. Ulischja, Maruscha
und Vikta und die anderen Basen werden da sein ... und die Burschen
werden kommen ... und Peter mit der Geige hat zugesagt...«</p>
<p class="calibre3">»Welcher denn?«</p>
<p class="calibre3">»Den Michaels ihrer, die hinter dem Schulzen sitzen, er ist, wie
wir die Kartoffeln ausnahmen, vom Militär heimgekehrt ... und redet
so verdreht, daß man es schwer herauskriegt ...«</p>
<p class="calibre3">Sie plapperte die Stube voll, soviel sie nur konnte, und rannte
nach Haus.</p>
<p class="calibre3">Wieder umfaßte Schweigen den Raum.</p>
<p class="calibre3">Manchmal schlug der Regen gegen die Scheiben, als ob jemand eine
Handvoll Sand geschleudert hätte, oder der Wind rauschte und
spielte im Garten und blies in den Schornstein, daß die Feuerbrände
auf den Herd auseinanderstoben und Rauch in die Stube puffte ...
Und die Spindeln auf dem Boden surrten immerzu.</p>
<p class="calibre3">Der Abend zog sich langsam dahin, bis die Alte mit einer leisen,
zittrigen Stimme das Abendlied anstimmte:</p>
<p class="vers">Alle unsere Tagesmühen ...</p>
<p class="calibre3">Und die Jungen mit Jagna sangen halblaut und doch so
durchdringend mit, daß die Hühner im Flur auf den Staffeln
aufzuschnarren und zu gackern anfingen.</p>
<p class="pcalibre6 initial1">Der nächste Tag war ebenso
regnerisch und düster. Jeden Augenblick trat einer vor sein Haus
und blickte lange und besorgt in die neblige Welt, ob es sich nicht
irgendwo aufhellen wollte/aber es war nichts zu sehen als graue
Wolken, die so niedrig zogen, daß es schien, als ob sie sich an den
Bäumen zerrissen; der Regen rieselte ohn' Unterlaß, gegen Mittag
aber steigerte er sich zu einem solchen Wolkenbruch, als hätte
einer die himmlischen Schleusen geöffnet; es trommelte nur so auf
die Dächer.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page190" title="DaoH/gary"></a> Die Leute
drückten sich in den Stuben herum; der eine oder der andere
schleppte sich durch Schmutz und Regen zu den Nachbarn, um sein
Klagelied anzubringen. Man schimpfte auf das Wetter, in das man
nicht einmal einen Hund hätte hinausjagen mögen, und manch einer
hatte doch noch seine Nadelstreu im Wald liegen, ein anderer hatte
sein Holz nicht eingefahren, ein dritter nur »fast alles«/die eine
hatte noch den Kohl nicht zu Ende geschnitten, wegen dessen heute
gar nicht hinauszufahren war, denn der Weiher war in der Nacht so
gestiegen, daß man schon bei Tagesanbruch die Schleusen öffnen
mußte, um das Wasser in den Fluß abzulassen, der dadurch aus den
Ufern trat; sogar die Wiesen kamen unter Wasser und die Kohlfelder
ragten wie Inseln mit den schwarzen Rücken ihrer Beete aus dem
weißlichen schaumbedeckten Strudel auf.</p>
<p class="calibre3">Bei der Dominikbäuerin hatte man ebenfalls den Rest, der noch im
Felde geblieben war, nicht eingefahren.</p>
<p class="calibre3">Jagna wußte schon vom frühen Morgen an nicht recht wohin, sie
ging von einer Ecke zur anderen, dann sah sie wieder durchs Fenster
auf die Georginenbüsche, die das Wasser zu Boden gelegt hatte,
starrte in die verregnete Welt hinaus und seufzte sehnsüchtig.</p>
<p class="calibre3">»Man langweilt sich zum Gotterbarmen!« flüsterte sie ungeduldig
in Erwartung der Dämmerung und des kommenden Abends, an dem bei
Borynas Kohl geschält werden sollte, und der Tag schleppte sich
gerade so langsam wie ein Bettler durch den Dreck, so langweilig
und so eigentümlich traurig, daß es schon gar nicht mehr zum
Aushalten war. Gereizt war sie auch, so daß sie in einem fort auf
die Jungen einschrie und mit allem, was ihr nur unter die Hände
kam, herumstieß; obendrein hatte sie noch Kopfschmerzen, so daß sie
sich die Schläfen mit gebrühtem Hafer, den sie mit Essig besprengt
hatte, belegen mußte/da erst ging es vorüber. Trotzdem konnte sie
sich keinen Platz finden, und die Arbeit glitt ihr aus den Händen,
weil sie sich immer wieder in den <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page191" title="DaoH/wedi"></a> Anblick des aufgepeitschten Weihers
vertiefte, der, wie ein Vogel, schwere Flügel ausbreitete, damit um
sich schlug und rauschend aufzufliegen versuchte, so daß das Wasser
auf den Weg spritzte, und doch konnte er nicht auffliegen, als ob
seine Füße mit dem Boden verwachsen wären. Hinter dem Wasser aber
stand Borynas Haus, man konnte gut das altersgrüne Dach sehen, die
neu mit Holzschindeln beschlagene Frontgalerie, deren Dächlein noch
gelb leuchtete, und die Wirtschaftsgebäude hinter dem Obstgarten;
doch sie wußte gar nicht, worauf sie sah...</p>
<p class="calibre3">Die Dominikwittib war von früh an außer Haus, denn man hatte sie
aufs andere Ende des Dorfes zu einer Gebärenden geholt, da sie für
eine Heilkundige galt und sich auf verschiedene Krankheiten
auskannte.</p>
<p class="calibre3">Es war ein Drängen über Jagna gekommen, hinaus unter die
Menschen zu gehen, sobald sie aber die Schürze über den Kopf schlug
und über die Schwelle in den Schmutz und ins Regenwetter
hinaustrat, verließ sie alle Lust... so daß sie sich zuletzt dem
Weinen nahe fühlte, unter der Gewalt einer seltsamen
Sehnsüchtigkeit... Da sie sich nicht anders helfen konnte, öffnete
sie ihre Lade und fing an, aus ihr den Sonntagsstaat hervorzukramen
und über die Betten auszubreiten... In der Stube wurde es bunt vor
gestreiften Beiderwandröcken..., Schürzen... Jacken... Doch all das
wollte sie heute nicht freuen... mit gleichgültigem, gelangweiltem
Blick sah sie auf ihr Hab und Gut und zog schließlich von unten das
Tuch und das Band hervor, die sie von Boryna hatte; sie schmückte
sich damit und besah sich lange im Spiegelchen.</p>
<p class="calibre3">»Nicht schlecht... man muß das für den Abend umtun,« dachte sie,
und nahm es gleich ab, denn irgend jemand kam zwischen den Hecken
auf das Haus zu.</p>
<p class="calibre3">Mathias trat ein... Jagna schrie auf vor Staunen, denn es war
dieser, um den man sie am meisten beschuldigte, daß sie mit ihm des
Nachts im Garten zusammenträfe und ihm <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page192" title="DaoH/gary"></a> auch öfters anderswo Einlas
gewährte ... Er war ein älterer Bursche, mochte gut über die
Dreißig sein, und noch Junggeselle, aber heiraten wollte er nicht,
der Schwestern wegen, die noch nicht untergebracht waren, und, wie
Gusche sich zusammenredete, weil ihm die Mädchen und andermanns
Frauen besser schmeckten ... Ein breitgewachsener Kerl war es, wie
eine Eiche, kräftig und selbstbewußt, dabei so hochmütig und
unnachgiebig, daß ihn die meisten fürchteten. Und geschickt war das
Luder zu allem; auf der Flöte spielte er, daß es einem bis an die
Seele ging, konnte einen Wagen zurechtzimmern, baute Häuser, klebte
Ofen aus und machte alles mit solcher Geschicklichkeit, daß ihm die
Arbeit unter seinen Fäusten nur so hinflog/nur das Geld wollte an
ihm gar nicht haften bleiben, obgleich er gut im Verdienst war,
denn er vertrank und verspendierte gleich alles, oder borgte es aus
... Täubich war sein Vatername, obgleich er eher einem Habicht
ähnlich war seinem Gesicht nach und in bezug auf seine
Hitzigkeit.</p>
<p class="calibre3">»Gelobt sei Jesus Christus! ...«</p>
<p class="calibre3">»In Ewigkeit ... Mathias!«</p>
<p class="calibre3">»Ich bin's schon selbst, Jagusch, ich bin's ...«</p>
<p class="calibre3">Er drückte ihr die Hand und sah ihr so feurig in die Augen, daß
das Mädchen errötete und unruhig nach der Tür sah.</p>
<p class="calibre3">»Warst ein halbes Jahr in der Welt ...,« murmelte sie
verlegen.</p>
<p class="calibre3">»Ein ganzes halbes Jahr und dreiundzwanzig Tage ... ich hab' gut
gezählt ...«; ihre Hände aber ließ er nicht los.</p>
<p class="calibre3">»Ich will Licht machen!« rief sie, da es schon tüchtig dunkelte
und um von ihm loszukommen.</p>
<p class="calibre3">»Willst du mich nicht begrüßen, Jagusch,« bat er leise und
wollte sie umfassen, aber sie entglitt ihm schnell und ging zum
Herd, um Licht zu machen, sie hatte Angst, daß sie die Mutter oder
irgend jemand anders im Dunkeln überraschen könnte, aber sie kam
nicht dazu, weil Mathias sie um die <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page193" title="DaoH/gary"></a> Hüften faßte, stark an sich drückte und
wütend zu küssen begann ...</p>
<p class="calibre3">Sie wand sich wie ein gefangener Vogel, aber sie hatte nicht die
Macht, sich einem solchen hungrigen Drachen zu entwinden, der sie
an sich preßte, daß die Rippen fast knackten und dermaßen küßte,
daß ihr ganz schwach wurde; die Augen umnebelten sich, sie konnte
keinen Atem fangen, und nur mit dem Rest ihrer Beherrschung
bettelte sie:</p>
<p class="calibre3">»Laß ... Mathias ... die Mutter ...«</p>
<p class="calibre3">»Noch ein bißchen, Jagusch, noch einmal, sonst werd' ich ganz
toll ... Und er küßte sie so, daß das Mädchen ganz willenlos wurde
und ihm zwischen den Händen durchglitt, wie Wasser, aber er ließ
sie mit einem Male los, denn es wurden im Flur Schritte laut; er
zündete noch eigenhändig das Lämpchen über dem Rauchfang an und
machte sich dran, eine Zigarette zu drehen, mit vor Vergnügen
funkelnden Augen Jagusch betrachtend, die noch nicht zu sich kommen
konnte und schwer atmend sich fest gegen die Wand stützte.</p>
<p class="calibre3">Jendschych trat ein und fing an, das Feuer auf dem Herd
anzufachen, setzte Töpfe mit Wasser auf und machte sich in einem
fort in der Stube zu schaffen, so daß sie nur wenig mehr
miteinander sprachen, und nur mit glühenden, gierigen Augen
einander betrachteten, als ob sie sich am liebsten auffressen
wollten ...</p>
<p class="calibre3">In Bälde, es mochten kaum ein paar Paternoster vergangen sein,
kam die Dominikbauerin heim, sie mußte wohl böse sein, denn schon
im Hausflur riß sie das Maul gegen Schymek auf und als sie Mathias
gewahr wurde, blickte sie ihn streng an, ließ seine Begrüßung
unbeachtet und ging in die Kammer, sich umzukleiden.</p>
<p class="calibre3">»Geh schon, sonst wird die Mutter mit dir zanken ...,« bat Jagna
leise.</p>
<p class="calibre3">»Kommst du zu mir heraus, Jagusch, was?« bat er.</p>
<p class="calibre3">»Bist schon aus der Welt zurückgekehrt?« sagte die Alte, als
hätte sie ihn soeben erst entdeckt.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page194" title="DaoH/gary"></a> »Das bin
ich, Mutter ...,« sprach er sanft und wollte ihr die Hand
küssen.</p>
<p class="calibre3">»Was da, Mutter, such dir 'ne Hündin als Mutter, nicht mich!«
knurrte sie auf, ihm die Hand wütend entreißend. »Wozu bist du
hierhergekommen? Hab' ich dir nicht schon gesagt, daß du hier
nichts zu suchen hast ...«</p>
<p class="calibre3">»Zu Jaguscha bin ich gekommen, nicht zu euch,« rief er trotzig,
denn die Wut packte ihn.</p>
<p class="calibre3">»Bleib' du mir von der Jagna ab, verstanden! Komm du mir hier
noch einmal, daß man sie dann durch dich im Dorf auf den Zungen
herumträgt, wie irgend so eine ..., daß dich nicht noch einmal
meine Augen hier sehen ... brüllte sie los.</p>
<p class="calibre3">»Ihr schreit, wie eine Krähe, das ganze Dorf wird's hören!«</p>
<p class="calibre3">»Laß sie hören, laß sie zusammenlaufen, laß sie wissen, daß du
dich an Jagna gehängt hast, wie 'ne Klette an einen Hundeschwanz,
daß man dich selbst mit einer Feuergabel nicht verjagen kann
...«</p>
<p class="calibre3">»Wenn ihr nicht ein Frauenzimmer wäret, dann würd' ich euch mal
an die Rippen fassen, für solches Reden ...«</p>
<p class="calibre3">»Versuch' du, Bube, versuch' du bunter Hund ...,« sie griff nach
einem eisernen Feuerhaken.</p>
<p class="calibre3">Aber dabei blieb es, denn Mathias spie aus, schmiß die Tür ins
Schloß und ging rasch fort, wozu denn auch, sollte er sich
vielleicht mit einem Weibsbild herumschlagen und sich zum Gelächter
des ganzen Dorfes machen?</p>
<p class="calibre3">Die Alte aber, als sie seiner nicht mehr habhaft werden konnte,
machte sich über Jagna her, und nu mal gleich los und auf sie
eingeifern und alles herholen, was sie schon lange auf der Leber
hatte ... Jagusch saß indessen still dabei, fast wie erstorben vor
Schreck, als ihr aber die Worte der Mutter schon bis aufs Blut
gingen ... kam sie zur Besinnung, fing an zu heulen und steckte
klagend den Kopf in die Federbetten ... Sie war heftig erbittert...
denn sie hatte keine Schuld <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page195" title="DaoH/gary"></a> ... sie hatte ihn doch nicht ins Haus gerufen ...,
er war ja von selbst gekommen ..., und was die Mutter ihr da vom
Frühjahr vorhielt, da hatte er sie nur am Zaunüberstieg getroffen
...; konnte sie sich solchem Ungeheuer entwinden? ... wo es ihr so
in alle Glieder gefahren war, daß sie ... und später konnte sie
sich ihn da vom Leibe halten? ... Immer ist es so mit ihr, wenn sie
nur einer scharf ansieht oder stark anpackt ... dann bebt in ihr
alles, die ganze Kraft geht von ihr ab und es wird ihr so schwach
im Magen, daß sie schon nichts mehr weiß ... was kann sie
dafür?</p>
<p class="calibre3">Sie klagte still und unter Tränen, bis die Alte sich begütigte
und ihr besorgt die Augen und das Gesicht abtrocknete, über den
jungen Kopf strich und sie zu beruhigen begann.</p>
<p class="calibre3">»Nu, sei man still, Jagusch, weine nicht ... nein ... sonst
kriegst du rote Augen, wie ein Karnickel, und wie sollst du denn so
auf den Borynahof gehen?«</p>
<p class="calibre3">»Ist es denn schon Zeit?« fragte sie nach einer Weile, schon
etwas beruhigt.</p>
<p class="calibre3">»Natürlich, daß es Zeit ist, und mach' dich recht fein, viele
Leute werden da sein und auch Boryna selbst gibt acht ...«</p>
<p class="calibre3">Jagusch erhob sich gleich und fing an, sich anzuziehen.</p>
<p class="calibre3">»Soll ich dir nicht Milch kochen?«</p>
<p class="calibre3">»Nein, ich hab' gar keinen Hunger, Mutter.«</p>
<p class="calibre3">»Schymek, du mißratene Kreatur, wärmst dich hier, und da nagen
die Kühe an den Krippen,« schrie sie mit dem Rest ihrer Wut, und
Schymek rannte davon, um nicht etwas abzukriegen.</p>
<p class="calibre3">»Es scheint sich mir,« sprach sie stiller, indem sie Jagna beim
Ankleiden behilflich war, »daß der Schmied mit Boryna in gutem
Einvernehmen ist. Ich bin ihm begegnet, wie er vom Alten ein feines
Bullenkalb wegholte ... Schade ... gut seine fünfzehn Papierer war
es wert ... vielleicht ist es aber doch gut, daß sie miteinander in
Frieden sind, weil der Schmied ein großes Maul hat und sich <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page196" title="DaoH/gary"></a> aufs Recht auskennt
...« Sie trat ein paar Schritte zurück und sah ihre Tochter mit
Wohlgefallen an. »Aber diesen Dieb, den Kosiol, haben sie, scheint
mir, schon wieder freigelassen, man wird wieder alles zuschließen
müssen und Obacht geben ...«</p>
<p class="calibre3">»Ich geh' schon!«</p>
<p class="calibre3">»Ja, geh' du nur und scharmezier' mit den Burschen bis über
Mitternacht 'rum,« platzte sie noch einmal mit dem Rest des Ärgers
los.</p>
<p class="calibre3">Jagna ging hinaus, aber noch vom Weg her hörte sie die Alte, wie
sie auf Jendschych einschimpfte, daß die Schweine nicht
eingetrieben wären und die Hühner auf den Bäumen nächtigten.</p>
<p class="calibre3">Bei Boryna waren schon viele Leute.</p>
<p class="calibre3">Ein Feuer flammte auf dem Herd und erleuchtete die große Stube,
daß die Scheiben der Bilder gleißten und die Weltkugeln
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#foot6" id="text6"><sup class="calibre6">F6</sup></a> aus farbigen Oblaten, die an Fäden von den
schwarzen, rußigen Deckenbalken herabhingen, hin und her
schaukelten; inmitten der Stube lag ein Haufen Rotkohl und drum
herum in einem weitgezogenen Halbkreis mit den Gesichtern nach dem
Feuer hingewandt, saßen Mädchen und ein paar ältere Frauen
beisammen/sie schälten den Kohl und warfen die Köpfe auf ein am
Fenster ausgebreitetes Leinwandtuch.</p>
<p class="calibre3">Jagusch wärmte sich die Hände am Herd, stellte ihre Holzpantinen
unters Fenster und setzte sich gleich am Rand neben die alte Gusche
zum Arbeiten nieder.</p>
<p class="calibre3">Das Stimmengewirr stieg immer mehr, denn es kamen noch immerfort
Frauen hinzu und auch etliche Burschen, die mit Jakob zusammen Kohl
aus der Scheune trugen, mehr aber noch Zigaretten rauchten, den
Mädchen lachend die Zähne zeigten und sich untereinander
neckten.</p>
<p class="calibre3">Fine, die doch eigentlich noch der reine Kiekindiewelt war, war
überall die erste an der Arbeit und beim Amüsieren, denn der Alte
war nicht zugegen, und Anna kroch <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page197" title="DaoH/gary"></a> wie gewöhnlich herum, als ob sie eine
Nachteule oder ein Brummkater wäre.</p>
<p class="calibre3">»Das ist hier rot in der Stube, wie von Mohnblumen,« rief Antek,
der die Fässer auf den Flur gerollt hatte und jetzt etwas abseits
vom Herd die Krauthobel aufstellte.</p>
<p class="calibre3">»Huch! Die haben sich geputzt wie für eine Hochzeit!« ließ sich
eine der älteren Frauen vernehmen.</p>
<p class="calibre3">»Und Jagusch hat sich wohl in Milch gewaschen,« fing Gusche an
zu sticheln.</p>
<p class="calibre3">»Laßt das,« murmelte sie errötend.</p>
<p class="calibre3">»Freut euch, Mädel, Mathias ist schon hergewandert aus der Welt,
gleich fangen hier wieder die Musiken und Tänze und das Herumstehen
in den Obstgärten an ...,« redete sie weiter.</p>
<p class="calibre3">»Den ganzen Sommer über war er nicht da.«</p>
<p class="calibre3">»Versteht sich, hat doch das Herrenhaus in Wola gebaut.«</p>
<p class="calibre3">»So 'n Luder, versteht alles, läßt selbst Seifenblasen aus der
Nase fliegen,« sagte einer der Burschen.</p>
<p class="calibre3">»Und auf die Mädchen versteht er sich, daß man nicht einmal drei
Quartal zu warten braucht ...«</p>
<p class="calibre3">»Von der Gusche kriegt keiner 'n gutes Wort ab,« fing eines der
Mädchen an.</p>
<p class="calibre3">»Paß auf, daß ich über dich nicht was zu sagen wüßte ...«</p>
<p class="calibre3">»Wißt ihr schon, man sagt, der alte Wanderer ist
angekommen?«</p>
<p class="calibre3">»Er kommt zu uns heute,« rief Fine.</p>
<p class="calibre3">»Ganze drei Jahre war er in der Welt.«</p>
<p class="calibre3">»In der Welt? ... Am heiligen Grab war er doch!«</p>
<p class="calibre3">»Hale! Hat ihn da einer gesehen? Lügen tut das Biest und die
Dummen werden nicht alle; ebenso erzählt ja auch der Schmied von
überseeischen Ländern, alles was er sich in den Zeitungen
zusammenliest ...«</p>
<p class="calibre3">»Sagt das nicht, Gusche, denn selbst Hochwürden hat es der
Mutter zugesichert.«</p>
<p class="calibre3">»Das ist ja wahr, daß die Dominikbäuerin so gut wie ihr <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page198" title="DaoH/gary"></a> zweites Haus auf
dem Pastorat hat und immer weiß, wann der Pastor Leibschmerzen hat,
sie ist doch 'ne Heilkundige ...«</p>
<p class="calibre3">Jagna verstummte, aber sie hatte große Lust, sie mal mit dem
Kohlmesser zu stechen, denn die ganze Stube brach in schallendes
Gelächter aus; nur dem Gregor seine Ulischja neigte sich zur
Klembbäuerin hin und fragte:</p>
<p class="calibre3">»Woher ist er denn?«</p>
<p class="calibre3">»Woher? Von weit her, wer kann das wissen!« sie beugte sich
etwas vor, legte einen Kohlkopf auf ihre Handfläche, säuberte ihn
von den Blättern und sprach rasch und immer lauter, damit es auch
die anderen hörten: »Jeden dritten Winter kommt er nach Lipce und
nimmt bei Boryna Quartier./ Rochus ließ er sich nennen, obgleich
gewißlich sein Name nicht Rochus ist ... Ein Bettler ist er und
auch kein Bettler, wer kann das wissen ... aber ein frommer Mensch
ist er und ein guter ... es fehlt ihm nur der goldene Reif um den
Kopf, dann wäre er richtig, wie die Heiligen auf den Bildern.
Rosenkränze hat er um den Hals hängen, damit hat er übers heilige
Grab gestrichen ... Heiligenbilder schenkt er den Kindern, und
manchen auch solche mit Königen, die früher aus unserem Volke kamen
... und fromme Bücher hat er, auch solche, in denen alles steht und
auch verschiedene Geschichten über die Welt ... meinem Walek hat er
sie doch vorgelesen, da haben wir, ich und der Meine, mit zugehört,
nur daß ich es wieder vergessen habe, weil's auch schwer
herauszubringen ist ... Und so fromm wie der ist, einen halben Tag
kniet er oft durch, manchesmal unterm Kreuz am Wege oder auch
irgendwo im Feld; und in die Kirche, da geht et immer nur zur
Messe. Hochwürden hat ihn schon zu sich auf die Propstei
eingeladen, da hat er ihm gesagt:</p>
<p class="calibre3">Beim Volk ist es mir zu bleiben, nicht in den feinen Zimmern ist
mein Platz.</p>
<p class="calibre3">Alle tun auch 'rausfinden, daß er wohl nicht vom Bauernstand
ist, obgleich er auch spricht, wie alle, und gelehrt ist <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page199" title="DaoH/gary"></a> er; das ist er
auch, mit dem Juden hat er deutsch geredet und auf dem Herrenhof in
Tschasgowa/hat er mit dem Fräulein, das für die Gesundheit in
warmen Ländern war, auch auf ausländ'sch sich besprochen ... und
von keinem nimmt er was an, nur vielleicht den kleinen Tropfen
Milch und einen Brotknust, und dafür lernt er noch den Kindern was
... man sagt ...«/die Klembbäuerin unterbrach sich plötzlich, denn
die Mädchen brachen in ein solches Gelächter aus, daß sie fast auf
den Rücken fielen.</p>
<p class="calibre3">Sie lachten über Jakob, der in einem Leinwandtuch Kohl
hereintrug und, durch irgendwen angestoßen, mitten in der Stube so
lang er war hinpurzelte, so daß der Kohl nach allen Ecken
auseinanderrollte, er versuchte sich mühevoll auszurichten; doch
jedesmal, wenn er auf allen Vieren hochkrabbeln wollte, wurde er
von neuem angestoßen und fiel wieder um.</p>
<p class="calibre3">Fine kam ihm zur Hilfe und stand ihm bei, wieder hochzukommen,
was er da aber geflucht und geflucht hat ...</p>
<p class="calibre3">Und langsam ging das Gespräch auf etwas anderes über.</p>
<p class="calibre3">Alle sprachen halblaut durcheinander, und ein Gesumm von Stimmen
entstand darob, wie in einem Bienenstock vor dem Ausschwärmen, und
ein Gekicher, ein Geneck und ein Spaß war in der Runde, daß die
Augen nur so funkelten und die Münder lachten. Die Arbeit ging
dabei blitzgeschwind vorwärts, nur die Messer knirschten gegen die
Strünke und die Kohlköpfe flogen wie Kugeln in dichten Abständen
hintereinander auf das Leinwandtuch und häuften sich zu einem immer
größeren Berg. Antek aber schnitt den Kohl klein über einem großen
Zuber am Herd; er hatte seine Oberkleidung abgelegt und stand nur
noch im Hemd und in den gestreiften Beiderwandhosen da, er war ganz
rot geworden, und über der Stirn unter dem zerzausten Haar perlten
die Schweißtropfen; er schaffte mächtig, lachte in einem fort,
neckte sich weidlich herum und sah so wohlgestaltet aus, daß Jagna
auf ihn, wie auf ein Bild <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page200" title="DaoH/gary"></a> schaute und nicht nur Jagna allein ...; er aber
hielt hin und wieder an, um Atem zu schöpfen und sah sie mit seinen
frohen Blicken so an, daß sie die Augen senkte und errötete. Doch
niemand sah es, außer Gusche, die tat, als ob sie nichts merke und
legte es sich im Kopf zurecht, wie sie das im Dorf erzählen
würde.</p>
<p class="calibre3">»Marzicha ist, sagt man, niedergekommen, wißt ihr das?« fing die
Klembbäuerin an.</p>
<p class="calibre3">»Das ist nichts Neues bei ihr, jedes Jahr macht sie sich
das.«</p>
<p class="calibre3">»Ein Frauenzimmer wie 'n Stier, das Kind zieht ihr nur das Blut
vom Kopf ab,« brummte Gusche und wollte sich darüber noch besser
ausbreiten, aber die anderen Frauen wiesen sie zurecht, daß sie
über solche Sachen rede bei den Mädchen.</p>
<p class="calibre3">»Die wissen auch über bessere Bescheid, braucht euch nicht zu
sorgen. Heut sind schon solche Zeiten da, daß, wenn man selbst
einem Gänsemädchen vom Storch redet, dann lacht sie dir ins Gesicht
... das war so früher nicht, nein, nein ...«</p>
<p class="calibre3">»Na, ihr habt schon alles gewußt, wie ihr noch hinterm Vieh
war't ...,« sagte die alte Wawschjonbäuerin ernst, »ich weiß schon
noch, was ihr da auf den Weidenplätzen getrieben habt.«</p>
<p class="calibre3">»Wenn ihr es wißt, könnt ihr es behalten,« krächzte Gusche
schrill.</p>
<p class="calibre3">»Damals war ich schon verheiratet ... mit Mathias scheint mir
... nein, mit Michael, ja, stimmt, denn Wawschjon war doch der
dritte ...;« murmelte sie, ohne recht zu treffen.</p>
<p class="calibre3">»Heda, ihr sitzt hier so und wißt nicht mal, was passiert ist!«
schrie Nastuscha Täubich, Mathias seine Schwester, atemlos
hereinstürzend.</p>
<p class="calibre3">Von allen Seiten wurden neugierige Fragen laut, und aller Augen
hafteten an ihr.</p>
<p class="calibre3">»Dem Müller seine Pferde sind gestohlen!«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page201" title="DaoH/wedi"></a> »Wann
denn?«</p>
<p class="calibre3">»Kaum drei Paternoster her. Soeben hat es Jankel dem Mathias
erzählt.«</p>
<p class="calibre3">»Der Jankel, der weiß immer alles gleich und manchmal selbst ein
bißchen früher...«</p>
<p class="calibre3">»Solche Pferde, die reinen Riesen!«</p>
<p class="calibre3">»Aus dem Stall haben sie sie hinausgeführt. Der Knecht war in
der Mühle um Hafer zu holen, kommt zurück, und, hast du nicht
gesehen, weder Pferde noch Geschirr, und der Hofhund vergiftet,
denkt nur!«</p>
<p class="calibre3">»Zum Winter geht es, da fängt manch Verschiedenes an.«</p>
<p class="calibre3">»Das kommt davon, weil keine Strafe für die Diebe da ist. Hale,
viel werden sie ihm machen, stecken ihn ins Kriminal, geben ihm zu
essen, in der Wärme wird er sitzen, lernt verschiedene Praktiken
mit den Kollegen, und wenn sie ihn rauslassen, dann gibt's noch
einen besseren Dieb, einen studierten.«</p>
<p class="calibre3">»Wenn man mir so mein Pferd herausholen würde und ich würde
einen solchen zu fassen kriegen, dann würd' ich ihn auf dem Fleck
umbringen, wie einen tollen Hund,« rief einer der Burschen.</p>
<p class="calibre3">»Nur das hätte so einer verdient, die Dummen warten nur auf
Gerechtigkeit. Jeder hat das Recht, wenn ihm Unrecht geschieht,
sich Recht zu verschaffen.«</p>
<p class="calibre3">»So einen müßte man einfangen und dann gemeinsam umbringen, dann
gibt's auch keine Strafe, denn alle können sie doch nicht
bestrafen?«</p>
<p class="calibre3">»Ich weiß schon... das haben sie bei uns so gemacht... gleich,
da war ich schon mit dem zweiten verheiratet... nein, ich glaube,
Mathias war es noch...«</p>
<p class="calibre3">Aber diese Ausführungen unterbrach Boryna, der gerade in die
Stube trat.</p>
<p class="calibre3">»Ihr flüstert hier so schön miteinander, daß man es von der
anderen Seite des Weihers hört!« rief er lustig, nahm die Mütze ab
und begrüßte alle der Reihe nach. Er mußte <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page202" title="DaoH/wedi"></a> schon einen sitzen haben, denn er
war rot wie ein Spitzhahn, den Knierock hatte er aufgelassen und
sprach laut und viel, was sonst nicht seine Gewohnheit war. Er
hatte Lust, sich neben Jagna zu setzen, aber er wägte ab, daß es
wohl nicht gut anginge so vor den Augen der ganzen Versammlung,
solange sie nicht mit ihm versprochen war; so redete er denn lustig
darauf los und besah sie sich mit Wohlgefallen, wie schön sie heute
war und wie fein sie sich mit dem von ihm geschenkten Kopftuch
aufgeputzt hatte.</p>
<p class="calibre3">Gleich darauf trugen Witek und Jakob eine lange Bank an den Herd
heran, Fine wischte sie mit einem reinen Linnen ab und fing an, die
Schüsseln und Löffel für das Essen aufzusetzen.</p>
<p class="calibre3">Und Boryna brachte aus der Kammer eine dickbäuchige, zwei Quart
große Buttel Aquavit und begann damit, alle der Reihe nach
abzugehen und jedem zuzutrinken.</p>
<p class="calibre3">Die Mädchen zierten sich etwas, bis schließlich einer der
Burschen sagte:</p>
<p class="calibre3">»Die sind auf Schnaps lecker, wie die Katz' auf die Milch, nur
wollen sie sich erst bitten lassen.«</p>
<p class="calibre3">»Selbst der richtige Säufer, sitzt immerzu bei Jankel, da denkt
er, daß alle dasselbe!«...</p>
<p class="calibre3">Und sie tranken, drehten sich weg, versteckten ihre Gesichter
hinter der Hand, gossen den Rest auf den Boden aus, zogen eine
Fratze, sagten: »Stark is er« und gaben Boryna das Glas zurück.</p>
<p class="calibre3">Nur Jagna versteifte sich und trank nicht, trotz der Bitten und
Überredungen.</p>
<p class="calibre3">»Selbst den Geschmack von Branntwein kenn' ich nicht, und bin
nicht neugierig darauf,« sagte sie.</p>
<p class="calibre3">»Na, setzt euch nur hin, liebe Leute, was da ist, wollen wir
essen,« lud der Alte ein.</p>
<p class="calibre3">Sie setzten sich nach vielen Umständen, wie das die gute Sitte
wollte und aßen gemächlich, zwischendurch miteinander redend.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page203" title="DaoH/lac"></a> Aus den
Schüsseln stieg der Dampf und hüllte alle in eine Dunstwolke ein
... aus der nur das Schaben der Löffel, Schmatzen und gelegentlich
ein Wort zu hören war.</p>
<p class="calibre3">Sie hatten ein leckeres Essen gekocht, manch einer wunderte sich
selbst darob. Es gab Fleischbrühe mit Kartoffeln, gekochtes Fleisch
mit gerösteter Gerstengrütze und Kohl mit Erbsen – es war eine
ehrliche Bewirtung, wie es ein Hofbauer zu spendieren hat, und
außerdem tat Boryna immerzu auffordern und mehrmals nötigen, und
Fine ihrerseits sowohl wie Anna paßten auf, um zuzulegen und
zuzugießen ...</p>
<p class="calibre3">Witek warf trockene Klötze aufs Feuer, das lustig knatterte, und
Jakob trug in der Zeit, da gegessen wurde, Kohl in die Stube und
schüttete ihn aus einen Haufen, zog begierig die Düfte ein, leckte
sich den Bart und seufzte vor sich hin.</p>
<p class="calibre3">»Einen halben Ochsen würd' ich runterschlucken, mit einem oder
zwei Schüsselchen Grütze ... und die Biester fressen so wie die
ausgehungerten Pferde, bringen's noch fertig, einem nicht mal einen
Knochen übrigzulassen,« dachte er mit Unbehagen und schnallte den
Gurt fester, denn es knurrte ihm nur so vor Hunger in den
Eingeweiden.</p>
<p class="calibre3">Sie waren bald zu Ende und erhoben sich mit einem »Gott
bezahl's!« für die Wirte.</p>
<p class="calibre3">»Laßt es euch wohl bekommen!«</p>
<p class="calibre3">Ein Lärmen entstand; der ging hinaus, um sich durchzulüften und
die Knochen zu recken, der war begierig nach dem Wetter zu sehen,
ob es sich nicht aufhellte, und die Burschen, die machten, daß sie
zu den Mädchen auf die Galerie kamen, um mit ihnen
herumzutollen.</p>
<p class="calibre3">Jakob aber saß auf der Schwelle mit einer Schüssel zwischen den
Knien und aß, daß ihm die Ohren bebten, ohne auf Waupa zu achten,
der sich verschiedenartig in Erinnerung brachte, und als er sah,
daß nichts zu holen war, auf die Galerie zu den Hunden hinausschob,
die den Menschen nachgefolgt waren und sich um die Knochen balgten,
die Fine ihnen hingeworfen hatte.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page204" title="DaoH/lac"></a> Sie machten
sich gerade abermals an die Arbeit, als Rochus unter die Tür trat
mit einem: »Gelobt sei Jesus Christus!«</p>
<p class="calibre3">»In Ewigkeit, Amen!« antworteten sie im Chor.</p>
<p class="calibre3">»Beeilt euch, Wanderer, setzt euch her/solang noch nicht die
Schüssel leer ... Verspätet habt ihr euch, aber es wird noch für
euch reichen ...,« rief Boryna und schob ihm einen Stuhl an den
Herd heran.</p>
<p class="calibre3">»Gib mir Milch und Brot, Fine, das wird schon reichen.«</p>
<p class="calibre3">»Es ist auch noch ein bißchen Fleisch,« ließ sich Anna
schüchtern vernehmen.</p>
<p class="calibre3">»Nein, Gott bezahl's, aber Fleisch esse ich nicht.«</p>
<p class="calibre3">Sie schwiegen erst und betrachteten ihn mit einer freundlichen
Neugierde; als er sich aber ans Essen setzte, erhoben sich
Gespräche und Gelächter aufs neue.</p>
<p class="calibre3">Nur Jagna sah oft mit Staunen auf den Wandersmann, daß ein
solcher Mensch, ganz wie alle anderen, doch am heiligen Grabe
gewesen war, die halbe Welt gesehen hatte und so viele Wunder ...
»Wie mag es denn da in dieser Welt sein? Wohin muß man gehen, um da
hinzukommen? ... Ringsherum sind doch nur Dörfer, Felder und
Wälder, und hinter ihnen wieder Dörfer, Felder und Wälder ... An
die hundert Meilen muß einer wohl gehen, oder vielleicht auch an
die tausend,« dachte sie und hatte eine seltsame Lust, zu fragen,
aber wie hätte sie das wagen können, er hätte sie gewiß noch
ausgelacht ...</p>
<p class="calibre3">Rafus sein Sohn, dieser, der vom Militär zurück war, hatte eine
Geige gebracht, sie gestimmt, und fing an, verschiedene Lieder
aufzuspielen.</p>
<p class="calibre3">Eine Stille entstand, nur der Regen peitschte gegen die Scheiben
und die Hunde geiferten vor dem Haus. Und er spielte immerzu und
immer wieder etwas Neues, mit den Händen fingerte er und strich so
mit dem Bogen über die Saiten, daß die Melodie wie von selbst
herauskam ... Er spielte fromme Lieder, als ob sie für jenen
Wandersmann <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page205" title="DaoH/lac"></a>
bestimmt wären, der das Auge nicht von ihm wandte; und darauf
wiederum spielte er andere, ganz weltliche, vom Hans, der in den
Krieg gemußt/jenes Lied, das die Mädchen so oft auf dem Feld
anstimmten ... und so klagend stieg es aus jenen Hölzern, daß ein
Frösteln durch alle Knochen ging, und Jagusch, die auf Musik
empfindlich war, wie selten eine, fühlte, daß ihr die Tränen über
die Wangen liefen.</p>
<p class="calibre3">»Hör' doch auf, denn Jagusch weint ...,« rief Nastuscha
hinüber.</p>
<p class="calibre3">»Nein ... das ist nur so ... es nimmt mich immer mit ... das
Spiele n... nein ...,« flüsterte sie beschämt und verbarg das
Gesicht hinter der Schürze.</p>
<p class="calibre3">Es half aber nichts, denn obgleich sie nicht wollte, tropften
ihr die Tränen von selbst aus jener seltsamen Sehnsüchtigkeit, die
ihr im Herzen geblieben war, Gott weiß wonach ...</p>
<p class="calibre3">Doch der Bursche hörte nicht auf zu spielen, nur daß er jetzt
feurige Mazurken und solche Obereks vom Ohr ausholend über die
Fiedel schnitt und geigte, daß die Mädchen sich nicht mehr zu
helfen wußten und vor lauter Lust die bebenden Knie
aneinanderpreßten, dabei mit den Armen schwingend, und die Burschen
hell aufjuchzten und hin und wieder im Takte trampelten ... Die
Stube füllte sich mit solchem Lärm, Getrampel und Gelächter, daß
die Scheiben klirrten.</p>
<p class="calibre3">Plötzlich fing aus dem Flur ein Hund an, zu winseln, und heulte
so furchtbar auf, daß alle verstummten.</p>
<p class="calibre3">»Was ist geschehen?«</p>
<p class="calibre3">Rochus stürzte so schnell nach dem Flur hin, daß er fast über
die Krauthobel zu Fall gekommen wäre.</p>
<p class="calibre3">»Ist nichts ... irgendein Junge hat dem Hund den Schwanz
zwischen die Tür geklemmt, darum schrie er,« rief Antek, nachdem er
auf den Flur geguckt hatte.</p>
<p class="calibre3">»Das ist gewiß Witek seine Arbeit,« bemerkte Boryna.</p>
<p class="calibre3">»I, wie denn, Witek würde einem Hund was zuleide <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page206" title="DaoH/lac"></a> tun, er, der das ganze
krüpplige Tierzeug vom Dorf zusammentreibt und auskuriert ...,«
verteidigte Fine empört.</p>
<p class="calibre3">Rochus kehrte stark aufgebracht zurück, er mußte wohl den Hund
befreit haben, denn man hörte das Winseln nur noch irgendwo fern
zwischen den Hecken.</p>
<p class="calibre3">»Auch der Hund ist Gottes Kreatur und fühlt, wenn man ihm
Unrecht zufügt, ganz wie ein Mensch ... Herr Jesus hatte auch
seinen Hund und ließ ihm von niemand was antun ...,« sagte er
leidenschaftlich.</p>
<p class="calibre3">»Herr Jesus sollte da einen Hund gehabt haben, wie alle
Menschen?« zweifelte Gusche.</p>
<p class="calibre3">»Daß ihr es wißt, daß er einen hatte, und Burek hat er ihn
genannt ...«</p>
<p class="calibre3">»Hale ... Na! Sieh mal an ...!« ließen sich neugierige Stimmen
vernehmen.</p>
<p class="calibre3">Rochus schwieg eine Weile, dann aber hob er seinen weißen Kopf,
der mit langen, über der Stirn gerade geschnittenen Haaren gekrönt
war, heftete seine hellen, wie blaßgeweinten Augen auf die
Feuersglut und ließ sich leise vernehmen, indem er mit den Fingern
die Perlen des Rosenkranzes abtastete.</p>
<p class="calibre3">»... In jener fernen Zeit ...</p>
<p class="calibre3">Als der Herr Jesus noch auf Erden wandelte und das Volk selber
regierte, ist also geschehen, was ich hier sagen werde ...</p>
<p class="calibre3">Es ging sich der Herr Jesus zur Kirchweih nach Mstow, und kein
Weg war nirgends da, nur böse glühende Sande überall, denn die
Sonne brannte und es war eine solche Hitze, als wie wenn Gewitter
kommt ...</p>
<p class="calibre3">Und kein Schatten und kein Schutz.</p>
<p class="calibre3">Herr Jesus ging mit vieler Geduld, denn zum Wald war noch ein
gutes Stück Wegs, und da er seine lieben heiligen Füße schon nicht
mehr fühlte vor Müdigkeit und arg zu leiden hatte wegen dem
Durst/so setzte er sich eins ums <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page207" title="DaoH/lac"></a> andere Mal, wenn es da auch noch so mächtig
brannte, auf einen der Flugsandhaufen, wo nur lauter Ziegenbart
wuchs. Schatten war da nur so viel, was die verdorrten Stauden der
Königskerzen hergaben, so daß selbst ein Vöglein dort keinen
Unterschlupf gefunden hätte ...</p>
<p class="calibre3">Und kaum hatte er sich zum Sitzen niedergelassen und hatte nicht
einmal redlich aufgejapst, als auch gleich der Böse, wie dieser
häßliche Habicht, der von oben herab auf ein müdes Vöglein stößt,
dahergefahren kam, und so hatte der Verpestete mit seinen Hufen den
Sand aufgeschlagen und hat sich so wie 'n Vieh herumgewälzt, daß
eine solche Staubwolke aufkam und eine solche Finsternis entstand,
daß die Welt nicht mehr zu sehen war.</p>
<p class="calibre3">Herr Jesus, obschon es ihm den Atem in der Brust einklemmte und
ihm die Glieder matt wurden, stand allemal auf und ging seiner Wege
weiter, und lachte sich nur über den Dummen, denn er wußte ja, daß
der Böse ihm den Weg verwirren wollte, damit er nicht zur Kirchweih
ankäme, dem sündigen Volk Vergebung zu bringen ...</p>
<p class="calibre3">Und so wanderte der Herr Jesus ... und wanderte ... bis er denn
zum Wald hinkam ...</p>
<p class="calibre3">Er ruhte sich nicht schlecht in diesem Schatten aus, labte sich
an dem Wasser und langte sich einen Bissen aus dem Bettelsack,
danach brach er sich einen tüchtigen Stecken aus dem Buschwerk
'raus, bekreuzigte sich und stapfte in den Wald hinein.</p>
<p class="calibre3">Und der Forst war alt und dicht, und die Sümpfe ungangbar, und
die Moräste und Moorwasser so fürchterlich, daß der Böse wohl dort
hausen mußte, und das Dickicht so groß, daß selbst manchem Vogel
nicht leicht war, da durchzudringen. Kaum ist da der Herr Jesus
drin, da fängt auch schon der Böse an, den Forst zu schütteln, zu
heulen, und die Tannen wegzubrechen./Und der Wind, da er doch ein
Höllenknecht ist, half ihm so schnell er konnte, riß das Dürrholz
ab, riß die Äste zu Boden, riß die ganzen Eichen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page208" title="DaoH/Wunibald"></a> um, dröhnte und knatterte
im Forst herum, wie nur 'n Dummer kann.</p>
<p class="calibre3">Eine solche Dunkelheit kam über den Wald, daß man sich ruhig
hatte das Auge ausstechen lassen können und hätte grad soviel
gesehen/und dazu ein Rauschen und ein Knacken ... und dazu ein
Wirbelwind ... und plötzlich springt ein solches Tiergezeug hervor,
bleckt die Zähne... und knurrt ... und schreckt... und leuchtet mit
den Glotzen und langt schon fast ... fast mit den Krallen zu ...
aber natürlich, daß sie sich nicht trauten, denn wieso denn sollten
sie ... es war doch Herr Jesus in der eigenen heiligen Person
...</p>
<p class="calibre3">Doch auch der Herr Jesus hatte es satt, dieses dumme Scheuchen,
und da er es eilig zur Kirchweih hatte, so machte er das Zeichen
des heiligen Kreuzes über dem Forst, und gleich versank der Böse
mit seiner ganzen Anverwandtschaft in den Moorwassern.</p>
<p class="calibre3">Es blieb nur so ein wilder Hund nach, denn zu jener Zeit waren
die Hunde noch nicht mit den Menschen verbrüdert.</p>
<p class="calibre3">Dieser Hund da war zurückgeblieben, kam hinter Herrn Jesus
hergestürzt, bellte, und machte sich an seine lieben heiligen Füße
heran, das eine Mal schnappte er mit den Hauern nach den Hosen, das
andere Mal riß er ihm den Kapottrock entzwei, griff nach den
Bettelsacken und versuchte mit Gewalt an das lebendige Fleisch
heranzukommen ... Herr Jesus aber, da er barmherzig war und keiner
Kreatur etwas zuleide getan hätte/und er hätte ihn doch mit dem
Stecken leicht zuschanden machen können oder selbst mit einem
einzigen Gedanken vernichten/sagte nur:</p>
<p class="calibre3">›Da hast du ein Brötlein, Dummer, wenn du hungrig bist,‹ und er
warf ihm etwas aus dem Sack zu.</p>
<p class="calibre3">Der Hund aber war so böse und verstockt, daß er gar nichts
danach fragte, seine Hauer bleckte, knurrte, geiferte, immer
dichter herandrängte und schon ganz dem Herrn Jesus seine Hosen
verdorben hatte.</p>
<p class="calibre3">›Brot hab' ich dir gegeben, dir kein Unrecht getan und du <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page209" title="DaoH/Wunibald"></a> reißt mir hier
die Kleider vom Leib und bellst drauflos. Dumm bist du, mein
Hündchen, weil du deinen Herrn nicht erkannt hast. Das wirst du
noch beim Menschen abdienen müssen und wirst ohne ihn nicht
auskommen können ...« Herr Jesus sagte das so stark, daß der Hund
sich mit eins auf den Hintern setzte; er drehte um, tat seinen
Schwanz einklemmen, heulte auf und rannte wie besessen in die Welt
hinein.</p>
<p class="calibre3">Und Herr Jesus kam zur Kirchweih.</p>
<p class="calibre3">Auf der Kirchweih war so viel Volk wie Bäume im Wald oder Gras
auf den Wiesen/ganz dicht.</p>
<p class="calibre3">In der Kirche war aber es leer/denn in der Schenke wurde
gespielt, und gleich an der Kirchentür wurde Markt abgehalten,
getrunken und Lotterei getrieben, Gott zum Verdruß, wie das um
solche Zeit sich trifft.</p>
<p class="calibre3">Es tritt Herr Jesus nach dem Hochamt heraus und schaut, er sieht
das Volk wogen wie das Korn unterm Wind, einmal nach dieser Seite,
einmal nach der andern, und rennen; einer rennt mit einer Peitsche,
ein anderer reißt eine Latte vom Zaun, ein dritter langt sich eine
Runge, und noch einer sucht sich einen Stein, die Weiber kreischen
und klettern auf die Zäune und auf die Wagen, die Kinder heulen los
und alles schreit:</p>
<p class="calibre3">›Toller Hund, toller Hund!‹</p>
<p class="calibre3">Und der Hund mitten durch das Volk, wie durch eine plötzlich
aufgerissene Gasse mit heraushängender Zunge schnurstracks auf
Herrn Jesus zu.</p>
<p class="calibre3">Es erschrak nicht unser Herr, nein ... er erkannte, daß es
derselbe Hund aus dem Wald war, so breitete er denn seinen heiligen
Kapottrock aus und spricht zum Tier, das plötzlich stehengeblieben
war:</p>
<p class="calibre3">›Komm her, Burek, bei mir bist du noch sicherer geborgen, wie
selbst im Wald.‹</p>
<p class="calibre3">Er deckte ihn mit dem Kapottrock zu, legte die Hände über ihn
und sprach:</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page210" title="DaoH/Wunibald"></a> ›Tötet
ihn nicht, Leute, das ist auch Gottes Geschöpf, und es ist arm,
hungrig, gehetzt und herrenlos.‹</p>
<p class="calibre3">Aber die Bauern fingen an zu schreien und zu schimpfen, zu
brummen und mit den Rungen auf den Boden zu schlagen: ›Das wäre ein
wildes und tolles Tier, und hätte ihnen schon so viel Gänslein und
Lämmlein gestohlen, und Schaden machte es immerzu und kein Respekt
habe es vor den Menschen, und wäre gleich mit den Zähnen bereit ...
so daß niemand ins Feld ohne Stock gehen kann, denn es gäbe keine
Sicherheit vor dieser Teufelsbrut ... und man müßte ihn durchaus
erschlagen.‹</p>
<p class="calibre3">Und sie wollten den Hund mit Gewalt unter dem Herrn Jesus seinen
Kapottrock hervorholen und umbringen.</p>
<p class="calibre3">Bis Herrn Jesus der Zorn ankam und er sie anfuhr:</p>
<p class="calibre3">›Rührt nicht an, alle miteinander! Den Hund, den tut ihr
fürchten, ihr Liederjahne und Säufer, aber den Herrgott, den
fürchtet ihr nicht, was? ...‹</p>
<p class="calibre3">Sie wichen zurück, denn er hatte mit Macht gesprochen, und
weiter sagte ihnen Herr Jesus, daß sie Liederjane wären ... zur
Kirchweih wären sie gekommen und täten hier nur in den Schenken
herumsitzen, und Gott zum Zorn sein, und keine Buße täten sie, und
wären Schandmäuler und Schinder füreinander und Diebe und gottloses
Pack, und Gottes Strafe würde sie schon erreichen.</p>
<p class="calibre3">So schloß Herr Jesus, erhob seinen Stecken und wollte fortgehen
...</p>
<p class="calibre3">Aber das Volk hatte ihn schon erkannt und nu hin, da, auf die
Knie, und nur so losgeheult und geweint und gewimmert ...</p>
<p class="calibre3">›Herr, bleibe mit uns! Bleibe, oh Herr Jesu Christ! Bleibe! Treu
wollen wir zu dir halten, wie 'n Hund ... wir Säufer, wir
Gottvergessenen, wir schlechten Menschen, oh bleibe, bestrafe,
schlage, aber bleibe ..., wir verlassenen Waisen, wir herrenlosen
Menschen ...‹ Und sie weinten so und bettelten so und küßten seine
Hände und seine heiligen Füße, daß das <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page211" title="lac/DaoH"></a> Herz des Herrn weich wurde; ein
paar Paternoster lang blieb er mit ihnen, belehrte sie, sprach sie
der Sünden ledig und segnete alles.</p>
<p class="calibre3">Und dann, als er schon im Weggehen war, sprach er:</p>
<p class="calibre3">Hat euch der Hund unrecht getan, so soll er von nun an euch
dienen. Die Gänslein wird er hüten, die Lämmlein beschützen, und so
du der eine oder der andere dich besäufst/ wird er dein Hab und Gut
bewachen und wird euch von nun an Freund sein.</p>
<p class="calibre3">›Aber ehren sollt ihr ihn und kein Unrecht tun.‹</p>
<p class="calibre3">Und unser Herr Jesus ging fort in die weite Welt.</p>
<p class="calibre3">Und als er sich umsieht/sitzt Burek auf demselben Platz.</p>
<p class="calibre3">›Burek, was kommst du nicht, willst du Dummer denn allein
dableiben? ...‹</p>
<p class="calibre3">Und der Hund ging mit und folgte jetzunder dem Herrn auf Weg und
Steg so sacht und bedachtsam und so treu, wie der beste Knecht.</p>
<p class="calibre3">Und sie gingen fortan miteinander.</p>
<p class="calibre3">Durch die Wälder, über die Wasser/und durch die ganze Welt.</p>
<p class="calibre3">Und wenn sie manchmal Hunger zu leiden hatten, dann spürte der
Hund wohl ein Vögelein oder ein Gänslein auf oder brachte ein
Schaf, und so lebten sie gemeinsam.</p>
<p class="calibre3">Und manches gute Mal, wenn der liebe Herr ermüdet ruhte, jagte
Burek die bösen Menschen fort oder vertrieb ein wildes Tier und gab
unsern Herrn Jesus nicht heraus, mitnichten ...</p>
<p class="calibre3">Als die Zeit kam, daß die häßlichen Juden und die bösen
Pharisäer den Herrn zur Richtstätte brachten/warf sich Burek auf
alle und biß um sich und verteidigte so gut er konnte, seinen
Herrn, das arme, liebe Tier:</p>
<p class="calibre3">Und Herr Jesus sprach zu ihm unter der Last des Kreuzes, das er
für seine heilige Marter schleppen mußte.</p>
<p class="calibre3">›Das Gewissen wird sie stärker beißen ... Du kommst da nicht
gegenan ...‹</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page212" title="lac/DaoH"></a> Und als sie
den Gemarterten ans Kreuz geschlagen hatten, setzte sich Burek hin
und heulte ...</p>
<p class="calibre3">... Am zweiten Tag, als alle fortgegangen waren und weder die
allerheiligste liebe Jungfrau noch die heiligen Apostel da waren
... blieb nur noch Burek allein ...</p>
<p class="calibre3">... Er leckte immerzu die heiligen, mit Nageln durchbohrten,
absterbenden lieben Füße des Herrn Jesus und heulte ... und heulte
... und heulte ...</p>
<p class="calibre3">... Und als schon der dritte Tag gekommen war ... erwachte Herr
Jesus und sieht, daß niemand mehr am Kreuze geblieben ist, nur
einzig der Burek winselt kläglich und drückt sich dicht an seine
Füße ...</p>
<p class="calibre3">... Da sah unser allerheiligster Herr Jesus Christus mitleidig
aus ihn herab in jener Stunde und sagte mit dem letzten Hauch:</p>
<p class="calibre3">›Komm mit mir, Burek!‹</p>
<p class="center">— — — — —</p>
<p class="calibre3">Und in diesem Augenblick ließ das Hündlein seinen letzten Atem
und folgte dem Herrn.</p>
<p class="calibre3">Amen.«</p>
<p class="calibre3">»So war es, wie ich sagte, liebe Leute!« sprach er sanft, als er
beendigt hatte, bekreuzigte sich und ging auf die andere Seite, wo
ihm schon Anna seine Schlafstätte bereitet hatte, denn er war sehr
ermüdet.</p>
<p class="calibre3">Tiefes Schweigen lag über die Stube gebreitet, alle ließen sich
die seltsame Geschichte durch den Kopf gehen, und einige Madchen,
wie Jagna, Fine und Nastuscha wischten sich ein paar heimliche
Tränen ab, so hatte sie das Los des Herrn und Bureks Abenteuer mit
Rührung erfüllt; und das schon allein, daß sich ein solcher Hund in
der Welt fand, der besser und treuer unserm Herrn diente, als die
Menschen, gab allen nicht wenig zu denken ... und sie fingen
allmählich an, langsam verschiedene leise Bemerkungen zu machen und
sich über diese Bestimmung Gottes zu wundern, bis Gusche, die
aufmerksam <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page213" title="lac/DaoH"></a>
zugehört hatte, den Kopf erhob, höhnisch auflachte und sprach:</p>
<p class="calibre3">»Eia popei, der Bauer pflückt Pflaumen und es sind ihrer zwei!
Ich werd' euch was Besseres sagen, wie der Mensch zum Ochsen
gekommen ist:</p>
<p class="vers">Es schuf Gott einen Stier,<br class="calibre2"/>
Und der Stier war allhier,<br class="calibre2"/>
Und der Bauer nahm ein Messer<br class="calibre2"/>
Und machte es besser.<br class="calibre2"/>
Hat ihm von unten abgeschnitten.<br class="calibre2"/>
Ein Ochse kam sich angeschritten ...<br class="calibre2"/>
... Und der Ochs ist da,<br class="calibre2"/>
Ju-hi-vallera.</p>
<p class="calibre3">Meine Wahrheit ist grad so gut, wie dem Rochus seine.« Sie fing
an zu lachen.</p>
<p class="calibre3">Auch alle in der Stube brachen in ein Gelächter aus und bald
schwirrten Scherze, lustige Reden und verschiedene Erzählungen
durch den Raum.</p>
<p class="calibre3">»Gusche, die weiß alles ...«</p>
<p class="calibre3">»Warum denn auch nicht, Witwe von drei Männern, da lernt man
schon was.«</p>
<p class="calibre3">»Natürlich, der eine lehrte ihr was des Morgens mit dem
Peitschenstiel ... der zweite mittags mit dem Riemen, und der
dritte trieb's ihr oft abends mit der Runge ein ...,« schrie
Raphus.</p>
<p class="calibre3">»Einen vierten würd' ich auch noch heiraten, aber nicht dich,
denn du bist mir zu dumm und läufst mit einer Rotznase herum, wie
'n Judenjunge.«</p>
<p class="calibre3">»Wie es dem Herrn Jesus seinem Hund ohne Herrn erging, geradeso
kann ein Frauenzimmer nicht ohne Prügel auskommen ... Der Gusche
ist dabei auch nicht gut zumut,« warf einer der Burschen ein.</p>
<p class="calibre3">»Dumm bist du ... paß du nur auf, wenn du dem Vater seine
Quärtchen zu Jankel trägst, daß dich niemand sieht, und die
Witwenschaft laß mal in Ruh, das ist nichts für deinen Verstand,«
knurrte sie ihn scharf an, daß sie allesamt <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page214" title="lac/DaoH"></a> schwiegen, denn sie fürchteten, daß
sie in der Wut alles laut sagen würde, was sie wußte, und sie
konnte eine Menge wissen. Ein eigensinniges Weib war sie, ein
unverträgliches, und hatte über alles ihr Urteil fertig, und
manchmal ein solches, daß den Menschen ein Schauer über die Haut
lief und die Haare sich sträubten, denn sie achtete nichts, nicht
mal den Priester und die Kirche, so daß Hochwürden sie schon öfters
ermahnen mußte und ihr ans Herz legen, es nicht wieder zu
vergessen. Das hatte aber nicht geholfen, und sie erzählte bann
noch obendrein im Dorf herum:</p>
<p class="calibre3">»Auch ohne Priester findet jeder den Weg zum lieben Gott, wenn
er nur ehrlich ist; es ist besser, er paßte auf seine
Wirtschafterin auf, denn sie läuft jetzt mit noch einem und wird
wieder irgendwo was ablegen ...«</p>
<p class="calibre3">Das war Gusche ...</p>
<p class="calibre3">Sie wollten schon auseinandergehen, als der Schulze mit dem
Schultheiß eintraten. Sie gingen gerade von Hütte zu Hütte, um zu
sagen, daß man morgen, laut Verordnung, auf dem Weg hinter der
Mühle zum Scharwerk zu kommen habe, denn die Regengüsse hätten die
Erde unterspült ...</p>
<p class="calibre3">Kaum daß er eingetreten war, breitete der Schulze die Arme
auseinander und rief:</p>
<p class="calibre3">»Die besten Mädchen hat sich das alte Biest
zusammengerufen!«</p>
<p class="calibre3">Er hatte wahr gesprochen, denn es waren ja wirklich nur lauter
Hofbauerntöchter, von guter Abkunft und mit einer guten
Mitgift.</p>
<p class="calibre3">Denn Boryna war doch auch der erste im ganzen Dorf, sollte er
sich denn da Dienstvolk und Kätnerinnen oder solche Armut, die zu
zehnen an einem Kuhschwanz hängt, zusammenholen und zu sich
einladen!</p>
<p class="calibre3">Der Schulze trat mit dem Alten beiseite, redete aber so leise,
daß niemand etwas hören konnte, schäkerte mit den Mädchen herum und
ging bald darauf, denn er hatte noch <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page215" title="lac/DaoH"></a> die Hälfte des Dorfes für morgen
zusammenzurufen. Es dauerte auch nicht mehr lange, daß sie alle
auseinander gingen, da es spät war und Kohl zum Schälen fast schon
fehlte.</p>
<p class="calibre3">Boryna dankte allen und jedem einzeln, und was die älteren
Frauen waren, so öffnete er ihnen die Tür und brachte sie vors Haus
...</p>
<p class="calibre3">Aber Gusche sagte noch im Weggehen ganz laut:</p>
<p class="calibre3">»Gott bezahl's für die Bewirtung, aber ganz gut war es
nicht.«</p>
<p class="calibre3">»Hale! Na ...«</p>
<p class="calibre3">»Eine Wirtin fehlt euch, Matheus, und ohnedem kann keine Ordnung
sein ...«</p>
<p class="calibre3">»Ih du mein, was soll man machen, was soll man machen, ist schon
Gottes Fügung, daß sie gestorben ist ...«</p>
<p class="calibre3">»Gibt es denn wenig Mädchen! Jeden Donnerstag lauern sie doch im
Dorf, ob nicht zu irgendeiner Brautbitter von euch gehen ...,«
sprach sie listig, um ihm die Zunge zu lockern. Boryna aber,
obgleich er schon die Antwort fertig hatte, kratzte sich nur über
den Kopf, lächelte und suchte unwillkürlich mit den Augen nach
Jagusch, die sich zum Gehen anschickte ...</p>
<p class="calibre3">Darauf hatte schon Antek gelauert, er zog sich unmerklich an und
ging zuerst hinaus.</p>
<p class="calibre3">Jagusch ging allein nach Hause, denn die anderen wohnten auf der
anderen Seite nach der Mühle zu.</p>
<p class="calibre3">»Jagusch!« flüsterte er, sich in der Dunkelheit hinter
irgendeinem Zaun hervorschiebend.</p>
<p class="calibre3">Sie blieb stehen und erbebte, denn sie hatte seine Stimme
erkannt.</p>
<p class="calibre3">»Ich werd' dich heimbringen, Jagusch!« Er sah sich um, die Nacht
war dunkel und ohne Sterne; der Wind brauste in den Lüften und fuhr
über die Baumkronen.</p>
<p class="calibre3">Er umfaßte sie fest, und so aneinandergeschmiegt verschwanden
sie in den Dunkelheiten.</p>
<ol class="calibre7"><li class="calibre8"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#text6" id="foot6"><span class="pcalibre5 pcalibre4 footnote"><span class="spaced">Weltkugeln:</span> Aus
den geweihten, buntfarbenen Weihnachtsoblaten, die der Organist von
Haus zu Haus herumschickt und die man am Weihnachtsabend vor der
Mahlzeit unter gegenseitigen Glückwünschen teilweise verzehrt,
werden von Dorfmädchen Kugeln geklebt, die man an bunten Fäden an
die Deckenbalken hängt. Diese Kugeln, die aus vier
verschiedenfarbenen Teilen bestehen, nennt man Welten, Weltkugeln.
Welten werden auch besonders kunstvoll aus Strohhalmen
angefertigt.</span></a></li>
</ol>
<p class="pcalibre6 initial1"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page216" title="lac/DaoH"></a>  Am nächsten Tag durchflog ganz
Lipce die Kunde von Borynas Versprechung mit Jagna.</p>
<p class="calibre3">»Der Schulze war als Brautbitter gegangen/ darum lief die
Schulzin, denn er hatte ihr strengstens verboten, auch nur einen
Hauch vom Munde zu lassen, bis daß er wiederkäme, erst um die
Vesperzeit zur Nachbarin, um sozusagen Salz zu borgen, und im
Weggehen schon konnte sie nicht länger an sich halten, nahm die
Gevatterin auf die Seite und tuschelte ihr die Nachricht zu:</p>
<p class="calibre3">»Wißt ihr denn schon, Boryna hat zu Jagna mit Schnaps geschickt!
Aber nicht erzählen, der Meine hat es verboten.«</p>
<p class="calibre3">»Ist nicht die Möglichkeit! Wo werd' ich denn mit der Zunge so
herumlaufen! Bin doch kein Klatschmaul ... So 'n alter Kerl und
macht sich an die dritte Frau heran! Was werden bloß die Kinder
sagen! Oh diese Welt!« stöhnte sie empört heraus.</p>
<p class="calibre3">Und kaum war die Schulzin aus dem Haus, wickelte sie die Schürze
um und stürzte, vorsichtig Umschau haltend, durch den Obstgarten zu
den Klembs, die nebenan wohnten, um eine Heedebürste zu borgen, da
ihre irgendwo weggekommen sei.</p>
<p class="calibre3">»Habt ihr gehört! Boryna heiratet dem Dominik seine Jagna!
Gerade eben sind sie zu ihr mit Schnaps hin.«</p>
<p class="calibre3">»Nein!/was ihr nicht sagt! Wie sollte er denn, hat doch
erwachsene Kinder und ist doch schon selbst in Jahren!«</p>
<p class="calibre3">»Das schon, jung ist er nicht mehr, aber abschlagen werden sie
ihm nicht, nein, ein Hofbauer wie der und noch dazu so reich!«</p>
<p class="calibre3">»Und dann die Jagna! Hat man so was gesehen! Mit dem ... und mit
wem die sich wohl alles 'rumgetrieben hat ... und jetzt wird die
die erste Hofbäuerin sein! Das ist 'ne Gerechtigkeit in der Welt!
... und wieviel Mädchen sind noch da ... wenn schon, ist da doch
auch meiner Schwester ihre ...«</p>
<p class="calibre3">»Oder meine Brudertochter! Und Kopschiwa seine, und <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page217" title="lac/DaoH"></a> die andern und
Nastuscha! Sind die nicht auch Bauerntöchter, nett und
reputierlich, was? ...«</p>
<p class="calibre3">»Wie die sich aufblasen wird! Geht ja schon jetzt wie 'n Pfau
herum und steckt die Nase in die Luft.«</p>
<p class="calibre3">»Das wird schon nicht ohne Gotteslästerung abgehen/ der Schmied
und die anderen Kinder werden der Stiefmutter nichts schenken, was
ihnen zukommt, nein.«</p>
<p class="calibre3">»Hale, werden sie da was machen können? Grund und Boden gehört
dem Alten, sein Wille gilt da.«</p>
<p class="calibre3">»Dem Recht nach, versteht sich, versteht sich, aber was die
Gerechtigkeit ist, da ist doch auch den Kindern ihrs mit.«</p>
<p class="calibre3">»Ih, du lieber Gott, Gerechtigkeit is da, wo das Geld is
...«</p>
<p class="calibre3">Sie ereiferten sich und klagten über den Lauf der Welt, dann
gingen sie auseinander und mit ihnen kam die Neuigkeit wie eine
Flut über das ganze Dorf.</p>
<p class="calibre3">Und da nicht viel Arbeit zu tun war, und sonst nichts Wichtiges,
und die Menschen in den Häusern herumsaßen, denn die Wege waren bis
zum Grund aufgeweicht, so hatte man nichts Besseres zu tun, als die
Versprechung in allen Häusern durchzunehmen. Das ganze Dorf war
voll Neugierde, wie das wohl ausgehen sollte; von vornherein wurden
Schlägereien und Prozesse und Gott weiß was für Geschichten
erwartet. Wieso denn, man kannte doch Borynas Heftigkeit, wenn der
sich mal in was verbeißen würde, tät' er für Hochwürden selbst
nicht davon ablassen; und was Antek sein Trotz war, da wußte man
auch Bescheid.</p>
<p class="calibre3">Selbst die Menschen, die zum Scharwerk auf dem durchbrochenen
Damm hinter der Mühle zusammengetrieben waren, blieben hier und da
stehen und fingen an, über diesen Fall zu debattieren.</p>
<p class="calibre3">Der eine sagte was, der andere sagte was, bis schließlich der
alte Klemb, der ein kluger und würdiger Bauer war, sich streng
vernehmen ließ:</p>
<p class="calibre3">»Da kommt noch was Schlimmes davon, fürs ganze Dorf, paßt nur
auf.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page218" title="lac/DaoH"></a> »Antek wird
nicht Platz machen, wieso denn, noch ein neues Maul für die
Schüssel,« sagte irgendeiner.</p>
<p class="calibre3">»Dummes Zeug, bei Boryna reicht es auch für fünf/um den
Erbanteil geht es da.«</p>
<p class="calibre3">»Ohne daß er ihr was verschreibt, wird das nicht abgehen.«</p>
<p class="calibre3">»Die Dominikbäuerin ist nicht dumm, die wird schon allen was
einrichten.«</p>
<p class="calibre3">»Das ist die Mutter, da ist es ihr hundsverdammtes Recht, wenn
sie für ihr Kind einsteht,« warf Klemb ein.</p>
<p class="calibre3">»In der Kirche sitzt sie nur immerzu und ist schlau auf die
Groschen wie 'n Jude.«</p>
<p class="calibre3">»Red' nicht das erste beste von den Menschen, damit dir die
Zunge nicht steif wird.«</p>
<p class="calibre3">Und so befaßte sich das Dorf den ganzen Nachmittag mit der
Versprechung, was auch kein Wunder war, denn die Borynas waren
erbangesessene, alte Hofbauern; und Matheus war doch obenan in der
Gemeinde, wenn er auch kein Amt hatte. Wie sollte es denn auch
anders sein, auf urewiger Bauernerde saß er, sein Ahn und Urahn
hatten schon da gesessen, und Verstand hatte er und Reichtum hatte
er auch/so daß sie alle, ob sie wollten oder nicht, auf ihn hören
mußten und ihn hoch achteten.</p>
<p class="calibre3">Nur keins von den Kindern, selbst der Schmied nicht, hatten noch
etwas von der Versprechung gehört, jedermann fürchtete, mit dieser
Nachricht zu ihnen zu laufen, um nicht im ersten Ärger etwas
abzubekommen.</p>
<p class="calibre3">So war es denn bei Borynas noch still, selbst stiller heute noch
wie gewöhnlich/der Regen hatte nachgelassen, und schon vom Morgen
an begann der Himmel sich aufzuklären; darum war Antek mit Jakob
und den Frauensleuten gleich nach dem Frühstück in den Wald
gefahren, um Dürrholz für die Feuerung zu sammeln und zu versuchen,
ob es nicht möglich wäre, etwas Fichtenstreu zusammenzuharken.</p>
<p class="calibre3">Der Alte war zu Hause geblieben.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page219" title="lac/DaoH"></a> Schon vom
frühen Morgen an war er seltsam unverträglich und eigentümlich
mißgestimmt, so daß er nur nach einer Gelegenheit suchte, die
Unruhe und das Gift, die in ihm gärten, auf jemanden abzuschieben;
Witek hatte er schon durchgeprügelt, weil er vergessen hatte, den
Kühen frische Streu hinzuwerfen und weil sie bis zur Hälfte der
Flanken im Mist lagen; mit Antek hatte er sich gezankt; Anna hatte
er angeschrien wegen des Jungen, der auf allen Vieren vors Haus
gekrochen war und sich über und über mit Schmutz besudelt hatte;
selbst auf Fine hatte er losgehackt, daß sie allzulange trödelte
... und die Pferde auf sie warteten.</p>
<p class="calibre3">Und als er schließlich allein mit Gusche zurückgeblieben war,
die seit gestern da war, um aufs Vieh zu sehen, da wußte er schon
gar nicht mehr, was er mit sich anfangen sollte. Er brachte sich
ständig in Erinnerung, was ihm Ambrosius über den Empfang bei der
Dominikbäuerin erzählt hatte, und was Jagna gesagt hatte, trotzdem
hatte er in sich nicht die rechte Sicherheit und glaubte dem Alten
nicht recht, der für ein Glas Schnaps einen schon belügen konnte.
Er kroch in der Stube herum, sah durchs Fenster auf den leeren Weg,
oder guckte unruhig von der Galerie sogar auf Jagusch ihr Haus/und
erwartete das Dunkelwerden wie eine Erlösung ...</p>
<p class="calibre3">Hundertmal hatte er Lust, nach dem Schulzen zu laufen, um sie zu
treiben, daß sie doch eher gingen/aber er blieb daheim, da die
Augen Gusches, die überall hinter ihm her waren, ihn zurückhielten;
das waren zusammengekniffene Augen, die voll Hohn leuchteten und
sich lustig machten ...</p>
<p class="calibre3">»Das Hexenaas dreht mit ihren Glotzen an einem herum, wie mit
einem Bohrer!« dachte er.</p>
<p class="calibre3">Gusche aber machte sich in Haus und Hof mit dem Wocken unter dem
Arm zu schaffen und sah sich fleißig um, sie spann, daß die Spindel
in der Luft surrte, wickelte den Faden auf und ging weiter, zu den
Gänsen, zu den Schweinen/ nach dem Kuhstall, und Waupa trottete
schläfrig und <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page220" title="lac/DaoH"></a>
träge hinter ihr her. Sie redete den Alten nicht an, obgleich sie
gut wußte, was ihn so mitnahm und mißmutig machte, und ihn so
umhertrieb, daß er sich sogar entschloß, die Pflöcke an der
Hauswand einzuschlagen, die den Winterbelag der Wände stützen
sollten.</p>
<p class="calibre3">Sie blieb nur immer wieder bei ihm stehen und sagte
schließlich:</p>
<p class="calibre3">»Die Arbeit geht euch heut nicht gut vonstatten.«</p>
<p class="calibre3">»Ja, sie geht nicht. Gottverdamm mich! Sie geht nicht ...«</p>
<p class="calibre3">»Das wird hier noch 'ne Hölle geben, du lieber Jesus, das wird
was geben!« dachte sie im Weitergehen. »Der Alte hat recht, ganz
recht, daß er heiratet! Sonst würden ihm die Kinder so ein
Altenteil geben, wie meine mir!«</p>
<p class="calibre3">»Ganze zehn Morgen Feld hab' ich weggegeben, wie reines Gold,
und was hab' ich davon?« ... Sie spie aus vor Wut. »Lohnarbeit muß
ich tun, zu einer Kätnerin bin ich heruntergekommen! ...«</p>
<p class="calibre3">Der Alte aber, der nicht länger an sich halten konnte, schmiß
die Art zu Boden und rief aus:</p>
<p class="calibre3">»Für den Hund ist solche Arbeit!«</p>
<p class="calibre3">»Es sitzt euch was innen.«</p>
<p class="calibre3">»Es sitzt, es sitzt ...«</p>
<p class="calibre3">Gusche setzte sich auf die Wandbank, spann einen langen Faden,
wickelte ihn auf die Spindel und sagte leise, etwas ängstlich:</p>
<p class="calibre3">»Ihr habt doch keinen Grund, euch zu verdrießen und zu
sorgen.«</p>
<p class="calibre3">»Wißt ihr's denn?«</p>
<p class="calibre3">»Habt keine Angst, die Dominikbäuerin ist klug und Jagna hat
auch ihren Verstand.«</p>
<p class="calibre3">»Meint ihr!« rief er freudig und setzte sich zu ihr.</p>
<p class="calibre3">»Wieso denn, meine Augen hab' ich doch.«</p>
<p class="calibre3">Sie schwiegen lange, sich gegenseitig hinhaltend.</p>
<p class="calibre3">»Ladet mich zur Hochzeit ein, dann werd' ich euch ein solches
Hopfenlied <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#foot7" id="text7"><sup class="calibre6">F7</sup></a> singen,
daß gleich in neun Monaten <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page221" title="lac/DaoH"></a> Taufe ist ...,« fing sie spöttisch an; aber da sie
merkte, daß der Alte finster wurde, warf sie in einem anderen Tone
hin:</p>
<p class="calibre3">»Recht tut ihr schon, Matheus, das ist gewiß. Hätt' ich mir
damals einen genommen, als der Meine gestorben war, dann ständ' ich
heute nicht wie 'ne Kätnerin da, nein ... Dumm war ich, habe den
Kindern vertraut, bin auf den Altenteil gegangen, habe ihnen meinen
Grund und Boden abgeschrieben, und was denn nu? ...«</p>
<p class="calibre3">»Ich schreib' nicht eine einzige Feldparzelle ab!« sagte er
hart.</p>
<p class="calibre3">»Ihr habt Vernunft, daß ihr so redet, das habt ihr! Auf den
Gerichten habe ich mich herumschleppen müssen, da sind mir noch die
paar Silberlinge, die ich hatte, draufgegangen, und Gerechtigkeit
habe ich mir doch nicht damit gekauft ... und für die alten Tage
bin ich auf Lohnarbeit und auf Herumgestoßensein angewiesen! Daß
dies Aaszeug unterm Zaun verreckt für das, was sie mir angetan.
Sonntag bin ich hingegangen, um doch wenigstens das Haus mal zu
sehen und den Fruchtgarten, wo ich die Bäume noch alle selbst
gepfropft habe/da hat die Schwiegertochter das Maul auf mich
losgelassen, daß ich da spijenieren hingekommen bin. Du lieber Herr
Jesus! Zum Spijenieren auf meinem eignen Grund und Boden! Ich
dachte, ich sollte gleich totfallen, so hat mich das abgewürgt! Zu
Hochwürden bin ich gewesen, wenn schon nicht anders, daß er sie von
der Kanzel 'runtermacht, da hat er mir gesagt, daß der Herr Jesus
mich für dieses Unrecht belohnen wird! Natürlich, natürlich ...
wenn einer nichts hat, dann ist er gut für die Gnade vom Jesus, so
ist es schon ... aber immerhin hätt' ich lieber gemocht auf meinem
Grund und Boden herumzuwirtschaften, in der warmen Stube unterm
Federbett zu schlafen, fette Sachen zu essen und amesieren ...«</p>
<p class="calibre3">Und sie begann mit einem solchen Feuereifer auf alles zu
schimpfen, daß Boryna aufstand und fortging ins Dorf zum Schulzen
hin, da es ja auch schon schummerig wurde.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page222" title="lac/DaoH"></a> »Geht ihr
denn bald, was?«</p>
<p class="calibre3">»In diesem Augenblick noch, Simeon muß schon kommen.«</p>
<p class="calibre3">Er kam auch gleich, und sie gingen zusammen zur Schenke, um ein
Gläschen zu trinken und Arrak zum Brauttraktament mitzunehmen.
Ambrosius war schon da und schloß sich ihnen an, aber sie tranken
nur kurz, denn Matheus trieb sie an.</p>
<p class="calibre3">»Ich werde hier auf euch warten; und wenn sie euch Bescheid
trinken, dann bringt die Frauen gleich mit her,« rief er noch
hinterdrein.</p>
<p class="calibre3">Sie stapften so kräftig mittwegs vorwärts, daß der Schmutz nur
so aufsprang; die Dämmerung verdichtete sich und umhüllte die Welt
mit einem grauen, traurigen Gewebe, unter dem das ganze Dorf
versunken lag; nur hier und da begannen aus den Dunkelheiten die
Lichter auszublitzen, und die Hunde fingen auf den Heckenwegen an
zu bellen, wie gewöhnlich vor der Abendmahlzeit.</p>
<p class="calibre3">»Gevatter?« ließ sich nach einer Weile der Schulze
vernehmen.</p>
<p class="calibre3">»Häh?«</p>
<p class="calibre3">»Mir deucht, Boryna wird 'ne feine Hochzeit herrichten?«</p>
<p class="calibre3">»Herrichten, oder nicht herrichten!« sagte der andere hämisch,
denn er war von Natur aus ein Nörgler.</p>
<p class="calibre3">»Er wird schon eine herrichten! Der Schulze sagt euch das, da
könnt ihr's mir glauben. Wir werden schon aus ihnen ein solches
Paar drehen; haha, ihr werdet sehen.«</p>
<p class="calibre3">»Nur daß die Stute noch durchgehen wird, denn der Hengst, deucht
mir, hat schon Hanf im Schweif!«</p>
<p class="calibre3">»Das ist nicht eure Sache.«</p>
<p class="calibre3">»Hale ... Die Kinder werden auf uns fluchen ...«</p>
<p class="calibre3">»Es wird schon alles sein werden, das sag' ich euch, als
Schulze.«</p>
<p class="calibre3">Sie traten gleich darauf ins Haus der Dominikbäuerin ein.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page223" title="lac/DaoH"></a> Die fein
sauber gefegte Stube war schon erleuchtet/denn man erwartete sie
doch.</p>
<p class="calibre3">Die Brautbitter gaben Gott zum Gruß, nickten allen Anwesenden
zu, auch den Jungen, die in der Stube waren, setzten sich auf die
an's Herdfeuer gerückten Stühle und fingen von diesem und jenem an
zu reden.</p>
<p class="calibre3">»Eine Kälte ist das, als ob's schon zum Frost ginge,« begann der
Schulze das Gespräch und wärmte sich die Hände.</p>
<p class="calibre3">»Na, natürlich, zum Frühjahr geht's ja auch nicht, da kann man
sich nicht wundern!«</p>
<p class="calibre3">»Habt ihr schon den Kohl eingefahren, was?«</p>
<p class="calibre3">»Ih ... etwas ist da auf dem Kohlfeld nachgeblieben, aber jetzt
kann man ja nicht 'ran,« antwortete die Alte gelassen und folgte
mit den Augen der Jagna, die am Fenster das Garn auf eine Weise
doppelfädig haspelte und heut so wohlgeraten aussah, daß der
Schulze, noch ein junger Mann, sie mit begehrlichen Augen ansah/und
schließlich dergestalt anknüpfte:</p>
<p class="calibre3">»Da es so schlimmes Wetter und solch ein Schmutz und solche
Dunkelheit ist, so sind wir, ich und der Simeon, vom Wege zu euch
eingekehrt; ihr habt uns würdig empfangen, mit gutem Wort
bewirtet/so wollen wir von euch denn etwas einhandeln, Mutter
...«</p>
<p class="calibre3">»In der Welt kann man dies und jenes einhandeln, nur muß man
sich umtun danach ...«</p>
<p class="calibre3">»Wahr habt ihr geredet, Mutter; doch ist es uns nicht danach,
uns umzutun, denn bei euch, dünkt uns, sind wir am rechten
Ort.«</p>
<p class="calibre3">»Handelt man los,« rief sie vergnügt.</p>
<p class="calibre3">»Eine Färse würden wir so zum Beispiel vielleicht wollen.«</p>
<p class="calibre3">»Ho, ho! Die steht hoch im Preis; am ersten besten Schnürchen
wird sie schon nicht fortgeführt!«</p>
<p class="calibre3">»Aus geweihtem Silber bringen wir ein Schnürchen für sie mit und
aus solchem, daß selbst ein Drache das nicht zerreißen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page224" title="lac/DaoH"></a> könnte. Na, wieviel
denn, Mutter?« Und er fing an, die Flasche aus der Tasche
herauszuziehen ...</p>
<p class="calibre3">»Wieviel? Das ist nicht leicht zu sagen! Jung ist die noch, aufs
neunzehnte Frühjahr geht's ihr erst, und gut und arbeitsam, daß sie
noch paar Jahr bei der Mutter bleiben könnte ...«</p>
<p class="calibre3">»Ein müßiges Bleiben ist das/da kommt kein Zuwachs raus, das ist
ein müßiges Bleiben ...«</p>
<p class="calibre3">»Manch eine könnt' ihn auch leicht bei der Mutter schon haben!«
murmelte Simeon.</p>
<p class="calibre3">Der Schulze lachte schallend auf, und die Alte blitzte nur mit
den Augen und sagte rasch:</p>
<p class="calibre3">»Sucht euch eine andere, meine kann warten.«</p>
<p class="calibre3">»Natürlich kann sie das, aber wir finden keine schmuckere und
von keiner besseren Mutter!«</p>
<p class="calibre3">»Meint ihr! ...«</p>
<p class="calibre3">»Ich, der Schulze, sag es euch, da müßt ihr es glauben.« Er
holte ein Glas hervor, wischte es mit dem Rockschoß aus, goß Arrak
ein und sagte ernst: »Hört aufmerksam zu, Dominikbäuerin, was ich
euch sagen werde; ein Beamter bin ich, und mein Wort ist nicht wie
so 'n Vöglein, das hier mal pfeift und da mal piukt, und hast du
nicht gesehen! Und Simeon, das weiß man auch, wer der ist/kein
Landstreicher doch nicht, aber ein Hofbauer, Vater von Kindern und
Schultheiß! ... Versteht ihr, was für 'ne Personage zu euch
gekommen ist und wozu sie gekommen sind, versteht ihr das?«</p>
<p class="calibre3">»Ich versteh' schon recht, Peter, und weiß schon.«</p>
<p class="calibre3">»Eine kluge Frau seid ihr, da wißt ihr, daß die Jagusch früher
oder später mal aus dem Hause muß und auf ihr Eigenes, so hat es
schon Herr Jesus bestimmt, und die Eltern ziehen die Kinder für die
Welt groß, nicht für sich.«</p>
<p class="calibre3">»Das ist schon wahr, wahr, und du, Mutter/</p>
<p class="vers">Hüte, hege, pflege ...<br class="calibre2"/>
Und rück' noch Geld heraus.<br class="calibre2"/>
Nimmt sie dir einer aus dem Haus!«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page225" title="lac/DaoH"></a> »So ist es
schon in der Welt, das wird man auch nicht ändern. Vielleicht
trinken wir uns einen Tropfen zu, was, Mutter?«</p>
<p class="calibre3">»Was weiß ich denn? ... Zwingen werd' ich sie nicht, was,
Jagusch, willst du ihm Bescheid trinken? ...«</p>
<p class="calibre3">»Ih ... wie weiß ich ...,« pipste Jagna auf, das gerötete
Gesicht zum Fenster abdrehend.</p>
<p class="calibre3">»Gehorsam ist sie! Ein demütiges Kalb, wird von zwei Müttern
gesäugt ...,« warf Simeon ernst bei.</p>
<p class="calibre3">»In eure Hände, Mutter!«</p>
<p class="calibre3">»Trinkt in Gottes Namen; aber ihr habt noch nicht gesagt, wer es
ist:« sagte sie, da es nicht schicklich war, im voraus und aus
einem anderen Munde, als dem der Brautbitter, darüber Bescheid zu
wissen.</p>
<p class="calibre3">»Wer? Der Boryna selbst doch!« rief er, das Glas
herunterstürzend.</p>
<p class="calibre3">»Ein alter Witwer!« rief sie wie enttäuscht zurück.</p>
<p class="calibre3">»Alt! Beleidigt doch nicht den Herrgott! Alt, und hatte doch vor
kurzem noch eine Gerichtssache wegen Alimente!«</p>
<p class="calibre3">»Das ist wahr, aber es war doch nicht seins.«</p>
<p class="calibre3">»Wie sollte er auch, ein solcher Hofbauer und sich mit der
ersten besten einlassen! Trinkt Mutter ...«</p>
<p class="calibre3">»Trinken würd' ich schon, aber weil es doch man 'n Witwer ist,
und ein Alter ist ja näher dran, bei Abraham sein Bier trinken zu
müssen, und was dann? ... Die Kinder werden die Stiefmutter
'rausjagen und ...«</p>
<p class="calibre3">»Matheus sagte, daß eine Verschreibung wohl sein müßte,« brummte
Simeon.</p>
<p class="calibre3">»Vor der Hochzeit wohl noch!«</p>
<p class="calibre3">Die Brautbitter verstummten; erst nach einer Weile goß der
Schulze ein neues Glas voll und wandte sich damit nach Jagna.</p>
<p class="calibre3">»Trink' mal, Jagusch, trink' mal! Einen Eh'mann freien wir dir
zu, der ein Mann wie eine Eiche ist, Herrin wirst <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page226" title="lac/DaoH"></a> du sein, Hofbäuerin, die erste
im Dorf; nu, komm' mal, in deine Hände, Jagusch, brauchst dich
nicht zu schanieren ...«</p>
<p class="calibre3">Sie zögerte, wurde rot und drehte sich zur Wand hin; doch
schließlich, nachdem sie ihr Gesicht mit der Schürze verdeckt
hatte, trank sie einen kleinen Schluck und schüttete den Rest zu
Boden ...</p>
<p class="calibre3">Danach machte das Glas die Runde von einem zum andern. Die Alte
bot Brot und Salz an und gab noch schließlich geräucherte Dörrwurst
als Beigabe zum Schnaps.</p>
<p class="calibre3">Sie tranken ein paarmal der Reihe nach, daß ihnen allen die
Augen sich aufhellten und die Zungen locker wurden. Nur Jagna lief
davon nach ihrer Kammer, denn ein Weinen hatte sie gepackt, sie
wußte selbst nicht, warum; man konnte durch die Wand hindurch ihr
Schluchzen hören.</p>
<p class="calibre3">Die Alte wollte zu ihr laufen, aber der Schulze hielt sie
zurück.</p>
<p class="calibre3">»Auch das Kalb blökt, wenn man es von der Mutter absetzt ... die
Sache kennt man. Nicht in die Welt geht sie doch, nicht in ein
anderes Dorf, da werdet ihr euch noch dran freuen können ... Kein
Unrecht wird ihr passieren, ich, der Schulze, sag' es euch/glaubt
mir ...«</p>
<p class="calibre3">»Das schon ... nur habe ich immer gedacht, daß ich noch
Enkelkinder erleben sollte, zur Freude auf die alten Tage ...«</p>
<p class="calibre3">»Da sorgt euch nicht darüber, eh' noch die Ernte anfängt, werdet
ihr schon den ersten haben ...«</p>
<p class="calibre3">»Das weiß nur der Herr Jesus voraus, nicht wir schuldigen
Menschen! Getrunken haben wir, das ist schon wahr ... aber mir ist
so sonderlich schwer ums Herz, wie bei einem Begräbnis ...«</p>
<p class="calibre3">»Is auch kein Wunder, die einzige Tochter im Haus, da ist euch
noch ihr schon gleich bange ... Noch ein Schluck gegen den Kummer!
Wißt ihr was, wir gehen mitsammen zur Schenke, denn mir ist schon
der Branntwein ausgegangen und der Herr Bräutigam sitzt da und hat
schon Kohlchen unterm Hintern.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page227" title="lac/DaoH"></a> »Sollen wir
denn in einer Schenke Verlobung feiern?«</p>
<p class="calibre3">»Nach alter Sitte, wie es unsere Väter taten, ich der Schulze
hab' es euch gesagt/dann glaubt.«</p>
<p class="calibre3">Die Frauen zogen sich etwas festlicher an und bald gingen sie
alle zum Hause hinaus.</p>
<p class="calibre3">»Und die Jungen sollen denn die nicht mit? Der Schwester ihre
Verlobung ist für die doch auch ein Fest,« bemerkte der Schulze, da
die Burschen traurige Gesichter machten und unruhig auf die Mutter
blickten.</p>
<p class="calibre3">»Es ist schwer, das Haus nur Gottes Vorsehung zu
überlassen.«</p>
<p class="calibre3">»Ruft doch die Agathe von den Klembs, die wird schon hier
einhüten.«</p>
<p class="calibre3">»Agathe, die ist schon auf den Bettel gegangen. Man wird
jemanden unterwegs auffinden. Kommt nur, Jendschych, und du auch,
Schymek, zieht die Kapottröcke an; was denn, wollt ihr denn wie die
Lumpen gehen ... und wenn sich mir einer betrinkt ... dann soll er
was erleben. Die Kühe sind noch nicht besorgt, für die Schweine
müssen noch die Kartoffeln zerstoßen werden/denkt daran.«</p>
<p class="calibre3">»Wir denken, Mutter, wir denken!« flüsterten sie ängstlich,
obgleich sie schon lange Kerle bis fast an die Decke heran waren
und breit gewachsen, wie Birnbäume auf den Feldrainen, aber sie
gehorchten der Mutter, wie Halbwüchsige, weil sie sie mit eiserner
Hand an den Schöpfen hielt, und wenn es nötig war, ihnen selbst mal
über die Sitzgegend fuhr und nach den Zotteln langte oder
Maulschellen austeilte; aber Gehorsam und Achtung, das mußte
sein.</p>
<p class="calibre3">Sie gingen nach der Schenke.</p>
<p class="calibre3">Es war schon dunkle Nacht, daß man keine Hand vor Augen sah, wie
gewöhnlich in der Herbstregenzeit. Der Wind ging oben in den Lüften
und schlug auf die Kronen der Bäume ein, daß sie sich schüttelten
und aufrauschend auf die Zäune legten; der Weiher brauste und warf
sich so hin und her, daß zu Gischt zerstobene Spritzer auf die
Mitte <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page228" title="lac/DaoH"></a> des
Weges flogen und nicht selten den Gehenden ins Gesicht
peitschten.</p>
<p class="calibre3">Die Schenke war auch nicht sehr hell, der Wind blies durch eine
kleine eingedrückte Scheibe und ließ das Lämpchen, das an einer
Schnur über dem Schenktisch hing, hin und her schaukeln, wie eine
goldene Blume.</p>
<p class="calibre3">Boryna stürzte ihnen entgegen, um sie zu begrüßen und umarmte
und küßte sie mit plötzlicher Wärme, da er merkte, daß Jagusch
schon so gut wie sein war.</p>
<p class="calibre3">»Und Herr Jesus sagte: nimm dir armes Erdenwurm ein
Frauenzimmer, damit dir armseligem Tropf die Zeit nicht über werde
dahiero. Amen!« lallte Ambrosius, der schon über eine Stunde
getrunken hatte und nun natürlich mit der Zunge und auf den Beinen
nicht sicher war.</p>
<p class="calibre3">Der Jude stellte also gleich Arrak, süßen Schnaps und Essenz auf
die Tonbank, dazu Heringe, einen Safrankuchen und irgendwelche
seltsame Brezelchen mit Mohn.</p>
<p class="calibre3">»Eßt, trinkt, liebe Leute, leibliche Brüder, treue
Christenmenschen!« forderte Ambrosius auf. »Ich hatte auch mal eine
Frau, nur ich weiß schon gar nicht mehr wo ... in Frankreich glaub'
ich ... nein, in Italien war es, nein ... jetzt aber bin ich eine
alleinstehende Waise ... Ich sag' euch, rief da mal der Korporal:
Schließt euch zusammen!«</p>
<p class="calibre3">»Trinkt mal, Leute! Fangt an, Peter,« unterbrach ihn Boryna, der
für einen ganzen Silberling Karamelbonbons brachte und sie Jagna in
die Faust drückte. »Da, Jagusch, fein süß sind sie, da.«</p>
<p class="calibre3">»Hale ... ihr macht euch Schaden ...,« zierte sie sich.</p>
<p class="calibre3">»Fürcht' dich nicht ... ich kann's mir leisten, du wirst selbst
sehen ... da ... für dich würd' ich selbst Vogelmilch finden ... du
wirst schon bei mir nichts auszustehen haben ...« ... und er fing
an, sie um die Taille zu fassen und sie zum Essen und Trinken
aufzufordern. Jagna nahm alles ruhig, kalt und gleichgültig an, als
ob es nicht ihre Verlobung heute wäre. Nur an eines hatte sie
gedacht, ob der Alte <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page229" title="lac/DaoH"></a> wohl die Korallenschnüre, von denen er auf dem
Jahrmarkt gesprochen hatte, noch vor der Hochzeit hergeben
würde.</p>
<p class="calibre3">Sie fingen an, die Gläser dicht hintereinander zu leeren, Arrak
und Süßen umschichtig, und alle sprachen auf einmal, selbst die
Dominikbauerin hatte sich einen Ordentlichen angetrunken, und nu
mal schlankweg allerhand Verschiedenes auseinandergesetzt und
losgeredet, so daß der Schulze sich wunderte, was für eine kluge
Frau sie doch wäre.</p>
<p class="calibre3">Auch die Söhne hatten einen Festen sitzen, denn Ambrosius und
der Schulze tranken ihnen häufig zu und forderten sie auf.</p>
<p class="calibre3">»Trinkt, Jungen, ist doch Jagnas Versprechung, trinkt ...«</p>
<p class="calibre3">»Wir wissen, wir wissen,« antworteten sie zugleich und wollten
Ambrosius die Hand küssen. Schließlich zog die Dominikbäuerin
Boryna nach dem Fenster beiseite und sagte ohne Umschweife:</p>
<p class="calibre3">»Sie ist euer/die Jagusch, Matheus, euer.«</p>
<p class="calibre3">»Gott lohn's euch für die Tochter, Mutter.« Er griff sie um den
Hals und küßte sie.</p>
<p class="calibre3">»Ihr habt doch versprochen, eine Verschreibung zu machen,
was?«</p>
<p class="calibre3">»Verschreibung! Wozu Verschreibung, was mein ist, das ist auch
ihres ...«</p>
<p class="calibre3">»Hale, damit sie doch ein mutiges Auge hat vor den Stiefkindern,
daß sie sie nicht beschimpfen!«</p>
<p class="calibre3">»Die sollen sich bloß hüten! Alles ist mein, da ist es auch der
Jagusch ihr eigen.«</p>
<p class="calibre3">»Gott bezahl's euch, aber merkt zu, etwas älter seid ihr doch,
und jeder ist doch sterblich, denn</p>
<p class="vers">Der Tod wählt nicht lang,<br class="calibre2"/>
Nimmt hier einen Menschen/da ein Lamm<br class="calibre2"/>
Und morgen/bist selbst du nicht geborgen.«</p>
<p class="calibre3">»Noch bin ich rüstig, an die zwanzig Jahr halt' ich noch aus,
fürchtet euch nicht!«</p>
<p class="calibre3">»Den Fürchtenicht haben die Wölfe gefressen.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page230" title="gary/DaoH"></a> »Ich freu'
mich so, sagt, was ihr möchtet! Soll ich euch die drei Morgen neben
Lucas seinen abschreiben?«</p>
<p class="calibre3">»'ne Fliege ist dem Hund noch recht, wenn er hungrig ist/ wir
sind nicht hungrig. Jagusch fallen vom Vater her fünf Morgen zu und
wohl ein Morgen Wald ... verschreibt ihr auch sechs Morgen; die
sechs Morgen am Weg, wo ihr dieses Jahr Kartoffeln hattet.«</p>
<p class="calibre3">»Mein bestes Feld!«</p>
<p class="calibre3">»Ist vielleicht die Jagusch ein Ausschuß und nicht die Beste im
Dorf!«</p>
<p class="calibre3">»Natürlich, das ist sie, darum Hab' ich ja auch die Brautbitter
geschickt; aber, mein Gott, sechs Morgen, das ist ein mächtiges
Stück Land, eine ganze Wirtschaft. Was würden die Kinder dazu
sagen!« Er fing an, sich auf dem Kopf zu kratzen, denn es hatte ihn
ganz schmerzhaft gepackt; wie denn auch, so viel von der besten
Erde herzugeben!</p>
<p class="calibre3">»Ih du meine Güte, ihr seid doch auch klug, so leicht findet man
keinen zweiten wie ihr, ihr müßt doch selbst begreifen, daß eine
Verschreibung nur da ist, um das Mädchen sicherzustellen. Es wird
euch doch euer Leben lang von diesem Boden keiner etwas abmessen
und nehmen; und was Jagusch ihres ist, was ihr dem Recht nach vom
Vater zukommt, da wird man gleich zum Frühjahr einen Dmeter
bestellen und das ist dann schon euer, da könnt ihr schon säen ...
Begreift ihr, daß es nicht euer Nachteil ist, und die sechs Morgen
werdet ihr abschreiben.«</p>
<p class="calibre3">»Versteht sich, für Jagusch schreib' ich sie ab ...«</p>
<p class="calibre3">»Wann denn?«</p>
<p class="calibre3">»Kann auch morgen sein! Nein, Sonnabend bestellen wir das
Aufgebot und fahren gleich nach der Stadt. Was da, einmal muß die
Ziege sterben!«</p>
<p class="calibre3">»Jagusch, komm mal, Töchterchen, komm!« rief sie dem Mädchen zu,
dem der Schulze etwas auseinandersetzte und sie dermaßen an die
Tonbank drängte, daß sie aus vollem Halse lachte.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page231" title="gary/DaoH"></a> »Da
verschreibt dir der Matheus die sechs Morgen am Weg,« sagte
sie.</p>
<p class="calibre3">»Gott bezahl's euch,« murmelte sie, ihm die Hand
hinstreckend.</p>
<p class="calibre3">»Trinkt mal Jagna von diesem Süßen zu ...«</p>
<p class="calibre3">Sie tranken aus, Matheus faßte sie um und war im Begriff, sie
den Leuten vorzuführen, aber sie entglitt ihm und trat an die
Brüder heran, mit denen Ambrosius reformierte und trank.</p>
<p class="calibre3">In der Schenke erhob sich ein immer größeres Stimmengewirr, und
es wurde immer voller, denn dieser und jener, der die Stimmen
drinnen horte, trat herein, um nachzusehen, und manch einer
wiederum, um bei dieser Gelegenheit sich auf fremde Kosten einen zu
leisten; selbst der blinde Bettler, der sich vom Hund führen ließ,
fand sich ein und saß auf einer sichtbaren Stelle, horchte herum
und betete ein ums andere Mal laut und vernehmlich, bis sie ihn
merkten. Die Dominikbäuerin ging selbst zu ihm hin mit Schnaps und
Essen und drückte ihm ein paar Kupfermünzen in die Faust.</p>
<p class="calibre3">Sie hatten sich einen Tüchtigen angetrunken, so daß schon alle
durcheinander redeten, einander auf die Schultern klopften, sich
umfaßten und küßten, und ein jeder war dem andern Bruder und
Freund, wie gewöhnlich, wenn die Gläser dicht nacheinander
folgen.</p>
<p class="calibre3">Nur der Jude machte sich leise zu schaffen und stellte immer
neue Maße und Bierflaschen hin und schrieb mit Kreide an die Tür,
was jeder spendierte.</p>
<p class="calibre3">Und Boryna war vor Freude wie benebelt, trank, traktierte,
forderte auf, redete, wie man ihn selten reden gehört hatte und
strebte in einen fort nach Jagusch hin, sprach verliebtes Zeug auf
sie ein, strich ihr ums Mäulchen, und da es sich nicht schickte in
aller Leute Gegenwart sie zu umhalsen und abzuküssen, obgleich es
ihn mächtig danach gelüstete, so faßte er sie nur immer wieder um
die Taille und zog sie in eine dunkle Ecke.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page232" title="gary/DaoH"></a> Die
Dominikbäuerin hatte sich bald besonnen, daß es schon Zeit war,
nach Hause zu gehen, und begann die Söhne zu rufen, sich bereit zu
halten.</p>
<p class="calibre3">Schymek aber war schon regelrecht besoffen, so daß er auf die
Reden der Mutter nur den Gurt zurechtrückte, mit der Faust auf den
Tisch lostrommelte und schrie:</p>
<p class="calibre3">»Ein Hofbauer bin ich, hundsverdammt noch mal ... Wer Lust hat,
der kann gehen ... Will ich trinken, dann werd' ich trinken ...
Jude, Schnaps her!«</p>
<p class="calibre3">»Still, Schymek, still, sonst wird sie dich durchprügeln!«
jammerte Jendschych mit weinerlicher Stimme, er war auch schon
stark angetrunken, und hielt den Bruder am Kapottrock zurück.</p>
<p class="calibre3">»Nach Hause, Burschen, nach Hause!« zischte die Dominikbauerin
drohend.</p>
<p class="calibre3">»Ein Hofbauer bin ich! Wenn ich bleiben will, dann bleib' ich
und werde Schnaps trinken ... genug schon der mütterlichen
Regiererei ... und will sie nicht ... dann schmeiß' ich 'raus,
hundsverdammt noch mal ...«</p>
<p class="calibre3">Doch die Alte schlug ihn vor die Brust, daß es schallte; er kam
ins Wanken und wurde nüchtern; Jendschych setzte ihm die Mütze auf
und führte ihn hinaus. Die Luft hatte Schymek augenscheinlich
wieder benebelt, denn kaum war er ein paar Schritte gegangen,
torkelte er, klammerte sich an den Zaun und fing an zu schreien und
zu skandalieren.</p>
<p class="calibre3">»Ein Hofbauer bin ich, hundsverdammt noch mal ... mein ist der
Grund und Boden ... was mir paßt ... mache ich ... Branntwein
trink' ich ... Jude, Arrak her ... und will sie nicht ... schmeiß'
ich 'raus ...«</p>
<p class="calibre3">»Schymek! Um Gottes willen, Schymek, komm nach Hause, die Mutter
kommt schon!« jammerte Jendschych, und weinte helle Tränen.</p>
<p class="calibre3">Bald darauf kam auch die Alte mit Jagna und nahm die Söhne mit,
die sich inzwischen schon in die Haare gefahren waren und sich am
Zaun im Schmutz herumprügelten.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page233" title="gary/DaoH"></a> In der
Schenke wurde es, nachdem die Frauen gegangen waren, etwas stiller,
die Leute gingen langsam auseinander, so daß nur Boryna mit den
Brautbittern zurückblieb, außerdem noch Ambrosius und der Bettler,
der nun auch mittrank.</p>
<p class="calibre3">Ambrosius war schon gar nicht mehr bei Besinnung, stand mitten
in der Stube, sang und erzählte laut vor sich hin.</p>
<p class="calibre3">»Schwarz war er ... so schwarz wie ein Kochtopf ... er zielte
auf mich ... aber kannst mich wo treffen ... das Bajonett hab' ich
ihm in den Bauch gerannt ... 'rumgedreht hab' ich, daß es nur
geknackt hat ... das war der erste! ... Wir stehen ... und stehen,
da kommt der Kapitän angesetzt ... Jesus Christus! Der Kapitän
selbst! ... Jungens ... sagt er ... Leute ... sagt er.</p>
<p class="calibre3">Schließt zusammen! ... Schließt zusammen! ...« schrie er mit
einer gewaltigen Stimme, reckte sich kerzengerade und ging langsam
zurück und der Holzfuß stieß auf/»trinkt mir zu, Peter, trinkt ...
eine arme Waise bin ich ...« lallte er undeutlich von der Wand her,
an der er lehnte; er wartete aber nicht mehr ab, sondern sprang
gleich auf und ging hinaus /nur vom Weg aus drang seine heisere
Stimme herüber, denn er hatte zu singen begonnen ...</p>
<p class="calibre3">In die Schankstube trat der Müller, ein gewaltiger Kerl in
städtischer Kleidung, mit rotem Gesicht, weißhaarig und mit
kleinen, flinken Äuglein!</p>
<p class="calibre3">»Die Hofbauern trinken sich einen! Ho, ho, der Schulze und der
Schultheiß und Boryna! 'ne Hochzeit oder was!«</p>
<p class="calibre3">»Nichts anderes. Trinkt einen mit uns, Herr Müller, trinkt,«
schlug Boryna vor.</p>
<p class="calibre3">»Wenn das so ist, kann ich euch eine Neuheit sagen, daß ihr mit
einem Male nüchtern sein werdet!«</p>
<p class="calibre3">Sie starrten ihn mit geistesabwesenden Augen an.</p>
<p class="calibre3">»Nicht einmal eine Stunde ist es her, daß der Gutsherr den Hau
in der Wolfsschlucht verkauft hat!«</p>
<p class="calibre3">»Dieser Gauner, hundsverflucht! ... Verkauft, unsern <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page234" title="Konmax/DaoH"></a> Wald verkauft!«
schrie Boryna auf und schleuderte außer sich die erste beste
Flasche zu Boden.</p>
<p class="calibre3">»Verkauft hat er! Das Recht ist auch für den Gutsherrn, und für
jeden ist das Recht...,« lallte der völlig betrunkene Simeon.</p>
<p class="calibre3">»Das ist nicht wahr! Ich, der Schulze sag' es euch, daß es nicht
wahr ist, dann glaubt's!«</p>
<p class="calibre3">»Verkauft kann er ihn haben, nur daß wir ihn nicht hergeben, so
wahr ein Gott im Himmel ist, geben tun wir ihn nicht!« rief Boryna
und hämmerte mit der Faust auf den Tisch ...</p>
<p class="calibre3">Der Müller ging davon, sie aber beratschlagten noch bis tief in
die Nacht hinein und drohten nach dem Herrenhof hinüber.</p>
<ol class="calibre7"><li class="calibre8"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#text7" id="foot7"><span class="pcalibre5 pcalibre4 footnote"><span class="spaced">Das
Hopfenlied:</span> Ein uraltes polnisches, recht anzügliches und
derbes Hochzeitslied, das der Braut nach der Trauung von älteren
verheirateten Frauen gesungen wird. Es ist ein an ausgelassensten
Varianten reicher Chorus der Erfahrenen, die sich in allerlei
Ratschlägen und gepfefferten Enthüllungen ergehen.</span></a></li>
</ol>
<p class="pcalibre6 initial1">Ein paar Tage waren vergangen,
seit Jagusch versprochen war.</p>
<p class="calibre3">Die Regenfälle hatten aufgehört, die Wege waren angetrocknet und
etwas froststeif geworden, das Wasser hatte sich verlaufen, so daß
nur in den Ackerfurchen, hier und da in den Niederungen und auf den
Mooren trübe Lachen, wie verweinte Augen, glasten ...</p>
<p class="calibre3">Allerseelen kam, grau, sonnenlos und tot, nicht einmal der Wind
wühlte in den vertrockneten Stauden, und schüttelte die Bäume
nicht, die schwer über die Erde gebeugt dastanden ...</p>
<p class="calibre3">Eine schmerzliche, dumpfe Stille lastete auf der Welt.</p>
<p class="calibre3">Und in Lipce tonten schon vom Morgen an die Glocken langsam und
unaufhörlich/leidschwere, klagende Töne begannen über den im Nebel
liegenden, leeren Feldern aufzustöhnen, und riefen mit düsterer
Trauerstimme in den trüben Tag hinein/in jenen Tag, der sich blaß
erhoben hatte, in Nebel verhüllt bis weit in die unerreichbaren
Fernen, bis weit in jene Grenzenlosigkeit des Himmels und der
Erde/dunstblau, wie eine unergründliche Wassertiefe.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page235" title="Konmax/DaoH"></a> Von der
Morgenröte im Osten her, die noch blaß glimmte, wie gerinnendes
Kupfer, begannen unter den blaugrauen Wolken hin Schwärme von
Dohlen und Krähen dahinzuflitzen ...</p>
<p class="calibre3">Sie zogen hoch, hoch, daß man sie kaum mit dem Auge erkennen
konnte, daß man kaum mit dem Ohr dieses wilde, klagende Gekrächze
und Geschrei unterscheiden konnte, das dem Gestöhn der Herbstnächte
ähnlich war.</p>
<p class="calibre3">Und die Glocken läuteten immerzu.</p>
<p class="calibre3">Der düstere Hymnus ergoß sich schwer in die tote, stumpfe Luft,
sank in Klagelauten auf die Felder nieder, dröhnte trauervoll durch
die Dörfer und Wälder/floß durch die ganze Welt, so daß Menschen,
Felder und Dörfer nur ein einziges großes Herz zu sein schienen, in
dem wehmütige Klage pochte ...</p>
<p class="calibre3">Die Vögelzüge fluteten in einem fort dahin; Staunen und Angst
erweckte ihr Anblick, denn sie zogen immer tiefer und in immer
größeren Schwärmen, so daß sie auf dem Himmel wie verwehte
Rußflocken zu sehen waren; das dumpfe Rauschen ihrer Flügel und
ihrer Rufe steigerte sich, wurde mächtiger und brauste wie ein
nahender Sturm ... Sie kreisten über dem Dorf und flatterten über
den Feldern, wie ein Haufen Blätter, den die Windsbraut
emporgerissen hatte, sie gingen in die Wälder nieder, hängten sich
an die nackten Pappeln, besetzten die Kirchenlinden, die Bäume auf
dem Friedhof, die Obstgärten, die Firste der Hütten und selbst die
Zäune ... bis sie, durch das ununterbrochene Dröhnen der Glocken
aufgescheucht, emporflatterten und in einer schwarzen Wolke
waldwärts zogen ... und das scharfe durchdringende Rauschen zog
ihnen nach.</p>
<p class="calibre3">»Ein schwerer Winter kommt,« sagten die Leute.</p>
<p class="calibre3">»Sie ziehen nach den Wäldern, das gibt sicherlich bald
Schnee.«</p>
<p class="calibre3">Und das Volk trat immer zahlreicher vor die Hütten, denn niemals
waren noch so viel Vögel zusammen gesehen worden <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page236" title="Konmax/DaoH"></a> /lange blickte ihnen alles
mit seltsamem Bangen nach, bis sie in die Wälder versanken. Man
starrte, seufzte schwer, dieser oder jener machte das Zeichen des
Kreuzes auf die Stirn zum Schutz gegen das Böse, und sie fingen an,
sich zum Kirchgang anzukleiden und hinauszutreten, denn die Glocken
stöhnten dumpf ... immerzu, und es kamen schon aus den anderen
Dörfern Leute des Wegs. Sie tauchten aus dem Nebel auf den
Fußstegen und Feldpfaden auf.</p>
<p class="calibre3">Zehrende Trauer fiel auf alle Seelen; eine eigentümlich
schmerzliche Stille umspann die Herzen/die Stille wehmütigen
Sinnens und eines Gedenkens jener, die schon dort hingegangen
waren, unter die überhängenden Birken und die schwarzen, gebeugten
Kreuze.</p>
<p class="calibre3">»Oh, du mein lieber Jesu! Mein Jesu!« seufzten sie und hoben
ihre Gesichter, fahl wie die Erde, empor, und tauchten
unerschrockene Augen in das Geheimnis, und gingen ruhig hin, Opfer
und Gebete für die Toten zu bringen.</p>
<p class="calibre3">Das ganze Dorf war wie ertrunken in dieser schweren,
wehmutsvollen Stille/nur die ängstlichen Bittgesänge der Bettler
klangen zuweilen von der Kirche herüber.</p>
<p class="calibre3">Auch auf dem Borynahof war es stiller wie gewöhnlich/ obgleich
dort drinnen die Hölle auf der Lauer saß, bereit bei der ersten
besten Gelegenheit hervorzubrechen...</p>
<p class="calibre3">Es mußte ja ..., denn die Kinder wußten schon alles.</p>
<p class="calibre3">Und am gestrigen Sonntag war das erste Aufbot des Alten mit
Jagusch herausgekommen ...</p>
<p class="calibre3">Am Sonnabend waren sie nach der Stadt gewesen, wo Boryna ihr
beim Notar sechs Morgen abgeschrieben hatte ... Er war spät und mit
einem zerkratzten Gesicht nach Hause gekommen, denn da er etwas
angetrunken war, wollte er schon auf dem Wagen Jagusch nehmen, und
kriegte gerade so viel, wie sie mit Faust und Krallen ihm
verabfolgt hatte.</p>
<p class="calibre3">Zu Hause sprach er mit keinem, obgleich ihm Antek immerzu unter
die Augen kam; er legte sich gleich schlafen, so wie er stand, in
den Stiefeln und im Schafpelz ... so daß <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page237" title="lesebaer/Wunibald"></a> am nächsten Morgen Fine
gegen ihn zu murren anfing, er hätte das Federbett mit Schmutz
beschmiert.</p>
<p class="calibre3">»Still, Fine, still! Das passiert schon manch einem, der sonst
nie Schnaps trinkt...,« sagte er lustig und ging gleich am frühen
Morgen zu Jagna, dort saß er bis in die späte Nacht, so daß sie mit
dem Mittagessen und Abendbrot vergeblich auf ihn gewartet
hatten.</p>
<p class="calibre3">Auch heute war er spät aufgestanden, denn es war schon lange
nach Sonnenaufgang, hatte den besten Knierock übergezogen, befahl
Witek, die guten Stiefel mit Schmer einzuschmieren und neue
Stroheinlage dafür zurechtzuschneiden/ Jakob hatte ihn rasiert, er
hatte sich seinen Gurt umgewickelt, setzte den schwarzen Hut mit
der roten Kokarde auf und sah ungeduldig zum Fenster hinaus auf die
Frontgalerie, wo Anna ihren Jungen lauste; er wollte ihr nicht
begegnen. Schließlich hatte er es doch erspäht, daß sie auf einen
Augenblick in die Stube gegangen war, und schob heimlich hinaus
zwischen die Hecken./So viel nur gerade hatten sie ihn an diesem
Tag zu sehen bekommen...</p>
<p class="calibre3">Fine weinte den ganzen Tag herum und irrte in der Stube hin und
her wie ein gefangener Vogel! Antek aber glühte in immer
schmerzlicheren und grausameren Qualen/ er aß nicht, schlief nicht,
es wollte ihm nichts gelingen; betäubt und gänzlich geistesabwesend
war er noch und wußte nicht, was ihm geschehen war. Auf seinem
Gesicht lagerten tiefe Schatten, so daß die Augen noch größer
wurden und glasig glühten, wie durch Stein gewordene Tränen/mit
zusammengebissenen Zähnen, um nicht laut zu schreien und zu
fluchen, wanderte er in der Stube herum, und dann ums Haus. Oder er
ging in den Heckenweg, auf die Dorfstraße, kehrte um, ließ sich auf
die Bank in der Galerie fallen und saß, stundenlang vor sich
hinbrütend und ganz ertrunken im Schmerz, der immer noch in ihm
wuchs und ihn immer stärker packte.</p>
<p class="calibre3">Das Haus lag stumm, nur Weinen, Aufstöhnen und <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page238" title="lesebaer/Wunibald"></a> Seufzer ertönten
darin, wie nach einem Begräbnis. Die Türen von den Ställen standen
sperrangelweit auf, so daß das Vieh sich im Obstgarten herumtrieb
und in die Fenster guckte; aber niemand war da, der es eingetrieben
hätte, nur der alte Waupa versuchte, es bellend zusammenzutreiben/
aber vergeblich, er konnte es nicht bewältigen.</p>
<p class="calibre3">Im Stall reinigte Jakob ein Gewehr auf der Pritsche und Witek
sah mit andächtigem Staunen zu und lugte durch das enge
Fensterchen, damit man sie nicht überraschte...</p>
<p class="calibre3">»Hat das einen Knall gegeben, Jesus!/Ich dachte, daß der
Gutsherr oder der Förster schießen ...«</p>
<p class="calibre3">»Hale... jawohl... ich habe lange nicht mehr geschossen, tüchtig
hatte ich es geladen und 'n Donner hat es gegeben, wie aus einer
Kanone...«</p>
<p class="calibre3">»Seid ihr wohl gleich am Abend hingegangen?«</p>
<p class="calibre3">»Ja, aufs Gutsfeld beim Wald bin ich hingegangen, denn da lieben
die Ricken auf die Wintersaat hinauszukommen... Es war dunkel, da
hab' ich denn lange gesessen ... und plötzlich beim Morgengrauen
kommt ein guter Bock... Ich hab' mich so hingekauert, daß er nur
fünf Schritt von mir ab war... ich habe nicht geschossen, weil er
furchtbar groß war, wie ein Ochs ... da denk' ich ... mit dem wirst
du nicht fertig ... Ich habe ihn durchgelassen ... und so in ein
Paternoster oder in zwei... kamen die Ricken heraus ... Ich hab'
mir die beste ausgesucht... und kaum daß ich anlege, da gibt es
einen Knall! Tüchtig hab' ich geladen, ha, der Arm ist mir
geschwollen, so hat mich der Kolben gestoßen ... aber sie ist
umgefallen ... nur mit den Füßen hat sie noch gezappelt... wie
sollte sie nicht auch ... 'ne halbe Handvoll Blei hat sie in die
Seite gekriegt... und geblökt hat das Vieh... daß ich Angst hatte,
der Förster könnte es hören; abschlachten mußt' ich sie
noch...«</p>
<p class="calibre3">»Ist sie im Walde geblieben, was?« fragte der Junge, ganz
erhitzt durch die Erzählung.</p>
<p class="calibre3">»Sie ist geblieben, wo sie geblieben ist, das ist nicht deine
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page239" title="lesebaer/Wunibald"></a>
Sache, und sagst du einem wenn auch nur ein kleines Wort, dann
sollst du sehen, was ich dir mache...«</p>
<p class="calibre3">»Wenn ihr verbietet, dann sag' ich auch nichts, aber Fine, der
kann man doch?«</p>
<p class="calibre3">»Hale, damit es das ganze Dorf gleich zu wissen kriegt, da hast
du einen Groschen, kauf' dir was ...«</p>
<p class="calibre3">»Nein, ich sag' es auch so nicht, nur nehmt mich mal mit, mein
guter, goldener...«</p>
<p class="calibre3">»Frühstücken!« rief Fine vorm Haus.</p>
<p class="calibre3">»Nur still sein, dann nehm' ich dich schon mal mit, das tu'
ich!«</p>
<p class="calibre3">»Und laßt ihr mich nur ein einziges Malchen einen Schuß machen,
wollt ihr, hm?« flehte er.</p>
<p class="calibre3">»Na... das Pulver, denkst du, Dummer, kriegt man umsonst...«</p>
<p class="calibre3">»Geld hab' ich, Jakob, hab' ich schon, noch vom Jahrmarktstag
her, da hat mir der Bauer zwei Silberlinge geschenkt, die ich für
Seelengebete aufbewahrt habe, diese...«</p>
<p class="calibre3">»Schön, schön, ich will es dir lernen,« murmelte er und strich
dem Burschen über den Kopf... so hatte ihm dieser durch sein
Betteln das Herz gewonnen...</p>
<p class="calibre3">Einige Paternoster nach dem Frühstück waren schon beide auf dem
Weg zur Kirche. Jakob humpelte rüstig voraus und Witek war etwas
zurückgeblieben, weil es ihn genierte, daß er keine Stiefel hatte
und barfuß gehen mußte.</p>
<p class="calibre3">»Und darf man denn barfuß in die Sakristei, was?« fragte er
leise.</p>
<p class="calibre3">»Dummerjahn. Herr Jesus wird wohl auf fremde Stiefel achtgeben,
anstatt auf das Gebet...«</p>
<p class="calibre3">»Das schon wohl, aber in Stiefeln schickt es sich doch
besser...,« flüsterte er betrübt.</p>
<p class="calibre3">»Stiefel wirst du dir auch noch mal kaufen, das wirst du
schon...«</p>
<p class="calibre3">»Die kauf' ich, Jakob, die will ich kaufen. Wenn ich nur erst
groß bin und ein Knecht bin, dann fahre ich gleich <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page240" title="Monne3/horst48"></a> nach Warschau und werde
mich zu den Pferden verdingen .. und in der Stadt, da gehen sie
schon alle in Stiefeln, nicht, Jakob?«</p>
<p class="calibre3">»Natürlich, natürlich!/und was weißt du denn davon?«</p>
<p class="calibre3">»Und wie noch!/Fünf Jahre war ich da, als sie mich aus Kozlow
brachten, da weiß ich's noch gut ... jawohl, 'ne Kälte war es ...
zu Fuß gingen wir zur Arbeit an der Maschine ... ich weiß noch ...
und die vielen hellen Lichter ... ich seh' noch wie das flimmert
... ich weiß ... ein Haus neben dem andern, und solche großen, da
sind die Kirchen nichts dagegen ...«</p>
<p class="calibre3">»Was du nicht zusammenschnackst!« warf ihm Jakob verächtlich zu
...</p>
<p class="calibre3">»Ich weiß gut, Jakob ... die Dächer könnt' ich doch nicht sehen
... und die vielen Kutschen ... Fenster bis zur Erde ... jawohl ...
ganze Wände waren, glaub' ich, aus Glas ... und in einem fort ein
solches Läuten ...«</p>
<p class="calibre3">»Natürlich, was sollte denn das sonst für Läuten sein?«</p>
<p class="calibre3">»So viele Kirchen, das ist kein Wunder!«</p>
<p class="calibre3">Sie schwiegen, denn sie waren schon auf dem Kirchhof und fingen
an, sich durch die dichte Menschenschar durchzudrängen, die die
Kirche ringsum belagerte, weil drinnen nicht genug Platz war.</p>
<p class="calibre3">Die Bettler hatten vom Haupteingang bis weit auf die Dorfstraße
hinaus eine Gasse gebildet und jeder machte sich auf seine Art
bemerkbar, schrie und betete laut und bettelte um Unterstützung,
und manche strichen die Geige und stimmten Lieder mit klagender
Stimme an, andere spielten Flöte oder auf der Ziehharmonika, und es
war ein Lärm, daß es in den Ohren gellte ...</p>
<p class="calibre3">In der Sakristei standen die Leute so dicht gedrängt, daß um den
Tisch herum, an dem der Organist Gaben für die Seelenfürbitten
empfing, den Menschen fast die Rippen krachten; an einem anderen
Tisch aber saß sein Sohn, der Jascho, derselbe der die höheren
Schulen durchmachte.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page241" title="lesebaer/gary"></a> Jakob
hatte sich zuerst durchgedrängt und überreichte dem Organisten eine
nicht kleine Liste von Namen. Dieser vermerkte sich alle Namen und
nahm für jede Seele drei Kopeken oder auch, wenn einer kein parates
Geld hatte, drei Eier.</p>
<p class="calibre3">Witek blieb etwas zurück, da man ihm tüchtig auf die bloßen Füße
getreten hatte, aber er drängelte vorwärts so gut er konnte,
obgleich manch einer aufmurrte, daß er sich unter die Ellenbogen
drücke und den älteren Leuten den Weg vertrete; das Geld hielt er
fest in der Faust/erst als sie ihn bis vor den Tisch hingeschubst
hatten, gerade auf den Organisten zu, versagte ihm die Zunge ...
Wie denn auch, um ihn herum nichts als Hofbauern und Hofbäuerinnen,
fast das ganze Dorf, auch die Müllerin im Hut, wie eine Gutsherrin,
und die Schmiedsleute und der Schulze mit der Seinen ... und alle
sehen ihn an ... hören zu ... und zählen sich laut die
verschiedenen Seelen vor ... und geben jeder zehn, zwanzig Namen
auf ... für die ganze Familie ... für Väter, Großeltern und Urahnen
... Und er, was? ... Weiß er denn, wer seine Mutter ist? Wer der
Vater? Weiß er das? ... Hat er denn einen, für den er hier was
geben kann? Mein Jesu! Oh du mein Jesulein... er stand da mit weit
aufgerissenem Mund und großen himmelblauen Augen, hilflos, wie ein
richtiger Dummerjahn ... Das Herz hatte sich ihm im Leibe gekrümmt
vor lauter Pein, so daß er kaum japste, kaum Atem holen konnte ...
und so bang wurd' es ihm im Leibe, als ob er schon den letzten
Hauch lassen sollte ... aber er blieb nicht so stehen, denn man
hatte ihn in die Ecke unter das Weihwasserbecken zurückgeschoben.
Er stützte sich mit seinem jungen Kopf gegen die Zinnschüssel, um
nicht zu fallen, und die Tränen liefen wie Perlenschnüre aus seinen
Augen ... wie Rosenkränze des Schmerzes ... Vergeblich versuchte er
sie zurückzuhalten ... es war umsonst ... und es war in ihm ein
solches Beben, daß es ihn in allen seinen jungen Knochen
schüttelte, daß er weder gerade stehen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page242" title="Monne3/gary"></a> noch die Zähne zusammenkriegen
konnte; er hockte sich in der Ecke nieder, abseits von den
Menschenblicken und weinte herzhafte Tränen eines verlassenen
Waisenkindes ...</p>
<p class="calibre3">»Mütterchen! Mütterchen!« wimmerte etwas in ihm und zerriß ihm
die Seele bis in alle Gründe. Und er konnte es nicht fassen und es
sich nicht erklären, warum denn alle Väter haben, Mütter haben, und
er allein nur Waise ist, er allein nur, er allein ...</p>
<p class="calibre3">»Jesu, mein Jesu! ...« schluchzte er und klagte, wie ein
Vöglein, das von den Netzen gewürgt wird. Erst Jakob fand ihn
wieder und rief ihm zu:</p>
<p class="calibre3">»Witek, hast du denn schon für Seelenfürbitten gegeben?«</p>
<p class="calibre3">»Nein,« antwortete er, riß sich plötzlich empor, trocknete die
Augen und schritt entschlossen nach dem Tisch hin ... jawohl, auch
er wird Namen aufgeben ... was brauchen sie zu wissen, daß er
niemanden hat ... wozu ... daß er Waise ist, weiß er für sich
allein genug ... und daß er ein Findelkind ist, nun dann ist er
eben eins ... Selbstsicher ließ er die Augen in die Runde wandern
und gab mit fester Stimme die Namen: Josepha, Marianne und Anton
auf, die ihm als erste einfielen ...</p>
<p class="calibre3">Er bezahlte, nahm den Rest und betrat mit Jakob die Kirche, um
ein Gebet zu sprechen und zuzuhören, wie der Priester auch die
Namen seiner Seelen aufrufen würde ...</p>
<p class="calibre3">Mitten in der Kirche stand ein Katafalk mit einem Sarg darauf,
der mit hell brennenden Lichtern umstellt war, der Priester las von
der Kanzel herab unzählige Namens-Verzeichnisse vor ... und wenn er
sich einmal unterbrach, antwortete ihm das laute Gebet, daß alle
für die Seelen, die im Fegefeuer weilen, sprachen.</p>
<p class="calibre3">Witek kniete neben Jakob hin, der einen Rosenkranz unter dem
Rock hervorzog und alle Aves und Credos abzubeten begann, die der
Priester verordnet hatte. Auch er sprach ein und das andere Gebet,
aber die eintönigen Stimmen der <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page243" title="lesebaer/gary"></a> Betenden, die Wärme und die Erschöpfung
nach dem Weinen hatten ihn müde gemacht, so daß er sich etwas gegen
die Hüfte Jakobs stützte und einschlief ...</p>
<p class="center">— — — — —</p>
<p class="calibre3">Nachmittags zogen zur Vesperandacht, die einmal im Jahr in der
Friedhofskapelle abgehalten wurde, alle Borynaleute hinaus.</p>
<p class="calibre3">Es gingen die Anteks mit den Kindern, es gingen die
Schmiedsleute, es ging Fine mit Gusche und zuletzt humpelte Jakob
neben Witek/um diesen Festtag bis zur Neige auszukosten.</p>
<p class="calibre3">Der Tag schloß schon die grauen, müden Lider, erlosch und
versank langsam in die erschreckenden, trüben Abgründe der
Dunkelheiten; der Wind regte sich und begann stöhnend über die
Felder zu ziehen, er warf sich zwischen die armseligen Bäume und
blies mit dem scharfen, faulichten Atem des Herbstes.</p>
<p class="calibre3">Still war es, eine seltsam düstere Allerseelenstille; die Menge
ging des Wegs im strengen Schweigen, nur das dumpfe Aufstampfen der
Füße ließ sich vernehmen, nur die Bäume am Weg schaukelten unruhig,
und das leise, schmerzliche Rauschen der Zweige zitterte über den
Häuptern, nur das Musizieren der Bettler und die Bettelgesänge
schluchzten in der Luft und zerfielen ohne Widerhall.</p>
<p class="calibre3">Vor dem Tor und selbst schon zwischen den Grabhügeln an der
Friedhofsmauer standen Reihen von Fässern, wie man sie sonst für
die Salzlauge gebraucht, und um sie herum machten sich Scharen von
Bettlern breit.</p>
<p class="calibre3">Das Volk flutete auf der ganzen Breite des Wegs, unter den
Pappelbäumen dem Friedhof zu; in der Dämmerung, die die Welt wie
mit grauer Asche bestreut hatte, blinkten die Lichter der kleinen
Kerzen, die einzelne bei sich hatten, und schaukelten die gelben
Flämmchen der Öllampen, und jeder zog vor dem Eintritt ein Brot,
einen Käse, ein Stückchen Speck oder Wurst aus seinem Bündel
hervor, oder auch eine <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page244" title="lesebaer/gary"></a> Haspel Garn, oder eine Handvoll gekämmten
Flachses, einen Kranz getrockneter Pilze,... sie legten alles
andächtig in die Fässer hinein. Einige davon waren für den Priester
bestimmt; für den Organisten und für Ambrosius standen auch welche
da, und der Rest war für die Bettler. Und wer nichts hineinlegte,
der drückte etwas Geld in die ausgestreckten Hände der Armen ...
und flüsterte die Namen der Verstorbenen, für die er um eine
Fürbitte bat... Der Chorus von Gebeten, Gesängen, von aufgezählten
Namen erhob sich immerzu mit einem klagenden Klang weit über die
Friedhofspforte hinaus; die Leute gingen vorüber, gingen weiter,
zerstreuten sich zwischen die Grabhügel, so daß bald
Johanniswürmchen gleich Lichtlein hier und da aus der Dunkelheit,
aus dem Dickicht der Bäume aus den vertrockneten Gräsern
aufzuglimmen und zu flimmern begannen.</p>
<p class="calibre3">Das dumpfe, ängstlich gedämpfte Flüstern der Gebete bebte durch
die Stille, die dicht über der Erde lag; manchmal riß sich ein
schmerzliches Schluchzen von den Grabhügeln los, und manches Mal
rankte sich zwischen den Kreuzen hindurch ein jammervolles
Weheklagen und stieg auf in herzzerreißenden Windungen; oder ein
jäher, kurzer, verzweiflungsvoller Schrei fuhr wie ein Blitz durch
die Luft, und Kindergewimmer klang aus den dämmerigen Dickichten,
wie das Zirpen verwaister Vögel im Nest.</p>
<p class="calibre3">Zuweilen senkte sich dumpfes, schweres Schweigen auf den
Friedhof, so daß man nur das düstere Rauschen der Bäume hörte; die
Stimmen waren verhallt und nur noch in die fernen Himmel stieg ein
Echo von all dem Weinen, all den Klagen und bangen Rufen und zog
hoch über die weite Welt dahin ...</p>
<p class="calibre3">Die Menschen bewegten sich nur noch lautlos zwischen den Gräbern
umher, flüsterten ängstlich und schauten voll Bangen in die
nachtverhüllte, unergründliche Weite ...</p>
<p class="calibre3">»Jeder muß sterben!« seufzten sie schwer mit starrer Ergebung
und schleppten sich weiter, ließen sich an den Gräbern <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page245" title="lesebaer/gary"></a> der Väter
nieder, sprachen Gebete, oder saßen stumm und versunken da, taub
auf die Sprache des Lebens, taub auf die Sprache des Todes, taub
gegen die Stimme des Schmerzes/den Bäumen ähnlich, und wie die
Bäume bebten ihre Seelen im traumhaften Gefühl der Angst...</p>
<p class="calibre3">»Mein Jesus! Barmherziger Herr, Maria!« entströmte es der
Wirrnis ihrer gequälten Seelen, und fahl, wie das Antlitz der
Mutter Erde, hoben sich ihre erstarrten und erschöpften Gesichter;
ihre grauen Augen, die wie die Lachen waren, die aus der Dämmerung
noch weißlich starren, hefteten sie auf die Kreuze, und mit
Bewegungen, rote das traumbefangene Wanken der Baume, ließen sie
sich auf die Knie fallen; Christus zu Füßen legten sie ihre
geängsteten Herzen nieder und brachen in das heilige Weinen der
Hingabe und Ergebung aus.</p>
<p class="calibre3">Jakob und Witek gingen mit den anderen herum, und als es
gänzlich dunkel wurde, wandte sich Jakob nach dem im Hintergrunde
liegenden alten Friedhof.</p>
<p class="calibre3">Dort zwischen den verfallenen Gräbern war es still, leer und
düster/dort lagen die Vergessenen, an die alle Erinnerung längst
gestorben war/wie ihre Tage, wie ihre Zeiten, und wie alles, was zu
ihnen gehörte; es ließen dort nur irgendwelche Vögel ihre
unheimlichen Schreie vernehmen, das Dickicht raschelte dort
traurig, und hier und da ragte ein vermodertes Kreuz./Dort lagen
ganze Geschlechter, ganze Dörfer, ganze Generationen hingemäht/dort
betete schon niemand mehr, man weinte dort nicht und brannte keine
Lämpchen ... Der Wind nur heulte da in den Ästen, riß die letzten
Blätter von den Zweigen und schleuderte sie in die Nacht der
endgültigen Vernichtung zu ... Dort stießen sich nur Stimmen, die
keine Stimmen waren, und Schatten, die doch keine Schatten waren,
gegen die nackten Bäume, wie erblindete Vögel, und schienen um
Erbarmung zu winseln.</p>
<p class="calibre3">Jakob holte ein paar ersparte Brotschnitten hervor, riß sie in
Brocken, kniete nieder und warf sie über die Grabhügel. <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page246" title="lesebaer/gary"></a></p>
<p class="calibre3">»Esse, christliche Seele, die ich dich zu dieser Abendzeit
anrufe, esse, menschliche Büßerin, esse!« flüsterte er ganz
hingenommen.</p>
<p class="calibre3">»Nehmen sie es denn?« fragte Witek leise mit geängsteter
Stimme.</p>
<p class="calibre3">»Versteht sich! Der Priester läßt es nicht zu, sie zu füttern!
... Manch einer legt was in die Tonnen, aber die Armen haben nichts
davon ... dem Pfarrer seine Schweine und den Bettlern ihre haben
ihren Fraß davon ... und die büßenden Seelen leiden Hunger ...«</p>
<p class="calibre3">»Werden sie auch kommen? ...«</p>
<p class="calibre3">»Fürcht' dich nicht ... alle, die im Fegefeuer Qualen leiden ...
alle. Herr Jesus läßt sie an diesem Tage die Erde betreten, damit
sie die Ihren besuchen ...«</p>
<p class="calibre3">»Damit sie die Ihren besuchen!« wiederholte Witek mit einem
Gruseln.</p>
<p class="calibre3">»Fürcht' dich nicht, Dummer, du, der Böse hat heute keinen
Zutritt, die Fürbitten jagen ihn weg und die Gebete und Lichter ...
Der Herr Jesus geht doch heute selbst durch die Welt und zählt
nach, wieviel Seelen er noch hat, der liebe Hausherr, bis er sie
sich alle ausfindet, alle ... Gut weiß ich noch, wie meine Mutter
sagte, und auch die alten Leute sagen es aus ...«</p>
<p class="calibre3">»Der Herr Jesus geht heute in der Welt herum?« flüsterte Witek
und blickte sich aufmerksam um ...</p>
<p class="calibre3">»Du wirst ihn wohl gerade sehen können ... den sehen doch nur
die Heiligen, oder die, welche am meisten dulden müssen.«</p>
<p class="calibre3">»Sieh mal, da leuchtet was, das sind doch Menschen,« rief Witek
angstvoll und zeigte auf eine Reihe Grabhügel, ganz schon am
Friedhofszaun ...</p>
<p class="calibre3">»Da liegen die, die man im Forst erschlagen hat ... jawohl ...
auch meine Herrschaft liegt da ... und meine Mutter ... jawohl
...«</p>
<p class="calibre3">Sie zwängten sich durch das Dickicht und knieten an einer Anzahl
verfallener Grabhügel, die so auseinandergeweht <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page247" title="lesebaer/gary"></a> waren, daß kaum einer von
ihnen übriggeblieben war; weder Kreuze bezeichneten die Stellen
noch Bäume beschatteten sie; nichts war da, nur der kahle Sand und
ein paar vertrocknete Stauden von Königskerzen und darüber Stille,
Vergessenheit und Tod ...</p>
<p class="calibre3">Ambrosius mit Gusche und der alte Klemb knieten an den Gräbern
dieser Toten; zwei Lämplein, die man in den Sand gedrückt hatte,
glimmten, der Wind kam herangefegt, ließ die Lichtlein schaukeln,
riß die Worte der Gebete auseinander und trug sie davon in die
schwarze Nacht...</p>
<p class="calibre3">»Das ist so ... meine Mutter liegt da ... ich entsinne mich ...«
flüsterte Jakob leise, mehr vor sich hin als zu Witek, der sich
neben ihm hingekauert hatte, denn ein Frösteln war ihm durch alle
Glieder gefahren.</p>
<p class="calibre3">»Und man nannte sie Magdalena ... Der Vater hatte sein eigenes
Land, diente aber im Gutshof als Kutscher ... fuhr mit dem
Hengstgespann mit dem älteren Herrn ... und dann ist er gestorben
... den Grund und Boden haben die Oheime genommen ... und ich habe
die Schweine von der Herrschaft gehütet ... Jawohl, Magdalena hat
die Mutter geheißen und der Vater/Peter, und der Familienname war
Socha, wie auch der meine ist. Und dann hat mich der Gutsherr zu
den Pferden genommen, damit ich an Vaters Stelle mit dem
Hengstgespann fahren sollte ... auf Jagden sind wir immerlos
gefahren zu anderen Herrschaften ... auch ich habe nicht schlecht
geschossen ... der jüngere Gutsherr hatte mir ein Gewehr gegeben
... und die Mutter, die saß nur immerzu mit der älteren Gnädigen im
Herrenhof ... Ich weiß es noch gut ... und als alle gehen mußten
... haben sie mich auch genommen ... Ein ganzes Jahr war ich
dabei... und habe gemacht, was mir befohlen wurde ... Gewiß habe
ich nicht einen Graurock kalt gemacht ... und nicht zwei ... und
der jüngere Gutsherr kriegte einen in die Kaldaunen ... die
Eingeweide sind ihm rausgegangen. Ist doch mein Herr gewesen ...
ein <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page248" title="lesebaer/gary"></a>
herzensguter Mann ... auf die Schultern hab' ich ihn genommen und
hinausgetragen ... und dann ist er in die warmen Länder gefahren,
mir aber hat er befohlen Briefe nach dem alten Herrn zu bringen ...
da bin ich denn gegangen ... das ist schon gewißlich wahr, daß ich
abgejagt war und herunter bis auf den Hund ... die Pfote haben sie
mir durchgeschossen, heilen wollte die da nicht mehr, da ich in
einem zu draußen war, immer unter freiem Himmel ... und Schnee lag
bis an den Gurt hoch, verteufeltes Frostwetter dabei ... ich weiß
noch ... jawohl ... Nachts hab' ich mich da angeschleppt ... ich
suche herum. Jesus, Maria! Als ob mir einer mit der Runge einen
über den Schädel gehauen hätte! ... Das Herrenhaus ist nicht da,
die Wirtschaftsgebäude sind weg ... selbst die Zäune sind nicht
übriggeblieben, alles abgebrannt bis auf den Grund ... und der alte
gnädige Herr und die alte Gnädige und meine Mutter ... und die
Josefa, die sie als Kammermädchen da hatten ... liegen zu Tode
geschlagen im Garten! ... Jesu! Jesu! alles weiß ich noch ...
jawohl ... Maria,« stöhnte er leise und erbsengroße Tränen
kollerten ihm dicht hintereinander über sein Gesicht, so daß er sie
nicht einmal abwischte ... Er seufzte kummervoll und sehnsüchtig
vor sich hin, denn alles war lebendig vor ihm aufgewacht, neben ihm
war Witek eingeschlafen, denn das Weinen hatte den armen Wicht müde
gemacht ...</p>
<p class="calibre3">Es ging immer tiefer in die Nacht hinein, der Wind zerrte immer
heftiger an den Bäumen, so daß die langen Strähnen der Birken über
die Grabhügel fegten, und ihre weißen Stämme tauchten aus den
Dunkelheiten hervor, wie in Totenlinnen gehüllt ... Die Menschen
gingen auseinander ... die Lichter erloschen ... die Gesänge der
Bettler verstummten ... ein feierliches Schweigen, voll seltsamer
Geräusche und ergreifender Stimmen nahm Besitz vom Gräberhain ...
Es war als ob der Friedhof sich mit Schatten füllte ... als ob eine
Schar Gespenster sich drängte ... als ob ein Dickicht voll
dämmriger Umrisse aufwuchs ... und <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page249" title="lac/gary"></a> ein Chorus leiser schluchzender Stimmen zu
spinnen begann ... als ob ein Meer nie zu ergründender Zuckungen
aus den Dunkelheiten hervorzuquellen begann ... durchwebt von
Angstblitzen, von schütterndem Aufschluchzen ... vom Geheimnis voll
Grauen und Wirrwarr, bis sich ein Krähenschwarm von der Kapelle
aufwarf und schreiend nach den Feldern flügelte, da begannen mit
einem Male in ganz Lipce die Hunde zu heulen, lange und trostlos
bang ...</p>
<p class="calibre3">Das Dorf verhielt sich still, trotz des Festtages; die Wege
waren leer, die Schenke verschlossen und nur hier und da durch die
kleinen schwitzigen Scheibchen blinkten Lichtlein und flossen
leise, andächtige Gesänge und laute Gebete, die für die
Verstorbenen gesprochen wurden ...</p>
<p class="calibre3">Mit Angst schlich man vor die Türen der Häuser, mit Angst
lauschte man auf das Rauschen der Bäume, mit Angst blickte man sich
nach den Fenstern um/ob die nicht da stehen, ob die nicht
erscheinen, die an diesem Tage herumirren, getrieben durch die
Sehnsucht und durch Gottes Willen ... ob sie nicht an den
Kreuzwegen mit Büßerstimmen wimmern ... ob sie nicht wehmütig durch
die Scheiben starren ...</p>
<p class="calibre3">Und hier und da stellten die Hausmütter nach altem heiligen
Brauch die Reste der Abendmahlzeit auf die Mauerbänke an den
Häusern, bekreuzigten sich mit frommem Schauer und flüsterten
...</p>
<p class="calibre3">»Da nimm, labe dich, christliche Seele, die du im Fegefeuer
weilest ...«</p>
<p class="calibre3">In Stille, Wehmut, Erinnerungen und Bangen floß dieser
Allerseelenabend dahin ...</p>
<p class="calibre3">Drinnen in der Stube bei Anteks saß Rochus, jener Wanderer aus
dem heiligen Land; er las und erzählte fromme, heilige
Geschichten.</p>
<p class="calibre3">Es waren genug Menschen da, denn auch Ambrosius mit Gusche und
Klemb waren gekommen, und Jakob mit Witek, und Fine mit Nastuscha
waren zugegen; nur der alte Boryna war fort, er saß bis spät in der
Nacht bei Jagna.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page250" title="lac/JohannN"></a> Es war
eine Stille in der Stube, nur das Heimchen knarrte überm Herd, und
die trockenen Scheite knallten in der Feuersglut.</p>
<p class="calibre3">Sie saßen alle auf den Bänken vor dem Herd, nur Antek blieb am
Fenster. Rochus stocherte hin und wieder mit einem Stecken in den
Kohlen herum und redete mit leiser Stimme:</p>
<p class="calibre3">»... Es ist nicht grauenvoll zu sterben, nein, denn wahrlich,
wie jene Vögelchen, die, wenn es gegen Winter geht, nach den warmen
Ländern ziehen, so ist auch die mühselige liebe Seele, die nach
Jesu verlangt ...</p>
<p class="calibre3">Wie jene Bäumchen in ihrer Nacktheit, die der Herrgott zur
Lenzzeit in grüne Blättlein und wohlriechende Blümelein kleidet, so
ist die Menschenseele, die nach Jesus geht, um Freude, Lust, Lenz
und ihr ewiges Kleid zu empfangen.</p>
<p class="calibre3">Wie jene müde Mutter Erde von der Sonne umarmt wird / so wird
der Herr jede liebe Seele liebkosend umfangen, daß ihr weder Winter
noch Schmerz, noch der Tod selbst etwas werden anhaben können
...</p>
<p class="calibre3">Denn seht! nur Weinen ist auf dieser Erden, nur Kummer und
Leid!</p>
<p class="calibre3">Und die Bosheit mehrt sich, wie die Disteln, und wächst zu
Wäldern auf!</p>
<p class="calibre3">Und alles ist eitel und vergeblich, alles ist wie dieser Moder,
wie jene Bläslein, die ein Wind auf dem Wasser aufbläht, und ein
zweiter zunichte macht.«</p>
<p class="pcalibre6 initial1">Von der Kanzel sag' ich es
immer wieder, einem nach dem andern, aber ihr seid, wie die Hunde,
immer aufeinander los, immer nur,« / der Wind stieß dem Priester
den Rest seiner Rede in die Kehle zurück, so daß er einen
Hustenanfall bekam; Antek schritt neben ihm daher, schwieg und
spähte zwischen die Bäume ins Dunkel.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page251" title="lac/JohannN"></a> Der Wind
fuhr immer stärker einher, wälzte sich über den Weg und schlug so
stark gegen die Pappeln und rüttelte sie so heftig, daß sie sich
stöhnend neigten und empört aufrauschten.</p>
<p class="calibre3">»Und hab' ich dem Biest nicht gesagt,« fing wieder der Priester
an, »daß er die Stute selbst nach dem Weiher führen soll, da hat er
sie doch herausgelassen / na, und da hat sie sich nun glücklich
verlaufen ... Wo sie doch blind ist, ... und wenn sie nun zwischen
die Zäune kommt. Die Beine kann sie sich brechen!« jammerte er und
suchte sorgsam umher, sah fast hinter jeden Zaun und ließ die
Blicke über die Felder gehen.</p>
<p class="calibre3">»Sie ist doch aber immer selbst gegangen ...«</p>
<p class="calibre3">»Die kennt den Weg nach dem Weiher ... das schon, wenn einer das
Faß mit Wasser füllen würde und sie nur in die Richt drehen wollte,
dann würde sie schon von selbst zum Pfarrhaus zurechtfinden ...
Aber sonst haben sie sie doch bei Tag herausgelassen ... und heute
hat Magda oder Walek sie doch erst bei Dunkel vorgespannt ...
Walek!« rief er laut, denn irgendein Schatten tauchte zwischen den
Pappeln auf ...</p>
<p class="calibre3">»Walek hab' ich auf unserer Seite gesehen, aber noch vor
Dunkelwerden.«</p>
<p class="calibre3">»Der ist natürlich erst suchen gegangen, als die rechte Zeit
schon vorbei war! / Die Stute ist an die zwanzig Jahre schon, die
ist bei mir zur Welt gekommen ... und ihr Gnadenbrot hat sie sich
schon langst verdient ... und anhänglich ist sie wie ein Mensch ...
Mein Gott, wenn ihr nur nichts Böses passiert!«</p>
<p class="calibre3">»Was soll ihr da geschehen,« brummte Antek voll Wut, denn hätte
er sich etwa nicht ärgern sollen, er war doch zu Hochwürden
gegangen, um sich Rat zu holen, um sich zu beklagen, aber der, nur
angeschrien hatte er ihn da, und obendrein hatte er ihn dann noch
mitgeschleppt, um seine Stute zu suchen! Natürlich ist es schade um
die Stute, wenn sie auch <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page252" title="lac/JohannN"></a> blind und alt ist, aber immerhin ist doch der
Mensch die Hauptsache!</p>
<p class="calibre3">»Und du, gehe in dich und hüte deine Zunge, denn es ist dein
leiblicher Vater! Hörst du!«</p>
<p class="calibre3">»Das weiß ich gut genug!« antwortete er giftig.</p>
<p class="calibre3">»Eine Todsünde ist es und Gottesfrevel. Nichts Gutes wird sich
der da erkämpfen, wer in Pflichtvergessenheit die Hand gegen die
Eltern hebt und sich dem Gebot Gottes widersetzt. Deinen Verstand
hast du, du solltest es doch wissen.«</p>
<p class="calibre3">»Ich will nur Gerechtigkeit!«</p>
<p class="calibre3">»Und suchst Rache, was?«</p>
<p class="calibre3">Antek wußte nicht, was er darauf sagen sollte.</p>
<p class="calibre3">»Und das will ich dir noch sagen, ein frommes Kalb wird von zwei
Müttern gesäugt.«</p>
<p class="calibre3">»Das sagen mir alle ... natürlich, nur daß ich diese Frommheit
satt habe, länger halt' ich's nicht mehr aus! Wenn er selbst ein
Räuber und ein Betrüger wäre ... weil es der leibliche Vater ist,
da ist ihm schon alles erlaubt, und die Kinder dürfen nicht für ihr
Recht stehen! Herrgott nochmal, das ist 'ne Einrichtung in der
Welt, daß man ausspeien möchte und so weit fortlaufen, wie einen
die Augen nur führen können.«</p>
<p class="calibre3">»Na, da geh' doch, wer hält dich denn!« warf der Priester
aufbrausend dazwischen.</p>
<p class="calibre3">»Vielleicht geh' ich auch, was soll ich denn hier noch tun, was
bloß?« murmelte er leise und tränenschwer.</p>
<p class="calibre3">»Du redest, und das ist alles. Manch einer hat auch nicht ein
Ackerbeet und sitzt da, arbeitet und dankt noch Gott dafür. An die
Arbeit solltest du dich halten und nicht herumjammern wie 'n Weib.
Gesund bist du, stark, hast was, wo du dich dran halten kannst
...«</p>
<p class="calibre3">»Gewiß, ganze drei Morgen sogar!« warf Antek verächtlich
hin.</p>
<p class="calibre3">»Hast Frau und Kind, daran solltest du lieber denken.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page253" title="lac/JohannN"></a> »Ich
denk' schon, ich denk' ...,« murrte er zwischen den Zähnen.</p>
<p class="calibre3">Sie kamen auf die Schenke zu, deren Fenster erleuchtet waren.
Bis auf den Weg drangen vereinzelte Stimmen herüber.</p>
<p class="calibre3">»Was ist denn das, wieder eine Sauferei, was?«</p>
<p class="calibre3">»Das sind die Rekruten, die man dieses Jahr ausgehoben hat, sie
trinken zum Zeitvertreib ... Sonntags treibt man sie in die Welt
hinaus, da machen sie sich noch heute einen lustigen Tag ...«</p>
<p class="calibre3">»Die Schenke ist so gut wie voll!« murmelte der Priester, an der
Pappel stehenbleibend, von wo man gut durchs Fenster den ganzen
Innenraum überblicken konnte, der mit Menschen vollgepfropft
war.</p>
<p class="calibre3">»Sie sollten doch heute zusammenkommen, um wegen dem Wald Rat zu
halten ... den der Gutsherr an die Juden zum Fällen losgeschlagen
hat ...«</p>
<p class="calibre3">»Den ganzen hat er doch nicht verkauft, es ist noch so viel
nachgeblieben!«</p>
<p class="calibre3">»Bevor er mit uns nicht einig ist, wird nicht eine Tanne
angerührt!«</p>
<p class="calibre3">»Wie denn?« ... fragte der Priester mit etwas erschrockener
Stimme.</p>
<p class="calibre3">»Wir lassen's nicht zu, dagegen hilft nichts! Der Vater will
prozessieren, doch Klemb und die, die mit ihm halten, sagen, daß
sie keine Gerichte wollen, aber daß die Bäume gefällt werden, das
ließen sie nicht zu, und wenn es selbst nötig wäre, daß das ganze
Dorf hinaus müßte, dann werden sie gehen, selbst wenn es mit Äxten
und Heugabeln ist, wie es gerade kommt, ihr Eigenes geben sie nicht
her ...«</p>
<p class="calibre3">»Jesus Maria! Dann würd' es ja ohne Schlägerei und ohne Unglück
nicht abgehen!«</p>
<p class="calibre3">»Das versteht sich! Erst muß man ein paar Köpfe der
Herrenhofleute mit der Axt spalten, dann hat man gleich
Gerechtigkeit!«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page254" title="lac/JohannN"></a> »Antek!
Du hast wohl den Verstand verloren vor Wut, oder was fehlt dir? Du
redest ja Unsinn, mein Bester!«</p>
<p class="calibre3">Aber Antek hörte nicht mehr auf ihn, er wandte sich rasch ab und
verschwand im Dunkel; und der Priester, der das Rädergeroll und das
leise, klagende Wiehern der Stute vernommen hatte, schritt rasch
auf den Pfarrhof zu ...</p>
<p class="calibre3">Antek seinerseits ging in der Richtung der Mühle, ins untere
Dorf und zwar auf der anderen Seite des Weihers entlang, um nicht
an Jagnas Haus vorüber zu müssen.</p>
<p class="calibre3">Wie ein Splitter steckte sie ihm unter dem Herzen, wie ein böser
Splitter, so daß man sie weder herausreißen noch vor ihr flüchten
konnte.</p>
<p class="calibre3">Ein grelles Licht strahlte aus ihrem Haus, hell und besonders
lustig ... er blieb stehen, um nur das eine einzige Mal
hineinzusehen, um wenigstens seiner Wut Luft zu machen / aber es
riß ihn irgendwas von der Stelle, so daß er davonraste wie ein
Sturm, ohne sich umzusehen.</p>
<p class="calibre3">»Dem Vater Seine war sie schon, dem Vater Seine!«</p>
<p class="calibre3">Zum Schwager, dem Schmied flüchtete er / einen Rat wird der auch
nicht geben, aber man kann unter Menschen sitzen und nicht dort
sein in Vaters Haus ... Und dieser Priester zum Beispiel! Die
Arbeit hält er ihm vor! Hale, und selbst macht er nichts, hat
keinen Kummer und keine Sorgen, dann ist es leicht, andere
anzutreiben. Auf Weib und Kinder hat er ihn verwiesen ... Die
vergißt er schon nicht, nein! Dieses Geflenn, diese Demut und die
bettelnden Hundeaugen hat er schon gerade genugsam satt ... und
wenn sie nicht wäre! ... Wenn er allein wäre! Herr Jesus! Er
stöhnte auf und es packte ihn eine solche wahnsinnige Wut, daß ihn
die Lust ankam, irgendwem an die Gurgel zu springen, zu würgen, zu
zerreißen und bis zum Tod zu schlagen! ...</p>
<p class="calibre3">Aber wen? ... Nein, er wußte es nicht und die Wut schwand so
plötzlich, wie sie gekommen war; mit leeren Augen starrte er in die
Nacht und horchte auf das Rütteln des <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page255" title="lac/JohannN"></a> Sturmes, der sich durch die
Gärten wühlte und so an den Bäumen rüttelte, daß sie sich über die
Zäune lehnten und ihn mit ihren Zweigen gegen das Gesicht
peitschten ... Er schleppte sich so langsam und schwerfällig
weiter, daß er kaum vorwärtskam, denn es begannen seine Seele die
Gespenster der Müdigkeit, Trauer und Ohnmacht zu bedrängen, so daß
er bald vergessen hatte, wohin er ging und was er gewollt hatte
...</p>
<p class="calibre3">»Dem Vater Seine ist Jagna, dem Vater Seine!« sprach er immer
wieder vor sich hin / »dem Vater Seine,« immer stiller / wie ein
Gebet, das einem nicht entschwinden darf.</p>
<p class="calibre3">In der Schmiede war es rot von der Feuerglut, ein Bursche blies
so mächtig mit dem Blasebalg, daß die aufglühenden Kohlen brausten
und zu einer blutigen Flamme aufloderten; der Schmied stand am
Amboß, hatte die Mütze aus der Stirn geschoben, die Ärmel
hochgekrempt, einen Lederschurz um und ein dermaßen rußgeschwärztes
Gesicht, daß ihm die Augen nur wie kleine Kohlen im Kopfe glühten;
er hämmerte ein rotgeglühtes Eisenstück so stark, daß es donnerte,
und ein Funkenregen unter dem Hammer hervorsprühte, mit Zischen in
die aufgeweichte Erde fallend.</p>
<p class="calibre3">»Was gibt's denn?« fragte er nach einer Weile.</p>
<p class="calibre3">»Ja, was soll es da geben!« antwortete Antek leise, gegen einen
Korbwagen lehnend, von denen etliche zum Beschlagen dastanden, und
starrte versunken in die Glut.</p>
<p class="calibre3">Der Schmied schaffte tüchtig, immer wieder glühte er das Eisen
und hämmerte, schlug den Hammer im Takt oder half dem Burschen nach
beim Blasen mit dem Blasebalg, wenn man stärkeres Feuer brauchte,
und heimlich sah er zu Antek hinüber. Ein boshaftes Lächeln
schlängelte sich unter seinem rostroten Schnurrbart.</p>
<p class="calibre3">»Du warst, hör' ich, bei Hochwürden? Na und was gab's?«</p>
<p class="calibre3">»Was sollte es geben, gar nichts. Dasselbe hätte man in der
Kirche hören können.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page256" title="lac/JohannN"></a> »Und
hast du was anderes erwartet?« meinte der Schmied ironisch
lachend.</p>
<p class="calibre3">»Er ist doch der Priester, ein gelernter Mann ...,« sprach
Antek, sich gleichsam entschuldigend.</p>
<p class="calibre3">»Gelernt, wie man was nehmen soll, aber nicht wie man einem was
gibt.«</p>
<p class="calibre3">Antek war schon die Lust vergangen, etwas dagegen zu sagen.</p>
<p class="calibre3">»Ich geh' in die Stube,« sagte er nach einer Weile.</p>
<p class="calibre3">»Geh nur, der Schulze kommt auch 'rüber, da kommen wir gleich
nach! Und der Tabak ist auf dem Schränkchen, kannst was rauchen
...«</p>
<p class="calibre3">Er hörte kaum hin und trat in die Wohnung, die auf der anderen
Seite vom Weg lag.</p>
<p class="calibre3">Die Schwester zündete Feuer an und der älteste Junge lernte am
Tisch aus der Fibel ... sie begrüßten sich schweigend.</p>
<p class="calibre3">»Lernt er da?« bemerkte er, denn der Junge buchstabierte laut
und deutete mit einem zugespitzten Stöcklein von Buchstabe zu
Buchstabe.</p>
<p class="calibre3">»Seit der Kartoffelernte schon; das Fräulein von der Mühle zeigt
ihm das, denn Meiner hat keine Zeit dafür.«</p>
<p class="calibre3">»Rochus tut auch seit gestern in Vaters Stube wieder
lehren.«</p>
<p class="calibre3">»Ich wollte den Jasiek da auch hinschicken, aber Meiner läßt das
nicht zu, weil es bei Vater ist und weil das Fräulein mehr gelehrt
ist, denn sie war auf den Schulen in Warschau ...«</p>
<p class="calibre3">»Gewiß, gewiß ...,« sagte er, um irgendwas zu sagen.</p>
<p class="calibre3">»Und Jasiek ist so anstellig dabei, daß sich das Fräulein selbst
wundert.«</p>
<p class="calibre3">»Wie sollt' er auch nicht ... ist doch dem Schmied sein Fleisch
und Blut ..., der Sohn von solchem Klugschnacker ...«</p>
<p class="calibre3">»Du machst dich lustig, und er hat doch recht, wenn er <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page257" title="DaoH/JohannN"></a> sagt, daß der
Vater, solange er lebt, die ganze Schenkung zunichte machen
kann.«</p>
<p class="calibre3">»Versteht sich, reiß mal dem Wolf aus der Gurgel, was er schon
verschluckt hat! Sechs ganze Morgen Land. Ich mit der Frau, wir
dienen ihm da fast wie Gesinde, und er verschreibt's einer Fremden,
der ersten besten ...«</p>
<p class="calibre3">»Wenn du dich zanken wirst, und fluchen, und Rat bei anderen
holen, und dich prozessieren / dann jagt er dich noch zum Hause
'raus,« redete sie leise, sich nach der Tür umblickend.</p>
<p class="calibre3">»Wer hat das gesagt?« brach er los, vom Stuhl auffahrend.</p>
<p class="calibre3">»Still doch ... das sagen die Leute, still! ...« flüsterte sie
ängstlich.</p>
<p class="calibre3">»Weichen tu' ich keinen Schritt, laß ihn mich mal mit Gewalt
'rausjagen, zum Gericht geh ich, prozessieren werd' ich mich,
weichen tu' ich nicht!« schrie er schon fast.</p>
<p class="calibre3">»Du wirst die Mauer schon nicht mit dem Kopf einrennen, und wenn
du auch noch so sehr, wie ein Schafsbock, drauflos stoßen würdest!«
sagte der Schmied, die Stube betretend.</p>
<p class="calibre3">»Was soll man da tun? Du hast klug reden, da gib denn auch einen
klugen Rat ...«</p>
<p class="calibre3">»Mit Böswilligkeiten ist nichts vom Alten 'rauszukriegen!« Er
zündete die Pfeife an und fing an, ihm vorzustellen, zu erklären
und ihn zu begütigen, und er drehte so viel herum, daß Antek
endlich ein Licht aufging.</p>
<p class="calibre3">»Du hältst es mit ihm?« schrie er los.</p>
<p class="calibre3">»Für die Gerechtigkeit bin ich!«</p>
<p class="calibre3">»Hat er dir gut dafür bezahlt?«</p>
<p class="calibre3">»Wenn er bezahlt hat, dann nicht aus deiner Tasche.«</p>
<p class="calibre3">»Gerade aus meiner, hundsverdammt noch mal, aus meiner! Das ist
mir ein Wohltäter aus andermanns Tasche, so 'n Aas. Genug hast du
gekriegt, da soll's dir wohl nicht eilig sein.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page258" title="DaoH/JohannN"></a>
»Dasselbe nur, was du auch bekommen hast!«</p>
<p class="calibre3">»Hale, dasselbe ... und das Hausgerät, und die Kleider und die
Kuh, und was hast du nicht alles dem Vater abgelistet? Ich merk' es
mir schon, und die jungen Gänse, und Ferkel, wer kann das alles
aufzählen. Und das Bullenkalb, das er dir neulich gegeben hat, ist
das nichts?«</p>
<p class="calibre3">»Du hättest es ja auch nehmen können.«</p>
<p class="calibre3">»Ein Dieb bin ich nicht und 'n Zigeuner auch nicht!«</p>
<p class="calibre3">»Ich aber bin der Dieb, ich? ...«</p>
<p class="calibre3">Sie sprangen aufeinander zu, bereit, sich gleich an den
Rockklappen zu packen, aber sie ließen bald nach, denn Antek sagte
leiser.</p>
<p class="calibre3">»Ich sag' das nicht für dich ... Aber das Meine geb' ich nicht
ab, wenn ich drumumkommen sollte.«</p>
<p class="calibre3">»Ih ... dir geht es nicht so um den Grund und Boden, deucht
mir...,« warf der Schmied spöttisch ein.</p>
<p class="calibre3">»Und warum denn sonst?...«</p>
<p class="calibre3">»Hinter der Jagna bist du her gewesen, da kommt es dir jetzt
sauer an.«</p>
<p class="calibre3">»Hast du 's gesehen?...« schrie Antek, wie ins Herz
getroffen.</p>
<p class="calibre3">»Es gibt solche im Dorf, die es gesehen haben, und das nicht nur
einmal ...«</p>
<p class="calibre3">»Daß ihre Augen mit Nacht geschlagen werden!« murmelte er schon
etwas leiser, denn gerade trat der Schulze in die Stube und
begrüßte die Anwesenden; er schien zu wissen, weshalb sie sich
zankten, denn auch er begann alsogleich den Alten zu verteidigen
und zu entschuldigen.</p>
<p class="calibre3">»Gut mit Schnaps traktiert hat er euch und mit Würsten
gefüttert, kein Wunder daß ihr jetzt zu ihm haltet ...«</p>
<p class="calibre3">»Rede nicht das erste beste Zeug, wenn der Schulze zu dir
spricht!« rief dieser hochmütig.</p>
<p class="calibre3">»Eure Schulzenschaft ist für mich grob so viel wert, wie dieser
zerbrochene Stecken ...«</p>
<p class="calibre3">»Was hast du gesagt, was?«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page259" title="DaoH/JohannN"></a> »Ihr
habt es gehört! Und wenn nicht, dann sag' ich euch noch solches
Wort dazu, daß euch die Fersen jucken werden ...«</p>
<p class="calibre3">»Sag' dieses Wort, untersteh' dich!«</p>
<p class="calibre3">»Das sag' ich / ihr seid ein Saufkumpan, Wortbrecher, ein
Judassohn! Ich will es sagen, ich tu' es sagen, daß ihr für das
Geld der Gemeinde herumludert, und daß ihr euch gut dafür vom
Herrenhof habt schmieren lassen, daß der Gutsherr unsern Wald hat
verkaufen können! ... Und wenn ihr noch was wollt, dann leg' ich
euch noch was drauf, aber mit diesem Knüttel ... rief er hitzig,
nach seinem Stecken langend.</p>
<p class="calibre3">»Du sprichst zu einem Beamten, mäßige dich, ehe es dich gereuen
sollte, Antek!«</p>
<p class="calibre3">»Und in meinem Haus falle nicht die Menschen an, denn hier ist
keine Schenke,« schrie der Schmied, indem er sich schützend vor den
Schulzen aufpflanzte; aber Antek achtete auf nichts mehr, schnauzte
die beiden hundsmäßig an, schmiß die Türe zu und entfernte sich
...</p>
<p class="calibre3">Es hatte ihn redlich erleichtert, und er kehrte etwas beruhigt
nach Hause zurück; nur das eine tat ihn verdrießen, daß er sich
unnötigerweise mit seinem Schwager gezankt hatte.</p>
<p class="calibre3">»Jetzt werden sie schon alle gegen mich sein,« dachte er am
nächsten Tag des Morgens beim Frühstück, und erblickte mit Staunen
den Schmied, der in die Stube trat.</p>
<p class="calibre3">Sie begrüßten sich, als ob nie etwas zwischen ihnen vorgefallen
wäre.</p>
<p class="calibre3">Und da Antek im Begriff war, nach der Scheune zu gehen, um
Häcksel zu schneiden, ging ihm der Schmied nach, setzte sich auf
einen Garbenhaufen nieder, den man von der Banse zum Dreschen
hinuntergeworfen hatte und fing leise an:</p>
<p class="calibre3">»Zum Teufel alle Zänkereien und weswegen noch? Wegen einem
dummen Wort! Da bin ich denn als erster zu dir gekommen, hier hast
du meine Hand, wir wollen wieder Frieden machen ...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page260" title="DaoH/JohannN"></a> Antek
reichte ihm die Hand, sah ihn mißtrauisch an und murmelte:</p>
<p class="calibre3">»Selbstredend war es nur wegen der Worte, denn Ärger gegen euch
hatt' ich nicht. Der Schulze hat mich aufgebracht, denn was soll er
für ihn eintreten, ... ist doch nicht seine Sache, da soll er seine
Finger davon lassen!«</p>
<p class="calibre3">»Gerade das habe ich ihm auch gesagt, als er dir noch nachrennen
wollte ...«</p>
<p class="calibre3">»Mich schlagen ... ich würde ihm schon eine Tracht verabfolgen
wie seinem Vetter, der noch von der Erntezeit her seine Rippen
kuriert ...,« rief er aus und fing an, das Stroh in die
Häckselschneide zu stopfen.</p>
<p class="calibre3">»Auch daran hab' ich ihn erinnert ...,« warf der Schmied
bescheiden ein und lächelte durchtrieben.</p>
<p class="calibre3">»Ich werd' schon mit ihm abrechnen, er wird schon an mich denken
... Diese noblichte Personage, so 'n Beamtenbiest! ...«</p>
<p class="calibre3">»Ist doch nur 'n Hohlkopf, und damit genug, laß ihn fahren.
Etwas anderes hab' ich mir ausgedacht und darum will ich mit dir
reden ... Das muß man so machen ... Nachmittags wird hier die Meine
kommen, dann geht ihr mit ihr zusammen zum Alten, euch gründlich zu
bereden ... Das Gewüte und Geklage in allen Ecken herum hat da
keinen Wert, vor die Augen muß man treten und geradeaus sagen, was
man auf der Leber hat ... Gut kann es werden, oder nicht gut
werden, aber vorgehalten muß ihm alles werden!«</p>
<p class="calibre3">»Was hat man ihm da vorzuhalten, wenn er die Verschreibung
gemacht hat!«</p>
<p class="calibre3">»Mit Wut bringt man es bei ihm zu nichts! Natürlich, daß er ihr
die Verschreibung gemacht hat, solange er lebt kann er sie aber
immer wieder zurücknehmen, merk' dir das; darum eben braucht man
nicht gegen ihn anzugehen. Laß ihn sich verheiraten, laß ihn seinen
Spaß haben.«</p>
<p class="calibre3">Antek erblaßte etwas bei dieser Erwähnung und begann innerlich
zu beben, so daß er mit dem Häckselschneiden aufhören mußte.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page261" title="DaoH/JohannN"></a>
»Dagegen empöre dich nicht ihm direkt ins Gesicht hinein, lob' nur
erst, daß er gut dran tut zu heiraten und daß er das mit der
Verschreibung nach seinem Willen tun konnte ..., wenn er nur den
Rest uns verspricht, dir und der Meinen, aber vor Zeugen!« fügte er
schlau hinzu.</p>
<p class="calibre3">»Und Fine und Gregor?« fragte Antek widerwillig.</p>
<p class="calibre3">»Die wird man auszahlen! Hat denn vielleicht der Gregor wenig im
voraus bekommen? Fast jeden Monat schickt er ihm doch was nach
seinem Regiment. Hör' nur auf mich und tu' wie ich rate, und du
wirst nichts dabei verlieren. Das ist schon mein Verstand, ich
werde das schon so deichseln, daß alles unser sein wird ...«</p>
<p class="calibre3">»Der Hammel lebt noch und der Kürschner näht schon einen
Schafspelz aus seinem Fell ...«</p>
<p class="calibre3">»Höre auf mich ... Laß ihn erst mal vor Zeugen versprechen,
damit man was hat, wo man die Krallen ansetzen kann ... Gerichte
sind noch da und Gerechtigkeit auch, hab' keine Angst. Und es ist
schon ein Haken dran, denn von deiner Mutter ist doch Grund und
Boden nachgeblieben ...«</p>
<p class="calibre3">»Große Geschichte, vier Morgen zusammen / für mich und für die
Deine ...«</p>
<p class="calibre3">»Aber weder du noch die Meine haben ihn gekriegt! Und so viele
Jahre, die er darauf sät und erntet! / Dafür wird er euch gut
zahlen müssen und mit Prezenten! ... Ich wiederhole es dir noch
einmal, sei dem Alten in keiner Sache entgegen, lobe und red' ihm
um den Bart, gehe hin zur Hochzeit, spare nicht an guten Worten und
du wirst sehen, daß wir ihn uns deichseln werden ... Und wenn es
nicht in Güte geht, dann wird das Gericht ihn schon 'rumkriegen ...
Mit Jagusch kennt ihr euch gut aus... da könnte sie dir auch was
nützen ... sag' ihr nur was davon ... sie könnte den Alten noch
besser auf unsere Seite kriegen ..., na, einverstanden? ... Ich muß
nämlich schon gehen ...«</p>
<p class="calibre3">»Einverstanden! beeil' du dich, mir aus den Augen zu kommen,
damit ich dir nicht eines ins Maul gebe und dich <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page262" title="DaoH/JohannN"></a> vors Tor schmeiße!« preßte
er zwischen den Zähnen hervor.</p>
<p class="calibre3">»Was ... Antek? Was ist dir?« stotterte der Schmied erschrocken,
denn Antek ließ die Sense fahren und kam auf ihn zu; blaß und mit
schrecklichen Augen.</p>
<p class="calibre3">»Judas, Aas, Dieb!« gurgelte er aus sich heraus mit schnaubendem
Haß, so daß der Schmied aufsprang und auf und davon rannte.</p>
<p class="calibre3">»Er ist wohl nicht richtig geworden, oder was war das? ...«
dachte er immerzu unterwegs. »Was soll ich da denken, ich hab' ihm
einen guten Rat gegeben ... und der? ... wenn er so dumm ist, dann
laß ihn als Tagelöhner gehen, mag der Alte ihn fortjagen, da will
ich noch mithelfen ... und so oder anders, ich laß nicht von dem
Grund und Boden ... So einer bist du also! Ins Maul wolltest du mir
eine langen, vors Tor schmeißen, daß ich mit dir teilen wollte, ...
daß ich wie zu einem Bruder gekommen bin mit einem guten Wort! So
einer bist du! Aha, allein möchtest du alles einstecken! Daß du's
nicht erlebst! Meine Pläne hast du mir 'rausgelockt, da werd' ich
dir, Biest, schon was einbrocken, daß dich das englische Fieber
schütteln wird.« Er wurde immer wütiger, denn es ärgerte ihn
fürchterlich, daß Antek seine Pläne durchschaut hatte und
vielleicht noch gar imstande sein würde, ihn vor dem Alten zu
verraten. Davor hatte er die größte Angst.</p>
<p class="calibre3">»Dem muß man vorbeugen!« entschied er sofort; und trotz der
Angst vor Antek kehrte er nach dem Borynahof um.</p>
<p class="calibre3">»Ist der Hofbauer da?« fragte er Witek, der vor dem Haus auf die
Gänse im Weiher mit Steinen warf.</p>
<p class="calibre3">»Hale, was soll er zu Hause sein, ist ja zu den Müllers gegangen
zur Hochzeit zu laden ...«</p>
<p class="calibre3">»Ich geh' ihm entgegen, wir werden uns sozusagen zufällig
treffen,« dachte er und ging in der Richtung der Mühle davon; aber
unterwegs kehrte er noch bei sich ein und befahl der Frau, sich
schön anzukleiden, die Kinder mitzunehmen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page263" title="halei/JohannN"></a> und gleich, wenn man zu Mittag
geläutet hatte, zu Anteks hinüberzugehen.</p>
<p class="calibre3">»Er wird dir schon sagen, was du zu tun hast! Mache nichts
allein und nichts nach deinem eigenen Kopf, denn du bist dumm
genug, und nur wenn 's nötig sein wird, dann heule los, umfange
Vaters Knie und leg' dich aufs Bitten ... und höre gut zu, was
Vater sagen wird und was Antek vordem sagt...« Ein gutes
Paternoster lang unterwies er sie so und schaute dabei zum Fenster
hinaus, ob der Alte nicht auf der Brücke auftauchen sollte.</p>
<p class="calibre3">»Ich geh' in die Mühle gucken, ob sie die Hirse schon fertig
haben.« Die Zeit wurde ihm zu Hause lang.</p>
<p class="calibre3">Er ging langsam, blieb stehen und überlegte. Gewiß, wer kann da
wissen, was er tun wird.</p>
<p class="calibre3">»Angefahren hat er mich, und tun könnte er doch was ich ihm
geraten habe ... dann ist's besser, daß die Frau dabei ist ... und
wenn er es nicht tut, werden sie sich verzanken ... der Alte wird
ihn 'rausschmeißen ...«</p>
<p class="calibre3">»So oder so, immer gibt's für einen was ab ...,« er lachte
befriedigt auf, rieb sich die Hände, drückte die Mütze fester auf,
knöpfte den Knierock zu, denn es war windig und eine durchdringende
Kühle kam vom Weiher.</p>
<p class="calibre3">»Einen Nachtfrost kriegen wir oder neue Regenfälle!« murmelte
er, auf der Brücke anhaltend und den Himmel beschauend. Die Wolken
jagten tief, waren dunkelgrau und schwer und wie beschmutzt, gleich
Herden ungewaschener Schafe. Der Weiher murrte dumpf, seine Wasser
platschten von Zeit zu Zeit an die Ufer, wo hier und da zwischen
schwarzen gebeugten Erlen und weit ausladenden Weiden Frauen in
grellroten Röcken sichtbar waren, die Wäsche wuschen / die
Waschhölzer klopften wütend an den beiden Ufern des Weihers. Die
Wege waren leer, nur ganze Scharen von Gänsen paddelten im dicken
Schmutzbrei und in den Gräben, die voll abgefallener Blätter und
Kehricht waren, und Kinder schrien vor den Häusern. Die Hähne
fingen an <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page264" title="halei/JohannN"></a>
auf den Zäunen zu krähen, als ob sie einen Witterungswechsel melden
wollten.</p>
<p class="calibre3">»In der Mühle paß ich ihn schneller ab!« brummte er vor sich hin
und ging talwärts.</p>
<p class="calibre3">Nachdem der Schmied gegangen war, fing Antek mit solcher Wut an,
Häcksel zu schneiden und hatte sich dermaßen in diese Arbeit
vertieft und so viel Häcksel bis Mittag fertig gemacht, daß Jakob,
der vom Walde gekommen war, rief:</p>
<p class="calibre3">»Für eine ganze Woche wird das reichen, na!« Er gab seiner
Verwunderung so laut Ausdruck, daß Antek zur Besinnung kam, das
Häckselmesser hinwarf, sich räkelte und den Weg zum Wohnhaus
einschlug.</p>
<p class="calibre3">»Was kommt, das kommt; aber heute sprech' ich mit dem Vater!«
beschloß er ... »Ein Zigeuner ist er, der Schmied, und ein Judas,
vielleicht tut er aber doch gut raten ... gewiß steckt da was
dahinter ...,« dachte er und ging in Vaters Stube nachzusehen, er
trat aber gleich zurück, denn es saßen dort an die zwanzig Kinder,
die alle zugleich buchstabierten ... Rochus unterrichtete sie und
paßte fleißig auf, daß sie keine dummen Streiche machten ... Er
wandelte in der Stube herum mit einem Rosenkranz in der Hand, hörte
zu, verbesserte manchmal eins, zupfte ein anderes am Ohr,
streichelte hier und da einen der kleinen Köpfe und setzte sich des
öfteren heran, um geduldig zu erklären, was da im Buch stand; er
stellte Fragen, und die ganze Schar der Kinder drängte sich, eins
das andere überbietend, zur Antwort heran, wie Truthähne, wenn sie
einer aufgereizt hat ... sie machten einen solchen Lärm, daß man
sie auch auf der anderen Seite hören konnte...</p>
<p class="calibre3">Anna bereitete das Mittagessen und redete hier und da mit ihrem
Vater, dem alten Bylica, der sich bei ihr selten sehen ließ, da er
viel kränkelte und sich kaum mehr fortbewegen konnte.</p>
<p class="calibre3">Er saß am Fenster, auf seinen Stock gestützt, ließ die <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page265" title="halei/JohannN"></a> Augen durch die
Stube schweifen und blickte einmal zu den Kindern hin, die in der
Ecke zusammengekauert und still dasaßen, dann wieder auf Anna ...
er war ganz weißhaarig, seine Lippen bewegten sich rastlos und
seine Stimme war schwach, wie die eines Vögleins ... sein Atem ging
in pfeifenden Tönen ...</p>
<p class="calibre3">»Habt ihr denn schon gefrühstückt, he?« fragte sie leise.</p>
<p class="calibre3">»Ih... die Wahrheit zu sagen, hat es Veronka vergessen ... und
ich hab' mich auch nicht gemeldet, nein ...«</p>
<p class="calibre3">»Veronka läßt selbst die Hunde hungern, denn sie kommen hier zu
mir manchmal zum Nachfuttern!« rief sie. Sie hatte außerdem noch
etwas gegen die ältere Schwester seit dem vergangenen Winter, weil
diese nach dem Tode der Mutter alles, was übriggeblieben war, an
sich gerissen hatte und nichts wieder herausgeben wollte, deswegen
sahen sie sich so gut wie gar nicht.</p>
<p class="calibre3">»Weil sie doch auch keinen Überfluß haben, nein ...« versuchte
er mit leiser Stimme zu verteidigen ... »Stach drischt beim
Organist', da ißt er auch was mit, und nimmt noch vier Groschen
jeden Tag ... und zu Haus sind so viel Mäuler zu stopfen ... daß es
selbst mit den Kartoffeln nicht reicht ... Das ist schon wahr ...
daß sie zwei Kühe haben, und Milch ist auch da ... so daß sie Käse
und Butter nach der Stadt tragen kann und dafür manchen Groschen
bekommt ... aber sie vergißt oft, daß man essen braucht ... kein
Wunder, wohl / wohl ... die vielen Kinder ... Beiderwand webt sie
den Leuten auch noch ... und spinnt und tut sich abschinden, wie
ein Lasttier ... viel brauch' ich doch auch nicht ... wenn es nur
zur rechten Zeit was gäbe und jeden Tag ... dann könnte man
...«</p>
<p class="calibre3">»Dann zieht doch zum Frühjahr besser zu uns, wenn ihr es bei
dieser Hündin so schlecht habt ...«</p>
<p class="calibre3">»Ich tu' mich doch nicht beklagen, klagen tu' ich nicht, nur ...
von wegen ...« die Stimme brach ihm plötzlich zusammen ...</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page266" title="halei/gary"></a> »Ihr
könntet die Gänse hüten und auf die Kinder passen...«</p>
<p class="calibre3">»Ich würd' schon alles machen, Hanusch, alles,« flüsterte er
ganz leise.</p>
<p class="calibre3">»In der Stube ist Platz, da würde man ein Bett hineinstellen,
damit ihr es warm habt ...«</p>
<p class="calibre3">»Ich würd' ja schon im Kuhstall oder auch bei den Pferden...,
wenn ich nur bei dir sein könnte, Hanusch, nur nicht mehr zurück!
Nur nicht ...« er verschluckte sich bei dieser flehentlichen Bitte
und die Tränen fingen an, ihm aus den tiefliegenden, geröteten
Augen zu tropfen ... »Das Federbett hat sie mir weggenommen/sie
sagt, die Kinder haben nichts zum Zudecken ... das ist wahr... sie
froren, daß ich sie selbst zu mir nahm ... aber der alte Schafspelz
ist nun schon ganz ausgeschabt, der wärmt mich gar nicht mehr ...
und das Bett hat sie mir genommen... und auf meiner Seite ist es
kalt ... nicht ein Stück Holz erlaubt sie mir... und jeden Löffel
Essen hält sie vor ... zum Betteln treibt sie mich 'raus ... Aber
ich hab' doch gar keine Kraft, zu dir hab' ich mich kaum noch
hingeschleppt ...«</p>
<p class="calibre3">»Um Gottes willen! Warum habt ihr uns denn nie etwas gesagt, daß
ihr's so schlecht habt ...«</p>
<p class="calibre3">»Wie soll man denn ... die eigene Tochter ... er ist 'n guter
Mann, aber immer auf Taglohn... wie soll man denn ...«</p>
<p class="calibre3">»Dieses Höllenweib! Die Hälfte des Bodens hat sie genommen, und
das halbe Haus und alles, und gibt euch solch ein Altenteil! An die
Gerichte muß man sich wenden! Sie sollten euch doch Essen geben und
Heizung und das, was ihr an Kleidern braucht, und wir die zwölf
Rubel das Jahr ... denn wir haben auch noch eure Schuld bezahlt ...
ist es nicht so? ...«</p>
<p class="calibre3">»Is wahr! Ehrlich seid ihr, is wahr ... Aber auch die paar
Silberlinge von euch, die ich, weil ich doch mal begraben werden
muß, zurückgelegt habe, hat sie mir abgetrieben <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page267" title="halei/gary"></a> ... und dann, man mußte es
doch auch geben... das hätte man doch nicht anders können... das
Kind doch ..Er schwieg, still und zusammengekauert blieb er sitzen
und glich mehr einem Haufen alter Hobelspäne, denn einem lebendigen
Menschen.</p>
<p class="calibre3">Nach dem Mittagessen, als die Schmiedin mit ihren Kindern
eingetreten war und man gerade angefangen hatte, sich zu begrüßen,
nahm er das Bündelchen, das ihm Anna im geheimen zurechtgemacht
hatte, und machte sich leise davon.</p>
<p class="calibre3">Boryna war zu Mittag nicht gekommen.</p>
<p class="calibre3">Die Schmiedin beschloß also zu warten, selbst wenn es bis in die
Nacht gehen sollte. Anna stellte den Webstuhl am Fenster zurecht
und zog die Wergfasern durch den Weberkamm. Hin und wieder nur,
wenn auch schüchtern, warf sie irgendein Wort ins Gespräch, das
Antek mit der Schwester führte. Er breitete vor ihr seine Klagen
aus, denen sie beipflichtete; aber das dauerte nicht lange, denn
Gusche stürzte herein und sagte so nebenher:</p>
<p class="calibre3">»Von den Organistenleuten komm' ich eben zu euch 'rübergelaufen,
ich hab' da waschen müssen ... Eben war Matheus mit der Jagna da,
zur Hochzeit zu bitten. Die gehen hin! Natürlich, Art find' sich zu
Art, der Reiche zum Reichen ... auch der Priester ist gebeten
...«</p>
<p class="calibre3">»Auch Hochwürden haben sie gebeten!...« rief Anna.</p>
<p class="calibre3">»Warum denn nicht, ist er vielleicht ein Heiliger, oder was? Sie
haben gebeten, er hat gesagt vielleicht wollte er kommen ... warum
denn auch nicht? Ist die Braut vielleicht nicht schmuck, werden sie
vielleicht kein gutes Essen und Trinken bereit halten! Die
Müllersleute haben auch zugesagt mit der Tochter. Ho, ho, solche
Hochzeit hat man noch nicht gesehen, seit Lipce Lipce ist! Ich weiß
Bescheid, weil ich doch mit Müllers Eve das Essen kochen soll. Ein
Mastschwein hat ihnen schon Ambrosius ausgeweidet, Würste machen
sie auch schon ...«/sie unterbrach sich plötzlich, denn <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page268" title="halei/lac"></a> niemand sagte
etwas, niemand befragte sie, sie saßen mürrisch da. Gusche sah die
ganze Gesellschaft aufmerksam an und rief aus:</p>
<p class="calibre3">»Bei euch soll's wohl Sturm geben?«</p>
<p class="calibre3">»Sturm oder nicht, das ist nicht eure Sache!« sagte die
Schmiedin so schneidend, daß Gusche beleidigt nach der anderen
Seite zu Fine abschob, die die Bänke und Stühle wieder
zurechtrückte, denn die Kinder hatten sich schon zerstreut und
Rochus war ins Dorf gegangen.</p>
<p class="calibre3">»Gewiß wird sich Vater nichts abgehen lassen,« murmelte die
Schmiedin mit einer gekränkten Stimme.</p>
<p class="calibre3">»Hat er's am Ende nicht dazu!« sagte Anna und verstummte
erschrocken, weil Antek drohend zu ihr herübergeblickt hatte. Sie
saßen nun fast schweigend da und warteten; hin und wieder sagte
eines von ihnen ein Wort und wiederum trat das dumpf-drückende und
beunruhigende Schweigen ein ...</p>
<p class="calibre3">Vor dem Hause auf der Galerie machte Witek mit den Kindern einen
solchen Spektakel, daß Waupa bellte und das ganze Haus dröhnte.</p>
<p class="calibre3">»Bares Geld muß er auch genug haben, denn immerzu verkauft er
was, und wo sollte er es sonst lassen?«</p>
<p class="calibre3">Antek machte eine wegwerfende Bewegung bei den Worten seiner
Schwester und trat aus der Stube ins Freie. Es wurde ihm langweilig
zu Hause, die Unruhe und die Angst wurden stärker in ihm, er wußte
selbst nicht warum; er wartete auf den Vater, konnte sich kaum mehr
gedulden, und war doch in tiefster Seele zufrieden, daß dieser sich
so lange nicht blicken ließ. »Nicht wegen Grund und Boden ist es
dir zu tun, sondern um die Jaguscha!« Er dachte an diese Worte, die
der Schmied gestern gesagt hatte ... »Wie ein Hund lügt er!« rief
er ganz außer sich. Er machte sich daran, die Wände nach der
Hofseite zu für den Winter abzudichten. Witek trug ihm von einem
Haufen Nadelstreu herbei, er stampfte sie fest und umsteckte sie
mit kleinen Latten, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page269" title="halei/lac"></a> aber die Hände zitterten ihm und immer wieder
unterbrach er die Arbeit. Er stützte sich gegen die Wand und sah
zwischen den nackten, blätterlosen Bäumen hindurch auf den Weiher,
hinüber zu Jaguscha ihrem Haus ... Nein, nicht Liebe wuchs da in
ihm, sondern Wut und tausend feindliche Gefühle, so daß es ihn
schon wundernahm! »Hündin, Aas, einen Knochen hat man ihr
hingeworfen und sie läuft,« dachte er. Aber es kamen auf ihn
Erinnerungen zu, krochen von irgendwo heran aus den öden Feldern,
von den Wegen, aus den schwarzen Obstgärten mit ihren krummästigen
Bäumen, umstellten sein Herz, hakten sich an seine Gedanken,
tauchten vor seinen Augen auf ... bis Schweiß seine Stirn bedeckte,
seine Augen aufglühten und ein starker feuriger Schauer ihn
durchrieselte! ... Hah, dort im Obstgarten ... und damals im Wald
... und als sie zusammen aus der Stadt heimkamen ...</p>
<p class="calibre3">Jesus! er torkelte fast, dann plötzlich sah er ganz nahe vor
sich ihr glutüberflammtes Gesicht, glaubte den leidenschaftlichen
Atem zu hören; ihre hellblauen Augen, ihr voller Mund, so rot und
so nah, daß er seinen Hauch spürte, übergossen ihn mit einer Glut
... und ihre leise, stockende Stimme hörte er leidenschaftlich und
liebestrunken: »Antosch! ... Antosch!« flüstern/sie neigte sich
nahe an ihn heran, so daß er ihren Leib dicht bei sich fühlte, ihre
Brüste, ihre Arme, ihre Knie/und er rieb sich die Augen und jagte
diese lockenden Traumgesichte von sich. Seine ganze verbissene Wut
taute ihm vom Herzen herab, wie das Eis der Strohdächer, das die
Sonne zur Frühlingszeit erwärmt, und eine solche Liebe erwachte in
ihm aufs neue, eine so schmerzliche Sehnsucht erhob in ihm ihr
stachlichtes Haupt, ein solches furchtbares Sehnen, daß er am
liebsten mit dem Kopf gegen die Wand gerannt wäre und gellend
aufgebrüllt hätte!</p>
<p class="calibre3">»Daß da der Blitz hineinfahren möchte!« rief er, zu sich
kommend, und sah scharf auf Witek, ob er nicht irgend etwas merke
...</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page270" title="lac/rudi49"></a> Seit drei
Wochen war er in Fieber, in Erwartung irgendeines Wunders, er wußte
keinen Rat, konnte keinen Einspruch erheben! Wie oft waren ihm
schon die wahnsinnigsten Gedanken und Entschlüsse gekommen, so daß
er schon hinlaufen wollte, um sie zu sehen, war es eine Nacht
vielleicht, daß er in Regen und Kälte wie ein Hund vor ihrer Tür
auf der Lauer gelegen hatte! Sie war nicht herausgekommen, sie mied
ihn, auf der Straße ging sie ihm schon von weitem aus dem
Weg!...</p>
<p class="calibre3">Wenn nicht, dann schon nicht! Und immer mehr verbiß er sich in
Groll gegen sie und gegen alles! Dem Vater Seine ist sie, dann gilt
sie mir dasselbe, wie eine Fremde, irgend so eine Hergelaufene, so
'n herrenloser Hund, so 'n Dieb, der unser höchstes Gut an sich
reißt, unseren Boden nimmt/mit dem Knüttel werd' ich sie
hinaustreiben und noch dazu zu Tode schlagen!</p>
<p class="calibre3">Und wollte er nicht oft genug dem Vater vor die Augen treten und
sagen: ihr könnt Euch nicht mit Jagna verheiraten, denn sie ist
Meine! Aber die Angst ließ ihm das Haar zu Berge stehen, was wird
darauf der Alte sagen, die Leute, das Dorf?...</p>
<p class="calibre3">Jagusch will doch aber seine Stiefmutter werden, eine Mutter
sozusagen/wie darf denn das sein, wie?... Das muß doch eine Sünde
sein, eine Sünde! Er hatte sogar Angst, daran zu denken, weil ihm
das Herz vor unerklärlichem Grausen zu stocken drohte, aus Furcht
vor irgendeiner entschlichen Strafe Gottes... Und niemandem davon
sagen können, und es immer in sich zu tragen, wie eine Glut/wie ein
lebendiges Feuer, das bis auf die Knochen brennt ... das geht über
Menschenkraft, das kann er nicht!</p>
<p class="calibre3">Und schon in einer Woche soll der Priester sie ihm
antrauen...</p>
<p class="calibre3">»Der Hofbauer kommen!« rief Witek hastig, so daß Antek
erschrocken aufzuckte.</p>
<p class="calibre3">Es dunkelte schon rings im Land...</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page271" title="rudi49/Wunibald"></a> Die
Dämmerung schüttete sich über das Dorf aus, wie noch nicht
erloschene Asche, noch rötlich von verborgenen Gluten/die
Abendröten brannten aus, verblaßten zur Farbe der dunkelbraunen
Wolken, die der Wind vor sich hertrieb, im Westen aufstaute und zu
riesenhaften Bergen aufeinandertürmte. Es wurde kalt, die Erde
erstarrte, die Luft hatte eine Schärfe und eine Frische, als wäre
Nachtfrost zu erwarten, und so hellhörig war sie, daß das
Aufstampfen des zur Tranke getriebenen Viehs lauter herklang, und
das Knarren der Einfahrtstore und der hölzernen Brunnenschwengel,
sowie die Gespräche, Kindergeschrei und Hundegebelfer deutlicher
von jenseits des Weihers herüberkamen; hier und da leuchteten schon
die Fenster auf und lange, zuckende, zerfetzte Lichtspiegelungen
fielen auf die Wasserfläche... Am Waldsaum schob sich langsam eine
rostrote Mondscheibe hervor, Feuerbrände standen über ihr, als ob
in der Tiefe des Waldes eine große Feuersbrunst lohte.</p>
<p class="calibre3">Boryna zog seine Werktagskleider an und ging über den Hof, nach
der Wirtschaft zu sehen, er guckte zu den Kühen ein, bei den
Pferden, in die Scheune und selbst noch zu den Ferkeln, schnauzte
Jakob wegen irgend etwas an, und Witek kriegte auch was ab wegen
der Kälber, die aus der Umzäumung ausgebrochen waren und sich
zwischen den Kühen herumtrieben. Als er wieder in seine Stube
eintrat, warteten sie da schon alle auf ihn... Sie schwiegen, nur
aller Augen richteten sich auf ihn und glitten gleich wieder ab,
denn er blieb mitten in der Stube stehen, sah sie sich nacheinander
an und fragte spöttisch:</p>
<p class="calibre3">»Alle da! wie zu irgendeinem Gericht!«</p>
<p class="calibre3">»Darum nicht, Vater, aber mit einer Bitte sind wir zu euch
gekommen,« sagte die Schmiedin eingeschüchtert.</p>
<p class="calibre3">»Und warum ist denn der Deine nicht dabei?...«</p>
<p class="calibre3">»Er hat eine dringende Arbeit vor, da ist er zu Hause
geblieben...«</p>
<p class="calibre3">»Natürlich ... Arbeit ... natürlich ...,« lächelte er
verständnisvoll, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page272" title="DaoH/horst48"></a> warf den Kapottrock ab und fing an, die Stiefel
auszuziehen; und sie schwiegen, ohne zu wissen, wo sie ansetzen
sollten. Die Schmiedin räusperte sich und ermahnte die Kinder zur
Ruhe, die anfingen, herumzutollen, Anna saß auf der Schwelle und
stillte den Jungen und überflog mit unruhigen Augen das Gesicht
Anteks, der am Fenster lehnte und sich im Kopfe zurechtlegte, was
er sagen sollte. Er zitterte am ganzen Leibe vor Aufregung und
Ungeduld. Die einzige, Fine, schälte ruhig Kartoffeln am Herd, warf
Stücke Holz aufs Feuer und blickte neugierig alle der Reihe nach
an, denn sie konnte nichts begreifen.</p>
<p class="calibre3">»Was wollt ihr, redet?« rief er scharf, durch das Schweigen
unruhig gemacht.</p>
<p class="calibre3">»Das heißt ... red' doch, Antek ... das heißt, wir sind
gekommen, von wegen ... was die Verschreibung ist,« stotterte die
Schmiedin.</p>
<p class="calibre3">»Die Verschreibung hab' ich gemacht und Sonntag ist die Hochzeit
... laßt es euch gesagt sein!«</p>
<p class="calibre3">»Das wissen wir, aber nicht darum sind wir gekommen.«</p>
<p class="calibre3">»Und warum denn sonst?«</p>
<p class="calibre3">»Ganze sechs Morgen habt ihr abgeschrieben!«</p>
<p class="calibre3">»Weil ich das so wollte, und wenn es mir einfällt, dann werde
ich diesen Augenblick alles verschreiben ...«</p>
<p class="calibre3">»Wenn alles euer sein wird, dann werdet ihr's verschreiben!«
sagte Antek.</p>
<p class="calibre3">»Und wem seins ist es denn, was, wem seins? ...«</p>
<p class="calibre3">»Der Kinder ihr's, unser.«</p>
<p class="calibre3">»Dumm bist du, wie 'n Hammel! Der Boden ist mein und ich mach'
mit ihm, was mir gefällt.«</p>
<p class="calibre3">»Ihr macht es, oder ihr macht es auch nicht ...«</p>
<p class="calibre3">»Wirst du's mir verbieten, du?«</p>
<p class="calibre3">»Ich, versteht sich, und wir alle, und wenn nicht, dann werden
es euch die Gerichte verbieten,« schrie er, denn er konnte nicht
länger an sich halten und ließ sich von einer sinnlosen Wut
hinreißen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page273" title="DaoH/Vera6020"></a> »Mit
Gerichten drohst du mir, was? Mit Gerichten! Halt' deine Schnauze,
solang ich noch gut bin, sonst wirst du es bereuen!« schrie er, mit
den Fäusten auf ihn losspringend.</p>
<p class="calibre3">»Unrecht lassen wir uns nicht tun!« kreischte Anna auf, sich
hochrichtend.</p>
<p class="calibre3">»Und was willst du? Drei Morgen Land hat sie in die Ehe gebracht
und einen alten Fetzen und wird hier das Maul aufreißen?«</p>
<p class="calibre3">»Selbst das nicht habt ihr Antek gegeben, selbst die paar
Morgen, die ihm von der Mutter Seite zukommen, und arbeiten müssen
wir für euch wie Gesinde, rein wie die Ochsen.«</p>
<p class="calibre3">»Dafür nehmt ihr die Ernte von drei Morgen ein.«</p>
<p class="calibre3">»Und Arbeit leisten müssen wir euch wie für zwanzig oder noch
mehr.«</p>
<p class="calibre3">»Wenn ihr meint, daß euch unrecht geschieht, geht hin und sucht
euch was Besseres.«</p>
<p class="calibre3">»Suchen brauchen wir nicht, denn hier ist unser Besitz! Unser
seit Ahn und Urahn!« rief Antek mit Wucht.</p>
<p class="calibre3">Der Alte warf ihm einen harten Blick zu und antwortete nicht; er
setzte sich an den Feuerherd und stieß so heftig mit dem Feuerhaken
in die Scheite, daß die Funken auseinanderstoben. Böse war er,
feurige Zornwellen gingen über sein Gesicht und die Haarsträhnen
fielen ihm immer wieder über die Augen, die wie bei einer Wildkatze
glühten ... doch er bezwang sich noch, obgleich er kaum an sich
halten konnte.</p>
<p class="calibre3">Ein lange währendes Schweigen, erfüllte die Stube, so daß man
nur das Keuchen und die raschen Atemzüge hören konnte. Anna
schluchzte leise und schaukelte das Kind, das zu greinen angefangen
hatte.</p>
<p class="calibre3">»Wir haben nichts gegen diese Heirat, wenn ihr wollt, dann
heiratet ...«</p>
<p class="calibre3">»Ihr könnt euch widersetzen, ich geb' nichts drum.«</p>
<p class="calibre3">»Nehmt doch nur die Abschreibung zurück,« warf Anna unter Tränen
ein.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page274" title="DaoH/Vera6020"></a>
»Willst du wohl still sein, was hast du, gottverflucht nochmal, in
einem fort herumzuplärren, wie eine Hündin!« Er warf so stark den
Feuerhaken in die Glut, daß Feuerbrände durchs Zimmer flogen.</p>
<p class="calibre3">»Und ihr mäßigt euch, denn es ist nicht eure Magd, daß ihr das
Maul aufreißt!«</p>
<p class="calibre3">»Was hat die denn hier zu schnauzen!«</p>
<p class="calibre3">»Das Recht hat sie schon, denn sie tritt für ihr Eigenes ein!«
schrie Antek immer lauter.</p>
<p class="calibre3">»Wenn ihr wollt, dann könnt ihr schon verschreiben, aber was
übriggeblieben ist, das schreibt für uns ab,« fing die Schmiedin
leise wieder an ...</p>
<p class="calibre3">»Guck einer die Dumme an, mit meinem Hab und Gut will sie hier
disponieren. Brauchst keine Angst zu haben, auf den Altenteil geh'
ich zu euch nicht ... laßt euch das gesagt sein!«</p>
<p class="calibre3">»Und wir lassen doch nicht ab. Gerechtigkeit wollen wir.«</p>
<p class="calibre3">»Wenn ich einen Knüttel nehme, dann werd' ich euch Gerechtigkeit
austeilen.«</p>
<p class="calibre3">»Versucht nur anzutippen, dann erlebt ihr gewißlich die Hochzeit
nicht mehr ...«</p>
<p class="calibre3">Und sie fingen an, sich gegenseitig zu beschimpfen, aufeinander
loszuspringen, sich zu bedrohen, mit den Fäusten auf den Tisch zu
schlagen und alle ihre Kränkungen und Klagen herzuzählen! Antek war
so außer sich geraten und hatte sich so erbost, eine solche Wut
brach aus ihm hervor, daß er den Alten mal am Arm, mal an der
Rockklappe schüttelte und bereit war loszuschlagen ..., aber Boryna
beherrschte sich immer noch, er wollte keine Schlägerei, schob
Antek beiseite, antwortete nur hin und wieder auf die
Beleidigungen, um nur den Nachbarn und dem ganzen Dorf kein
Schauspiel zu geben! In der Stube erhob sich ein solches Geschrei,
eine solche Unordnung und ein solches Heulen, denn die beiden
Weiber weinten und schrien um die Wette, und die Kinder kreischten
ebenfalls, daß Jakob und <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page275" title="DaoH/enterprise11"></a> Witek vom Hof aus unter die Fenster
gelaufen kamen, aber auseinanderkennen konnten sie nichts, weil
alle zugleich schrien, und zuletzt, als die Stimmen ihnen schon
versagten, krächzten sie einander nur noch mit Flüchen und
Drohungen an. Da brach Anna in ein neues gewaltiges Schluchzen aus;
sie lehnte gegen den Rauchfang und begann mit einer sinnlos
erregten Stimme, deren Worte durch Tränen fast erstickt waren, zu
schreien:</p>
<p class="calibre3">»Bleibt uns nur übrig, auf den Bettel zu gehen, in die Welt ...
oh, mein Jesus, mein Jesus! ... Wie die Lasttiere haben wir
gearbeitet, tage- und nächtelang ..., als Gesinde hat er uns
gehalten ... und jetzt, was? ... Der liebe Gott wird euch strafen
für unser Unrecht! ... das wird er ... Ganze sechs Morgen hat er
verschrieben ... und die Kleiderstücke der Mutter ... und die
Perlenschnüre ... alles das ... Und für wen ist das alles? Für ein
solches Schwein ... Daß du unter dem Zaun verreckst für unser
Unrecht, daß dich die Würmer zernagen, du Abschaum, du
Straßendirne, du!...«</p>
<p class="calibre3">»Was hast du gesagt? ...« brüllte der Alte auf und sprang auf
sie zu ...</p>
<p class="calibre3">»Daß sie ein Frauenzimmer für alle ist und ein Rumtreiber, das
weiß das ganze Dorf ... die ganze Welt weiß das ... alle ... alle
... alle ...«</p>
<p class="calibre3">»Heb' du dich weg von ihr, sonst schlag' ich dir die Schnauze an
der Mauer entzwei ... wahr' dich! ...«/Und er fing an, sie hin und
her zu schütteln, aber Antek sprang hinzu, schützte sie und fing
ebenfalls an, laut zu schreien:</p>
<p class="calibre3">»Ich sag' es mit, daß sie ein Frauenzimmer für jeden ist, ich!
Mit der schlief schon jeder, der es gewollt hat, ich! ...« rief er
und redete, was ihm der Speichel in den Mund trug; er kam nicht zu
Ende, denn der Alte, schon bis zum äußersten aufgebracht, schlug
ihm dermaßen mit der Faust ins Gesicht, daß er mit dem Kopf gegen
einen Glasschrank taumelte und im Fallen ihn mit sich zu Boden riß
... Er sprang blutüberströmt auf und stürzte sich auf den Vater.
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page276" title="DaoH/enterprise11"></a> Sie
warfen sich aufeinander, wie zwei wütige Hunde, packten sich vor
die Brust und schoben sich, miteinander ringend, in der Stube hin
und her, sie warfen einander, schlugen gegen die Betten, gegen die
Laden und Wände auf, daß die Köpfe krachten. Ein unbeschreibliches
Geschrei erhob sich, die Frauen wollten sie auseinanderzerren, aber
es gelang ihnen nicht, denn sie waren schon zu Boden gestürzt, und
so verknäult miteinander durch Haß und Kränkung, wälzten, drückten
und würgten sie sich ...</p>
<p class="calibre3">Zum Glück hatten sie die Nachbarn bald auseinandergebracht und
voneinander entfernt ...</p>
<p class="calibre3">Antek trugen sie auf die andere Seite und gossen kaltes Wasser
über ihn, weil er ohnmächtig geworden war vor Ermattung und
Blutverlust, denn die Scheiben des Schrankes hatten ihm das Gesicht
zerschnitten.</p>
<p class="calibre3">Dem Alten war nichts geschehen; sein Spenzer war nur etwas
zerrissen, das Gesicht zerschunden und ganz blau vor Wut ... Er
beschimpfte die Leute, die zusammengelaufen waren, und wies sie zum
Hause hinaus, die Tür zum Flur schloß er ab und setzte sich an den
Feuerherd ...</p>
<p class="calibre3">Aber beruhigen konnte er sich nicht, denn in einem fort kehrte
ihm die Erinnerung an das wieder, was sie von Jagna gesagt hatten,
es stieß ihn wie mit einem Messer ins Herz ...</p>
<p class="calibre3">»Das werd' ich dir nachtragen, du Hund, das sollst du fühlen!«
schwor er sich zu. »Wie kann man denn, auf Jagusch ...« Aber gleich
kam ihm zu Bewußtsein, was er schon öfters über sie gehört hatte,
was früher über sie geredet worden war und was er nie beachtet
hatte! Es überkam ihn heiß und es wurde ihm seltsam atembeklemmend
und verdrießlich zumute ... »Lügenkram, Klatschmäuler und
neidisches Pack, das weiß man!« rief er laut aus, aber immer mehr
von dem Gerede der Leute kam ihm in den Sinn. »Wie denn, der eigene
Sohn sagt's ja! Wie sollten denn die <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page277" title="DaoH/gary"></a> da nicht herumkläffen? Aaszeug!« Aber diese
Gedanken fraßen wie Feuer in ihm ...</p>
<p class="calibre3">Nachdem Fine die Spuren des Kampfes beseitigt hatte, und das
Abendbrot, wenn auch verspätet, auf den Tisch kam, machte er den
Versuch, ein paar Kartoffeln zu essen. Er legte aber den Löffel
bald weg. Es war ihm unmöglich, irgend etwas
herunterzuschlucken.</p>
<p class="calibre3">»Hast du den Pferden Futter eingeschüttet?« fragte er Jakob.</p>
<p class="calibre3">»Versteht sich ...«</p>
<p class="calibre3">»Wo ist Witek?«</p>
<p class="calibre3">»Zu Ambrosius ist er gelaufen, damit er Antek den Kopf
verbindet; sein Gesicht ist ihm aufgeschwollen, sieht schon aus wie
'n Suppentopf,« fügte er hinzu und machte sich gleich davon, denn
der Mond schien und er hatte gerade heute vor, sich auf Jagd auf
die am Waldrand liegenden Felder zu begeben ... »Biester,« brummte
er vor sich hin, das gute Leben bläht sie auf, darum schlagen sie
sich.</p>
<p class="calibre3">Auch der Alte hatte sich noch aufgemacht und war ins Dorf
gegangen, zu Jagna sah er aber nicht ein, obgleich noch Licht bei
ihr war; gerade schon vor ihrer Tür kehrte er um und ging die
Dorfstraße entlang der Mühle zu.</p>
<p class="calibre3">Die Nacht war kalt und sternenklar; der Nachtfrost ließ die Erde
erstarren; der Mond hing hoch und schien so hell, daß der ganze
Weiher wie Quecksilber auffunkelte, die Bäume warfen lange zittrige
Schatten auf die leeren Wege. Es war schon spät, die Lichter in den
Häusern erloschen, nur die geweißten Wände traten noch stärker
hervor aus den kahlen Gärten. Stille und Nacht umfingen das ganze
Dorf, einzig die Mühle ratterte und das Wasser gurgelte eintönig
... Matheus ging mal auf der einen, mal auf der anderen Seite des
Weihers auf und ab und wußte nicht, was er mit sich anfangen
sollte; er hatte sich nicht beruhigt, nein, weit davon entfernt,
die Wut und der Haß gruben noch stärker in ihm; bis er schließlich
nach der Schenke ging und nach dem Schulzen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page278" title="rudi49/DaoH"></a> schickte, mit dem er dann bis
Mitternacht saß und trank, aber den nagenden Wurm zu ertränken,
wollte ihm nicht gelingen ... nur einen Entschluß faßte er.</p>
<p class="calibre3">Am nächsten Tag des Morgens, sobald er aufgestanden war, ging er
auf die andere Seite hinüber. Antek lag noch im Bett, mit einem
Tuch verbunden, das voller Blutflecken war; er richtete sich
auf.</p>
<p class="calibre3">»In diesem Augenblick verlaßt ihr mein Haus, daß nicht eine Spur
von euch nachbleibt,« schrie der Alte. »Willst du Krieg, willst du
Gericht, geh' nach dem Gericht, verklage mich, such' dir dein
Recht. Was du von deinem gesäet hast, wirst du im Sommer ernten,
und jetzt, schere dich! Daß meine Augen euch nicht mehr sehen! Hast
du gehört!« brüllte er los, denn Antek erhob sich, antwortete
nichts ... und fing an, sich langsam anzuziehen...</p>
<p class="calibre3">»Daß ihr mir bis Mittag weg seid!« rief er noch vom Flur
her.</p>
<p class="calibre3">Auch darauf antwortete Antek kein Wort, als ob er nichts gehört
hätte ...</p>
<p class="calibre3">»Fine, rufe mal Jakob her, er soll die Stute vor den Wagen
spannen und sie hinausfahren, wohin sie wollen!«</p>
<p class="calibre3">»Hale, dem Jakob fehlt aber was, er liegt auf der Pritsche und
stöhnt in einem fort, und sagt, daß er gar nicht aufstehen kann, so
schmerzt ihn das schiefe Bein ...«</p>
<p class="calibre3">»Hale, das Bein schmerzt ihn! Das Faultier, sich ausruhen will
er ...,« und er machte sich selbst an die morgendliche Verrichtung
der Wirtschaftsarbeit ...</p>
<p class="calibre3">Aber Jakob wurde ernstlich krank; er sagte nicht, was ihm
fehlte, obgleich ihn Boryna danach gefragt hatte; er klagte nur, er
wäre krank und stöhnte und ächzte so, daß die Pferde wieherten, an
die Pritsche herankamen und ihm das Gesicht beschnupperten und
leckten; Witek trug ihm immer wieder Wasser in einem Eimer zu und
wusch heimlich im Strom irgendwelche blutige Fetzen ...</p>
<p class="calibre3">Der Alte merkte es nicht, denn er stand und paßte auf, daß die
Anteks wegkamen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page279" title="beda/DaoH"></a> Sie zogen
auch wirklich aus.</p>
<p class="calibre3">Schon ohne Geschrei, ohne zu zanken, ohne sich zu widersetzen,
sie packten ihre Sachen, trugen ihre Wirtschaftsgeräte hinaus und
schnürten ihre Bündel; Anna wurde ein paarmal schlecht vor Kummer,
so daß Antek ihr Wasser holen mußte, um sie wieder hochzukriegen;
er trieb in einem fort an, um nur so schnell wie möglich dem Vater
aus dem Gesicht zu kommen ... je eher je besser...</p>
<p class="calibre3">Er hatte sich ein Pferd von Klembs geborgt, das väterliche
wollte er nicht, und brachte sein Hab und Gut zu Annas Vater
hinüber, der am Ende des Dorfes, noch hinter der Schenke wohnte
...</p>
<p class="calibre3">Aus dem Dorf kamen ein paar Hofbauern mit Rochus an der Spitze;
sie wollten Frieden stiften zwischen den beiden; doch weder Vater
noch Sohn ließen sich irgendwie beikommen ...</p>
<p class="calibre3">»Er mag versuchen, wie die Freiheit schmeckt und das eigene
Brot,« entgegnete der Alte.</p>
<p class="calibre3">Antek antwortete nichts auf die Zureden, er hob nur die Faust
und stieß einen solchen Fluch aus und drohte so furchtbar, daß
selbst Rochus erblaßte und zu den Weibern zurücktrat, von denen
sich eine gehörige Anzahl an den Hecken und auf der Galerie des
Hauses angesammelt hatte, um Anna zu helfen, hauptsächlich aber, um
laut zu jammern, das Mundwerk im Gange zu halten und miteinander zu
klatschen! ...</p>
<p class="calibre3">Als Fine mit verheultem Gesicht das Mittagessen für den Vater
und Rochus aus den Tisch stellte, bogen die anderen mit den letzten
Sachen und den Kindern aus dem Heckenweg auf die Landstraße ...
Antek sah sich nicht einmal um nach dem Haus, er bekreuzigte sich
nur und seufzte schwer auf, schlug auf das Pferd ein, stützte den
Wagen, der hoch vollgeladen war und ging, wie ein Toter,
leichenblaß nebenher. Die Augen glühten ihm im verbissenen Haß und
die Zähne knirschten wie im Fieber ... aber er sprach nicht ein
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page280" title="lac/DaoH"></a> einziges Wort;
Anna aber schleppte sich hinter dem Wagen her, der ältere Junge
klammerte sich an den mütterlichen Beiderwandrock und schrie
gottsjämmerlich, den jüngeren hielt sie an ihre Brust gepreßt und
trieb ein paar Kühe, zwei magere Ferkel und eine Schar Gänse vor
sich her, und sie heulte, und wehklagte und fluchte so laut, daß
die Menschen aus den Häusern traten und im Zuge wie auf einer
Prozession ihnen nachfolgten ...</p>
<p class="calibre3">Beim Alten aß man Mittag in düsterem Schweigen.</p>
<p class="calibre3">Der alte Waupa bellte auf der Galerie, lief dem Wagen nach,
kehrte wieder um und heulte ... Witek rief ihn, aber der Hund hörte
nicht, lief im Garten umher, beschnüffelte den Hof, stürzte in die
leere Stube, raste in ihr ein paarmal umher und rannte zurück auf
den Flur, wo er zu bellen und zu winseln begann; er strich um Fine
herum, raste wie toll wieder hinaus, blieb sitzen mit starren,
wirren Augen und sprang schließlich auf, klemmte den Schwanz
zwischen die Beine und rannte hinter Anteks drein ...</p>
<p class="calibre3">»Da ist auch der Waupa ihnen nachgegangen ...«</p>
<p class="calibre3">»Der kehrt schon zurück, wenn er erst hungern muß, der kehrt
zurück, brauchst keine Angst zu haben, Fine,« sagte der Alte weich.
»Weine nicht. Dummchen, mach' die andere Seite rein, dann wird der
Rochus da 'ne Wohnung haben können. Ruf' Gusche, dann wird sie dir
helfen ... und guck' auf die Wirtschaft, bist doch die Hofbäuerin
jetzt, auf deinen Schultern liegt jetzt alles ... na, nun wein' man
nicht mehr,« er zog ihren Kopf zu sich heran, streichelte, preßte
sie in die Arme und liebkoste sie.</p>
<p class="calibre3">»Nach der Stadt werde ich gehen, dann kauf' ich dir neue
Schuhe!«</p>
<p class="calibre3">»Kauft ihr, Väterchen? Werdet ihr wirklich kaufen? ...«</p>
<p class="calibre3">»Ich kauf' sie dir, ich kauf' dir auch noch mehr, sei nur 'ne
gute Tochter und paß schön auf die Wirtschaft.«</p>
<p class="calibre3">»Werdet ihr mir denn auch Stoff für eine Jacke kaufen, wie
Nastuscha Täubich eine hat?«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page281" title="lac/DaoH"></a> »Ich kauf'
ihn dir, meine Tochter, ich kauf' ihn ...«</p>
<p class="calibre3">»Und Bänder, aber lange, damit ich sie auf eurer Hochzeit tragen
kann.«</p>
<p class="calibre3">»Was du nur brauchst, kannst du sagen, alles wirst du kriegen,
alles.«</p>
<p class="pcalibre6 initial1">»Schläfst du denn, Jagusch?
...«</p>
<p class="calibre3">»Kann ich denn da schlafen. Schon beim Morgengrauen bin ich
aufgewacht, und immerzu hab' ich es im Kopfe, daß heute Hochzeit
ist ... man kann es kaum glauben.«</p>
<p class="calibre3">»Bist du bange, meine Tochter, was?« fragte sie etwas leiser mit
einer ängstlichen Hoffnung im Herzen ...</p>
<p class="calibre3">»Was sollte es mir da bange sein! Nur daß ich von euch gehen muß
auf Meines ...«</p>
<p class="calibre3">Die Alte erwiderte nichts, sie unterdrückte das Wehmutsgefühl,
das sie plötzlich erfaßt hatte, erhob sich vom Lager, kleidete sich
flüchtig an und ging in den Stall, um die Jungen zu wecken, die
nach dem gestrigen Polterabend nicht zur rechten Zeit aufgestanden
waren und in den vollen Tag hinein schliefen. Der Morgen hatte die
Erde mit einer silbrigen Lichtflut überschwemmt, aus der hier und
da der Rauhreif aufblinkte. Im Osten entbrannte die Morgenröte, als
ob irgendwer Gluten über den Himmel ausgestreut hatte.</p>
<p class="calibre3">Die Dominikbäuerin hatte ihre Morgenwaschung auf dem Flur
vorgenommen und machte sich leise in der Stube zu schaffen, doch
von Zeit zu Zeit sah sie nach Jagna hinüber, deren Kopf zwischen
den Kissen des Lagers im Morgengrauen, das noch die Stube erfüllte,
kaum zu erkennen war ...</p>
<p class="calibre3">»Liege nur, Tochter, liege du nur! ... Das letztemal schläfst du
in deiner Mutter Haus,« dachte sie mit Zärtlichkeit und immer
wiederkehrendem Wehmutsgefühl. Sie konnte nicht glauben, daß es
wirklich heute schon so weit war und mußte sich alles erst deutlich
wieder in Erinnerung rufen ... Sie hatte es doch selbst so
gewünscht, und nun, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page282" title="lac/gary"></a> nun ... eine Angst hatte sie gepackt und fing sie
so an zu schütteln, daß sie sich vor Schmerzen krümmte ... Sie ließ
sich auf den Bettrand nieder ... »Boryna ist ein guter Mann, der
wird sie in Ehren halten und ihr kein Unrecht antun ... und Jagusch
wird ihn leiten, wie sie will, denn der Alte sieht nichts in der
ganzen Welt, nur sie ...«</p>
<p class="calibre3">»Nein, nein, deswegen brauchte sie sich nicht zu ängstigen,
deswegen nicht ... aber die Stiefkinder! Das war es ... wozu
brauchte er die Anteks gleich aus dem Haus zu jagen? Jetzt werden
sie erst schüren und auf Rache sinnen! ... Und wären sie geblieben,
und der Antek so dicht daneben, da wär' doch nur was
Gotteslästerliches daraus geworden, oder noch Schlimmeres! ... Oh,
du mein Jesus! Und zu helfen gibt's da nichts mehr ... Das Aufgebot
ist schon 'raus ... das Schwein ist geschlachtet, die
Hochzeitsgäste auch schon geladen ... so viel schon fertig ... die
Verschreibungsurkunde in der Lade ... Nein, nein! Komme was da
will, aber ein Unrecht laß ich ihr nicht tun, solange ich lebe!«
dachte sie entschlossen und ging wieder und schrie die Jungen an,
warum sie nicht aufstanden.</p>
<p class="calibre3">Nachdem sie zurückgekommen war, wollte sie Jagna laut anrufen,
doch diese war wieder eingeschlafen; vom Bett her kam ihr leiser
gleichmäßiger Atem, und die Alte faßten wieder verschiedene
Zweifel, und Wehmutsgefühle griffen mit Sperberklauen nach ihrem
Herzen, zerfleischten es und schrien in ihr mit den Stimmen der
Sorge und der Angst! Sie kniete am Fenster nieder, starrte mit
ihren geröteten, fiebrigen Augen ins Morgenlicht und betete lange
und heiß. Sie stand neu gekräftigt wieder auf, bereit allem die
Stirn zu bieten!</p>
<p class="calibre3">»Jagusch! Steh' auf, Tochter, es ist schon Zeit! die Eve wird
gleich zum Kochen hier sein, und noch so viel Arbeit ist da!«</p>
<p class="calibre3">»Is gutes Wetter?« fragte sie, schläfrig den Kopf
hochrichtend.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page283" title="MEsswein/gary"></a> »Und
was für eins, es glitzert nur so in der Welt vom Morgenfrost!
Gleich geht die Sonne auf ...«</p>
<p class="calibre3">Jagna kleidete sich schnell an. Die Alte war ihr dabei
behilflich und schien lange zu überlegen, bis sie schließlich
sagte:</p>
<p class="calibre3">»Und das will ich dir nochmal sagen, was ich dir schon früher
gesagt habe ... Den Boryna muß man achten ... ein guter Mensch ist
er ... Und laß dich nicht wieder mit irgend jemand ein ... damit
man dich nicht auf den Zungen 'rumträgt ... die Menschen sind wie
die Hunde ... die beißen wo sie können! Hörst du mich denn, meine
Tochter? ...«</p>
<p class="calibre3">»Ich hör' schon, ich hör' schon, und ihr redet, als ob ich nicht
selber meinen Verstand hätte ...«</p>
<p class="calibre3">»Guter Rat ist niemandem zuviel ... Paß auch darauf, daß du mir
mit dem Boryna nicht so holterdiepolter umgehst, immer nur sanft
und mit Güte ... Ein Älterer gibt mehr acht auf so was, wie
irgendein Grünschnabel ..., und wer weiß, er kann dir noch Grund
zuschreiben oder etwas Bargeld zustecken!«</p>
<p class="calibre3">»Ich geb' nichts drauf,« murrte sie verärgert auf.</p>
<p class="calibre3">»Weil du jung bist und dumm ... Seh dich nur mal im Dorf um,
zwischen den Menschen, da kannst du sehen, um was sie sich zanken
und abarbeiten und Sorge tragen! Nur um den Grund und Boden, um Hab
und Gut! Wäre es dir vielleicht gut, ohne diesen heiligen Streifen
Erde, wie? Dich hat der Herr Jesus nicht dazu geschaffen, auf
Lohnarbeit zu gehen und dich durchzuhungern. Und weswegen hab' ich
denn mein ganzes Leben gesorgt/nur für dich, Jagusch! Und jetzt
bleib' ich, wie der einzelne Finger, ganz allein auf mich gestellt?
...«</p>
<p class="calibre3">»Gehen die Jungen vielleicht in die Welt? Die bleiben dir doch
...«</p>
<p class="calibre3">»Von denen hab' ich grad soviel wie von einem Tag, der vergangen
ist!« rief sie aus und zerfloß in Tränen. »Und mit <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page284" title="MEsswein/gary"></a> den Stiefkindern mußt du
Frieden halten!« fügte sie hinzu, die Augen trocknend.</p>
<p class="calibre3">»Fine ist 'n gutes Mädchen, Gregor kommt noch nicht bald vom
Militär heim ... und ...«</p>
<p class="calibre3">»Vor den Schmiedsleuten mußt du dich in acht nehmen ...«</p>
<p class="calibre3">»Die stehen sich doch mit Matheus, und wie dick ...«</p>
<p class="calibre3">»Da hat der Schmied seine Berechnung bei, die hat er! Aber ich
wach' schon ... Am schlimmsten ist es mit Anteks, weil sie sich
nicht versöhnen wollen ... selbst Hochwürden wollte gestern Frieden
stiften ... sie haben aber nicht gewollt ...«</p>
<p class="calibre3">»Weil Matheus wie 'n böser Hund ist, ... sie so aus dem Hause zu
jagen!« rief sie leidenschaftlich.</p>
<p class="calibre3">»Was ist dir bloß, Jagusch, was ist denn? Der Antek hat doch am
schlimmsten auf dich geredet, den Grund und Boden hat er dir wieder
wegnehmen wollen und geflucht hat er und hat sich gegen dich
verschworen, daß man das gar nicht alles wiedersagen kann.«</p>
<p class="calibre3">»Antek gegen mich? Belogen haben sie euch, daß ihnen ihre
häßlichen Zungen verdorren ...«</p>
<p class="calibre3">»Warum hältst du denn auf Anteks Seite, du? ...« klagte sie
drohend.</p>
<p class="calibre3">»Weil alle gegen ihn sind! Ich bin nicht so wie ein Bettlerhund,
der hinter jedem herläuft, der ihm nur einen Brocken hinwirft! Ich
sehe gut, daß ihm Unrecht geschieht ...«</p>
<p class="calibre3">»Dann würdest du ihm vielleicht das Verschriebene zurückgeben
... wie? ...«</p>
<p class="calibre3">Aber Jagna kam nicht zur Antwort, denn die Tränen stürzten ihr
aus den Augen. Sie rannte in den Alkoven, drückte die Tür hinter
sich zu und heulte da lange.</p>
<p class="calibre3">Die Dominikbäuerin störte sie nicht; aber eine neue Sorge glitt
ihr ins Herz hinein... Doch die Zeit war nicht zum Meditieren: Eve
kam, die Jungen räkelten sich vor der Flurtür, man mußte
darangehen, Ordnung zu machen und die letzten Vorbereitungen
treffen ...</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page285" title="rudi49/gary"></a> Die
Sonne war aufgestanden, der Tag rollte rüstig vorwärts.</p>
<p class="calibre3">Es war ein ordentlicher Nachtfrost gewesen, so daß die Pfützen
auf den Wegen und die Ränder des Weihers sich mit Eis bedeckt
hatten und das leichtere Vieh sich schon auf den festgefrornen
Wegen halten konnte, ohne einzubrechen.</p>
<p class="calibre3">Wärme kam auf, an den Hecken und im Schatten schimmerte es noch
weißlich, von den Strohdächern jedoch tropfte das Tauwasser in
leuchtenden Perlenschnüren und auf den Mooren dampften die Dünste,
wie aufsteigender Rauch. Die Luft war so klar, daß man die
umliegenden Felder wie auf der eigenen Handfläche vor sich liegen
sah, die Wälder hatten sich näher herangeschoben, so daß man die
einzelnen Bäume auseinanderkennen konnte ...</p>
<p class="calibre3">Auf dem blauen, tiefhängenden Himmel war nicht ein Wölkchen zu
sehen.</p>
<p class="calibre3">Es ging auf gut Wetter, denn die Krähen flatterten zwischen den
Häusern herum und die Hähne krähten.</p>
<p class="calibre3">Ein rechter Sonntag war es, und obgleich die Kirchenglocken noch
nicht läuteten, wimmelte es im Dorf wie in einem Bienenhaus. Die
Hälfte des Dorfes traf ihre Vorbereitungen zur Hochzeit Jagnas mit
dem Boryna.</p>
<p class="calibre3">Von einem Haus zum anderen liefen durch die reifbedeckten
Obstgärten Mädchen und trugen Bündel von Bändern, Beiderwandröcke
und verschiedenfarbenen Putz ...</p>
<p class="calibre3">In den Bauernhöfen herrschte ein großer Wirrwarr, man bereitete
sich vor, probierte den feinsten Staat an, putzte sich, und durch
die vielfach geöffneten Fenster und Türen erklangen schon freudige
Stimmen und selbst Hochzeitslieder.</p>
<p class="calibre3">Auch im Hause der Dominikbäuerin entstand ein Lärm und eine
Verwirrung, wie es an solchen Tagen üblich ist.</p>
<p class="calibre3">Das Haus war frisch geweißt worden, und obgleich der Kalk von
der Nässe etwas abgeblättert war, leuchtete es schon von weitem;
auch geschmückt war es wie zum Pfingstfest. <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page286" title="MEsswein/gary"></a> Die Burschen hatten schon
gestern überall, ins Strohdach und wo nur Ritzen in den Wänden
waren, Tannenreiser gesteckt und den ganzen Heckenweg, von der
Dorfstraße bis zum Flur mit Fichtennadeln bestreut/es duftete wie
im Forst zur Frühlingszeit.</p>
<p class="calibre3">Und auch innen war alles fein säuberlich hergerichtet.</p>
<p class="calibre3">Auf der anderen Seite, wo sonst ein Aufbewahrungsort für altes
Gerümpel war, loderte ein tüchtiges Feuer, an dem die Eve vom
Müller unter Beihilfe von Gusche und ein paar Nachbarinnen das Amt
der Köchin versah.</p>
<p class="calibre3">Aus der ersten Stube hatten sie jegliches überflüssige Gerät in
die Kammer getragen, daß nur die Bilder zurückgeblieben waren. Die
Jungen stellten starke Bänke und lange Tische an den Wänden entlang
auf. Die Stube war auch neu geweißt, sauber gescheuert und der Herd
mit einem hellblauen Leintuch bedeckt. Die Stubendecke und die
altersschwarzen Balken aber hatte Jagusch reich mit Papiermustern
verziert. Matheus hatte aus der Stadt buntes Papier gebracht und
sie hatte daraus zackige Räderchen, Blümlein und verschiedene
Seltsamkeiten ausgeschnitten; Hunde zum Beispiel, die Schafe vor
sich herjagen, und den Hirten mit seinem Stock hinterdrein laufend,
oder eine ganze Prozession mit einem Priester, mit Fahnen und
Bildern und andere Verschiedenheiten, daß es schwer ist alles zu
behalten; und alles war so getroffen und so lebendig wiedergegeben,
daß sich die Menschen gestern am Polterabend darüber gewundert
hatten./Sie konnte auch ganz anderes noch, alles was sie sich nur
dachte, oder was sie ansah, konnte sie machen ..., so daß es in
Lipce kein Haus gab ohne diese ihre Papierbilder ...</p>
<p class="calibre3">Sie hatte sich in der Kammer etwas in Ordnung gebracht und kam
heraus, den Rest der Papierbilder an den Wänden entlang unter den
Heiligenbildern aufzukleben, denn anderswo war schon kein Platz
mehr.</p>
<p class="calibre3">»Jagusch! du könntest jetzt wahrlich schon deinen wunderlichen
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page287" title="MEsswein/gary"></a> Kram in
Ruhe lassen, die Brautjungfern müssen in diesem Augenblick noch
kommen... die Menschen fangen bald an, sich einzufinden; die Musik
geht auch schon im Dorf herum ... und die gibt sich mit Spielereien
ab...«</p>
<p class="calibre3">»Ich komm noch zurecht ...,« gab sie kurzweg zur Antwort, und
ließ bald das Aufkleben nach; denn sie hatte schon keine rechte
Geduld mehr dazu ... Sie streute noch Fichtennadeln über den
Fußboden aus, bedeckte die Tische mit feinem Linnen, räumte in der
Kammer auf, neckte sich mit den Brüdern herum und ging dann vor die
Tür hinaus, um lange in die Weite zu sehen! Gar keine Freude fühlte
sie in sich, gar keine. Sie dachte nur, daß sie sich satt tanzen
würde und daß es Musik und Singen geben würde, worauf sie gerade
Lust hatte. Sie war wie dieser helle, funkelnde und doch
herbsttote, stumme Tag. Wenn sie nicht alles daran erinnert hätte,
daß heute Hochzeit sein sollte, würde sie nicht daran gedacht
haben. Boryna hatte ihr gestern am Polterabend acht Schnüre
Korallen geschenkt, die er von den beiden Seligen noch hatte... Sie
lagen tief in der Lade, nicht einmal anprobiert hatte sie sie...
Sie gab nichts drauf, ihr war heute überhaupt alles gleich ... Nur
irgendwo fortlaufen hatte sie mögen, vor sich hinrennen, wenn auch
in die weite Welt ... aber wohin da? Wußte sie es denn! Alles war
ihr heute zuwider, immer nur kam es ihr in den Sinn, was die Mutter
über Antek gesagt hatte ... »Wie denn nur, er hatte Schlechtes über
sie geredet, er? ...« Sie konnte das nicht glauben, sie wollte
nicht ... ein Weinen kam ihr an, wenn sie nur daran dachte! ...
Wenn er aber doch! ... gestern, als sie am Weiher die Wäsche wusch,
ging er vorbei, ohne sie auch nur anzusehen! Und als sie des
Morgens mit Boryna zur Beichte gingen und ihm vor der Kirche
begegneten ... ist er doch auf der Stelle umgekehrt, wie vor einem
bösen Hund ... Und wenn aber doch? ... Dann laß ihn geifern, wenn
er so ist, laß ihn geifern!...</p>
<p class="calibre3">Sie fing an, sich gegen ihn zu empören, plötzlich aber <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page288" title="rudi49/gary"></a> stürzten die
ganzen Erinnerungen an jenen Abend, als sie von Boryna vom
Kohlschälen heimkehrten, auf sie ein, tauchten sie ganz in Feuer,
umschlangen ihre Seele mit solcher Macht und lebten so greifbar in
ihr auf, daß sie sich nicht mehr zu helfen wußte ... und sich mit
einmal an die Mutter wandte:</p>
<p class="calibre3">»Wißt ihr aber, nach der Trauung sollt ihr mir nicht mein Haar
abschneiden!«</p>
<p class="calibre3">»Hale, was die sich Kluges ausgedacht hat!/Hat man das je
gehört, daß man dem Mädchen nach der Trauung die Haare nicht
stutzt!«</p>
<p class="calibre3">»Aber die auf den Herrenhöfen und in den Städten werden auch
nicht geschoren!«</p>
<p class="calibre3">»Natürlich, versteht sich, weil ihnen das so paßt für ihre
Zügellosigkeit, damit sie die Menschen beschwindeln und sich für
was anderes ausgeben können. Neue Ordnungen wird sie hier
einführen! Laß die Frauenspersonen vom Herrenhof was Komisches aus
sich machen, daß die Leute darüber lachen müssen, laß sie mit
Zotteln wie die Judenmädchen herumlaufen/das können sie, wenn sie
so dumm sind; du aber bist eine Hofbauerntochter von Ahn und Urahn
und keine Stadtschlampe, darum mußt du es machen, wie es unser
Herrgott befohlen hat und wie man es immer in unserem Bauernstand
gehalten hat ... Ich kenne diese städtischen Erfindungen, ich kenn'
sie ... die sind noch niemandem zum Wohl geraten! Ist nicht die
Pakulanka in die Stadt dienen gegangen, und was nun? ... Der
Schulze hat es mir gesagt, ein Papier wäre in die Kanzlei gekommen,
daß sie ihr Kind erwürgt hat und im Kriminal sitzt ... oder auch
dieser Wojtek, Borynas Verwandter von der Schwester Seite, hat sich
mächtig was in der Stadt beiseitegelegt, daß er jetzt in den
Dörfern rundum auf den Bettel gehen muß ... und früher da hatte er
einen Hof in Wolka, und Pferde und Brot soviel er wollte ...
Semmeln wollte er essen, da hat er nun einen Stock und einen
Bettelsack für die alten Tage.« <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page289" title="Monne3/gary"></a> Jagna aber gab nicht acht auf die weisen
Beispiele und wollte nichts vom Abschneiden des Haares wissen ...
Auch Eve versuchte sie zu überreden, und gerade sie war eine, die
sich auskannte, nicht nur ein Dorf hatte sie gesehen, und ging
jahraus jahrein mit den Pilgerzügen nach Tschenstochau. Auch die
Gusche machte ihr die Sache klar, aber wie sie nun einmal war,
konnte es nicht ohne Sticheleien und Gespött abgehen, und
schließlich sagte sie:</p>
<p class="calibre3">»Laß du den Zopf, laß ihn nur, der wird Boryna zu paß kommen, um
die Hand wird er ihn sich wickeln, um dich besser dran zu halten
und dir fester mit dem Stock welche draufzuzählen ... dann wirst du
ihn noch selber abschneiden... Ich kannte manch eine ...« weiter
kam sie nicht, denn Witek tauchte auf, um sie zu rufen. Nach der
Vertreibung der Anteks war sie nämlich zu Boryna übergesiedelt,
weil Fine mit der Wirtschaft nicht fertig werden konnte. Sie half
heute der Eve beim Kochen, und ging ab und zu hinüber, auf die
Wirtschaft zu sehen, denn der Alte hatte heute zu nichts Sinn, die
Fine war schon seit Morgen bei den Schmiedsleuten, um sich da
auszuputzen, und der Jakob lag noch immer krank.</p>
<p class="calibre3">»Kommt rasch, der Jakob verlangt nach euch,« drängte der
Junge.</p>
<p class="calibre3">»Geht es ihm denn schlechter?«</p>
<p class="calibre3">»Versteht sich, er jammert und stöhnt, daß man es bis auf der
Dorfstraße hört!«</p>
<p class="calibre3">»Ich komm' in diesem Nu. I du mein, ich will nur eben sehen, was
mit ihm los ist und komm' gleich wieder ...«</p>
<p class="calibre3">»Beeil' du dich auch, Jagusch. Wir haben gleich die
Brautjungfern im Haus,« trieb die Mutter an.</p>
<p class="calibre3">Aber Jagusch eilte sich nicht, sie ging wie im Traum herum, ließ
sich hier und da auf eine Bank fallen, dann wieder sprang sie auf
und fing an aufzuräumen, aber die Arbeit glitt ihr aus den Händen,
und sie blieb lange stehen, gedankenlos durchs Fenster starrend.
Die Seele schaukelte in <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page290" title="Monne3/gary"></a> ihr wie bewegtes Wasser und schlug immer wieder
an die Erinnerungen, wie gegen einen Stein ...</p>
<p class="calibre3">Im Hause aber entstand ein immer lauteres Stimmengewirr, denn in
einem fort kamen verschiedene Gevatterinnen, Verwandte und
Hofbäuerinnen hereingelaufen und brachten nach der alten Sitte
Hühner, einen Leib Weißbrot, Butterkuchen, Salz, Mehl, Speck oder
auch einen in Papier gewickelten Silberrubel / und alles das als
Dank für die Hochzeitseinladung, damit die Wirtin sich nicht zu
große Unkosten machen sollte.</p>
<p class="calibre3">Sie tranken der Brautmutter mit einem Gläschen Süßen zu,
plauschten miteinander, bestaunten alles und liefen rasch ihrer
Wege.</p>
<p class="calibre3">Die Dominikbäuerin war emsig an der Arbeit / sie überwachte die
Zubereitung des Festschmauses, räumte auf, gab Anweisungen, hielt
ihr wachsames Auge über allem und hatte für alles einen guten Rat
bereit; sie mußte die Jungen immerzu antreiben, denn sie ließen
sich viel Zeit, und sobald es nur ging, lief einer von ihnen ins
Dorf zum Schulzen, denn da waren schon die Musikanten, und die
Brautführer sammelten sich dort.</p>
<p class="calibre3">Zum Gottesdienst war kaum einer gegangen, was Hochwürden recht
erzürnt hatte, denn um einer Hochzeit willen durfte man doch nicht
den Kirchgang vergessen / was ja schon recht war, aber das Volk
meinte, daß solche Hochzeiten nicht jeden Sonntag gefeiert
würden.</p>
<p class="calibre3">Gleich nach Mittag fingen die geladenen Gäste aus den
benachbarten Dörfern an einzutreffen.</p>
<p class="calibre3">Die Sonne hatte schon die Mittagshöhe überschritten und streute
blasses herbstliches Licht aus, so daß die Erde wie übertaut
gleißte, die Fenster flammten, der Weiher schimmerte und glitzerte,
die wassergefüllten Gräben am Weg flimmerten wie Fensterscheiben
und die ganze Welt war wie gesättigt mit dem Licht und mit der
letzten Wärme des ersterbenden Herbstes.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page291" title="DaoH/gary"></a> Eine
dumpfe, stumme Stille umhüllte die übergoldete Erde.</p>
<p class="calibre3">Der Tag brannte grell zu Ende und erlosch langsam.</p>
<p class="calibre3">Aber in Lipce war ein Getöse wie auf einem Jahrmarkt.</p>
<p class="calibre3">Gleich nachdem man die Vesper ausgeläutet hatte, schoben die
Musikanten vom Hause des Schulzen auf die Dorfstraße hinaus.</p>
<p class="calibre3">Zu vorderst kam die Geige mit der Flöte, hintennach brummelte
die Trommel mit den klirrenden Schellen, und der Brummbaß im Putz
der bunten Bänder hupfte hinterdrein.</p>
<p class="calibre3">Hinter den Musikanten kamen die beiden Brautbitter und die
Brautführer/sechs an der Zahl.</p>
<p class="calibre3">Und alles junge Burschen, stattlich und schlank wie Fichten
anzuschauen, dünn in der Taille, in den Schultern breit gewachsen,
leidenschaftliche Tänzer, trotzige, herrische Schnauzen, stolze
Draufgänger, die vor nichts beiseite drehen/lauter Hofbauernsöhne,
erbangesessene.</p>
<p class="calibre3">Sie stampften zu einem Haufen eng aneinander gedrängt inmitten
des Wegs daher, so daß die Erde unter ihren Füßen dröhnte; sie
kamen freudig und festlich angeschritten und waren prächtig
anzusehen. Die gestreiften Hosen, die roten Spenzer, die Büschel
bunter Bänder an den Hüten ließen ihre Farben im Sonnenschein
spielen und die aufgeknöpften weißen Haartuchröcke blähten sich im
Wind wie Flügel ...</p>
<p class="calibre3">Sie juchheiten hellauf, sangen sich einen, trampelten verwegen
im Takt dazu und kamen so brausend dahergezogen, als ob ein junger
Forst sich im Sturm auf die Wanderschaft gemacht hätte ...</p>
<p class="calibre3">Die Musik spielte ihnen einen Polnischen auf und sie zogen von
Haus zu Haus, die Hochzeitsgäste einzuholen./ Hier trug man ihnen
Branntwein heraus, dort lud man sie in die Stube ein, anderswo
antwortete man ihnen mit Gesängen/ und von überall kamen
geschmückte Menschen herbei, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page292" title="DaoH/gary"></a> die sich ihnen anschlossen, um gemeinsam
weiterzuziehen. Vor den Fenstern der Brautjungfern stimmten schon
alle miteinander das althergebrachte Lied an:</p>
<p class="vers">Komm' heraus, Brautjungferlein, komm' heraus
Kathrinchen,<br class="calibre2"/>
Komm', es ist schon Zeit/<br class="calibre2"/>
Es werden dir spielen, es werden dir singen<br class="calibre2"/>
Baß und Geige zum Geleit/<br class="calibre2"/>
Und wer nicht satt zu essen kriegt und nicht genug zu trinken
...<br class="calibre2"/>
Der geh' nach Haus zur rechten Zeit!<br class="calibre2"/>
Oj-ta-dana-dana! Oj-ta-dana-da! ...</p>
<p class="calibre3">Sie juchzten gemeinsam und mit solcher Macht, daß es durchs
ganze Dorf schallte, daß die frohen Stimmen über die Felder
klangen, im Wald hallten und in die weite Welt flogen.</p>
<p class="calibre3">Die Leute traten vor die Häuser, eilten in die Gärten,
kletterten auf die Zäune, und auch manch einer, der nicht zu der
Hochzeitsgesellschaft gehörte, schloß sich ihnen an, um Aug und Ohr
zu sättigen. Fast das ganze Dorf hatte sich um die Hochzeitsbitter
geschart und sie mit einem dichten Haufen umdrangt, ehe sie noch
ankamen, so daß sie immer langsamer gingen. Ein zahlloser
Kinderschwarm rannte ihnen voraus, kreischte und sang mit.</p>
<p class="calibre3">Sie geleiteten die Gäste bis ans Hochzeitshaus und spielten
ihnen zu einem würdigen Eintritt auf, um dann nach dem Haus des
Bräutigams umzukehren.</p>
<p class="calibre3">Witek, der im Spenzerrock mit Bandkokarde und flatternden
Bändern stolz hinter den Brautführern herging, sprang jetzt
voraus.</p>
<p class="calibre3">»Hofbauer, die Musik mit den Brautführern kommt!« schrie er ins
Fenster hinein und rannte zu Jakob hin.</p>
<p class="calibre3">Mit Schwung begannen sie auf der Hausgalerie zu spielen; da trat
in einem Nu Boryna heraus, sperrte die Tür weit auf, begrüßte sie
alle und lud sie ein, hineinzutreten; doch der Schulze und Simeon
faßten ihn unter die Arme und führten ihn schon geradewegs zu
Jagna, denn es war Zeit, zur Kirche zu gehen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page293" title="DaoH/gary"></a> Er ging
rasch, und es war erstaunlich, wie jung er aussah; das Haar
gestutzt, das Gesicht sein sauber ausrasiert, sah er stattlich aus
in seiner festlichen Kleidung wie kaum einer; und da er mächtig
viel von sich hielt, so fiel seine breitgewachsene Gestalt schon
von weitem auf durch die Würde, die sich auch in seinem Antlitz
ausprägte; er scherzte fröhlich mit den Burschen, redete dies und
das und wandte sich immer wieder an den Schmied, der ihm ständig in
den Weg kam.</p>
<p class="calibre3">Würdig führten sie ihn zur Dominikbäuerin hinein; das Volk trat
auseinander, sie aber geleiteten ihn mit Musik und Singen
geräuschvoll in die Stube.</p>
<p class="calibre3">Jagusch war nicht zugegen, die Frauen putzten sie noch in der
Kammer, die fest verschlossen war und eifrig gehütet wurde, denn
die Burschen versuchten gegen die Tür anzudrücken und eine Ritze in
der Bretterwand aufzukratzen. Sie neckten sich in einem fort mit
den Brautjungfern herum, so daß ein Gekreisch, Gelächter und
Weibergeschrei entstand.</p>
<p class="calibre3">Die Mutter mit den Söhnen empfing die Gäste, bewirtete sie mit
Schnaps, führte die Respektspersonen nach den Bänken und gab auf
alles acht. Es hatte sich so viel Volk eingefunden, daß man sich
nur mit Mühe durch die Stube drängen konnte; sie standen bis auf
dem Flur und selbst noch auf dem Heckenweg. Und nicht geringe
Gäste, nein. Lauter Hofbauern, erbangesessene und von den
reichsten. Alles Verwandte und Verschwägerte, Vetters- und
Gevattersleute der Borynas und Patsches, obendrein noch alle guten
Bekannten selbst aus den Dörfern weit im Umkreis.</p>
<p class="calibre3">Natürlich, daß weder Klemb noch die Wintzioreks noch die armen
Teufel, die auf einem Morgen saßen, mit dabei waren, oder gar das
kleine Volk, das auf Taglohn ging und es immer mit dem alten Klemb
hielt ...</p>
<p class="calibre3">Nicht für den Hund ist die Wurst und nicht für die Schweine der
Honig!</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page294" title="DaoH/gary"></a> Erst in
etwa zwei Paternostern öffnete man die Tür zur Kammer und die
Organistin mit der Müllerin führten Jagusch in die Stube. Die
Brautjungfern bildeten einen Kranz um sie; sie hatten sich so
geputzt und sahen so stattlich aus, daß sie wie Blumen waren und
doch nicht Blumen, und die Braut, die am stattlichsten gewachsene
von allen, stand wie die schönste Rose mitten unter ihnen, ganz in
bunten Samten, in weißen Stoffen, in Federn, Bändern, Silber und
Gold/so daß sie wie ein Bild anzusehen war, daß man bei den
Prozessionen voranträgt. Es wurde plötzlich ganz still, so stumm
und starr waren die Leute.</p>
<p class="calibre3">Ha! wahrlich! Seit Mazuren Mazuren ist, gab es hier keine
schönere Braut!</p>
<p class="calibre3">Im Nu vollführten die Brautführer einen starken Lärm und sangen
aus voller Kehle:</p>
<p class="vers">Spiele, Geiger, spiele vor dem Haus,<br class="calibre2"/>
Und du, Jagusch, söhn' dich mit den Eltern aus!<br class="calibre2"/>
Spiele, Geiger, spiele vor dem Haus,<br class="calibre2"/>
Und du, Jagusch, söhn' dich mit den Brüdern aus!</p>
<p class="calibre3">Boryna trat hervor, faßte ihre Hand und kniete mit ihr nieder,
die Mutter machte ein Kreuz über beide mit einem Heiligenbild,
segnete sie und sprengte Weihwasser aus, bis Jagusch mit einem Male
zu weinen anfing und ihre Füße umfaßte, dann umschlang sie die Knie
der anderen, bat um Verzeihung und nahm Abschied von allen. Die
Frauen nahmen sie in die Arme, umhalsten sie und schoben sie
einander zu, bis sie alle mitsammen zu weinen anfingen; mit der
größten Inbrunst begann aber Fine zu schluchzen, da ihr die selige
Mutter in den Sinn kam.</p>
<p class="calibre3">Alles strömte zum Hause hinaus, stellte sich in Reih und Glied
und ging zu Fuß der nahegelegenen Kirche zu.</p>
<p class="calibre3">Die Musikanten gingen voraus und bliesen und schwangen die
Fiedelbogen aus vollen Kräften.</p>
<p class="calibre3">Hinter ihnen wurde Jagna von den Brautführern geleitet/ sie ging
im üppigen Gang, durch Tränen lächelnd, die <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page295" title="DaoH/gary"></a> ihr noch an den Wimpern hingen;
festlich war sie wie ein Blütenstrauch und zog wie eine Sonne die
Augen aller auf sich; ihr Haar umkränzte die Stirn in Flechten, und
über ihnen trug sie eine Brautkrone aus Pfauenfedern, güldenem Tand
und Rosmarinblütenzweigen. Und lange buntfarbene Bänder fielen von
dieser Krone auf ihre Schultern herab und flatterten und flogen
surrend in einem Regenbogen hinter ihr her; der weiße Rock war
reich gekräuselt in der Taille, das Mieder aus himmelblauem Samt
war mit Silber ausgenäht, das Hemd hatte weitgebauschte Ärmel und
schloß am Halse mit einer blau festonierten, reich gefältelten
Falte ab; Schnüre von Korallen und Bernsteinperlen hingen ihr bis
auf die Brust herab.</p>
<p class="calibre3">Dann folgten die Brautjungfern mit Matheus. Wie die breitastige
Eiche im Forst der schlanken Fichte folgt, so folgte er Jagusch
nach; er schaukelte sich in den Hüften und sah sich nach beiden
Seiten des Weges um. Ihm war als hatte er eben Anteks Gesicht im
Gedränge auftauchen sehen.</p>
<p class="calibre3">Und dann erst kam die Dominikbäuerin mit den Brautbittern, die
Schmiedsleute, Fine, die Müllersleute, die Organistin und was so
die ersten waren.</p>
<p class="calibre3">Zum Schluß aber drängte das ganze Dorf ihnen nach, den Weg dicht
füllend.</p>
<p class="calibre3">Die Sonne ging schon unter, hing rot und groß über dem Walde und
übergoß den ganzen Weg, den Weiher und die Häuser mit einem
blutigen Schein; sie aber gingen langsam in diesen Gluten dahin,
daß es einem in den Augen flimmerte, von diesen Bändern,
Pfauenfedern, Blumen und all diesen roten Beinkleidern,
orangefarbenen Frauenröcken, Kopftüchern und weißen Männerröcken.
Es war als ob ein mit aufgeblühten Blumen bedecktes Feld langsam
dem Wind entgegenging und schaukelte und sang, die Brautjungfern
nämlich stimmten immer wieder mit dünnen Stimmen das Lied an:</p>
<p class="vers"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page296" title="DaoH/gary"></a> Es fahren, es fahren, es rollen die Wagen/<br class="calibre2"/>
Sie taten dir weinend den Abschied sagen ...<br class="calibre2"/>
          Hei!<br class="calibre2"/>

Die frohen Lieder singen und klingen/<br class="calibre2"/>
Sie werden dir, Jagusch, Bitternis bringen ...<br class="calibre2"/>
          Hei!</p>
<p class="calibre3">Die Dominikbäuerin setzte während des ganzen Weges immer wieder
zum Weinen an und bestaunte die Tochter wie ein Heiligenbild, so
daß sie nichts hörte, was man zu ihr sprach.</p>
<p class="calibre3">In der Kirche zündete schon Ambrosius die Kerzen auf dem Altar
an.</p>
<p class="calibre3">In der Vorhalle machten sie sich noch zurecht, ordneten sich zu
Paaren und marschierten dann auf den Altar los, denn auch der
Priester kam schon aus der Sakristei.</p>
<p class="calibre3">Die Trauung vollzog sich rasch, denn der Priester hatte es eilig
zu einem Kranken. Und als sie die Kirche verlassen wollten, fing
der Organist an, auf der Orgel solche Mazurkas, Obereks und solche
Kujawentänze aufzuspielen, daß die Füße von selbst aufzuckten, und
manch einem wäre fast ein Lied entschlüpft;/ein Glück, daß er sich
noch zur rechten Zeit besonnen hatte.</p>
<p class="calibre3">Sie kehrten schon ohne jegliche Festordnung, die ganze Breite
der Dorfstraße einnehmend, heim, und gingen wie es grad' einem
jeden gefiel. Es ging schon ziemlich hoch her, denn die Brautführer
und Brautjungfern sangen, als gälte es ihr Leben.</p>
<p class="calibre3">Die Dominikbäuerin lief schneller voraus, und als sie kamen,
begrüßte sie schon Braut und Bräutigam auf der Schwelle des Hauses
mit geweihtem Brot, Salz und einem Heiligenbild, und fing danach
erst an, die anderen von neuem zu bewillkommnen, zu umarmen und in
die Stube zu bitten.</p>
<p class="calibre3">Die Musik spielte im Flur auf, und jeder, der über die Schwelle
kam, griff nach der ersten besten Frau, deren er habhaft werden
konnte und fügte sich mit ihr gleitenden <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page297" title="DaoH/gary"></a> Schrittes in den »Gehetanz« ein/so
zogen die Paare wie eine buntgescheckte Schlange in der Stube im
Kreise herum, bogen sich, umkreisten sich, kehrten bedächtig um,
stampften würdevoll auf, wiegten sich wie es sich gehörte, gingen,
schoben sich vorüber, schlängelten sich Paar nach Paar, Kopf bei
Kopf/wie ein ins Wogen gekommener Streifen reifen Roggens, den Mohn
und Kornblumen reich durchwirken/ und vorne als erstes Paar war
Jagusch mit Boryna!</p>
<p class="calibre3">Die Lichter, die am Gesims des Rauchfanges aufgestellt waren,
flackerten, das Haus wankte, so daß es schien als müßten die Wände
bersten von all dem Gedränge und der Macht, die von den Tänzern
strömte ...</p>
<p class="calibre3">Sie wandelten ein gutes Paternoster lang, ehe sie fertig
wurden.</p>
<p class="calibre3">Die Musik fing jetzt an, zum ersten Brauttanz zu präludieren,
einer alten Sitte gemäß.</p>
<p class="calibre3">Die Leute hatten sich an den Wänden entlang dicht
zusammengedrängt und füllten alle Winkel, die Burschen aber
bildeten einen großen Kreis, in dem Jagna zu tanzen begann! Das
Blut wallte in ihr auf, daß ein Leuchten in ihre blauen Augen stieg
und die weißen Zähne aus dem erglühten Gesicht aufblitzten; sie
tanzte unermüdlich, die Tänzer immer wieder wechselnd, denn wenn es
auch nur einmal in die Runde sein sollte, so mußte sie doch mit
jedem herumtanzen.</p>
<p class="calibre3">Die Musikanten spielten scharf, daß ihnen fast die Hände lahm
wurden, aber Jagusch hatte erst begonnen; ihr Gesicht hatte sich
nur etwas stärker gerötet; sie wirbelte mit solcher Leidenschaft im
Kreise herum, daß die Bänder surrend hinter ihr her flatterten, die
Gesichter der Umstehenden peitschend, und ihre Röcke, vom
Wirbelwind des Tanzes aufgebläht, sich in der Stube
ausbreiteten.</p>
<p class="calibre3">Und die Burschen trommelten vor Vergnügen mit den Fäusten auf
die Tische und stießen verwegene Juchzer aus.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page298" title="DaoH/gary"></a> Erst zum
Schluß wählte sie sich den Bräutigam/Boryna hatte darauf schon
längst gewartet; er sprang wie ein Luchs auf sie zu, faßte sie um
die Taille und drehte sie stürmisch vom Fleck weg im Kreise herum,
den Musikanten zuschreiend:</p>
<p class="calibre3">»Den mazurischen Jungen, aber 'n festen!«</p>
<p class="calibre3">... Sie stießen aus ganzer Macht in die Instrumente, so daß es
in der Stube aufkochte.</p>
<p class="calibre3">Boryna aber umfaßte Jagna nur noch stärker, warf die Rockschöße
über den Arm, setzte den Hut zurecht, klappte die Absätze
gegeneinander und stob von der Stelle wie ein Sturmwind davon!</p>
<p class="calibre3">Heia! wie der tanzte! ... tanzte ... tanzte ... wie er sich auf
einer Stelle um sich selber drehte, linksum schwenkte, mit den
Hacken einen Wirbel schlug, daß vom Fußboden die Splitter flogen
und laut aufjuchzte, und mit Jagusch herumwarf und wirbelte, bis
sie nur noch wie ein wirres Knäuel waren und wie eine
vollgewickelte Spindel sich in der Stube drehten./Es strömte nur
mehr ein Wind und eine einzige Kraft von ihnen.</p>
<p class="calibre3">... Die Musik fiedelte glühend, selbstvergessen ihre maurische
Weise ...</p>
<p class="calibre3">Alles drängte sich in die Türen und staute sich in den Ecken,
verstummte und sah mit Staunen zu; er aber tanzte, unermüdlich und
immer verwegener. Es konnte schon manch einer nicht mehr an sich
halten, denn die Füße sprangen ihm schon von selber, so trampelte
man nur im Takte mit, und wer hitziger war, nahm sein Mädchen und
warf sich in den Tanz, auf nichts mehr achtend.</p>
<p class="calibre3">Jagusch aber wurde doch bald matt, obgleich sie kräftig genug
war, und fing an, ihm aus den Händen zu gleiten; da erst hörte er
auf und führte sie in die Kammer.</p>
<p class="calibre3">»Da du ein solcher Prachtkerl bist, so laß uns Brüder sein, und
bei der ersten Taufe sollst du mich zum Paten haben!« rief der
Müller, ihn in seine Arme schließend.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page299" title="DaoH/gary"></a> Sie
verbrüderten sich gleich herzlich, denn die Musik verstummte und
die Bewirtung begann.</p>
<p class="calibre3">Die Dominikbäuerin, die Söhne, der Schmied, die Gusche gingen
eifrig mit vollen Flaschen, die Schnapsgläser in der Hand, herum
und tranken einem jeden einzeln zu. Fine aber und die Gevatterinnen
reichten Butterbröte und Kuchen auf Sieben umher.</p>
<p class="calibre3">Ein immer größerer Lärm entstand, denn jeder sprach laut sein
Teil, und alle griffen erfreut nach den Gläsern, um sich das Fest
so recht zugute kommen zu lassen.</p>
<p class="calibre3">Auf die Bänke am Fenster setzten sich der Müller mit Boryna, der
Schulze, der Organist und was so die ersten Hofbauern waren. Es
ging dort schon eine nicht zu kleine Flasche Arrak von Hand zu Hand
und nicht in einer Runde; man trug ihnen außerdem noch Bier
hinzu/sie tranken eifrig auf gegenseitiges Wohl, fingen schon an,
sich zu umarmen und sich miteinander mächtig zu verbrüdern!</p>
<p class="calibre3">Und in der Stube stand das Volk haufenweis beieinander, mit wem
und wie es einem gerade paßte, man redete laut und unterhielt sich
nicht schlecht bei seinem Gläschen.</p>
<p class="calibre3">In der Kammer, die von einer von den Organistenleuten geborgten
Lampe erhellt war, hatten sich die Hofbäuerinnen, mit der
Organistin und Müllerin an der Spitze, niedergelassen; auf Truhen
und Bänken, die mit Beiderwandröcken bedeckt waren, saßen sie
würdevoll, schlürften Meth durch die Zähne, bröckelten sich mit
gespreizten Fingern Stückchen von ihrem süßen Kuchen ab, und wenn
eine hin und wieder etwas sagte, so war es nur ein Wort: sie hörten
aufmerksam zu, was die Müllerin von ihren Kindern erzählte.</p>
<p class="calibre3">Selbst im Hausflur herrschte eine Enge, und etliche versuchten
obendrein schon auf die andere Seite einzudringen. Eve mußte sie
hinaustreiben, denn man bereitete emsig das Abendessen vor, von dem
schon liebliche Düfte durchs ganze Haus zogen, so daß es manch
einen in die Nase stach.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page300" title="DaoH/gary"></a> Die Jugend
hatte sich vors Haus begeben, verweilte auf dem Heckenweg und saß
auf der Mauerbank. Die Nacht war kalt, still und ganz wie mit
Sternen betaut, man kühlte sich ab und tollte lustig herum, daß es
vor Lachen, Gekreisch und Gelaufe nur so dröhnte; einige jagten im
Obstgarten hintereinander her, so daß die Alten ihnen aus den
Fenstern zuschrien:</p>
<p class="calibre3">»Blümlein sucht ihr da, Mädels? Paßt ihr auf, daß ihr da nichts
verliert im Dustern.«</p>
<p class="calibre3">Wer tat auf sie achten?</p>
<p class="calibre3">In der ersten Stube aber wandelten Jagusch und Nastuscha Täubich
herum, hielten sich umschlungen, kicherten immerzu und flüsterten
sich allerhand ins Ohr. Schymek, der Älterste der Dominikbäuerin,
hatte sein Augenmerk auf sie gerichtet und verfolgte Nastuscha mit
seinen Blicken überallhin, trat immer wieder mit Schnaps an sie
heran, lachte sie an und versuchte ein Gespräch anzuknüpfen.</p>
<p class="calibre3">Der Schmied, festlich gekleidet in einem schwarzen Knierock, die
Hosen über die Stiefelschäfte, machte sich am eifrigsten zu
schaffen, er war überall da, trank mit jedermann, forderte auf,
bewirtete, räsonnierte und war so geschäftig, daß man immerzu in
einer anderen Ecke seinen rothaarigen Kopf mit dem sommersprossigen
Gesicht auftauchen sah.</p>
<p class="calibre3">Die Jugend hatte ein paarmal herumgetanzt, doch nur kurz und
ohne große Lust, da man schon auf das Festmahl lauerte.</p>
<p class="calibre3">Die Alten aber redeten untereinander, und der Schulze, der schon
angetrunken war, schrie immer lauter, blähte sich, schlug mit der
Faust auf den Tisch und trumpfte auf:</p>
<p class="calibre3">»Der Schulze sagt es euch, dann glaubt. Ein Beamter bin ich, das
Papier hab' ich gekriegt und Order hab' ich, die Gemeinde zu
berufen, damit wir ein paar Groschen pro Morgen für die Schule
bewilligen.«</p>
<p class="calibre3">»Ihr könnt euch gern auch fünf Kopeken pro Morgen bewilligen,
Peter, wir tun nicht einen Heller geben!«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page301" title="lesebaer/gary"></a> »Das
tun wir nicht!« wetterte einer los.</p>
<p class="calibre3">»Still da, nötig ist es, wenn eine amtliche Person das sagt
...«</p>
<p class="calibre3">»Eine solche Schule brauchen wir nicht!« sagte Boryna.</p>
<p class="calibre3">»Jawohl, die brauchen wir nicht,« wiederholten die anderen im
Chor.</p>
<p class="calibre3">»Hast du nicht gesehen ... In Wola haben sie solche Schule, drei
Winter lang sind meine Kinder hingegangen; und was? ... nicht mal
ihr Gebet können sie aus dem Gebetbuch lesen ... für die Katz ist
solch ein Unterricht!«</p>
<p class="calibre3">»Laßt die Mütter das Gebet lehren, dazu ist nicht die Schule da,
ich sag' es euch, der Schulze.«</p>
<p class="calibre3">»Und wozu denn sonst zum Beispiel?« brüllte der andere aus Wola
los und sprang von der Bank auf.</p>
<p class="calibre3">»Ich, der Schulze, will es euch sagen, paßt nur gut auf...
gleich, zum ersten ...« aber er brachte seine Erklärung nicht zum
Schluß, denn Simeon schrie über den ganzen Tisch herüber, den
verkauften Wald hätten die Juden schon gezeichnet und würden ihn
bald fällen, sie warteten nur auf Frost und Schlittenbahn.</p>
<p class="calibre3">»Laß sie sich man ihren Wald zeichnen, das Fällen können sie
sich in den Baum hängen ...,« warf Boryna ein.</p>
<p class="calibre3">»Zum Bauernkommissar gehen wir klagen.«</p>
<p class="calibre3">»Das ist nichts, der Kommissar hält es doch mit dem Gutsherrn;
aber alle zusammen sollte man hingehen und die Holzschläger
auseinander jagen.«</p>
<p class="calibre3">»Nicht eine Tanne darf man fällen lassen!«</p>
<p class="calibre3">»Man wird eine Klage vor Gericht einreichen!«</p>
<p class="calibre3">»Trinkt nur zu, Matheus, jetzt ist nicht die Zeit zum
Beratschlagen! Wenn man beim guten Trunk sitzt, ist es schon
leicht, zu drohen, und wenn es selbst dem Herrgott wäre,« rief der
Müller, frisch einschenkend. Diese Reden und Drohungen gingen ihm
wider den Strich, denn er hatte sich mit den Juden geeinigt und
sollte ihnen auf seiner Sägemühle das Holz schneiden.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page302" title="lesebaer/gary"></a> Sie
tranken einander sitzend zu und erhoben sich darauf, denn man fing
schon an, sich für das Abendessen vorzubereiten, das nötige Gerät
zusammenzutragen und auf die Tische zu setzen.</p>
<p class="calibre3">Die Bauern ließen aber die Waldfrage nicht fahren, wie sollte
man das auch, ein solcher wunder Punkt,... darum drängten sie sich
zusammen und mit gedämpfter Stimme, damit es der Müller nicht
hörte, beratschlagten sie und verabredeten sich, bei Boryna
zusammenzukommen, um irgendeinen Beschluß zu fassen ... aber sie
kamen nicht zu Ende, denn Ambrosius kam herein und schloß sich
ihnen ohne weiteres an. Er hatte sich verspätet, da er mit
Hochwürden bis im dritten Dorf, in Krosnowa, bei einem Kranken
gewesen war, und machte sich jetzt tüchtig ans Trinken, um alles
nachzuholen ... Doch es war nicht mehr Zeit genug, denn die älteren
Frauen sangen schon im Chor:</p>
<p class="vers">Und ihr lieben Brautführer, heut'<br class="calibre2"/>
Ladet zu Tisch die guten Leut'!</p>
<p class="calibre3">Darauf mit den Bänken einen Lärm vollführend, gaben die
Brautführer zur Antwort:</p>
<p class="vers">Sie sind schon geladen, sie sitzen zu Hauf<br class="calibre2"/>
Und gebt ihr was gutes dann essen sie's auf!</p>
<p class="calibre3">Und bedächtig ging man um die Tische herum, sich auf die Bänke
zu setzen.</p>
<p class="calibre3">Selbstverständlich saß auf den ersten Plätzen das Brautpaar, und
daneben von beiden Seiten, was so die ersten im Dorf waren dem
Ansehen, dem Vermögen und dem Alter nach, bis herunter zu den
Brautjungfern und Kindern. Sie hatten kaum Platz gefunden, obgleich
die Tische an drei Wänden entlang aufgestellt waren.</p>
<p class="calibre3">Nur die Brautführer, die die Gäste bedienten, sowie die
Musikanten setzten sich nicht.</p>
<p class="calibre3">Das Gewirr der Stimmen hatte sich gedämpft und nur der Organist
sprach laut und stehend das Gebet/der Schmied allein sprach mit,
denn, wie man wußte, konnte er ... auf <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page303" title="lesebaer/gary"></a> Lateinisch, und dann tranken
sie jeder einen auf die Gesundheit und zum guten Appetit.</p>
<p class="calibre3">Die Köchinnen begannen unter Beihilfe der Brautführer gewaltige
dampfende Schüsseln voll Essen hineinzutragen und sangen dazu:</p>
<p class="vers">Wir bringen euch Schüsseln voll Brühe mit
Reis<br class="calibre2"/>
Und drin selbst ein Federvieh zart und weiß!</p>
<p class="calibre3">Und beim zweiten Gang wurde gesungen:</p>
<p class="vers">Kutteln mit Pfeffer und Salzen<br class="calibre2"/>
Laßt froh die Zungen schnalzen!</p>
<p class="calibre3">Die Musikanten aber setzten sich um die Herdstelle und spielten
leise verschiedene Liedchen vor, um das Behagen am Schmaus zu
steigern.</p>
<p class="calibre3">Sie aßen denn auch voll Würde, langsam und fast im Schweigen vor
sich hin, kaum einer ließ ein Wort fallen, so daß nur das Schnalzen
der Zungen und das Schaben der Löffel die Stube füllte. Und als sie
schon etwas gegessen hatten und der erste Hunger gestillt war, ließ
der Schmied wieder eine Flasche die Runde machen, wobei man schon
anfing, etwas lebhafter zu reden und über den Tisch weg miteinander
zu räsonnieren.</p>
<p class="calibre3">Einzig Jagusch aß so gut wie gar nichts, vergeblich redete
Boryna auf sie ein, faßte sie um die Taille und redete ihr zu, wie
einem kleinen Kind. Nicht einmal ein Stückchen Fleisch konnte sie
herunterschlucken, so ermüdet war sie und heiß. Hin und wieder nur
trank sie einen Schluck kaltes Bier, ließ die Augen durch die Stube
schweifen und hörte mit einem Ohr auf Borynas Geflüster hin.</p>
<p class="calibre3">»Freust du dich, Jagusch, was? Du mein Schönchen! Du brauchst
dich nicht zu fürchten, Jagusch, gut wirst du es bei mir haben, daß
es dir selbst bei der Mutter nicht besser war ... Eine Herrin wirst
du sein, Jagusch, nur die Herrin ... ich will dir eine Magd halten,
damit du dich nicht abzuquälen brauchst ... du sollst schon sehen!
...« redete er leise in sie ein und sah ihr verliebt in die Augen,
ohne <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page304" title="lesebaer/gary"></a> mehr
auf die Menschen zu achten, so daß man sich schon laut über ihn
lustig machte.</p>
<p class="calibre3">»Wie so'n Kater um die Speckschwarte streicht er um sie
herum.«</p>
<p class="calibre3">»Ist auch ein fetter Bissen.«</p>
<p class="calibre3">»Und was der Alte sich dreht und um sie herumzappelt, da ist ein
Hahn nichts dagegen!«</p>
<p class="calibre3">»Wird der sich was auskosten, das alte Biest,« rief der
Schulze.</p>
<p class="calibre3">»Wie der Hund im Frost,« brummte der alte Simeon bissig.</p>
<p class="calibre3">Sie brachen in ein Gelächter aus, und der Müller legte sich fast
über den Tisch vor Vergnügen und trommelte mit der Faust
drauflos.</p>
<p class="calibre3">Die Köchinnen stimmten abermals an:</p>
<p class="vers">Fette Hirse tun wir euch tragen<br class="calibre2"/>
Ihr armen Teufel mit hungrigem Magen!</p>
<p class="calibre3">»Jagna, beug' dich zu mir 'ran, dann sag' ich dir was!« sprach
der Schulze, neigte sich hinter Borynas Rücken hinüber, denn er saß
neben ihm und kniff sie in die Hüfte; »mich da sollst du zum Paten
bitten!« rief er lachend und ließ seine lüsternen Augen über sie
hingehen, denn sie tat ihm ausnehmend gut gefallen. Sie errötete
stark, die Frauen aber stimmten dazu ein Gelächter an, und nu aber
los mit Geneck und gepfefferten Witzen und mit Ratschlägen, wie man
mit einem Mannsbild umgehen müsse!</p>
<p class="calibre3">»Und das Federbett mußt du jeden Abend vor dem Herd wärmen.«</p>
<p class="calibre3">»Die Hauptsache ist, daß er fettes Essen kriegt, dann wird er
schon Kräfte haben ...«</p>
<p class="calibre3">»Und schmeichle ihm, faß ihn oft um den Hals.«</p>
<p class="calibre3">»Nicht zu stramm halten, dann merkt er nicht, wo du ihn hinhaben
willst!« räsonnierten sie alle miteinander, wieso Frauen gewöhnlich
tun, wenn sie angeheitert sind und den Zungen freien Lauf
lassen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page305" title="lesebaer/gary"></a> Die
Stube erdröhnte vor Lachen, und zuletzt wurden sie so lose mit
ihren Mäulern, daß die Müllerin ihnen nahelegen mußte, doch auf die
jungen Mädchen und Kinder Rücksicht zu nehmen. Auch der Organist
setzte auseinander, daß es eine große Sünde sei, Ärgernis zu
verbreiten und ein schlechtes Beispiel zu geben.</p>
<p class="calibre3">»Denn Herr Jesus,« sprach er, »hat uns gesagt, und auch die
heiligen Apostel, was alles in den lateinischen Büchern dick
gedruckt steht, daß Totschlagen noch besser ist, als Ärgernis zu
erregen, denn wenn du bei einem von den Kleinen Ärgernis erregst,
dann ist es, als hättest du es mir selbst getan; so steht es in der
Heiligen Schrift/denn die Unzucht im Trinken und Essen, desgleichen
in Taten wird streng bestraft, das sag' ich euch, lieben Leute,«
stotterte er undeutlich, denn er hatte schon nicht ein und nicht
zwei Gläser getrunken ...</p>
<p class="calibre3">»Das Biest von Blasebalgtreter, den Spaß möchte er den Menschen
verbieten.«</p>
<p class="calibre3">»Am Priesterrock hat er gerochen, jetzt meint er, daß er heilig
ist!«</p>
<p class="calibre3">»Laß ihn sich die Ohren mit dem Kapottrock zustopfen!«
schwirrten die feindseligen Stimmen, denn man mochte ihn nicht im
Dorf.</p>
<p class="calibre3">»Heute ist doch Hochzeit, Sünde gibt es da nicht, wenn man mal
Spaß macht, sich amesiert und lacht, wo was zu lachen ist, das tu'
ich schon sagen, ich, der Schulze, ich sag' es euch, Leute.«</p>
<p class="calibre3">»Und auch Herr Jesus zum Beispiel ging zu Hochzeiten und trank
Wein ...,« warf Ambrosius ernst, aber leise dazwischen; er war
schon betrunken, und da er ganz am Ende an der Tür saß, hörte ihn
niemand./Alle redeten jetzt durcheinander, lachten, stießen mit den
Gläsern an und langten immer bedächtiger zu, um sich ganz und gar
sattzuessen; manch einer lockerte schon den Gürtel und reckte sich,
um mehr hineinzukriegen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page306" title="Snoopy64/gary"></a> Die
Köchinnen trugen wieder singend neue Schüsseln herein:</p>
<p class="vers">Gegrunzt, gequiekt, gegraben hat es im
Gärtelein,<br class="calibre2"/>
Jetzt muß es den Schaden zahlen – das Schwein!</p>
<p class="calibre3">»Haben die sich angestrengt, na, na!« wunderten sich die
Menschen.</p>
<p class="calibre3">»Das will ich meinen, an die tausend Silberlinge wird die
Hochzeit kosten ...«</p>
<p class="calibre3">»Es hat sich nicht schlecht bezahlt gemacht, er hat ihr doch die
sechs Morgen verschrieben! Zum Schaden der Kinder amüsieren sie
sich hier.«</p>
<p class="calibre3">»Und Jagna sitzt dabei wie der reine Brummkater.«</p>
<p class="calibre3">»Dafür leuchten Matheus seine Augen aber wie bei einem
Luchs!«</p>
<p class="calibre3">»Ist nur Moder, der lichtert, ih du meine Güte, was sonst!«</p>
<p class="calibre3">»Der wird noch weinen.«</p>
<p class="calibre3">»So einer ist das nicht, der langt ihr eher einen mit dem Stock
...«</p>
<p class="calibre3">»Dasselbe hab' ich schon der Schulzin gesagt, als sie mir von
der Verlobung erzählte.«</p>
<p class="calibre3">»Warum ist die denn heute nicht gekommen?«</p>
<p class="calibre3">»Wie soll sie denn, die muß doch jeden Augenblick niederkommen
...«</p>
<p class="calibre3">»Die Hand könnt' ich mir abhauen lassen, daß es nicht lange
dauert und die Jagna treibt sich mit den Burschen herum, laßt mal
erst die Musiken in die Schenke kommen.«</p>
<p class="calibre3">»Der Mathias wartet nur darauf!«</p>
<p class="calibre3">»Hale, hale?«</p>
<p class="calibre3">»Versteht sich! Dem Wawschon Seine hat gehört, was er in der
Schenke herumgeredet hat.«</p>
<p class="calibre3">»Daß sie ihn aber nicht eingeladen haben, mit aufzuspielen?«</p>
<p class="calibre3">»Der Alte wollte es, aber die Dominikwittib hat sich dagegen
verwahrt, wie soll sie denn auch anders, alle wissen doch, was war
...«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page307" title="MEsswein/gary"></a> »Jeder
gibt sein Teil dazu, hat sie denn einer gesehen?«</p>
<p class="calibre3">»Dann tut man wohl in den Wind reden?«</p>
<p class="calibre3">»Und der Bartek Kosiol hat sie doch im Frühling mal im Wald
ausgespäht.«</p>
<p class="calibre3">»Der Kosiol ist ein Dieb und ein Betrüger, er hat doch mit der
Patsches vor Gericht das wegen dem Schwein gehabt, nu tut er aus
Gift herumreden.«</p>
<p class="calibre3">»Andere haben auch Augen, können auch noch sehen.«</p>
<p class="calibre3">»Und schlecht wird es enden, man kriegt es schon zu sehen ...
versteht sich, mich soll es nichts angehen, aber wenn ich mir so
denke, daß den Anteks und deren Kindern solch ein Unrecht geschehen
ist/Strafe muß da sein, und sie wird nicht ausbleiben.«</p>
<p class="calibre3">»Versteht sich, der Herr Jesus ist nicht rasch bei der Hand,
aber gerecht ist er ...«</p>
<p class="calibre3">»Von Antek hat man doch auch was gemunkelt, mit dem will sie
auch mancher hier und da gesehen haben, wie sie sich miteinander
verabredeten ...,« sie dämpften die Stimmen, klatschten immer
bissiger und nahmen die ganze Familie ohne Gnade vor, der Alten
auch nicht das kleinste schenkend und hauptsächlich die Söhne
beklagend.</p>
<p class="calibre3">»Ist denn das keine Sünde! Den Burschen wächst schon der Bart
unter der Nase, Schymek ist schon gut an die Dreißig und heiraten
läßt sie ihn nicht, nicht mal aus dem Haus kann er alleine gehen
und bei der ersten besten Kleinigkeit ist da rein der Teufel
los.«</p>
<p class="calibre3">»Das ist doch wirklich auch 'ne Schande, so alte Mannsbilder und
müssen die ganzen Frauenarbeiten machen ...«</p>
<p class="calibre3">»Damit nur ja die Jagusch nicht ihre Händchen beschmutzt!«</p>
<p class="calibre3">»Und jeder von ihnen hat seine fünf Morgen, da könnten sie doch
heiraten!«</p>
<p class="calibre3">»So viele Mädchen sind im Dorf ...«</p>
<p class="calibre3">»Und eure Marzicha wartet doch auch wirklich schon lange genug,
und der Grund und Boden liegt gerade neben Patsches ihrem!«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page308" title="MEsswein/gary"></a> »Paßt
ihr nur besser auf eure Franka, daß sie nicht was vom Adam kriegt!
Die Alte ist ein Teufelsweib, das weiß man, aber die Burschen sind
auch Strohköpfe und Waschlappen!«</p>
<p class="calibre3">»Solche Kerle schon und trauen sich nicht, Mutters Rock
loszulassen!«</p>
<p class="calibre3">»Die lassen ihn schon fahren ... Der Schymek läuft schon heute
in einem fort hinter Nastuscha Täubich her.«</p>
<p class="calibre3">»Ihr Vater war ganz ebenso/ich weiß noch gut, und wie die Alte
jung war, hat sie es ebenso getrieben wie die Jaguscha!...«</p>
<p class="calibre3">»Wie die Wurzel, so die Staude!/Und wie die Mutter/ die
Tochter!«</p>
<p class="calibre3">Die Musik verstummte; die Musikanten gingen auf die andere Seite
essen, denn der Abendschmaus war zu Ende.</p>
<p class="calibre3">Es wurde plötzlich still, wie in der Kirche während des
Offertoriums, nach einer Weile aber entlud sich ein noch stärkeres
Stimmengewirr, so daß es schier wie ein Aufbrodeln war; alle
redeten auf einmal, schrien und sprachen aufeinander ein über die
Tische hinweg, so daß schon der eine den anderen nicht mehr
verstehen konnte.</p>
<p class="calibre3">Zum Schluß brachten sie für die Respektspersonen einen mit Honig
und Gewürzen zubereiteten Krupnik, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#foot8" id="text8"><sup class="calibre6">F8</sup></a> und für den Rest stellten sie starken Branntwein
und Bier hin.</p>
<p class="calibre3">Kaum einer beachtete, was er trank, denn die Köpfe waren schon
nicht schlecht benebelt, und ein Wohligkeitsgefühl versetzte alle
in eine behagliche Mattigkeit. Sie setzten sich wie es einem jeden
bequemer war, knöpften vor Hitze die Röcke auf und räkelten sich um
die Tische herum ... Mit den Fäusten schlugen sie auf, daß die
Schüsseln hochsprangen, hielten sich umschlungen, griffen einander
an die Rockklappen, oder umarmten sich, redeten einander zu und
schütteten sich die Herzen aus, wie der Bruder seinem Bruder, wie
der wahre Christ seinem christlichen Nachbarn.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page309" title="Snoopy64/gary"></a>
»Schlecht ist es in der Welt! Jawohl! Immer nur zugrunde gehen kann
der Mensch und Not leiden ...«</p>
<p class="calibre3">»Wollt ihr euch schicken, verdammtes Hundspack! ...« Unter den
Tischen balgten sich die Hunde um die Knochen.</p>
<p class="calibre3">»... Und Trost kann es nur geben, wenn der Nachbar mit dem
Nachbarn zusammenkommt, wenn sie beim Glase Schnaps sich die
Wahrheit sagen, das Herz ausschütten, und einander vergeben, was
einer sich bei dem anderen hat zuschulden kommen lassen/versteht
sich, das abgeweidete Getreide oder die eingepflügte Grenze nicht,
denn darüber werden schon die Gerichte Bescheid wissen und die
Zeugen werden es aussagen, wer unrecht hat und wem sein Recht
zukommt; aber das, was von wegen der Nachbarschaft vorkommt /mal
ist es dem einen sein Vieh, das im Garten gewühlt hat, mal sind's
die Frauen, die sich herumgezankt haben, manchmal prügeln sich die
Kinder, grad wie es kommt ... Dazu ist doch solch Freudetag, daß
die Leute vom Groll ablassen und daß Brüderschaft und Eintracht
zwischen den Menschen aufkommt!«</p>
<p class="calibre3">»Wenn's auch nur für diese Freudezeit ist, für diesen einen
Tag!«</p>
<p class="calibre3">»Und morgen kommt immer noch früh genug! Hei! Vor deinem Los
kannst du dich doch nicht verstecken, und wenn schon, dann nur
unter die heilige Erde wohl; es kommt, es wird dich ans Genick
packen, dir das Joch um den Nacken legen, mit der Not wird es dich
antreiben, und nu schlepp' du mal, Volk, lasse dein Blut fließen;
sorg' um dein bißchen Habe, laß es nicht aus den Fäusten, nicht für
einen Augenblick, damit die Brüder nicht über dich weggehen!«</p>
<p class="calibre3">»Zu Brüdern hat Herr Jesus die Menschen geschaffen, und Wölfe
sind sie füreinander!«</p>
<p class="calibre3">»Nein, nicht Wölfe, das ist die Not, die sie jagt, verzankt und
die einen auf die andern schleudert, daß sie sich beißen, wie die
Hunde um einen benagten Knochen!«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page310" title="MEsswein/gary"></a> »Nein,
nicht die Not allein, der Böse ist es, der die Finsternis über das
Volk wirft, daß es nicht auskennt, was gut und was böse ist!«</p>
<p class="calibre3">»Wahrhaftig, wahrhaftig! Und er bläst in die Seele wie in eine
Glut, die doch schon verglimmt, bis er Gier und Wut und alle Sünden
wachgeblasen hat!«</p>
<p class="calibre3">»Versteht sich, wer auf die Gebote taub ist, hört besser die
Teufelsmusik!«</p>
<p class="calibre3">»Einstens war es nicht so! Gehorsam war da, das Alter hat man
respektiert und Eintracht tat man halten!«</p>
<p class="calibre3">»Und Grund und Boden hatte jeder, soviel er nur bearbeiten
konnte, und Weideland, und Wiesen, und Wald.«</p>
<p class="calibre3">»Und hat denn je einer da von Steuern gehört?«</p>
<p class="calibre3">»Oder hat einer Holz kaufen müssen? ... In den Wald fuhr er und
nahm was er brauchte, und wenn es selbst die beste Kiefer oder
Eiche war! ... Was dem Gutsherrn seins, war auch dem Bauern
seins.«</p>
<p class="calibre3">»Und jetzt ist es nicht dem Gutsherrn, noch dem Bauern seins/dem
Juden gehört es, oder noch einem Schlimmeren.«</p>
<p class="calibre3">»Aaszeug! Euch hab' ich zugetrunken, trinkt ihr mir zu!
Festgesetzt haben sie sich, wie auf dem eigenen, trinkt mal, dein
Wohl, mein Wohl, damit Gerechtigkeit sich machen tut ...«</p>
<p class="calibre3">»Räudiges Herrenvolk! In eure Hände! Nehmt das Glas! Schnaps ist
keine Sünde, wenn es nur mit der Würde geht, ein gutes Glas unter
Brüdern bekommt der Gesundheit, reinigt das Blut und zieht die
bösen Krankheiten ab!«</p>
<p class="calibre3">»Wenn schon trinken, dann lieber gleich 'ne ganze Quart, und
wenn sich freuen, dann den ganzen Sonntag lang. Und hast du was zu
tun, Menschenkind/dann arbeite flink, schone deine Klumpen nicht
und halt' dich ehrlich dran! Und kommt mal sozusagen eine
Gelegenheit/Hochzeit, Taufe, oder stirbt einer weg/dann spann' aus,
mach' es dir bequem, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page311" title="MEsswein/gary"></a> nimm wahr und mach' dir deine Freude! Und geht
es einmal schlecht/die Frau geht zuschanden, ein Vieh verreckt,
oder es kommt ein Feuerschaden/Gottes Wille, lehn' dich nicht
dawider auf, denn was kannst du, armer Teufel, mit Geschrei und
Weinen dir da helfen?/Gar nichts; deine Ruhe wirst du nur los, daß
selbst das Essen dir wie Brennesseln im Maule deucht!/Darum dulde
du und vertraue auf dem Herrn Jesu seine Gnade ... kommt
Schlimmeres, packt dich der Knochenmann an der Gurgel und guckt dir
in die Augen/versuch' nicht zu entweichen, das ist nicht deine
Macht /denn alles ist in Gottes Hand ...«</p>
<p class="calibre3">»Das ist so, wer kann es nur voraussehen, wann Jesus sagt: Bis
dahin deins/hier ist meins, Menschenkind.«</p>
<p class="calibre3">»Wahr, wahr! Hoch, da oben fliegen sie wie Blitze die Befehle
von unserem Herrgott und niemand, selbst der Priester, der klügste
selbst kann sie im voraus durchschauen, bis daß sie aufs Volk, wie
reifes Korn, fallen!«</p>
<p class="calibre3">»Du aber, Mensch, hast nur eins zu wissen/tue deine Sache und
lebe, wie die heiligen Gebote befehlen, und sehe nicht in das
Kommende ... Herr Jesus tut jedem seinen Lohn zurechtlegen und wird
ehrlich jedem seinen Teil zahlen ...«</p>
<p class="calibre3">»Das hat das polnische Volk immer aufrechterhalten/ und so soll
es in alle Ewigkeit bleiben, Amen!«</p>
<p class="calibre3">»Und mit Geduld wirst du selbst die Tore der Hölle
überwinden.«</p>
<p class="calibre3">So redeten sie miteinander, dazwischen häufig einander
zutrinkend, und jeder äußerte sich über das, was ihm gerade am
Herzen lag und woran er schon lange gewürgt hatte! Am meisten und
am lautesten aber räsonierte Ambrosius, natürlich tat man nicht
viel auf ihn hinhören, denn jeder redete und wollte seine Sache
anbringen, ohne viel auf die anderen zu achten ... In der Stube
toste schon ein immer lauteres Stimmengewirr, als plötzlich Gusche
mit der Eve hereintraten, gravitätisch einen großen geschmückten
Kochlöffel <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page312" title="MEsswein/gary"></a> vor sich tragend./Ein Musikant, der
hinterdrein schritt, spielte auf der Geige, sie aber sangen:</p>
<p class="vers">Hebt euch, Leute, von den Tischen,<br class="calibre2"/>
Hebt euch von der Bank.<br class="calibre2"/>
Ein paar Heller für die Brüh<br class="calibre2"/>
Und zehn Heller für die Müh<br class="calibre2"/>
Gebt uns hier zum Dank!</p>
<p class="calibre3">Das Volk war satt, angeheitert und leichtgiebig gestimmt durch
das gute Essen und viele Trinken, so daß selbst einzelne
Silbermünzen in den Kochlöffel warfen.</p>
<p class="calibre3">Allzusammen fingen sie an, sich von den Tischen zu erheben und
langsam auseinanderzugehen; die einen wollten frische Luft
schöpfen, etliche blieben im Flur oder in der Stube stehen,
diskutierten weiter, und andere wiederum umarmten sich zum Zeichen
der gegenseitigen Freundschaft, manch einer aber torkelte schon und
fegte mit dem Kopf die Wände oder er bockte mit seinem Schädel
gegen die anderen an, wie ein Widder/was kein Wunder war, da
während des Abendessens die Schnapsbuttel reichlich gekreist
hatte.</p>
<p class="calibre3">Am Tisch blieben nur der Schulze und der Müller sitzen. Die
beiden zankten sich und gingen mit solcher Hitzigkeit aufeinander
los, wie zwei Habichte, so daß Ambrosius sie mit Schnaps zu
versöhnen versuchte.</p>
<p class="calibre3">»Paß auf die Kirchtür, alter Kirchenschließer, und laß die
Hofbesitzer in Ruh,« knurrte der Schulze.</p>
<p class="calibre3">Ambrosius ging mißmutig davon, er stieß mit seinem Stelzfuß laut
auf, und die Schnapsflasche gegen die Brust pressend, sah er sich
nach einem Kumpan um, mit dem er in guter Freundschaft sich satt
reden und einen ordentlichen trinken könnte.</p>
<p class="calibre3">Die Jugend war auf den Heckenweg hinausgetreten, wo sie sich
allesamt eingehakt hatten und miteinander plaudernd und schäkernd
auf die Dorfstraße hinausgingen, um allerhand Schabernack zu
treiben, so daß es dröhnte vor Gejage und Geschrei. Die Nacht war
klar, der Mond hing <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page313" title="Snoopy64/gary"></a> über dem Weiher; das Wasser glänzte so hell,
daß die kleinsten Kreise, die wie unter den Schlägen des Lichts
sich ausbreiteten, in halbkreisrunden Schlänglein silbern durch die
Stille glitten. Der Nachtfrost griff immer stärker um sich, die
Erdkrusten brachen unter den Tritten und der Reif hatte die Dächer
weiß überzogen und die Erde eisgrau bestreut.</p>
<p class="calibre3">Es war schon spät, denn die ersten Hähne ließen sich im Dorf
vernehmen.</p>
<p class="calibre3">In der Stube machte man inzwischen Ordnung und bereitete alles
zum Tanzen vor.</p>
<p class="calibre3">Und als die Musikanten genug gegessen hatten und ausgeruht
waren, fingen sie an leise aufzuspielen, um die Hochzeitsgäste
wieder zu sammeln.</p>
<p class="calibre3">Doch es war nicht nötig, sie lange anzutreiben, im hellen Haufen
drangen sie in die Stube, denn die Geigen lockten so zum Tanz, daß
die Füße einen von selbst schon trugen/ es war aber zu guter Letzt
doch verlorene Liebesmüh, die Burschen fühlten sich noch zu schwer
nach dem Festessen, der eine und der andere versuchte sich etwas zu
drehen, sie liefen aber bald wieder hinaus auf den Flur, um eine
Zigarette zu rauchen oder die festen Wände zu stützen.</p>
<p class="calibre3">Die Frauen führten Jagna in die Kammer ab und Boryna blieb mit
der Dominikbäuerin auf der Fensterbank sitzen, und was die Älteren
waren, so hatten sie sich auf den Bänken und in den Ecken breit
gemacht und redeten miteinander. In der Mitte der Stube waren nur
noch die Mädchen geblieben, deren Kichern immer von neuem hörbar
wurde; da ihnen aber die Zeit bald lang wurde, richteten sie
verschiedene Spiele ein, um die Burschen etwas aus sich
herauszulocken.</p>
<p class="calibre3">Zuerst spielten sie das Spiel: »Es geht der Fuchs um den Weg
herum, ohne Hand und Fuß.«</p>
<p class="calibre3">Als Fuchs hatten sie Jaschek mit dem Spitznamen »der Verkehrte«
verkleidet und ihm einen Schafspelz umgetan, dessen zottelige
Innenseite noch außen gekehrt war. Das <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page314" title="MEsswein/gary"></a> war ein Tolpatsch und
Dummerjahn. Sie hielten ihn alle zum Narren im Dorf. Obgleich er
ein ausgewachsener Bursche war, lief er mit offenem Maul herum,
spielte mit den Kindern und liebäugelte mit allen Mädchen. Er
machte den Eindruck, als ob er nicht ganz richtig sei; da er aber
der einzige Sohn war und seine zehn Morgen zu erwarten hatte, so
wurde er überall eingeladen./Häschen war Borynas Fine.</p>
<p class="calibre3">Und sie lachten ... wie sie lachten, Jesus! Jede paar Schritte
plusterte sich Jaschek auf und plumps, lag er am Boden, wie ein
Stück Holz, denn jedermann versuchte ihm ein Bein zu stellen, und
Fine hopste so schön, machte Männchen, muffelte mit den Lippen, daß
ein wahrer Hase nichts dagegen war.</p>
<p class="calibre3">Und dann spielte man »Wachtel«.</p>
<p class="calibre3">Nastuscha Täubich führte an, und sie war so flink, flitzte so
geschickt durch die Stube, daß sie sie gar nicht greifen konnten,
bis sie ihnen von selbst unter die Hände schlüpfte, um mal
herumzutanzen.</p>
<p class="calibre3">Und »Schweinchen« wurde gespielt.</p>
<p class="calibre3">Zum Schluß aber machte einer der Brautführer, scheinbar Tomek
Wachnik, einen Storch; er hatte sich mit einem Leinentuch den Kopf
bedeckt und darunter ließ er als Schnabel einen langen Stock hängen
und klapperte so geschickt, daß es sich ganz wie Storchklappern
anhörte; Fine, Witek und die kleineren rannten hinter ihm her und
schrien:</p>
<p class="vers">Le, le, le ...<br class="calibre2"/>
Dein' Mutter in der Hölle.<br class="calibre2"/>
Was tut sie denn da suchen?<br class="calibre2"/>
Sie backt den Kindern Kuchen.<br class="calibre2"/>
Was hat sie denn gemacht?<br class="calibre2"/>
Die Kinder umgebracht.</p>
<p class="calibre3">Sie zerstreuten sich schreiend und suchten in den Ecken Schutz,
denn er verfolgte sie, stieß mit dem Schnabel nach ihnen und schlug
mit den Flügeln um sich.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page315" title="Snoopy64/gary"></a> Die
Stube erzitterte vor diesem Gelächter, Gekreisch und Gejage.</p>
<p class="calibre3">Eine gute Stunde mochte schon das Spiel gedauert haben, als der
älteste der Brautführer ein Zeichen gab, sich ruhig zu
verhalten.</p>
<p class="calibre3">Aus der Kammer führten die Frauen Jagna heraus, die mit einem
weißen Linnentuch bedeckt war, und setzten sie inmitten der Stube
auf einen Backtrog, über den ein Federbett ausgebreitet lag/die
Brautjungfern sprangen hinzu und taten als ob sie sie ihnen
entreißen wollten, aber die älteren Frauen und die Männer wehrten
ihnen, darum drängten sie sich ihr gegenüber zu einem Haufen
zusammen und sangen wie durch Tränen mit trauriger Stimme:</p>
<p class="vers">Nun mußt du sein<br class="calibre2"/>
Ohne Kränzelein!<br class="calibre2"/>
Die gewundene Frauenhaube<br class="calibre2"/>
Oj-ta-dana-da<br class="calibre2"/>
Die benähte Frauenhaube<br class="calibre2"/>
Ziemt dir jetzt allein! ...</p>
<p class="calibre3">Dann erst deckte man sie auf.</p>
<p class="calibre3">Sie hatte schon eine Haube auf den aufgesteckten dicken Zöpfen,
aber sie erschien noch schmucker in dieser Tracht, denn sie lachte,
war froh und blickte mit leuchtenden Augen von einem zum
anderen.</p>
<p class="calibre3">Die Musik fing in langsamem Takt an zu spielen, und das ganze
versammelte Volk, die Alten und die Jungen und die Kinder selbst
stimmten mit einer einzigen großen Freudestimme das »Hopfenlied«
an. Nach dem Absingen des Liedes wurde Jagusch nur von
Hofbäuerinnen zum Tanz geholt. Gusche aber, die sich schon
ordentlich einen angetrunken hatte, stemmte die Arme in die Seiten
und fing an, ihr zuzusingen:</p>
<p class="vers">Hei! das hätt' ich wissen sollen,<br class="calibre2"/>
Daß dich da ein Witwer freit.<br class="calibre2"/>
Hei! ein Kränzelein aus Wicken,<br class="calibre2"/>
Hei! das hielt ich dir bereit!</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page316" title="Snoopy64/gary"></a> Und
sie sang auch noch andere Lieder mit allerlei versteckten
Anspielungen und Anzüglichkeiten.</p>
<p class="calibre3">Doch niemand achtete darauf, denn die Musikanten geigten schon
aus voller Macht und die Menschen traten an zum Tanz. Der Boden
erdröhnte plötzlich, als schlügen hundert Dreschflegel auf die
Tenne und ein undurchdringbares Gewirr füllte die Stube, denn dicht
an dicht folgten die einen den andern, Paar auf Paar, Kopf neben
Kopf, und nahmen einen Anlauf./Die Kapottröcke ließen sie wehen,
wiegten sich im breitspurigen Tanzschritt, stampften mit den
Absätzen auf, schwenkten die Hüte, und hier und da stimmte einer
ein schallendes Lied zur Musik an und die Mädchen sangen ihr
»da-dana« dazu. Sie drehten sich immer schneller, ihre Körper
schaukelten sich hin und her, bis sie in einen so raschen,
wirbelnden, selbstvergessenen Tanz übergingen, daß keiner mehr im
Gedränge auseinander zu kennen war.</p>
<p class="calibre3">Und jedesmal, wenn die Geigen einen Hopsa erschallen ließen,
stampften hundert Hackenpaare auf den Boden, hundert Stimmen
juchten auf, hundert Menschen schwenkten herum, als ob sie ein
Windstoß herumgeschleudert hätte/ so daß nur das Sausen der
Rockschöße und Beiderwandröcke und das Flattern der Kopftücher
vernehmbar wurde, die wie farbige Vögel in der Stube aufflogen.
Ein, zwei, drei Paternoster gingen vorbei und sie tanzten immerzu,
ohne aufzuatmen, ohne Unterbrechung; der Fußboden dröhnte, die
Wände bebten, in der Stube brodelte der Lärm, und die Lust wuchs
immerzu; wie die Fluten nach dem Gewitterregen /so wogte und wälzte
sich der Tanz durch die Stube.</p>
<p class="calibre3">Als sie geendigt hatten, kamen verschiedene Bräuche an die
Reihe, wie es beim Aufsetzen der Frauenhaube üblich war.</p>
<p class="calibre3">Zuerst mußte sich Jagna bei den Bäuerinnen einkaufen!</p>
<p class="calibre3">Danach wurden noch manche Hochzeitszeremonien vollführt; bis
schließlich die Burschen ein langes Strohseil aus <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page317" title="Snoopy64/gary"></a> ungedroschenem Weizen
drehten und es den Brautjungfern in die Hände gaben, die damit
einen großen Kreis umspannten, den sie eifrig bewachten. Mitten
drin stand Jagna, und wer mit ihr tanzen wollte, mußte sich
gewaltsam zu ihr den Weg bahnen, um sich mit ihr im Kreise zu
schwingen, nichtachtend, daß sie ihn mit verschiedenen Strohseilen
nur immer so über die Lenden prügelten. Zum Schluß aber begann die
Wachnikbäuerin mit der Müllerin für die Haube zu sammeln. Als
erster warf der Schulze ein Goldstück auf den Teller, und darauf
fingen, wie ein klirrender Hagel, die Silberstücke an
niederzuprasseln, und wie Blätter im Herbst flogen die
Papierrubel.</p>
<p class="calibre3">Mehr wie dreihundert Silberlinge hatten sie gesammelt.</p>
<p class="calibre3">Ein mächtiges Stück Geld, für die Dominikbäuerin aber war das
wie eine Mücke; im übrigen legte sie kein Gewicht auf Geschenktes,
denn sie hatte genug Eigenes, nur daß sie sich für Jagusch so
bereitwillig auf Unkosten einließen, hatte sie ordentlich
mitgenommen, so daß ihr vor Rührung ein Weinen ankam, das sie nicht
mehr unterdrücken konnte/ sie schrie den Jungen zu, den Schnaps zu
bringen und fing selbst an, zu traktieren, zuzutrinken und durch
die Tränen, die ihr über die Backen rannen, Gevatter und
Gevatterinnen abzuküssen.</p>
<p class="calibre3">»Trinkt, Nachbarn ... trinkt, liebe Leute, Brüderherzen ... Das
ist mir ein Freudentag heute ... auf Jagusch ihr Wohl ... dieses
Gläschen noch ... dieses;« und hinter ihr drein trank noch der
Schmied den anderen zu, und die Jungen auch auf eigene Hand/denn es
war ein nicht kleiner Haufen Volk beisammen. Auch Jagusch dankte
ihrerseits für die Güte und umfaßte die Knie der älteren Leute!
...</p>
<p class="calibre3">Es brauste auf in der Stube, denn auch die Gläser kreisten dicht
hintereinander von Hand zu Hand, und eine Wärme und Fröhlichkeit
stieg auf von allen Seiten! Die Gesichter röteten sich, die Augen
blitzten auf und die Herzen strebten brüderlich, nachbarlich
einander zu. »Hoppla/heh! einmal <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page318" title="Snoopy64/gary"></a> nur kann die Ziege sterben! Das hat der
Mensch, was er mit seinen Menschenbrüdern genossen hat, was er sich
amüsiert hat, ohne sich lange um die Welt zu kümmern! Jeden für
sich nimmt nur die Knochenfrau vor, aber feiern muß man im Haufen,
zum Freuen gehört eine ganze Kompagnie. Sie füllten auch in Haufen
die ganze Stube, tranken einander zu und besprachen sich froh und
jeder setzte laut auseinander, was er zu sagen hatte, so daß schon
der eine den andern nicht mehr hörte; aber das war einerlei, denn
sie fühlten so wie so dasselbe, dieselbe Freude hatte sie
zusammengebracht und alle ganz durchdrungen!</p>
<p class="calibre3">Und wenn einer trauern will, laß ihn das für morgen aufheben,
heute soll er sich amüsieren, Freundschaft genießen, seine Seele
erfreuen! So wie der Herr Jesus der heiligen Erde nach ihrem
sommerlichen Gebären Ruhe zukommen läßt, so ziemt es, daß auch dem
Menschen in der Herbstzeit Ruhe werde, nachdem er sein Feld
bestellt hat. Und hast du, Mensch, die Schober und Scheuern voll
Korn, schwer wie Gold, das nur auf die Dreschflegel wartet, dann
genieße du, und lohne dir die schweren Mühen und Sorgen der langen
Sommertage!</p>
<p class="calibre3">So redeten die einen vor sich hin, andere wiederum breiteten
sich über ihre Angelegenheiten und Sorgen aus; und etliche, die
nicht nur den Kuhschwanz vor sich sahen oder Weiberläufe, scharten
sich um den alten Simeon und sprachen über alte Zeiten, neues
Unrecht, von Steuern und den Geschäften der ganzen Gemeinde; und
sie redeten leise, da es sich auch um des Schulzen Streiche
handelte.</p>
<p class="calibre3">Nur Boryna schloß sich keinem Haufen an, er ging von den einen
zu den anderen, mal hier- mal dahin, und ließ die Augen hinter
Jagna wandern, und blähte sich mächtig, daß sie so schmuck war, den
Musikanten warf er immer wieder Silbermünzen hin, damit sie die
Fiedelbogen nicht schonten, da sie gedämpfter spielten, um
auszuruhen.</p>
<p class="calibre3">Sie stießen plötzlich einen wuchtigen Oberek in die Instrumente,
<a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page319" title="Snoopy64/gary"></a> daß einem
ein Schauer durch die Knochen lief, und Boryna sprang zu Jagna hin,
riß sie fest an sich und schob vom Platz weg einen solchen Tanz,
daß die Dielenbretter aufwimmerten, er fegte durch die Stube,
wendete, klappte mit den eisenbeschlagenen Hacken auf den Fußboden,
wirbelte, das Knie beugend, seine Tänzerin um sich herum, dann
glitt er breitspurig durch die Stube, sich im Takte nur so
schüttelnd, auf und nieder, hin und her von Wand zu Wand, sang den
Musikanten zu, die ihm einen Tusch zur Antwort bliesen, tobte
rasend weiter und führte hitzig den Tanz an, denn hinter ihm fingen
die anderen Paare an, sich aus den verschiedenen Gruppen zu lösen,
aufzutrampeln, zu singen und mit gewaltigem Anlauf loszutanzen, daß
sie sich wie hundert surrende Spindeln voll farbiger Garne durch
die Stube drehten und so schnell herumwirbelten, daß schon kein
Auge auseinanderkennen konnte, wo der Bursch und wo das Mädchen
waren. Das war als ob jemand einen Regenbogen ausbreitete und auf
ihn mit einem Sturmwind einpeitschte, daß er in allen Farben
spielte, aufschillerte und immer schneller, wütender, wilder sich
wand, so daß zuweilen die Lichter vom Luftzug verlöscht wurden und
Nacht die Tänzer umfing. Durch die Fenster floß das Mondlicht, das
in einem sich versprühenden Lichtstreifen funkelte wie siedendes
Silber, mitten durch die Dunkelheit, mitten durch das kreisende
Menschengewühl, das herangeflutet kam in einer schäumenden,
sangerfüllten Welle und aufflimmerte und sich zusammenballte in
diesem Lichtschimmer, wie in einem Traumgesicht, um wieder
aufzutauchen und für einen Augenblick vor der anderen Wand
aufzudämmern, wo die durch das Mondlicht getroffenen Gläser der
Bilder sprühende Wiederscheine rieseln ließen, um sich
vorbeizuwälzen und in die Nacht zurückzustürzen, daß in der
verdunkelten Stube nur schweres Keuchen, Getrampel und Rufe
aufstiegen und sich ineinander wirrten mit dumpfem Gedröhn.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page320" title="Snoopy64/gary"></a> Und
eine einzige lange Kette von Tanzen begann, ohne Unterbrechung und
Ruhepause ... denn kaum hob die Musik an, einen neuen Tanz zu
geigen, erhob sich das Volk jäh, reckte sich hoch auf, wie ein
Forst, und stürzte sich in den Tanz mit der Wucht eines
Wirbelwindes; das Aufstoßen der Hacken klang wie Donnergetöse,
Schreie der Lust ließen das ganze Haus erbeben. Und sie überließen
sich dem Tanz mit einer Selbstvergessenheit und Raserei, als ginge
es in den Sturm, in den Kampf auf Tod und Leben.</p>
<p class="calibre3">Und sie tanzten!</p>
<p class="calibre3">... Die zappelnden, schäkernden Krakowiaks mit der abgerissenen,
klirrenden Melodie, die wie mit Ziernäglein beschlagene Gürtel mit
tanzfrohen Liedlein ausgeputzt war; die Krakowiaks voll Lachen und
Mutwillen, voll fröhlichen Sangs und üppiger, starker, kecker
Jugend und zugleich voll lustiger Possen, voll Haschen und Greifen
und voll Glut des jungen, liebeshungrigen Blutes. Hei!</p>
<p class="calibre3">... Mazurkas langgedehnt, wie Feldraine, breitgestreckt wie die
Mathiasbirnbäume, <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#foot9" id="text9"><sup class="calibre6">F9</sup></a> rauschend, und wie die unabsehbaren Ebenen so breit,
voll Schwergewicht und schlank aufstrebend, sehnsüchtig und
verwegen, gleitend und dräuend gepackt, würdevoll und
draufgängerisch und steifnackig dazu, wie jene Mannsleute, die zu
einem Haufen zusammengeschart, wie ein Wald aufragend, sich in den
Tanz werfen mit Juchzern und solcher Macht, als ob es zu hundert
gegen Tausende angehen sollte/und wenn man dabei die ganze Welt
zerreißen, verprügeln, zerstampfen, zu Splittern zerschlagen auf
den Absätzen auseinandertragen müßte und selbst zugrunde gehen, um
dann noch nach dem Tode zu tanzen, mit den Hacken aufzutrampeln und
forsch auf mazurische Art aufzujuchzen: »da-dana!«</p>
<p class="calibre3">... Und mächtige Obereks tanzten sie, ruckweise Springetänze,
schwindelnde, tolle, rasende, herausfordernde und wehmütige,
sengende und versonnene, mit Klageliedern durchwobene, im Siedetakt
des feurigen Blutes pulsende <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page321" title="DaoH/gary"></a> und doch voll Güte und Lieben, plötzlich
niedersausende, wie eine Hagelwolke und voll herzlicher Stimmen,
voll himmelblauer Blicke, voll lenzverheißender Lüfte, voll
düfteschwangeren Zweigerauschens, das aus blütenschweren Obstgärten
kommt/Tänze, die wie jene sangerfüllten Frühlingsfelder sind,
Tänze, wo auch die Tränen noch durch Lachen fließen, und das Herz
Freudelieder singt, und die Seele sich sehnsüchtig losreißt, den
fernen Weiten, den entlegenen Wäldern entgegen und in die große
Welt hinausfliegt, ahnender Träume voll, vor sich her singend: »Oj
Da-dana!«</p>
<p class="calibre3">Solche unsagbaren Tanze folgten einer dem anderen.</p>
<p class="calibre3">Denn also freut sich das Bauernvolk zur gelegenen Zeit.</p>
<p class="calibre3">So tat man auch die Hochzeit von Boryna und Jagusch feiern.</p>
<p class="calibre3">Stunden auf Stunden eilten und versanken unbemerkt im Lärm, im
Geschrei, in rauschender Freude und Tanzvergessenheit, so daß sie
es gar nicht gewahr wurden, wie es sich schon im Osten zu lichten
begann, die Frühlichtschimmer langsam durchzusickern anfingen und
die Nacht bleichten. Die Sterne verblaßten, der Mond ging unter,
und von den Wäldern erhob sich ein Wind und wehte einher, als
wollte er die zerrinnende Dämmerung auseinanderblasen; durch die
Fenster sahen krause bepelzte Bäume hinein und neigten immer tiefer
die schläfrigen Köpfe voll Rauhreif ... Im Hause aber sang und
tanzte man noch immerzu.</p>
<p class="calibre3">Es war als ob Wiesen, Erntefelder und aufgeblühte Obstgärten
sich zu einem Fest zusammengefunden hätten und, durch einen
Wirbelwind ergriffen, einen endlosen, taumelnden, feurigen Reigen
schlangen.</p>
<p class="calibre3">Man hatte die Tür weit geöffnet und die Fenster aufgerissen, das
Haus aber spie immer noch Lärm und Lichterschein aus, bebte und
zitterte, und krachte, und stöhnte auf, und gab sich immer wilderem
Taumel preis, so daß es schon war, als ob die Bäume und Menschen,
die Erde und die <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page322" title="Snoopy64/gary"></a> Sterne, die Zäune und das alte Haus und alles
sich bei den Schultern gefaßt hätte, sich zu einem Knäuel
verwickelt, sich verstrickt hätte und berauscht, blind, auf nichts
mehr achtend, von Sinnen von Wand zu Wand taumelte, von der Stube
auf den Flur, vom Flur auf den Weg flutete, von dem Weg waldwärts
über die unübersehbaren Felder in die weite Welt hinaus in
Tanzraserei drängte, rollte, kreiste und als eine einzige
flimmernde Kette in den Lichtscheinen des aufsteigenden Morgenrots
sich verlor.</p>
<p class="calibre3">Die Musik war es, die sie da führte, dieses Spielen und Singen
...</p>
<p class="calibre3">... Die Baßgeigen juchzten im Takt und brummten mit zittrigen
Stimmen, wie Hummeln, und die Flöte gab die zweite Stimme an, pfiff
lustig vor sich hin, zwitscherte, trieb Schabernack scheinbar der
Trommel zum Verdruß, die possierlich hüpfte, mit den Schellen Lärm
schlug, schäkerte und wackelte, wie ein Judenbart im Wind. Und die
Geige führte, ging an der Spitze, wie die beste Tänzerin, sang erst
laut und hell, als wollte sie ihre Stimme versuchen, und fing dann
gedehnt, durchdringend und traurig an zu klagen, als ob an den
Kreuzwegen das Weinen der Verlassenen wimmerte, bis sie sich im Nu
umdrehte und plötzlich mit einer kurzen, blitzenden, scharfen
Melodie dreinfuhr, als hätten hundert Paare mit den Absätzen
geklappt, als hätten hundert Mann aus voller Brust juchheit. Der
Atem stockte und ein Schauer lief über die Haut. Und sie fing
gleich wieder an, Kreise zu ziehen, vor sich her zu singen, zu
wenden, im zierlichen Schritt zu trippeln, zu hüpfen, zu lachen und
in Lust sich zu ergehen, so daß die Warme zum Herzen strömte und
die Lust zu Kopfe stieg, wie Branntwein ... dann sang sie wieder
eine schleppend-traurige Weise, die wie mit Tränentau überperlt
war; sie sang das traute, herzliche Lied der Heimat, das trunken
ist voll großer Macht und Liebe, und führte in den
leidenschaftlich-selbstvergessenen mazurischen Tanz.</p>
<p class="center">— — — — —</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page323" title="Snoopy64/gary"></a> Das
Frühlicht wurde immer heller, so daß die Lichter verblaßten und die
Stube eine schmutzig-trübe Dämmerung überflutete, sie aber
vergnügten sich noch aus vollem Herzen, und wem die Bewirtung zu
wenig war, der schickte nach der Schenke, Schnaps zu holen, suchte
sich Kumpane und trank bis er umfiel.</p>
<p class="calibre3">Wer weggegangen war, der war weg, wer müde war, ruhte aus, wer
sich vollgetrunken hatte, der schlief auf der Wandbank oder im
Flur; andere aber, die noch weniger ihre Füße regieren konnten,
lagen unter den Zäunen und wo es sich gerade traf, der Rest aber
tanzte bis zum letzten.</p>
<p class="calibre3">Bis die, die noch am nüchternsten waren, sich zu einem Haufen an
der Tür geschart hatten, und mit den Füßen auf dem Fußboden Takt
stampfend, zu singen begannen:</p>
<p class="vers">Jetzt geht es heim, ihr Gäste, jung und alt!<br class="calibre2"/>
Über weite Wege<br class="calibre2"/>
über Wasserstege<br class="calibre2"/>
Durch dunklen Wald!</p>
<p class="vers">Jetzt geht es heim, ihr Gäste, jung und alt!<br class="calibre2"/>
Und Morgen wieder<br class="calibre2"/>
Singen wir Lieder,<br class="calibre2"/>
Kommen her zu frohem Aufenthalt!</p>
<p class="calibre3">Doch niemand hörte auf sie.</p>
<ol class="calibre7"><li class="calibre8"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#text8" id="foot8"><span class="pcalibre5 pcalibre4 footnote"><span class="spaced">Krupnik:</span> Ein altpolnisches
Getränk aus sehr starkem reinen Schnaps, Honig und frischer Butter.
Wird mit Nelken und Zimt zum Kochen gebracht und heiß
getrunken.</span></a></li>
<li class="calibre8"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003#text9" id="foot9"><span class="pcalibre5 pcalibre4 footnote"><span class="spaced">Mathiasbirnbäume:</span> Scherzname für wildwachsende
Feldbirnbäume. Anspielung auf die Genealogie dieser Baume: das
unentkernte Obst, das die Bauern essen und die Spuren davon an den
Feldrainen entlang. Mathias entspricht gewissermaßen dem deutschen
Sepp.</span></a></li>
</ol>
<p class="pcalibre6 initial1">Gerade brach der Tag an, als
Witek, ganz müde vom Fest und von Gusche angetrieben, nach Hause
rannte.</p>
<p class="calibre3">Das Dorf schlief noch im tiefen Grund der Dämmerung, die sich
schon im Vergehen zu einem dicken Wall dicht über der Erde gestaut
hatte, der Weiher lag starr, wie erdrückt, unter dem düsteren
Dickicht der Uferbäume und so in die Dunkelheit vergraben, daß er
sich kaum gegen die Mitte zu aus der Nacht herausschälte und in
milchigem Schimmer, wie ein erblindetes Auge, geisterte.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page324" title="Snoopy64/gary"></a> Es war
ein starker Morgenfrost, ein kalter Windzug strich durch die
froststarre Luft, die in die Nüstern stach und den Atem beklemmte,
die Erde klang hohl unter den Tritten, und die zugefrorenen Pfützen
lagen glasig auf den Wegen, wie angelaufene Glasscheiben; die Welt
wurde kalkig blaß unter dem allmählich wachsenden Frühlicht und
tauchte froststumm und bereift aus den Dämmerungen hervor; nur
irgendwo begannen schläfrig ein paar Hunde aufzukläffen, und die
Mühle schlurrte aus der Ferne; und um das Hochzeitshaus schlug der
festliche Lärm Kreise um Kreise in eines Steinwurfs Breite.</p>
<p class="calibre3">In Borynas Stube glimmte noch, wie ein Johanniswürmchen, ein
winziges Lichtlein, so daß Witek neugierig durchs Fenster blickte;
der alte Rochus saß am Tisch und sang aus dem Buch fromme Lieder
vor sich hin.</p>
<p class="calibre3">Der Junge schlich leise nach dem Kuhstall und wollte nach dem
Riegel tasten; plötzlich aber schrie er auf und fuhr erschrocken
zurück, denn mit Gewinsel war ein Hund an ihm hochgesprungen.</p>
<p class="calibre3">»Waupa! Waupa! Bist du denn wieder da, mein gutes Hundchen,
wieder da, du armer Kerl!« rief er, nachdem er den Hund erkannt
hatte und hockte vor Freude zu ihm auf der Schwelle nieder. »Bist
hungrig, armer Teufel, was?«</p>
<p class="calibre3">Er suchte unter dem Brustlatz nach der Wurst, die er sich vom
Hochzeitsschmaus abgespart hatte und schob sie ihm ins Maul, aber
Waupa hatte es nicht eilig mit dem Essen, er bellte in einem fort,
sprang an ihm hoch und winselte vor Freude.</p>
<p class="calibre3">»Hungern haben sie dich lassen und dich dann noch
'rausgeschmissen, armer Kerl!« murmelte er, die Tür zum Kuhstall
aufsperrend, und warf sich gleich, wie er ging und stand, auf seine
Pritsche. »Ich werd' dir schon nichts ankommen lassen und für dich
sorgen ...,« brummte er und vergrub sich ins Stroh, der Hund legte
sich neben ihn, knurrte ein paarmal auf und leckte ihn hin und
wieder ins Gesicht.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page325" title="Snoopy64/gary"></a> Es
dauerte nicht mehr lange, da schliefen sie beide. Und vom
nebenanliegenden Stall rief Jakob mit schwacher, kranker Stimme; er
rief lange, doch Witek schlief wie ein Stein, erst Waupa, der die
Stimme erkannt hatte, fing an, so wütend zu bellen und ihn am Rock
zu zerren, bis er aufwachte.</p>
<p class="calibre3">»Was denn?« lallte er schlaftrunken.</p>
<p class="calibre3">»Wasser! Die Hitze packt mich so an ... Wasser!«</p>
<p class="calibre3">Obgleich er verdrießlich war, und der Schlaf ihm in den Gliedern
saß, ging er doch, einen ganzen Eimer Wasser für Jakob holen, den
er ihm zum Trinken hinstellte.</p>
<p class="calibre3">»Ich bin so krank, daß ich kaum Luft schnappen kann ... Was
knurrt denn da?«</p>
<p class="calibre3">»Der Hund ist es! ist von den Anteks zurückgekommen, das arme
Tier!«</p>
<p class="calibre3">»Waupa!« flüsterte er, in der Dunkelheit nach dem Hundekopf
tastend, und Waupa sprang empor, bellte und versuchte auf die
Pritsche zu klettern.</p>
<p class="calibre3">»Witek, tu' mal den Pferden etwas Heu einlegen, denn sie klopfen
mit den Zähnen an die leeren Krippen, ich kann mich ja nicht
rühren. Tanzen sie noch?« fragte er nach einer Weile, nachdem Witek
Heu vom Stallboden heruntergeworfen hatte und es in die Raufen
hineintat.</p>
<p class="calibre3">»Die werden wohl zu Mittag erst fertig, und manche haben sich so
betrunken, daß sie draußen auf der Straße liegen.«</p>
<p class="calibre3">»Die amesieren sich was, die amesieren sich, die Hofbauern,«
seufzte er schwer auf.</p>
<p class="calibre3">»Waren die Müllersleute da?«</p>
<p class="calibre3">»Sie waren, nur daß sie früher gegangen sind.«</p>
<p class="calibre3">»Sind wohl viele dagewesen?«</p>
<p class="calibre3">»Wer die zählen könnte ... nicht mehr rühren konnt' man sich im
Haus.«</p>
<p class="calibre3">»Haben sie reichlich was aufgetischt?«</p>
<p class="calibre3">»Das war schon rein wie im Herrenhof. Ganze Schüsseln Fleisch
haben sie herumgetragen, und was sie Schnaps ausgesoffen <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page326" title="Snoopy64/gary"></a> haben und noch
all das Bier und Met noch! Allein Wurst waren drei gehäufte Mulden
voll.«</p>
<p class="calibre3">»Wann ist denn die Brauteinholung?«</p>
<p class="calibre3">»Heute doch, zur Vesper.«</p>
<p class="calibre3">»Die haben noch was vor sich, die werden sich noch genug was
amesieren ... Du lieber Jesus, ich dachte, ich sollt' auch was
davon abkriegen, und wenn auch man 'n Brocken für mich
übergeblieben wär', daß ich mich doch mindestens einmal ordentlich
satt essen könnte, und nun lieg' einer hier und verreck', und hör'
zu, wie die anderen das Vergnügen haben.«</p>
<p class="calibre3">Witek ging wieder schlafen.</p>
<p class="calibre3">»Wenn man doch mindestens die Augen satt sehen könnte ... wenn
doch ...«</p>
<p class="calibre3">Ermattet verstummte er und käute in seinem Innern sein Leid
wieder/stille, schüchterne Klagen, die in seiner Brust hin- und
herflatterten, wie flügellahme Vöglein, und schmerzvoll
zirpten.</p>
<p class="calibre3">»Möge es ihnen wohl bekommen, laß sie wenigstens was vom Leben
haben ...,« dachte er, den Kopf des Hundes streichelnd.</p>
<p class="calibre3">Das Fieber umnebelte ihn immer mehr, und um Schutz zu finden,
fing er an, das Gebet zu murmeln und sich Jesu Barmherzigkeit warm
anzuempfehlen auf Gnade und Ungnade, aber er vergaß, was er sagen
wollte, der Schlaf überfiel ihn immer wieder, und die Reihenfolge
seiner geflüsterten Worte, die von Bitten und Tränen geschwellt
waren, zerriß und verstreute sich, wie eine rote Korallenschnur, so
daß er die einzelnen Perlen zusammenraffen wollte, so sichtbar
rollten sie über seinen Schafpelz; doch alles entschwand ihm/er
schlief ein.</p>
<p class="calibre3">Manchmal wachte er auf, ließ den leeren Blick schweifen, und
ohne etwas wahrzunehmen, sank er und stürzte wieder in die tote,
leichenstarre Dunkelheit zurück.</p>
<p class="calibre3">Dann wieder stöhnte er und schrie im Schlaf, daß die <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page327" title="Snoopy64/gary"></a> Pferde
schnaubend an den Ketten rissen; das brachte ihn wieder etwas zur
Besinnung, und er richtete den Kopf ein wenig auf.</p>
<p class="calibre3">»Jesus, mindestens noch den Tag erleben!« jammerte er angstvoll
und ließ die Blicke durchs Fensterchen gehen, um in der Welt den
kommenden Tag zu suchen; nach der Sonne spähte er am grauen kalten
Himmel, der mit erblassenden Sternen beschlagen war.</p>
<p class="calibre3">Aber der Tag war noch weit.</p>
<p class="calibre3">Der Stall war versunken im trüben dunstigen Licht der
Morgendämmerung, so daß schon die Umrisse der Pferde sich
abzuzeichnen begannen und die Raufen an den Fenstern wie Rippen
gegen das Licht zu sehen waren.</p>
<p class="calibre3">Er konnte nicht mehr einschlafen, denn neue Schmerzen überkamen
ihn, sie glitten ihm ins Bein, wie Knüttelstöcke, trieben es
auseinander, bohrten und brannten, als ob ihm einer mit lebendiger
Glut die Wunden bestreute, so daß er sich plötzlich emporriß und
aus ganzer Kraft zu schreien begann, bis Witek davon aufwachte und
hereingestürzt kam.</p>
<p class="calibre3">»Ich tu' sterben! Ich tu' sterben! Es schmerzt so in mir, die
Krankheit wächst sich aus und tut mich erwürgen ... Witek, lauf'
Ambrosius holen ... oh Jesus, oder Gusche, vielleicht helfen sie
was, denn ich mach' es nicht mehr ... die letzte Stunde kommt schon
über mich ... die letzte Zeit ...« er brach in ein furchtbares
Weinen aus, wühlte das Gesicht ins Stroh und schluchzte bang und
schwer.</p>
<p class="calibre3">Und Witek lief trotz seiner Schläfrigkeit zum Hochzeitshaus
zurück.</p>
<p class="calibre3">Sie waren immer noch im vollen Tanz, Ambrosius aber war besoffen
und stand, wie es bei ihm immer so war, mitten auf der Dorfstraße
vor dem Haus, torkelte hin und her zwischen Weiher und Zaun und
sang sich einen.</p>
<p class="calibre3">Vergeblich flehte ihn Witek an und zerrte ihn am Ärmel, der Alte
war wie taub und wußte nichts mehr von sich, er wankte nur und sang
verbohrt immerzu dasselbe Lied. <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page328" title="Snoopy64/gary"></a> Jetzt lief Witek zu Gusche, da sie
Erfahrungen in Krankheiten hatte, doch sie saß mit den
Gevatterinnen in der Kammer, und sie tranken einander mit dem
Kupnik dermaßen zu, taten sich so gütlich am Bier, daß sie alle auf
einmal redeten und Gesänge jaulten. Es war nichts mit ihr zu reden.
Immer wieder wimmerte Witek, daß sie doch zu Jakob kommen müsse,
bis sie ihn schließlich zur Tür hinaus schmiß und ihm mit der Faust
noch ein paar nachknuffte. Nachdem er so viel erreicht hatte,
rannte er weinend zum Stall zurück.</p>
<p class="calibre3">Da aber Jakob gerade schon wieder eingeschlafen war, so wühlte
er sich ins Stroh hinein, zog einen alten Fetzen über den Kopf und
schlief ein.</p>
<p class="calibre3">Eine gute Zeit nach dem Frühstück, weckte ihn das Brüllen der
hungrigen und ungemelkten Kühe auf und dazu das Keifen Gusches,
die, wie die anderen, die Zeit verschlafen hatte und das durch
Geschrei in der Wirtschaft wieder gut zu machen versuchte.</p>
<p class="calibre3">Erst nachdem sie etwas Arbeit abgewälzt hatte, sah sie nach
Jakob.</p>
<p class="calibre3">»Helft mir doch, ratet mir doch,« bat er leise.</p>
<p class="calibre3">»Heirat' dir 'ne Junge an, dann wirst du gleich auskuriert
sein!« fing sie vergnügt an; als sie aber sein blau angelaufenes,
geschwollenes Gesicht sah, wurde sie merklich ernster. »Einen
Priester brauchst du mehr als einen Arzt! Was soll ich dir da
helfen? Besprechen könnt' ich, beräuchern, aber wird das helfen?
... Es scheint mir, daß du die Todkrankheit hast, die reine
Todkrankheit ...«</p>
<p class="calibre3">»Soll ich denn sterben?«</p>
<p class="calibre3">»Das steht in Gottes Macht, aber mir deucht, daß du der
Knochenfrau nicht mehr entwischst.«</p>
<p class="calibre3">»Sterben soll ich, sagt ihr?«</p>
<p class="calibre3">»Nach Hochwürden müßte man schicken, wie?«</p>
<p class="calibre3">»Hochwürden!« stieß er erstaunt hervor. »Hochwürden
hierherbringen in den Stall zu mir? ... Was kommt euch an?«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page329" title="Snoopy64/gary"></a> »Was
denn, ist doch nicht aus Zucker, der wird sich hier schon im
Pferdemist nicht auflösen! Dazu ist doch der Priester da, daß er
kommt, wohin man ihn zu einem Kranken ruft.«</p>
<p class="calibre3">»Jesus! und ich sollte die Frechheit haben, zu mir, in diesen
Mist? ...«</p>
<p class="calibre3">»Bist dumm wie'n Schaf!« Sie zuckte mit den Achseln und ging
davon.</p>
<p class="calibre3">»Selbst dumm, weiß nicht was sie redet ...« brummte er, arg
empört, fiel schwer auf sein Lager zurück und sann noch lange nach.
»Hat sich was, das Frauenzimmer ... hale, Hochwürden, der liebe,
spaziert sich in den Zimmern herum ... liest aus den Büchern ...
redet mit dem lieben Gott ... und zu mir soll man ihn rufen ...
diese Frauen, ... nur um die Zunge laufen zu lassen ... Dumme
...«</p>
<p class="calibre3">So blieb er denn einsam liegen, und es war als ob sie ihn
vergessen hätten.</p>
<p class="calibre3">Zuweilen nur ließ sich Witek blicken, um den Pferden Hafer
aufzuschütten oder sie zu tränken; dann reichte er auch ihm Wasser
und verschwand bald wieder. Er lief zurück ins Hochzeitshaus, wo
sich die Gäste allmählich zur Brauteinholung einzufinden begannen.
Zuweilen stürzte auch Fine mit Geschrei herein und steckte Jakob
ein Stück vom Hochzeitskuchen zu, sie plapperte, schnatterte,
füllte den Stall mit Geschrei, so daß die Hühner auf den Staffeln
erschrocken zu gackeln anfingen, und rannte schnell davon.</p>
<p class="calibre3">Natürlich, die konnte gut rennen, denn man amüsierte sich da
schon nicht schlecht, die Musik dröhnte durch die Wände und frohes
Geschrei und Singen kam von daher.</p>
<p class="calibre3">Jakob lag still, denn von Zeit zu Zeit packten ihn von ungefähr
die Schmerzen; so horchte er denn nur hin und suchte zu erkennen,
was sie sich da amüsierten, dabei redete er mal mit Waupa, der ihn
nicht für einen Augenblick verließ und gemeinsam mit ihm Fines
Kuchen verzehrte; er schnalzte zu den Pferden hinüber und redete
mit <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page330" title="DaoH/gary"></a> ihnen,
bis sie freudig wieherten und die Köpfe von den Krippen nach ihm
drehten, die Jungstute riß sich sogar vom Halfter los und kam bis
an die Pritsche zu schäkern und die feuchten, warmen Nüstern an
sein Gesicht zu reiben.</p>
<p class="calibre3">»Bist mager geworden, mein Armes, mager!« Er streichelte sie
zärtlich und küßte sie auf die geblähten Nüstern. »Hab man keine
Angst, bald werd' ich schon gesund, dann will ich dir die Flanken
wieder rund machen und wenn es mit reinem Hafer sein soll ...«</p>
<p class="calibre3">Er wurde bald wieder still und blickte gedankenlos auf die
schwärzlichen Aststellen, von denen an den Wänden Harz herunter
geronnen war, wie erstarrte blutige Tränen.</p>
<p class="calibre3">Der blasse Sonnentag schaute mit stillen Augen durch die Ritzen,
durch die aufgesperrte Tür aber ergoß sich ein Strom flirrender,
blitzender Helligkeit, die wie die goldenen Spinnweben der
Stoppelfelder war; die Fliegen schwirrten darin mit einem
taumeligen, schläfrigen Summen.</p>
<p class="calibre3">Stunden auf Stunden gingen dahin, schleppten sich langsam
vorüber, wie blinde, lahme Bettler, die mühselig über schlimme
Sandwege ziehen; sie gingen in Stille, oder sie waren wie ein
Stein, der ins Bodenlose fällt und stürzt, sich verliert,
entschwindet, daß selbst das Auge ihn nicht mehr greifen kann.</p>
<p class="calibre3">Manchmal nur stürmte ein Haufen schilpender Spatzen in den Stall
und machte sich keck über die Krippen her ...</p>
<p class="calibre3">»Was für verständige Biester!« flüsterte er. »So ein Vöglein,
und der Herr Jesus gibt ihm den Verstand, daß es weiß, wo es die
Nahrung finden kann. Ruhig, Waupa, laß sie sich satt essen und
durchhelfen, die armen Dinger, auch für sie kommt der Winter.« Er
besänftigte den Hund, der aufgesprungen war, die Räuber
fortzujagen.</p>
<p class="calibre3">Auf dem Hof fingen die Schweine an zu quieken und sich gegen die
Ecken der Stallwand zu reiben, so daß das ganze Gebäude bebte, und
danach schoben sie ihre langen, dreckigen Rüssel durch die Tür und
grunzten.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page331" title="wolfeh/gary"></a> »Treib'
sie 'raus, Waupa, dieses Lungervolk, die haben nie genug!«</p>
<p class="calibre3">Kaum waren sie weg, da begannen die Hühner am Eingang zu gacksen
und ein großer roter Hahn guckte behutsam herein, wich zurück,
schlug mit den Flügeln und krähte, bis er plötzlich frech über die
Schwelle sprang und sich über den Kober voll Hafer machte, und
hinter ihm her erschienen seine Hühner, aber sie kamen nicht zum
rechten Essen, denn ein Trupp schnatternder Gänse tauchte auf; es
flimmerten auf der Schwelle die roten zischelnden Schnäbel und die
langgestreckten Halse bewegten sich hin und her.</p>
<p class="calibre3">»Treib' sie 'raus, mein Hund, treib' sie 'raus! Das Kroppzeug
hat nur immerzu miteinander zu zanken, ganz wie die Weiber!«</p>
<p class="calibre3">Es ertonte denn auch gleich ein Lärm, Geschrei und ein Flug elf
latschen, und Federn flogen auf, wie aus einem aufgerissenen
Federbett, denn Waupa ließ sich nicht sein Vergnügen entgehen, er
kehrte keuchend mit heraushängender Zunge zurück und winselte
freudig.</p>
<p class="calibre3">»Still da!«</p>
<p class="calibre3">Vom Haus herüber tönte das Schimpfen Gusches, Hin- und Herlaufen
und das Stoßen der von Stube zu Stube gezerrten Gegenstände.</p>
<p class="calibre3">»Sie bereiten sich zur Brauteinholung!«</p>
<p class="calibre3">Über die Straße kam hin und wieder einer gefahren, und jetzt
schlurfte knarrend irgendein Wagen vorüber. Jakob suchte eifrig
alles zu erkennen.</p>
<p class="calibre3">»Klembs Leiterwagen, ein Pferd hat er vor, will gewiß Nadelstreu
aus dem Wald holen. Natürlich vorne ist die Achse ausgerieben und
darum scheuert die Nabe und knarrt.«</p>
<p class="calibre3">Auf den Wegen hallten Schritte; Gespräche, Stimmen ließen sich
hören und kaum vernehmbare, kaum empfundene Töne zitterten in der
Luft, aber er ergriff sie im Fluge und suchte sie zu
unterscheiden.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page332" title="wolfeh/DaoH"></a> »Der
alte Pietraß geht in die Schenke,« brummte er. Walentys Frau hat
was zu schreien ... gewiß sind die Gössel von irgendwem auf ihre
Seite gekommen ... Ein Teufel, nicht ein Weib ist das! Kosiols
Frau, scheint mir ... natürlich ... sie läuft und schreit ...
natürlich ist sie es!... Rafus sein Peter ... schwadroniert, das
Biest, als ob er Klöse im Maul hat ... sieh, die Priesterstute
fährt nach Wasser, jawohl ... sie bleibt stehen ... hat sich
festgefahren ... wird noch mal die Beine brechen ...</p>
<p class="calibre3">Und so tat er langsam sich alles heraushören, und wanderte mit
seinen Gedanken und seinem hellsehenden Empfinden durchs ganze
Dorf, er sorgte, kümmerte, beunruhigte sich und lebte das Leben des
Dorfes, so daß er kaum bemerkte, wie der Tag langsam verstrich; das
Licht auf den Wänden begann zu erlöschen, der Türausschnitt
erblaßte und im Stall fing die Dämmerung an zu weben.</p>
<p class="calibre3">Schon ganz gegen Abend kam Ambrosius, er war noch nicht ganz
nüchtern, denn er ging noch unsicher und redete so schnell, daß man
ihn kaum verstehen konnte.</p>
<p class="calibre3">»Das Bein sollst du dir verrenkt haben?«</p>
<p class="calibre3">»Seht mal nach und helft.«</p>
<p class="calibre3">Schweigend wickelte er die blutgetränkten Lappen ab. Sie waren
angetrocknet und klebten so fest am Bein, daß Jakob himmelhoch zu
schreien anfing.</p>
<p class="calibre3">»Selbst 'ne Jungfrau bei der Geburt quiekt nicht so!« knurrte er
verächtlich.</p>
<p class="calibre3">»Es schmerzt doch! Jesus! Zerrt doch nicht so!« Er heulte auf,
fast wie ein Tier.</p>
<p class="calibre3">»Die haben dich aber noblicht zugerichtet! Ein Hund hat dir die
Wade ausgebissen, oder was ist das?« rief er erstaunt, denn die
Wade war zerfetzt und eiterig und das Bein dick geschwollen wie
eine Kanne.</p>
<p class="calibre3">»Da ... sagt es nur ja nicht ... der Förster hat mich
angeschossen ... nur ...«</p>
<p class="calibre3">»Wahrhaftig ... Schrot sitzt unter der Haut dicht wie <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page333" title="DaoH/gary"></a> Mohn ... Hat er dir
die denn von weitem aufgebrannt? Ho, ho! mir deucht mit dem Klumpen
ist es aus ... die Knöchelchen knacken nur so. Warum hast du mich
denn nicht gleich gerufen?«</p>
<p class="calibre3">»Ich hab' mich gefürchtet ... wenn die das gemerkt hätten, einen
Hasen wollt' ich ... ich hatt' ihn auch schon geschossen ... und
war schon mitten auf dem Feld ... und da knallt der auf mich los
...«</p>
<p class="calibre3">»Einmal hat der Förster in der Schenke erzählt, daß ihnen da
jemand Schaden macht ...«</p>
<p class="calibre3">»Hale ... Schaden ... als ob die Hasen vielleicht jemandem
gehörten ... Aas... hat sich lauern gelegt, um mich zu kriegen ...
auf dem Feld bin ich schon, und der schießt aus beiden Läufen auf
mich ... daß dich, du Satan ... sagt es nur ja nicht... vor Gericht
würden sie einen bringen ... die Flurjäger... und auf der Stelle
würden sie die Flinte wegnehmen ... und sie tut mir doch nicht
gehören ... Ich dachte, das soll selbst vorübergehen ... helft mir
doch bloß, denn es schmerzt und reißt so schrecklich ...«</p>
<p class="calibre3">»So ein Schlaumeier bist du! So ein Heimlicher, sieht aus, als
ob er von nichts nicht weiß und teilt sich mit dem Gutsherrn die
Hasen auf ... Sieh mal an ... aber mit dem Klumpen wirst du
bezahlen müssen bei dem Kompagniegeschäft ...«</p>
<p class="calibre3">Er besah das Bein noch einmal und wurde arg bedenklich.</p>
<p class="calibre3">»Zu spät, viel zu spät!«</p>
<p class="calibre3">»Helft doch, helft doch nur,« stöhnte Jakob entsetzt.</p>
<p class="calibre3">Ambrosius antwortete nichts mehr, krempte nur die Ärmel hoch,
holte ein scharfes Taschenmesser hervor, packte das Bein fest an
und fing an, die Schrotkörner herauszukratzen und den Eiter
herauszudrücken.</p>
<p class="calibre3">Zu Anfang brüllte Jakob los wie ein Tier, das geschlachtet wird,
bis ihm Ambrosius das Maul mit dem Schafpelz zustopfte, dann wurde
er plötzlich still, denn er war vor <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page334" title="wolfeh/DaoH"></a> Schmerzen besinnungslos geworden.
Ambrosius reinigte ihm das wunde Bein, belegte es mit einer Salbe
und umwickelte es mit neuen Lappen, dann erst machte er sich daran,
ihn wieder zu Bewußtsein zu bringen.</p>
<p class="calibre3">»Ins Spital mußt du gehen ...,« knurrte er leise.</p>
<p class="calibre3">»Ins Spital? ...« Jakob war noch ganz benommen.</p>
<p class="calibre3">»Das Bein würden sie dir abschneiden, dann würdest du vielleicht
gesund werden.«</p>
<p class="calibre3">»Das Bein?«</p>
<p class="calibre3">»Natürlich, nichts mehr wert ist es, ganz verdorben, wird schon
schwarz.«</p>
<p class="calibre3">»Abschneiden?« fragte er, ohne zu begreifen.</p>
<p class="calibre3">»Im Knie. Hab' man keine Angst, mir hat die Kugel das Bein
gleich unterm Hintern abgerissen und ich leb' doch auch noch.«</p>
<p class="calibre3">»Ihr meint, man braucht nur das kranke Teil abzuschneiden, und
dann war' ich wieder gesund? ...«</p>
<p class="calibre3">»In einem Nu ... aber du mußt gleich ins Spital ...«</p>
<p class="calibre3">»Nee, ich hab' Angst, nee... nicht ins Spital...«</p>
<p class="calibre3">»Dummer! ...«</p>
<p class="calibre3">»Da schneiden sie einen bei lebendigem Leibe kaputt ... da ...
Schneidet ihr ... ich zahl' euch was ihr wollt, tut es doch ... ich
will nicht ins Spital, lieber schon hier verrecken ...«</p>
<p class="calibre3">»Dann verreckst du auch ... das kann dir nur der Doktor
abschneiden. Gleich geh' ich zum Schulzen, daß sie dir für morgen
eine Fuhre geben und dich in die Stadt fahren.«</p>
<p class="calibre3">»Ihr redet umsonst, denn ins Spital geh' ich nicht ...« sagte er
entschlossen.</p>
<p class="calibre3">»Hale, als wenn man dich erst fragen tut, so 'n Dummer!«</p>
<p class="calibre3">»Abschneiden und gleich werd' ich wieder gesund ...,«
wiederholte Jakob leise nach seinem Weggehen.</p>
<p class="calibre3">Der Fuß hörte auf zu schmerzen noch der Behandlung, aber er war
steif geworden bis zu den Weichen und über die ganze Seite fühlte
er ein Kribbeln, wie von Ameisen; er <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page335" title="wolfeh/DaoH"></a> achtete nicht darauf, denn er war ganz in
Gedanken versunken.</p>
<p class="calibre3">»Gesund würde ich werden! Das muß schon so sein, daß es so ist,
dem Ambrosius fehlt doch auch das ganze Bein ... einen Stelzfuß hat
er ... Und er sagt, daß es in einem Nu wieder gut ist ... Aber der
Boryna würde mich fortjagen ... natürlich, ein Knecht ohne Bein ...
taugt nicht zum Pflug und nicht zur Arbeit. Was soll ich da bloß
anfangen? Das Vieh hüten oder auf den Bettel gehen ... in die Welt
hinaus, an die Kirchenmauer ...? Oder wie ein alter Schuh auf den
Müllhaufen kommen ... am Zaun verrecken. Barmherziger Jesus! Oh
Jesus!« Plötzlich hatte er es klar begriffen und richtete sich fast
ganz auf in betäubender Angst. »Jesus! Jesus!« wiederholte er wie
im Fieber, am ganzen Körper schlotternd und geistesabwesend vor
sich hinstarrend.</p>
<p class="calibre3">Ein tiefes, schmerzzerrissenes Weinen quoll in ihm auf, ein
Schrei der Hilflosigkeit eines rettungslos in den Abgrund
Stürzenden.</p>
<p class="calibre3">Sein Weinen wurde zu einem Heulen, lange rang er hin und her mit
seiner Qual, doch durch Tränen und Verzweiflung fingen sich in ihm
irgendwelche Entschlüsse und Überlegungen an zu regen, er wurde
langsam still, beruhigte sich und vertiefte sich so in sich selbst,
daß er nicht mehr hörte, was um ihn geschah; wie durch einen fernen
Traum dämmerte ihm ein Spielen, Singen und ein naher Lärm auf.</p>
<p class="calibre3">Gerade um diese Zeit siedelten die Hochzeitsgäste zu Boryna
über.</p>
<p class="calibre3">Man bewerkstelligte die Einholung Jagnas zu ihrem Ehemann.</p>
<p class="calibre3">Kurz vordem hatte man eine mächtige Kuh herübergeführt und eine
Truhe, Federbetten, sowie verschiedenes Gerät, das sie noch als
Mitgift bekommen hatte, herübergefahren.</p>
<p class="calibre3">Jetzt aber, vielleicht ein Paternoster nach Sonnenuntergang, als
es schummerig wurde und die Welt infolge eines <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page336" title="wolfeh/DaoH"></a> bevorstehenden
Witterungswechsels sich mit Nebeln zu umspinnen begann, schoben die
Menschen im Haufen aus dem Hause der Dominikbäuerin auf die
Straße.</p>
<p class="calibre3">Die Musik ging an der Spitze und spielte frisch auf; hinterher
aber wurde die noch ganz hochzeitsmäßig gekleidete Jagusch von der
Mutter, den Brüdern und Gevattern geführt; nebenher und
hinterdrein, wie es gerade kam, drängte sich die Schar der
Hochzeitsgäste.</p>
<p class="calibre3">Sie gingen langsam am Weiher entlang, der wie schwarz angelaufen
dalag und unter der Last der Dämmerung zu erlöschen begann, mitten
durch den immer dichter werdenden Nebel in der Stille einer noch
stumpfen und blinden Dunkelheit, so daß das Getrampel der Füße und
das Spiel der Instrumente dumpf und eingeengt klang, als kämen die
Töne aus der Tiefe des Wassers.</p>
<p class="calibre3">Die Jugend stimmte hin und wieder ein Liedchen an, eine
Gevatterin trällerte los, oder einer von den Männern juchzte sein
»da-dana,« doch sie verstummten bald, es war noch keine rechte Lust
da, und die nasse Kälte fuhr einem durch Mark und Bein.</p>
<p class="calibre3">Erst als sie in den Heckenweg einbogen, der auf den Borynahof
zuführte, fingen die Brautjungfern an zu singen:</p>
<p class="vers">Und es kam der Dirn' das Weinen<br class="calibre2"/>
vor dem Traualtar;<br class="calibre2"/>
vier Lichter wurden angebrannt,<br class="calibre2"/>
man spielte die Orgel sogar.<br class="calibre2"/>
Und du, Mädchen, hast gedacht,<br class="calibre2"/>
daß sie dir ewig spielen werden? ...<br class="calibre2"/>
Gestern etwas, heute etwas ...<br class="calibre2"/>
Und sonst Not und Leid auf Erden ...<br class="calibre2"/>
Da-dana! Und sonst Not und Leid auf Erden!</p>
<p class="calibre3">Auf der Galerie, auf der Schwelle wartete schon Boryna, die
Junggesellen und Fine.</p>
<p class="calibre3">Vorweg kam die Dominikbäuerin mit einem Bündel, in dem sich eine
Brotschnitte, eine Prise Salz, ein Stück Kohle, Wachs von einer
Totenkerze und ein Büschel Ähren, das <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page337" title="wolfeh/DaoH"></a> am Kräutersonntag geweiht war,
befanden, und als Jagusch über die Schwelle ging, warfen die
Gevatterinnen ausgezupfte Stoffasern und Hede hinter ihr her, damit
der Böse keinen Zutritt habe und daß ihr alles gedeihen sollte.</p>
<p class="calibre3">Gleichzeitig begrüßten sie sich, küßten sich und wünschten dem
jungen Paar Glück, Gesundheit und was da der liebe Gott noch geben
mag, und alles strömte in die Stube, so daß sie bald alle Bänke und
Winkel besetzt hatten.</p>
<p class="calibre3">Die Musikanten klimperten leise, ihre Instrumente stimmend, um
die Bewirtung nicht zu stören, mit der Boryna selbst den Gästen
aufwartete.</p>
<p class="calibre3">Er ging mit einem vollen Maßkrug von Gevatter zu Gevatter, bot
an, nötigte, umarmte und trank jedem zu; der Schmied war ihm dabei
behilflich und schenkte in der anderen Ecke der Stube ein, wahrend
Magda und Fine einen mit Honig zubereiteten Quarkkuchen auf Tellern
herumtrugen, den die Schmiedin absichtlich für die Brauteinholung
gebacken hatte, um sich bei Vätern lieb Kind zu machen.</p>
<p class="calibre3">Aber es wollte nicht recht mit dem Amüsement vorwärtskommen,
natürlich goß man nicht den Schnaps hinter sich, anstatt in den
Mund und mied die Gläser nicht; sie tranken selbst mit Lust
einander zu, nur daß sie irgendwie nicht zur rechten Feststimmung
kommen konnten und nicht ins Sieden gerieten, kaum daß die Freude
ein paar Bläslein steigen ließ, wie Wasser auf schwachem Feuer; sie
saßen matt herum, bewegten sich schwer, linkisch, sprachen wenig
und leise und der eine oder der andere der Älteren gähnte heimlich,
streckte sich sehnsüchtig und dachte nur daran, wie er wohl
irgendwo so schnell wie möglich ins Stroh kommen könnte.</p>
<p class="calibre3">Und die Frauen, obgleich sie ein Gezücht sind, das am meisten
Lärm macht und nie genug vom Amüsieren kriegt, drückten sich auf
den Bänken herum und steckten in den Ecken einsilbig
beieinander.</p>
<p class="calibre3">Jaguscha hatte sich in der ehelichen Kammer gleich die sonstige
Festtracht angezogen und trat hinaus, um zu bewirken <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page338" title="wolfeh/DaoH"></a> und die Gäste zu
empfangen, aber die Mutter ließ sie nichts anrühren.</p>
<p class="calibre3">»Genieß du deine Hochzeit, mein Töchterchen! Wirst noch genug
Arbeit und Mühe haben!« flüsterte sie; sie zog sie immer wieder in
ihre Arme und drückte sie mit Tränen in den Augen ans Herz, so daß
es manch einem seltsam dünkte, sie ging doch nicht in die Welt,
heiratete nicht in ein anderes Dorf und hatte keine Armut zu
erwarten.</p>
<p class="calibre3">Sie lachten über diese mütterliche Zärtlichkeit und wetzten ihre
Zungen mit Spötteleien; jetzt erst bei der Brauteinholung, da
Jagusch als Hofbäuerin und Besitzerin in das eheliche Haus
eingezogen war, gingen ihnen die Augen auf; so viel Grund und
Boden, das viele Hab und Gut, und alles das hatte sie jetzt. Manch
einer der Mütter, deren Töchter schon lange in den Heiratsjahren
waren, fuhr der Neid in die Gurgel, und den Mädchen war es auch
nicht recht gut zumute, es kam ihnen irgendwelche Verdrießlichkeit
an.</p>
<p class="calibre3">Sie gingen miteinander auf die andere Seite des Hauses hinüber,
wo früher Anteks gewohnt hatten; Gusche und Eve bereiteten hier das
Abendessen vor. Es war ein starkes Geknatter auf dem Feuerherd, und
Witek konnte gar nicht genug Holzkloben zutragen und unter die
gewaltigen Kochtöpfe schieben.</p>
<p class="calibre3">Sie krochen im ganzen Haus herum und lugten mit ihren neidischen
Augen durch jede Ritze.</p>
<p class="calibre3">Wie hätte das auch anders zugehen können, daß man so ein Los
nicht neiden sollte.</p>
<p class="calibre3">Allein schon das Haus, das beste im ganzen Dorf war's, groß,
hell, hoch, die Stuben rein, wie im Herrenhof, sein geweißt und mit
Fußböden und wie sauber! Und das viele Mobiliar, die verschiedenen
Geräte, und dann all die Bilder, an die zwanzig Stück sicherlich,
und alle mit Glas. Und was war da nicht alles: Kuhställe,
Pferdeställe, und die Scheune, und der Schuppen! Und war da nicht
vielleicht genug lebendes Inventar! Fünf Kuhschwänze allein, ohne
den <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page339" title="wolfeh/DaoH"></a> Bullen,
der doch auch ein ordentliches Stück Profit abwirft! Drei Pferde;
und die Felder, und die Schweine, und die Gänse, und ...!</p>
<p class="calibre3">Sie seufzten schmerzlich und immer wieder fing die oder jene
eins ums andere Mal zu reden an.</p>
<p class="calibre3">»Mein Gott, daß doch der Herr Jesus immer solchen alles gibt,
die es gar nicht verdient haben!«</p>
<p class="calibre3">»Die haben es verstanden, sich zu helfen, die wissen
Bescheid!«</p>
<p class="calibre3">»Das ist mal sicher, allemal kriegt der was, der angelaufen
kommt.«</p>
<p class="calibre3">»Warum ist denn eure Ulisja nicht so klug gewesen,
entgegenzukommen?«</p>
<p class="calibre3">»Weil sie Gottesfurcht genug hat und ein ehrliches Leben
führt.«</p>
<p class="calibre3">»Das ist mit den anderen auch so.«</p>
<p class="calibre3">»Und einer anderen wird nichts nachgesehen, man braucht sie nur
einmal zur nächtlichen Zeit mit einem zu sehen, und gleich wird sie
auf den Zungen durch die ganze Welt getragen.«</p>
<p class="calibre3">»So eine hat Glück ...«</p>
<p class="calibre3">»Weil sie keine Scham hat.«</p>
<p class="calibre3">»Kommt doch 'rüber« rief Jendschych. »Die Musik spielt und in
der Stube ist kein einziger Weiberrock. Man will doch was zu tanzen
haben!«</p>
<p class="calibre3">»Guck mal an, was der für Lust hat, und wird dir denn die Mutter
... erlauben?...«</p>
<p class="calibre3">»Laß dir nur nicht deine Höschen abrutschen bei dieser Fahrt,
sonst gibt's noch'n Spiegel zu sehen.«</p>
<p class="calibre3">»Und halt die Klumpen besser beisammen!«</p>
<p class="calibre3">»Geh mit Walentys Frau tanzen, dann gibt es zwei Plumpsäcke
beieinander!«</p>
<p class="calibre3">Jendschych ließ nur einen Fluch fahren, griff sich die erste
beste heraus und führte sie mit sich, ohne viel darauf zu achten,
was da hinter ihm her summte.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page340" title="wolfeh/DaoH"></a> In der
Stube tanzten sie schon, wenn auch nur langsam und fast
widerwillig; Nastuscha Täubich und Schymek Patsches allein drehten
sich eifrig im Tanz. Sie hatten sich schon vordem verabredet, und
als die Musik ansetzte, nahmen sie sich fest in die Arme und
tanzten gründlich und ehrlich, und jedesmal wenn sie absetzten,
wandelten sie umschlungen in der Stube einher, Hüfte an Hüfte
geschmiegt, so daß es sie ordentlich nach einander verlangte; man
hörte sie lustig reden und laut lachen, die Dominikbäuerin aber
verfolgte ihren Sohn immerzu mit unruhigen Augen.</p>
<p class="calibre3">Erst als der Schulze kam, denn er hatte sich verspätet, weil er
die Rekruten nach dem Kreisamt bringen mußte, kam Leben in die
Leute; kaum war er eingetreten, kaum hatte er dem und jenem
zugetrunken, da fing er schon an mit seinen Gastgebern herumzureden
und die jungen Eheleute zu necken.</p>
<p class="calibre3">»Der Herr Bräutigam ist wie eine gekalkte Wand und die Braut wie
feines rotes Haartuch.«</p>
<p class="calibre3">»Das könnt ihr morgen sagen ...«</p>
<p class="calibre3">»Ihr seid doch ein Praktikus, Matheus, da habt ihr doch den Tag
nicht verpaßt.«</p>
<p class="calibre3">»Ist doch nicht wie ein Gänserich, ... vor allen Leuten!
...«</p>
<p class="calibre3">»Nicht ein halbes Maß Schnaps wett' ich dafür! Wirf du mal einen
Stein in die Büsche, da wird schon immer irgendein Vöglein
herausgeflogen kommen, das sag' ich euch, der Schulze!«</p>
<p class="calibre3">Sie lachten laut los, denn Jagna war auf die andere Seite
geflüchtet.</p>
<p class="calibre3">Auch die Weiber stichelten, soviel ihnen die Spucke nur
'rantrug.</p>
<p class="calibre3">Bald steigerte sich das Stimmengewirr, und Fröhlichkeit ergriff
die Gemüter; der Schulze hatte ehrlich dazu geholfen, und auch der
Schnaps tat das seine; Boryna sparte nicht und ließ die Flasche oft
die Runde machen; auch der Tanz <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page341" title="wolfeh/DaoH"></a> ging nun lebhafter und rascher vonstatten,
sie fingen schon an zu singen und aufzutrampeln und drehten sich in
einem immer größeren Kreise durch die Stube.</p>
<p class="calibre3">Gerade zu dieser Zeit erschien Ambrosius, ließ sich, kaum daß er
über die Schwelle war, nieder und ging mit seinen gierigen Augen
der Branntweinflasche nach.</p>
<p class="calibre3">»Euer Kopf dreht sich immer nur dahin, wo die Gläser klirren!«
warf der Schulze hin.</p>
<p class="calibre3">»Die klirren, weil das ihr Amt ist; und wer den labet, der da
lechzt, der tuet wohl!« entgegnete er ernst.</p>
<p class="calibre3">»Wasser gefällig, alter Schlauch?«</p>
<p class="calibre3">»Was dem Vieh schmeckt, schadet dem Menschen! Man sagt doch:
›Wen das Wasser erlöst, den erlöst es ... der Schnaps stellt aber
jeden auf die Beine‹.«</p>
<p class="calibre3">»Denn trink 'mal einen Branntwein, wenn du so'n Kalkulant
bist.«</p>
<p class="calibre3">»Trinkt mir zu, Herr Schulze! Man sagt auch das: ›Die Taufe nimm
in Wasser, die Hochzeit begieß mit Wein und den Tod mit
Tränen‹.«</p>
<p class="calibre3">»Recht haben sie, trinkt einen zweiten ...«</p>
<p class="calibre3">»Vor dem dritten lauf' ich auch nicht weg! Ich trinke immer
einen für meine erste Frau und zwei für die zweite.«</p>
<p class="calibre3">»Warum denn das?«</p>
<p class="calibre3">»Weil sie zur rechten Zeit gestorben ist, damit ich noch 'ne
dritte haben kann.«</p>
<p class="calibre3">»Auf 'ne Frau sinniert er, und es ist doch schon nach der
Abendzeit bei ihm, die Nacht sitzt ihm schon in den Glotzen
...«</p>
<p class="calibre3">»Mein Stecken find't schon noch bei Nacht die Weiberbeine!«</p>
<p class="calibre3">Die Stube erdröhnte vor Gelächter.</p>
<p class="calibre3">»Die Gusche wollen wir euch anheiraten!« schrien die Frauen.</p>
<p class="calibre3">»Den Schnaps mag sie und das Maulwerk hat sie auch,« ergänzten
die anderen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page342" title="wolfeh/DaoH"></a> »Man
sagt: ›ein arbeitsamer Mann und eine Frau, die ihre Schnauze
brauchen kann, kriegen sich die halbe Welt zusamm'n‹.«</p>
<p class="calibre3">Der Schulze setzte sich zu ihm hin und die anderen ringsherum,
wo nur ein Platz auf den Bänken war; und als keiner mehr zu finden
war, blieben sie stehen, drängten sich zu einem Haufen zusammen und
nahmen fast die Hälfte der Stube ein, ohne auf die Tanzenden zu
achten.</p>
<p class="calibre3">Gleich begannen da allerhand Neckereien, Erfindungen,
Erzählungen, lustige Reden und Anekdötchen, so daß schier die Wände
bebten; am meisten aber räsonierte Ambrosius, den Buckel voll log
sich die Kanaille und erzählte einem seine Lügengeschichten direkt
ins Gesicht, aber so geschickt und ergötzlich, daß sie sich vor
Lachen krümmten; und von den Frauen ließ sich die Wachnikbäuerin
von keinem übertrumpfen, ihr Maulwerk war obenan, und auch der
Schulze pflichtete ihr bei, soweit ihm das sein Ansehen und sein
Amt erlaubte.</p>
<p class="calibre3">Die Musik geigte schwungvoll und mächtig, und die Jugend schwang
sich frisch herum, juchzte und stieß scharf mit den Absätzen auf,
sie aber belustigten sich gemeinsam so froh, daß sie die ganze
liebe Welt vergessen hatten, bis einer plötzlich im Flur Jankel
entdeckte. Sie schleppten ihn in die Stube. Der Jude nahm die Mütze
ab, verbeugte sich, begrüßte die Anwesenden freundschaftlich, ohne
darauf zu achten, daß ihm die Spottnamen wie Steine um die Ohren
flogen.</p>
<p class="calibre3">»Rotkopf! Ungetaufter! Sohn einer Stute!«</p>
<p class="calibre3">»Ruhig da! Schnaps geben, traktiert ihn mal,« rief der
Schulze.</p>
<p class="calibre3">»Bin ich gegangen den Weg, wollt' ich sehen, wie sich die Herren
Hofbauern vergnüglich machen. Gott vergelt's, Herr Schulze, ich
will den Schnaps trinken, was soll ich nicht trinken auf die
Gesundheit von dem Brautpaar?«</p>
<p class="calibre3">Boryna brachte eine Flasche und schenkte ein. Jankel <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page343" title="wolfeh/DaoH"></a> wischte das Glas
mit dem Schoß seines Kaftans ab, bedeckte sich und trank aus und
goß noch einen zweiten hinter die Binde.</p>
<p class="calibre3">»Bleibt da, Jankel, Unkoscheres sollt ihr nicht haben. Heda,
Musikanten, spielt den Jüdischen auf! laßt Jankel tanzen!« riefen
sie lachend.</p>
<p class="calibre3">»Ich kann schon tanzen, das ist keine Sünde!«</p>
<p class="calibre3">Doch bevor die Musikanten die Zurufe begriffen hatten, schob
sich Jankel auf den Flur hinaus und verschwand im Hof, er war nach
Jakob geeilt, das Gewehr in Empfang zu nehmen.</p>
<p class="calibre3">Sie hatten nicht einmal sein Verschwinden gemerkt, denn
Ambrosius setzte seine Aufschneidereien fort, und die
Wachnikbäuerin tat ihr Bestes, ihn zu begleiten, als müßte sie die
Baßgeige zu seinem Schelmenlied spielen; so war ihnen die Zeit bis
zum Abendessen vergangen; die Musik spielte schon leiser, man hatte
die Tische aufgestellt und lärmte mit den Schüsseln, sie aber
lachten in einem fort.</p>
<p class="calibre3">Vergeblich lud Boryna zum Essen ein, man hörte nicht einmal auf
ihn. Darauf wiederholte auch Jagusch mehrmals, daß sie doch kommen
möchten, da hatte sie aber schon der Schulze mitten in den Haufen
gezogen, an seine Seite gesetzt und hielt sie fest bei der
Hand.</p>
<p class="calibre3">Schließlich rief Jaschek, den man den ›Verkehrten‹ nannte, ganz
laut:</p>
<p class="calibre3">»An die Schüsseln, Leute, das Essen wird sonst kalt!«</p>
<p class="calibre3">»Halt's Maul, Dummkopf, auch für dich wird sich eine Schüssel
zum Auslecken finden.«</p>
<p class="calibre3">»Der Küster lügen nur so, daß es raucht. Er denkt wohl, daß ihm
einer was glauben tut ...«</p>
<p class="calibre3">»Höre mal, du, was man dir ins Maul gibt, das kannst du nehmen,
das ist deins, aber rühr' mich nicht an, damit wirst du nicht
fertig.«</p>
<p class="calibre3">»Wollen sehen!« schrie der Bursche zurück; er war etwas dummelig
und schwer von Begriff.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page344" title="wolfeh/DaoH"></a> »Der
Ochs wird ebenso mit mir fertig, vielleicht selbst besser noch,«
warf Ambrosius ihm zu.</p>
<p class="calibre3">»Was der Pfarrer in den Eimer leert, tragt Ambrosius hinaus, nun
meint er, er hat den ganzen Pfarrer.«</p>
<p class="calibre3">»Laß du nur ein Kalb in die Kirche, dann hat es auch nichts
Besseres zu tun, als den Schwanz hochzuheben! Dummes Frauenzimmer!«
knurrte er gekränkt, denn es war Jascheks Mutter, die den Versuch
gemacht hatte, ihren Sohn zu verteidigen. Als erster erhob er sich
und hinter ihm her fingen die anderen an, ihre Plätze an den
Tischen einzunehmen. Sie beeilten sich, denn die Köchinnen trugen
die dampfenden Schüsseln herein und schmackhafte Düfte zogen durch
die Stube.</p>
<p class="calibre3">Sie setzten sich dem Alter nach hin, wie es sich bei einem
Brauteinholungsfest schickte. Die Dominikbäuerin mit ihren Söhnen
saß in der Mitte; die Brautjungfern und die Brautführer setzten
sich beieinander zu Tisch, und Boryna war mit Jagusch mitten in der
Stube geblieben, um die Gäste zu bedienen und auf alles Obacht zu
geben.</p>
<p class="calibre3">Es wurde ganz still. Nur hinter den Fensterscheiben kreischten
die Dorfkinder und prügelten sich untereinander, und Waupa lief
bellend ums Haus und versuchte in den Hausflur einzudringen. Die
Leute aber bewältigten mit ruhiger Würde das Essen und stachen auf
die gehäuften Schüsseln ein. Man hörte nur die Löffel gegen die
Kerben des Geschirrs kratzen und die Gläser klirren, die fleißig
die Runde machten.</p>
<p class="calibre3">Jagusch aber forderte immerzu auf, schob fast jedem etwas zu,
sei es Fleisch oder andere Speisen; sie nötigte die Gäste, daß sie
sich ja an allem gütlich tun möchten, und es ging ihr so geschickt
vonstatten, sie verstand jedem so passend etwas Schmeichelhaftes zu
sagen und tat zu jedermann mit solcher Anmut freundlich, daß manch
einer von den Burschen sie mit sehnsüchtigen Augen verfolgte, und
die Mutter sich vor Zufriedenheit reckte, ihren Löffel beiseite
legte, um <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page345" title="wolfeh/DaoH"></a>
besser nach ihr hinschauen zu können und sich über sie zu
freuen.</p>
<p class="calibre3">Auch Boryna merkte es, eilte ihr nach, als sie zu den Köchinnen
wollte, holte sie im Flur ein, preßte sie fest an sich und küßte
sie heftig ab.</p>
<p class="calibre3">»Du meine liebe Wirtin! Wie eine Gutsherrin weißt du dir zu
helfen und zu raten!«</p>
<p class="calibre3">»Bin ich denn vielleicht nicht die Wirtin? Aber geht nur wieder
in die Stube. Gulbas und Simeon sitzen mürrisch da und essen kaum
was. Trinkt ihnen mal zu.«</p>
<p class="calibre3">Versteht sich, daß er ging und ihr gehorchen tat, und alles
machte, was sie nur wollte. Jagusch aber war es seltsam froh und
lustig zumute. Sie fühlte sich Hausherrin und keine geringe / eine
Gutsfrau fast; das Regieren kam ihr wie von selbst, und
gleichzeitig wuchs in ihr die Würde und ein machtvoller,
selbstsicherer Stolz. Sie ging durch die Stuben und trug sich
aufrecht und ungezwungen, sah nach allem scharf und leitete alles
so verständig, als ob sie Gott weiß wie lange schon auf Eigenem
gewirtschaftet hätte.</p>
<p class="calibre3">»Wie sie ist, wird der Alte bald selber merken müssen, das ist
schon seine Sache, aber mir scheint, sie gibt 'ne gute Hausfrau
ab,« flüsterte Eve der Gusche zu.</p>
<p class="calibre3">»Klug ist auch die Kathrine, wenn sie was hat in der Terrine!«
antwortete diese hämisch. »Laß den Alten ihr erst mal zuwider
werden, und laß sie erst mal hinter den Burschen herjagen ...«</p>
<p class="calibre3">»Das wird sie doch nicht tun, nur dahinter sitzt doch noch der
Matthias, der wird sie schon nicht so leicht fahren lassen.«</p>
<p class="calibre3">»Ih ... fahren lassen! Dazu wird ihn schon ein anderer
kriegen...«</p>
<p class="calibre3">»Boryna?«</p>
<p class="calibre3">»Hale, Boryna! Da gibt es doch noch einen, der stärker ist als
die beiden ... jawohl... laßt nur erst die Zeit kommen und ihr
sollt sehen ...,« sie lächelte listig. »Witek, jag mal den Hund
weg, der bellt und bellt, daß einem die Ohren <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page346" title="lac/DaoH"></a> weh tun, kannst auch die verdammten
Jungen auseinandertreiben, die drücken uns hier noch die Scheiben
ein und zerren den Wandschutz auseinander.«</p>
<p class="calibre3">Witek rannte mit der Peitsche hinaus, der Hund verstummte und
man hörte nur noch das Gekreisch von Kinderstimmen und das
Getrappel der fortlaufenden Füße; er jagte sie bis auf den Weg
hinaus und lief dann vornübergebeugt zurück, denn ein Hagel von
Steinen und Schmutzklumpen sauste ihm nach.</p>
<p class="calibre3">»Witek! wart' mal!« rief Rochus, der an der Hausecke nach dem
Hof zu im Dunkeln stand. »Ruf' Ambrosius, er soll gleich kommen
wegen einer wichtigen Angelegenheit, ich wart' auf der
Galerie.«</p>
<p class="calibre3">Erst nach einem Paternoster kam Ambrosius stark erzürnt heraus,
denn er war mächtig böse, daß man ihm das Essen im besten
Augenblick, grad' beim Spanferkel mit Erbsen unterbrochen
hatte.</p>
<p class="calibre3">»Brennt die Kirche, oder was?«</p>
<p class="calibre3">»Schreit nicht, kommt mit zu Jakob, mir ist, er stirbt.«</p>
<p class="calibre3">»Laß ihn verrecken ... Leute hier beim Essen stören. Nach dem
Vesper bin ich doch bei ihm gewesen und hab' ihm gesagt, daß er
sich zum Spital bereit hält, das Bein würden sie ihm da abschneiden
und dann wäre er gleich wieder gesund! ...«</p>
<p class="calibre3">»Das habt ihr ihm gesagt! Jetzt begreif' ich; ich glaube, er hat
es sich selber abgeschnitten ...«</p>
<p class="calibre3">»Jesus, Maria! Was denn, selbst abgeschnitten? ...«</p>
<p class="calibre3">»Kommt, kommt schnell, ihr könnt ja nachsehen. Ich ging in den
Kuhstall, um mich schlafen zu legen, kaum bin ich auf dem Hof,
springt Waupa mich an, bellt, winselt, zerrt mit den Zähnen an
meinem Rock, reißt mich vorwärts, ich wußte gar nicht, was er
wollte ... und er voraus, und sitzt an der Schwelle des
Pferdestalles und winselt. Ich ging also hin und will sehen, was da
ist; da liegt Jakob auf der Schwelle, mit dem Kopf noch im Stall.
Ich dacht' erst, er <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page347" title="wolfeh/DaoH"></a> wollte Luft schnappen und daß ihm dabei schwach
geworden wär'. Ich trug ihn also auf die Pritsche und hab' die
Laterne angezündet, um Wasser zu finden, und wie ich ihn zu sehen
krieg', liegt er ganz in Blut und leichenblaß, und vom Bein her
strömt nur immer so das Blut. Laß uns nur rasch gehen, damit er uns
nicht wegstirbt ...«</p>
<p class="calibre3">Sie traten in den Stall, und Ambrosius machte sich scharf dran,
ihn in die Besinnung zu bringen; Jakob lag regungslos, atmete wenig
und stoßweise und röchelte durch die zusammengepreßten Zähne, so
daß man sie ihm geradezu auseinanderzwängen mußte, um ihm etwas
Wasser einzuflößen.</p>
<p class="calibre3">Das Bein war ihm am Knie abgetrennt, es hing kaum noch an der
Haut fest und blutete stark. An der Schwelle hatten sich
verschiedene Blutlachen gebildet, und daneben lag eine
blutbesudelte Axt, und der Schleifstein, der sonst unter der
Dachtraufe des Pferdestalls stand, lag neben der Schwelle.</p>
<p class="calibre3">»Da haben wir's, sich selbst das Bein abgehackt. Angst hat er
gehabt vor dem Spital, und der Dumme denkt, daß er sich selber
helfen kann, aber ein starkes Mannsbild! Jesus, sich selbst seinen
Klumpen abzuschneiden! Gar nicht zu glauben! Hat mächtig viel Blut
verloren.«</p>
<p class="calibre3">Jakob schlug die Augen plötzlich aus und ließ sie ziemlich klar
umherschweifen.</p>
<p class="calibre3">»Ist es abgeflogen? Zweimal hab ich drauflos gehackt, aber es
ist mir ganz schwarz vor Augen geworden ...« murmelte er.</p>
<p class="calibre3">»Hast du denn Schmerzen?«</p>
<p class="calibre3">»Nicht die Spur ... Nur die Kräfte sind mir ganz abgegangen,
aber ich bin wohler!«</p>
<p class="calibre3">Er lag still und gab nicht einen Schrei von sich, als Ambrosius
ihm das Bein zurechtlegte, reinigte und in nasse Tücher
wickelte.</p>
<p class="calibre3">Rochus hielt kniend die Laterne hin und betete so inbrünstig,
daß ihm die Tränen über die Wangen liefen. Jakob <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page348" title="lac/DaoH"></a> lag immer noch still da und
lächelte freudig bewegt und voll inniger Zuversicht, wie ein
verlassenes Kindlein auf dem Feld, das den Gräsern zulächelt, die
über ihm säuseln, der Sonne nachschaut, zu den vorüberfliegenden
Vöglein seine Hände hebt und sich auf seine Art vergnügt und mit
allen Dingen redet, ehe es noch weiß, daß es ohne Mutter ist, so
war es ihm jetzt zumute; gut war es ihm, ruhig fühlte er sich und
ohne Schmerzen, und die Seele war ihm so leicht und froh, daß er
sich nichts aus dem Kranksein machte, sich selbst ein klein wenig
brüstete ..., wie gut es ihm geglückt war, das Beil zu schärfen ...
wie er sich das Bein auf der Schwelle zurechtgelegt hatte ... und
mitten in die Kniescheibe hatte er sich dann geschlagen ...
Aufgeschmerzt hat es, aber das Bein hat nicht auf einmal locker
gelassen ..., da hat er aus ganzer Macht zum zweitenmal ausgeholt
... und sieh da, jetzt ist es alle mit den Schmerzen; es wird wohl
genützt haben ... Wenn er nur mehr Kraft hätte, würde er keinen
Augenblick mehr hier auf der Pritsche faulen, gleich mal mit
Hochzeit feiern ... und sich einen Tanz leisten ... auch essen,
denn er hat große Lust dazu.</p>
<p class="calibre3">»Lieg' du ruhig und rühr' dich kein bißchen, zu essen kriegst du
gleich, ich will's der Fine sagen.«</p>
<p class="calibre3">Rochus fuhr ihm mit der Hand über's Gesicht und ging mit
Ambrosius hinaus.</p>
<p class="calibre3">»Den Priester muß man ihm herholen, solange er bei Bewußtsein
ist!«</p>
<p class="calibre3">»Der Priester ist doch aber für den Abend nach Wola zu dem
Gutsherrn.«</p>
<p class="calibre3">»Ich hole ihn, man darf nicht zögern!«</p>
<p class="calibre3">»Wola ist eine Meile ... in der Nacht ... und den Weg findet ihr
nicht durch den Wald./Es steht hier ein fertiges Gespann für die
Leute, die nach dem Abendessen wegfahren, nehmt das und fahrt.«</p>
<p class="calibre3">Sie führten die Pferde auf die Dorfstraße und Rochus kletterte
auf den Sitz.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page349" title="wolfeh/gary"></a> »Und
vergeßt mir nur den Jakob nicht, man muß für ihn sorgen!« rief er
im Abfahren.</p>
<p class="calibre3">»Allein laß ich ihn nicht, ich sorg' für ihn.«</p>
<p class="calibre3">Bald aber hatte er ihn vergessen, er hatte nur gerade noch so
viel gedacht, der Fine vom Essen zu sagen, er selbst kehrte an den
Tisch zurück und setzte sich mit einer solchen Liebe bei einer
Flasche fest, daß er kurz darauf von der ganzen lieben Welt nichts
mehr wußte.</p>
<p class="calibre3">Fine, die ein gutmütiges Ding war, sammelte alles was sie
kriegen konnte, bereitwillig in eine Schüssel, goß ein tüchtiges
Maß Schnaps ein und trug alles hinüber.</p>
<p class="calibre3">»Jakob, eßt ein bißchen, macht euch auch ein Fest!«</p>
<p class="calibre3">»Gott bezahl's dir! Die Wurst, deucht mit, hat einen guten Duft,
es weht von ihr.«</p>
<p class="calibre3">»Ich hab' sie doch selbst gebraten, daß ihr sie nur ja auch
schmeckt.« Sie drückte ihm die Schüssel in die Hände, weil es im
Stall dunkel war. »Trinkt erst den Schnaps.«</p>
<p class="calibre3">Er trank alles bis auf den Grund.</p>
<p class="calibre3">»Bleib' doch etwas sitzen, mit ist so einsam hier.«</p>
<p class="calibre3">Er fing an herumzuschmecken, hier und da ein Stückchen in den
Mund zu schieben und daran herumzukauen; aber herunterschlucken
konnte er nicht recht etwas.</p>
<p class="calibre3">»Amesieren sie sich, was?«</p>
<p class="calibre3">»So eine Hochzeit und so viel Volk, daß ich mein Leben lang
nichts Größeres gesehen habe.«</p>
<p class="calibre3">»Is ja auch Boryna seine, da ist es kein Wunder,« murmelte er
stolz.</p>
<p class="calibre3">»Das ist so, und der Vater freut sich so und läuft in einem zu
hinter Jagusch her, in einem zu.«</p>
<p class="calibre3">»Wie sollt' es auch anders ... so eine Feine und so schön ums
Maul, wie eine Herrin!«</p>
<p class="calibre3">»Wißt ihr was, und der Dominikbäuerin ihr Schymek hält zu
Nastuscha Täubich.«</p>
<p class="calibre3">»Die Alte wird es nicht zugeben, bei der Nastuscha sitzen doch
an die zehn Mäuler auf den drei Morgen.«</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page350" title="lac/gary"></a> »Sie treibt
sie auch wo sie nur kann auseinander und paßt mächtig auf.«</p>
<p class="calibre3">»Ist der Schulze da?«</p>
<p class="calibre3">»Der amüsiert die andern und ist immer vorweg mit dem Maul, und
der Ambrosius auch.«</p>
<p class="calibre3">»Das sollen sie auch, wenn sie auf solcher Hochzeit sind und bei
so einem Bauer! Und weißt du etwas über Anteks?« fragte er
leise.</p>
<p class="calibre3">»Natürlich, ich bin am Abend schnell zu ihnen 'rübergelaufen und
habe den Kindern Fleisch und Kuchen und Brot gebracht ... Zum Hause
hat er mich hinausgeworfen und hat mir, was ich gebracht habe,
nachgeschmissen ... Er ist stark erzürnt und so böse, so böse ...
und Not und Sorge ist im Haus ... Anna muß sich immer mit der
Schwester herumzanken und in die Haare sollen sie sich schon
gefahren sein.«</p>
<p class="calibre3">Er sagte nichts darauf, schneuzte sich nur stark und begann
seltsam schnell zu atmen.</p>
<p class="calibre3">»Fine,« sagte er nach einer Weile, »die Stute stöhnt so herum
und legt sich seit Abend immerzu hin, die ist gewiß vor dem Fohlen
... man müßte da Obacht geben. Was zum Trinken zurechtmachen. Wie
sie da herumstöhnt. Das arme gute Vieh, und ich kann nicht helfen
... furchtbar schwach bin ich ... ganz ohne Kraft ...«</p>
<p class="calibre3">Er wurde müde, verstummte und schien einzuschlafen.</p>
<p class="calibre3">Fine ging rasch davon.</p>
<p class="calibre3">»Tseschu! Tseschu, Stute,« rief er, wieder zur Besinnung
kommend.</p>
<p class="calibre3">Die Stute wieherte gedehnt auf und fing an hin und her zu
zerren, so daß die Kette klirrte.</p>
<p class="calibre3">»Satt essen will ich mich doch einmal! Du kriegst auch deinen
Teil, mein Hund, das kriegst du, nur nicht winseln ...«</p>
<p class="calibre3">Er machte sich eifrig über die Wurst her, aber er konnte nicht
..., die Lust war ihm ganz vergangen, das Essen quoll ihm im Munde
auf.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page351" title="lac/gary"></a> »Lieber
Jesus, so viel Wurst und so viel Fleisch ... und ich kann nicht ...
ganz und gar nicht.«</p>
<p class="calibre3">Vergeblich versuchte er, beleckte, beroch/er konnte nicht, der
Arm sank schlaff herab; er schob ihn zwischen das Stroh, ohne die
Wurst aus der Hand zu lassen.</p>
<p class="calibre3">»Mein Gott, so viel von all dem Guten, wie ich nie im Leben
hatte, und nu kann ich nicht ...«</p>
<p class="calibre3">Wehmut preßte ihm die Seele zusammen und Tränen flossen über
sein Gesicht, er weinte hell auf vor Bedauern und schluchzte wie
ein Kind, dem man Unrecht getan hat.</p>
<p class="calibre3">»Später will ich was essen, ich ruhe jetzt ein bißchen aus,
danach will ich mir ordentlich was zugute tun,« dachte er.</p>
<p class="calibre3">Aber auch später konnte er nicht, er verfiel in einen Schlaf,
ohne die Wurst aus der Hand zu lassen und ohne zu merken, daß Waupa
im stillen davon abbiß ...</p>
<p class="calibre3">Plötzlich wurde er wach, denn die Musik legte nach dem
Abendessen so mächtig los, daß die Wände im Stall erbebten; aus den
Schweineställen drang zu ihm das erschrockene Gackern der erwachten
Hühner.</p>
<p class="calibre3">Schreie platzten in die Welt hinaus und sprühten aus dem
Festtrubel wie rote Lichter in die Nacht, sie hallten wie
Donnerschläge im Stalle wieder.</p>
<p class="calibre3">Ein mächtiges Vergnügen war dort schon im Gange, Gelächter,
Fröhlichkeit und Tanz; immer wieder erdröhnte die Erde vom Gejage,
und Mädchengekreisch zerriß die Luft.</p>
<p class="calibre3">Jakob hörte zuerst hin, doch bald vergaß er alles; ein Schlaf
ergriff ihn und trug ihn in eine unbekannte lärmerfüllte
Dunkelheit, wie unter rauschendes Wasser hinab, ... in den Schoß
mächtiger Wälder, die irgendein Sturm aufbrausen ließ.</p>
<p class="calibre3">Und als die Freude in Strömen zu fluten begann und der Wirbel
der wütend aneinander geklappten Hacken das ganze Haus
auseinanderzuspalten schien, wachte er etwas auf, ließ die Seele
aus den Dunkelheiten emportauchen, erhob sich aus <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page352" title="lac/gary"></a> seiner Versunkenheit, kehrte
zurück aus grauenerregenden Weiten und horchte.</p>
<p class="calibre3">Und manchmal versuchte er zu essen, oder flüsterte leise und
herzlich:</p>
<p class="calibre3">»Tsesch, Tsesch, Tseschka ... Stute!«</p>
<p class="calibre3">Aber schon ging die Seele langsam aus ihm hinaus und strebte den
Weltenräumen zu, sie schlug noch irre Kreise/ ein armes
Jesusvögelein, und konnte sich noch nicht losreißen, so daß sie von
Zeit zu Zeit sich wieder an die heilige Erde klammerte, um von
ihrer Mühsal auszuruhen und ihr einsames Weinen im Menschenlärm zu
ertränken; sie kehrte zu denen zurück, die ihr lieb waren, kehrte
unter die Lebendigen, rief klagend nach den Menschenbrüdern und
flehte um Hilfe zu ihren Herzen, bis sie schließlich, durch die
Macht und Gnade Jesu gestärkt, sich jenen Frühlingsauen
entgegenschwang und jenen unermeßlich weiten Brachfeldern Gottes,
die mit ewigem Licht und ewiger Freude umspönnen sind.</p>
<p class="calibre3">Und sie flog höher, weiter, weiter bis nach dahin ...</p>
<p class="calibre3">Bis nach dahin, wo man schon weder menschliches Weheklagen, noch
das leidvolle Knirschen jeglicher Seele hört ...</p>
<p class="calibre3">Nach dahin, wo nur noch die duftenden Lilien atmen, wo
Blütenfelder eingebettet in ihres eigenen Honigs Süße säuseln, wo
Sternenflüsse über reichgefärbte Gründe fließen, wo der ewige Tag
ist.</p>
<p class="calibre3">... Nach dahin, wo nur leises Beten wallt und Weihrauchdüfte wie
Nebel ziehen, wo Schellen summen und Orgelklänge leise tönen und
das heilige Hochamt ewig abgehalten wird, wo das schon entsühnte
Volk, die Engel und die Heiligen gemeinsam Gottes Ehre singen/zu
jener allerheiligsten, urewigen Gotteskirche hin, wo die
Menschenseele nichts mehr braucht, als zu beten, unter seligen
Tränen aufzuatmen und sich mit dem Herrn zu freuen auf alle ewigen
Zeiten.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page353" title="lac/gary"></a> Dahin riß
sich die gequälte, ruhelechzende Seele Jakobs.</p>
<p class="center">— — — — —</p>
<p class="calibre3">Im Hochzeitshause aber tanzten sie immerzu und freuten sich aus
vollem Herzen. Die Lust war selbst größer noch als am gestrigen
Tage, denn die Bewirtung war noch reichlicher und die Wirte
nötigten mit größerer Herzlichkeit. So wurde denn auch getanzt bis
zum letzten Atemzug.</p>
<p class="calibre3">Es war eine Siedehitze in ihnen, und wenn sie nur etwas
nachließen, erdröhnte die Musik mit erneuter Macht, so daß sie sich
nur vorbeugten wie ein Kornfeld, in das der Sturm hineinfährt,
neuen Anlauf nahmen, mit den Füßen Lärm aufwirbelten und mit hellem
Geschrei einen frischen Tanz begannen, singend, festlich, dicht
gedrängt und glutentfacht.</p>
<p class="calibre3">Die Glut hatte ihre Seelen weit gemacht, ließ ihr Blut
aufbrausen, ihren Verstand auf und davon rasen, und ihre Herzen
aufblühen im Übermaß der Lust; jeder Nerv bebte mit im Takt, jede
Regung war Tanz, jeder Aufschrei/ein Gesang, und jedes Auge/ein
Leuchten in nimmersatter Seligkeit.</p>
<p class="calibre3">So brachten sie die Nacht dahin, bis der Morgen graute.</p>
<p class="calibre3">Und es kam der Tag ... schwer und leise erhob er sich; von den
düsteren, undurchdringlichen Wolkenwällen rieselte die
Morgendämmerung auf die Welt herab. Und als die Sonne bald aufgehen
sollte, wurde er mit einem Male wieder dunkel, und Schnee begann zu
fallen. Es flog zuerst nur eine Flocke hin und wieder und zog
Kreise in die Luft, wie fallende Fichtennadeln am windigen Tag. Und
dann begann es zu schneien.</p>
<p class="calibre3">Der Schnee fiel wie durch ein dichtes Sieb gerade zur Erde
nieder, er fiel gleichmäßig, eintönig und still, breitete sich über
die Dächer, Bäume und Hecken aus, wie ein gebleichtes Gewebe und
bedeckte die ganze Erde mit seinen weichen Daunen.</p>
<p class="calibre3">Die Hochzeit war nun ausgefeiert, man wollte sich jedoch am
Abend in der Schenke noch zusammenfinden, um sich aufzubessern;
alles begann dann auseinanderzugehen.</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page354" title="lac/Konmax"></a> Die
Brautführer und die Brautjungfern aber mit den Musikanten an der
Spitze stellten sich vor der Galerie auf und sangen gemeinsam ihr
letztes Lied:</p>
<p class="vers">Gute Nacht dem Brautpaar,<br class="calibre2"/>
          Gute
Nacht!<br class="calibre2"/>
Wir wünschen gute nächtliche Zeit<br class="calibre2"/>
Und bleiben zu Diensten stets bereit.<br class="calibre2"/>
          Gute
Nacht!</p>
<p class="calibre3"><a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page357" title="lac/Konmax"></a> <a class="pcalibre3 pcalibre1 pcalibre2 pcalibre" id="page358" title="lac/Konmax"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?c503003e